webpackJsonp([1],{

/***/ 0:
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(jQuery) {// God save the Dev
	
	'use strict';
	
	/*if (process.env.NODE_ENV !== 'production') {
	  require('./assets/templates/layouts/index.html');
	  require('./assets/templates/layouts/services.html');
	  require('./assets/templates/layouts/service-item.html');
	  require('./assets/templates/layouts/calendar.html');
	  require('./assets/templates/layouts/promo.html');
	  require('./assets/templates/layouts/promo-item.html');
	  require('./assets/templates/layouts/team.html');
	  require('./assets/templates/layouts/course-short.html');
	  require('./assets/templates/layouts/course-long.html');
	  require('./assets/templates/layouts/blog.html');
	  require('./assets/templates/layouts/blog-item.html');
	  require('./assets/templates/layouts/teaching.html');
	  require('./assets/templates/layouts/contacts.html');
	}*/
	
	// Depends
	
	var $ = __webpack_require__(8);
	__webpack_require__(341);
	
	// Modules
	var Forms = __webpack_require__(334);
	var Slider = __webpack_require__(339);
	var Popup = __webpack_require__(338);
	var Fancy_select = __webpack_require__(333);
	var Jscrollpane = __webpack_require__(335);
	var LightGallery = __webpack_require__(337);
	var Jslider = __webpack_require__(336);
	var Fancybox = __webpack_require__(331);
	__webpack_require__(116);
	__webpack_require__(955);
	__webpack_require__(340);
	//require('../node_modules/sumoselect/jquery.sumoselect');
	
	// Stylesheet entrypoint
	__webpack_require__(960);
	
	// Are you ready?
	$(function () {
	  new Forms();
	  new Popup();
	  new Fancy_select();
	  new Jscrollpane();
	  new LightGallery();
	  new Slider();
	  new Jslider();
	  new Fancybox();
	
	  setTimeout(function () {
	    $('body').trigger('scroll');
	  }, 100);
	
	  // language
	
	  $('.header-lang > span').click(function () {
	    $(this).next('ul').toggle();
	    $('.header-currency > ul').hide();
	    $('.header-contacts > div').hide();
	    return false;
	  });
	
	  // currency
	
	  $('.header-currency > span').click(function () {
	    $(this).next('ul').toggle();
	    $('.header-lang > ul').hide();
	    $('.header-contacts > div').hide();
	    return false;
	  });
	
	  // header contacts
	
	  $('.header-contacts > span').click(function () {
	    $(this).next('div').toggle();
	    $('.header-lang > ul').hide();
	    $('.header-currency > ul').hide();
	    return false;
	  });
	
	  $(document).click(function () {
	    $('.header-lang > ul').hide();
	    $('.header-currency > ul').hide();
	    $('.header-contacts > div').hide();
	  });
	
	  $(document).on('click', '.header-lang > ul', function (e) {
	    e.stopPropagation();
	  });
	
	  $(document).on('click', '.header-currency > ul', function (e) {
	    e.stopPropagation();
	  });
	
	  $(document).on('click', '.header-contacts > div', function (e) {
	    e.stopPropagation();
	  });
	
	  // timer
	  var time = $('.timer').data('time');
	  var lang = $('.timer').data('lang');
	  $('.timer').timeTo({
	    //timeTo: new Date('Thu Oct 06 2020 09:00:00 GMT+0300 (Восточная Европа, летнее время)'),
	    timeTo: new Date(time),
	    lang: lang,
	    fontSize: 32,
	    displayDays: 2,
	    displayCaptions: true,
	    captionSize: 16,
	    countdown: true
	  });
	
	  // text truncating
	
	  $('.blog-item__text > p').succinct({
	    size: 125
	  });
	
	  $('.promo-item__text > p').succinct({
	    size: 125
	  });
	
	  $('.blog-main__item-text > p').succinct({
	    size: 125
	  });
	
	  $('.teaching-item__descr').succinct({
	    size: 185
	  });
	
	  /*var description = $('.blog-item__text > p').html();
	    if ($(window).width() < 480) {
	      $('.blog-item__text > p').succinct({
	          size: 400,
	      })
	  }
	  else {
	      $('.blog-item__text > p').html(description);
	  }
	    $(window).on('resize', function() {
	      if ($(window).width() < 480) {
	          $('.objavka-descr').succinct({
	              size: 400,
	          });
	      }
	      else {
	          $('.objavka-descr').html(description);
	      }
	  });*/
	
	  // mobile menu
	
	  var touch = $('.mobile-menu__btn');
	  var menu = $('.mobile-menu__wrapper');
	
	  var toggles = document.querySelectorAll('.mobile-menu__btn');
	
	  for (var i = toggles.length - 1; i >= 0; i--) {
	    var toggle = toggles[i];
	    toggleHandler(toggle);
	  }
	
	  function toggleHandler(toggle) {
	    toggle.addEventListener('click', function (e) {
	      e.preventDefault();
	      this.classList.contains('active') === true ? this.classList.remove('active') : this.classList.add('active');
	    });
	  }
	
	  $(touch).on('click', function (e) {
	    e.preventDefault();
	    menu.slideToggle();
	    $('body').toggleClass('active');
	  });
	
	  // scroll
	
	  $('.scroll-wrapper').niceScroll({
	    cursorcolor: '#36bd1b',
	    background: '#ebebeb',
	    cursorborder: '0',
	    cursorborderradius: '0',
	    cursorwidth: '3px',
	    horizrailenabled: false,
	    autohidemode: false
	  });
	
	  $('.text-scroll').niceScroll({
	    cursorcolor: '#008fe9',
	    background: '#ebebeb',
	    cursorborder: '0',
	    cursorborderradius: '0',
	    cursorwidth: '3px',
	    horizrailenabled: false,
	    autohidemode: false
	  });
	
	  setTimeout(function () {
	    $('.scroll-wrapper').getNiceScroll().resize();
	    $('.text-scroll').getNiceScroll().resize();
	  }, 300);
	
	  $('.popup-btn').click(function () {
	    setTimeout(function () {
	      $('.scroll-wrapper').getNiceScroll().resize();
	      $('.nicescroll-rails').css('z-index', '10000').show();
	    }, 300);
	  });
	  $('.mfp-close').on('click', function () {
	    setTimeout(function () {
	      $('scroll-wrapper').getNiceScroll().resize();
	      $('.nicescroll-rails').css('z-index', 'auto').hide();
	    }, 100);
	  });
	  $('.team-popup__btn').on('click', function () {
	    setTimeout(function () {
	      $('scroll-wrapper').getNiceScroll().resize();
	      $('.nicescroll-rails').css('z-index', 'auto').hide();
	    }, 100);
	  });
	  $('.popup-btn:not(.course-video)').magnificPopup({
	    type: 'inline',
	    callbacks: {
	      close: function close() {
	        setTimeout(function () {
	          $('scroll-wrapper').getNiceScroll().resize();
	          $('.nicescroll-rails-vr').css('z-index', 'auto').hide();
	        }, 100);
	      }
	    }
	  });
	
	  // courses
	
	  $('.course-program__btn').on('click', function () {
	    if (!$(this).hasClass('active')) {
	      $(this).addClass('active').find('span').html($(this).data('texthide')).closest('.section-course__program').find('.course-program__list > li:not(.visible)').slideDown();
	    } else {
	      $(this).removeClass('active').find('span').html($(this).data('textall')).closest('.section-course__program').find('.course-program__list > li:not(.visible)').slideUp();
	    }
	  });
	
	  $('.course-cost__list-item').on('click', function () {
	    $(this).addClass('active').siblings().removeClass('active');
	  });
	
	  // tabs
	
	  $('.tabs').on('click', 'li:not(.active)', function () {
	    $(this).addClass('active').siblings().removeClass('active').closest('.tabs-wrapper').find('.tabs-content').removeClass('active').eq($(this).index()).addClass('active');
	  });
	
	  // video
	
	  /*$('.course-video').magnificPopup({
	    items: {
	      src: 'https://www.youtube.com/watch?v=ETpYjBQhc8s'
	    },
	    type: 'iframe'
	  });*/
	
	  // gallery
	
	  $('.graduate-gallery').lightGallery({
	    selector: '.insta-pic'
	  });
	
	  // scroll left/right on mobile
	
	  $('.course-cost__list').each(function () {
	    $(this).scroll(function () {
	      var w = $(window).width();
	      var el_w = $(this).find('li:first-child').width();
	      var end = $(this).scrollLeft();
	      console.log(end, el_w, w);
	      $(this).closest('.course-cost__list-wrapper').addClass('begin');
	      if (end === el_w - w + 30) {
	        $(this).closest('.course-cost__list-wrapper').addClass('end').removeClass('begin');
	      } else {
	        $(this).closest('.course-cost__list-wrapper').removeClass('end').addClass('begin');
	      }
	      if (end > 0) {
	        $(this).closest('.course-cost__list-wrapper').addClass('begin');
	      } else {
	        $(this).closest('.course-cost__list-wrapper').removeClass('begin');
	      }
	    });
	  });
	
	  // show more
	
	  $('.btn-calendar').on('click', function () {
	    if ($(this).closest('.section-calendar').find('.col-md-4:hidden').length > 0) {
	      $(this).closest('.section-calendar').find('.col-md-4:hidden').slice(0, 6).slideDown();
	    } else {
	      $(this).hide();
	    }
	  });
	
	  $('.blog-main__btn').on('click', function () {
	    if ($(this).closest('.section-blog__main').find('.col-xs-12:hidden').length > 0) {
	      $(this).closest('.section-blog__main').find('.col-xs-12:hidden').slice(0, 3).slideDown();
	    } else {
	      $(this).hide();
	    }
	  });
	
	  // show hide text
	
	  if ($('.course-about__text').length) {
	    $('.course-about__text-show').show();
	  } else {
	    $('.course-about__text-show').hide();
	  }
	
	  setTimeout(function () {
	    $('.course-about__text').each(function () {
	      var c_h = $(this).height();
	      console.log(c_h);
	      $('.course-about__text-show').click(function () {
	        $(this).toggleClass('active');
	        $(this).html() == 'Показать все' ? $(this).html('Свернуть') : $(this).html('Показать все');
	        if ($(this).hasClass('active')) {
	          $('.course-about__text-wrapper').css('height', c_h);
	        } else {
	          $('.course-about__text-wrapper').css('height', 145);
	        }
	      });
	    });
	  }, 1000);
	
	  // blog search
	
	  $('.blog-main__search-btn').click(function () {
	    $(this).next('form').toggleClass('active');
	    return false;
	  });
	
	  $(document).click(function () {
	    $('.blog-main__search-form').removeClass('active');
	  });
	
	  $(document).on('click', '.blog-main__search-form', function (e) {
	    e.stopPropagation();
	  });
	
	  // lazy load
	  var lazyload = function lazyload() {
	    var scroll = $(window).scrollTop() + $(window).height() * 3;
	
	    $('.lazy').each(function () {
	      var $this = $(this);
	      if ($this.offset().top < scroll) {
	        $this.attr('src', $(this).data('original'));
	      }
	    });
	    $('.lazy-web').each(function () {
	      var $this = $(this);
	      if ($this.offset().top < scroll) {
	        $this.attr('srcset', $(this).data('original'));
	      }
	    });
	  };
	  $(window).scroll(lazyload);
	
	  //remove main menu item link
	
	  if (location.pathname == '/' || location.pathname == '/ua/') {
	    jQuery('.menu-item-main a').replaceWith(function () {
	      return jQuery('<span/>', {
	        html: this.innerHTML
	      });
	    });
	  }
	
	  $('.mfp-hide form').on('sent', function () {
	    $.magnificPopup.close();
	  });
	
	  $('#register-popup-noemail form').on('sent', function () {
	    $(this).removeClass('disabled');
	    var btntext = $(this).find('button[type="submit"]').html();
	    $(this).find('button[type="submit"]').html(btntext);
	  });
	
	  $('.event-reg').on('click', function (e) {
	    var eventid = jQuery(this).data('eventid');
	    var data = new FormData();
	    data.append('action', 'larus_event_register_form_action');
	    data.append('eventid', eventid);
	
	    $.ajax({
	      url: myajax.url,
	      type: 'POST',
	      data: data,
	      cache: false,
	      processData: false,
	      contentType: false,
	      dataType: 'json',
	      success: function success(request) {
	        $('#register-popup-noemail .popup-title').html(request.form_title);
	        $('#register-popup-noemail .popup-descr').html(request.title);
	        $('#register-popup-noemail input[name="event"]').val(request.title);
	      },
	      error: function error() {
	        console.log('Ошибка');
	      }
	    });
	  });
	
	  $('.header-currency a').on("click", function () {
	    var date = new Date();
	    var currency = $(this).data('currency');
	    date.setTime(date.getTime() + 86400000);
	    Cookies.set("currency", currency, { expires: date });
	  });
	
	  $(document).ready(function () {
	    $('.register-price').on('click', function (e) {
	      var eduFormats = $('.course-cost__content');
	
	      var education = '';
	      var cost = '';
	
	      eduFormats.each(function () {
	        if ($(this).hasClass('active')) {
	          education = $(this).data('education');
	          cost = $(this).find('.course-cost__list-item.active').data('cost');
	        }
	      });
	
	      $('#register-popup-prices').find('input[name="education"]').val(education);
	      $('#register-popup-prices').find('input[name="cost"]').val(cost);
	    });
	  });
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(8)))

/***/ }),

/***/ 244:
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*
	     _ _      _       _
	 ___| (_) ___| | __  (_)___
	/ __| | |/ __| |/ /  | / __|
	\__ \ | | (__|   < _ | \__ \
	|___/_|_|\___|_|\_(_)/ |___/
	                   |__/
	
	 Version: 1.8.1
	  Author: Ken Wheeler
	 Website: http://kenwheeler.github.io
	    Docs: http://kenwheeler.github.io/slick
	    Repo: http://github.com/kenwheeler/slick
	  Issues: http://github.com/kenwheeler/slick/issues
	
	 */
	/* global window, document, define, jQuery, setInterval, clearInterval */
	;(function(factory) {
	    'use strict';
	    if (true) {
	        !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(8)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	    } else if (typeof exports !== 'undefined') {
	        module.exports = factory(require('jquery'));
	    } else {
	        factory(jQuery);
	    }
	
	}(function($) {
	    'use strict';
	    var Slick = window.Slick || {};
	
	    Slick = (function() {
	
	        var instanceUid = 0;
	
	        function Slick(element, settings) {
	
	            var _ = this, dataSettings;
	
	            _.defaults = {
	                accessibility: true,
	                adaptiveHeight: false,
	                appendArrows: $(element),
	                appendDots: $(element),
	                arrows: true,
	                asNavFor: null,
	                prevArrow: '<button class="slick-prev" aria-label="Previous" type="button">Previous</button>',
	                nextArrow: '<button class="slick-next" aria-label="Next" type="button">Next</button>',
	                autoplay: false,
	                autoplaySpeed: 3000,
	                centerMode: false,
	                centerPadding: '50px',
	                cssEase: 'ease',
	                customPaging: function(slider, i) {
	                    return $('<button type="button" />').text(i + 1);
	                },
	                dots: false,
	                dotsClass: 'slick-dots',
	                draggable: true,
	                easing: 'linear',
	                edgeFriction: 0.35,
	                fade: false,
	                focusOnSelect: false,
	                focusOnChange: false,
	                infinite: true,
	                initialSlide: 0,
	                lazyLoad: 'ondemand',
	                mobileFirst: false,
	                pauseOnHover: true,
	                pauseOnFocus: true,
	                pauseOnDotsHover: false,
	                respondTo: 'window',
	                responsive: null,
	                rows: 1,
	                rtl: false,
	                slide: '',
	                slidesPerRow: 1,
	                slidesToShow: 1,
	                slidesToScroll: 1,
	                speed: 500,
	                swipe: true,
	                swipeToSlide: false,
	                touchMove: true,
	                touchThreshold: 5,
	                useCSS: true,
	                useTransform: true,
	                variableWidth: false,
	                vertical: false,
	                verticalSwiping: false,
	                waitForAnimate: true,
	                zIndex: 1000
	            };
	
	            _.initials = {
	                animating: false,
	                dragging: false,
	                autoPlayTimer: null,
	                currentDirection: 0,
	                currentLeft: null,
	                currentSlide: 0,
	                direction: 1,
	                $dots: null,
	                listWidth: null,
	                listHeight: null,
	                loadIndex: 0,
	                $nextArrow: null,
	                $prevArrow: null,
	                scrolling: false,
	                slideCount: null,
	                slideWidth: null,
	                $slideTrack: null,
	                $slides: null,
	                sliding: false,
	                slideOffset: 0,
	                swipeLeft: null,
	                swiping: false,
	                $list: null,
	                touchObject: {},
	                transformsEnabled: false,
	                unslicked: false
	            };
	
	            $.extend(_, _.initials);
	
	            _.activeBreakpoint = null;
	            _.animType = null;
	            _.animProp = null;
	            _.breakpoints = [];
	            _.breakpointSettings = [];
	            _.cssTransitions = false;
	            _.focussed = false;
	            _.interrupted = false;
	            _.hidden = 'hidden';
	            _.paused = true;
	            _.positionProp = null;
	            _.respondTo = null;
	            _.rowCount = 1;
	            _.shouldClick = true;
	            _.$slider = $(element);
	            _.$slidesCache = null;
	            _.transformType = null;
	            _.transitionType = null;
	            _.visibilityChange = 'visibilitychange';
	            _.windowWidth = 0;
	            _.windowTimer = null;
	
	            dataSettings = $(element).data('slick') || {};
	
	            _.options = $.extend({}, _.defaults, settings, dataSettings);
	
	            _.currentSlide = _.options.initialSlide;
	
	            _.originalSettings = _.options;
	
	            if (typeof document.mozHidden !== 'undefined') {
	                _.hidden = 'mozHidden';
	                _.visibilityChange = 'mozvisibilitychange';
	            } else if (typeof document.webkitHidden !== 'undefined') {
	                _.hidden = 'webkitHidden';
	                _.visibilityChange = 'webkitvisibilitychange';
	            }
	
	            _.autoPlay = $.proxy(_.autoPlay, _);
	            _.autoPlayClear = $.proxy(_.autoPlayClear, _);
	            _.autoPlayIterator = $.proxy(_.autoPlayIterator, _);
	            _.changeSlide = $.proxy(_.changeSlide, _);
	            _.clickHandler = $.proxy(_.clickHandler, _);
	            _.selectHandler = $.proxy(_.selectHandler, _);
	            _.setPosition = $.proxy(_.setPosition, _);
	            _.swipeHandler = $.proxy(_.swipeHandler, _);
	            _.dragHandler = $.proxy(_.dragHandler, _);
	            _.keyHandler = $.proxy(_.keyHandler, _);
	
	            _.instanceUid = instanceUid++;
	
	            // A simple way to check for HTML strings
	            // Strict HTML recognition (must start with <)
	            // Extracted from jQuery v1.11 source
	            _.htmlExpr = /^(?:\s*(<[\w\W]+>)[^>]*)$/;
	
	
	            _.registerBreakpoints();
	            _.init(true);
	
	        }
	
	        return Slick;
	
	    }());
	
	    Slick.prototype.activateADA = function() {
	        var _ = this;
	
	        _.$slideTrack.find('.slick-active').attr({
	            'aria-hidden': 'false'
	        }).find('a, input, button, select').attr({
	            'tabindex': '0'
	        });
	
	    };
	
	    Slick.prototype.addSlide = Slick.prototype.slickAdd = function(markup, index, addBefore) {
	
	        var _ = this;
	
	        if (typeof(index) === 'boolean') {
	            addBefore = index;
	            index = null;
	        } else if (index < 0 || (index >= _.slideCount)) {
	            return false;
	        }
	
	        _.unload();
	
	        if (typeof(index) === 'number') {
	            if (index === 0 && _.$slides.length === 0) {
	                $(markup).appendTo(_.$slideTrack);
	            } else if (addBefore) {
	                $(markup).insertBefore(_.$slides.eq(index));
	            } else {
	                $(markup).insertAfter(_.$slides.eq(index));
	            }
	        } else {
	            if (addBefore === true) {
	                $(markup).prependTo(_.$slideTrack);
	            } else {
	                $(markup).appendTo(_.$slideTrack);
	            }
	        }
	
	        _.$slides = _.$slideTrack.children(this.options.slide);
	
	        _.$slideTrack.children(this.options.slide).detach();
	
	        _.$slideTrack.append(_.$slides);
	
	        _.$slides.each(function(index, element) {
	            $(element).attr('data-slick-index', index);
	        });
	
	        _.$slidesCache = _.$slides;
	
	        _.reinit();
	
	    };
	
	    Slick.prototype.animateHeight = function() {
	        var _ = this;
	        if (_.options.slidesToShow === 1 && _.options.adaptiveHeight === true && _.options.vertical === false) {
	            var targetHeight = _.$slides.eq(_.currentSlide).outerHeight(true);
	            _.$list.animate({
	                height: targetHeight
	            }, _.options.speed);
	        }
	    };
	
	    Slick.prototype.animateSlide = function(targetLeft, callback) {
	
	        var animProps = {},
	            _ = this;
	
	        _.animateHeight();
	
	        if (_.options.rtl === true && _.options.vertical === false) {
	            targetLeft = -targetLeft;
	        }
	        if (_.transformsEnabled === false) {
	            if (_.options.vertical === false) {
	                _.$slideTrack.animate({
	                    left: targetLeft
	                }, _.options.speed, _.options.easing, callback);
	            } else {
	                _.$slideTrack.animate({
	                    top: targetLeft
	                }, _.options.speed, _.options.easing, callback);
	            }
	
	        } else {
	
	            if (_.cssTransitions === false) {
	                if (_.options.rtl === true) {
	                    _.currentLeft = -(_.currentLeft);
	                }
	                $({
	                    animStart: _.currentLeft
	                }).animate({
	                    animStart: targetLeft
	                }, {
	                    duration: _.options.speed,
	                    easing: _.options.easing,
	                    step: function(now) {
	                        now = Math.ceil(now);
	                        if (_.options.vertical === false) {
	                            animProps[_.animType] = 'translate(' +
	                                now + 'px, 0px)';
	                            _.$slideTrack.css(animProps);
	                        } else {
	                            animProps[_.animType] = 'translate(0px,' +
	                                now + 'px)';
	                            _.$slideTrack.css(animProps);
	                        }
	                    },
	                    complete: function() {
	                        if (callback) {
	                            callback.call();
	                        }
	                    }
	                });
	
	            } else {
	
	                _.applyTransition();
	                targetLeft = Math.ceil(targetLeft);
	
	                if (_.options.vertical === false) {
	                    animProps[_.animType] = 'translate3d(' + targetLeft + 'px, 0px, 0px)';
	                } else {
	                    animProps[_.animType] = 'translate3d(0px,' + targetLeft + 'px, 0px)';
	                }
	                _.$slideTrack.css(animProps);
	
	                if (callback) {
	                    setTimeout(function() {
	
	                        _.disableTransition();
	
	                        callback.call();
	                    }, _.options.speed);
	                }
	
	            }
	
	        }
	
	    };
	
	    Slick.prototype.getNavTarget = function() {
	
	        var _ = this,
	            asNavFor = _.options.asNavFor;
	
	        if ( asNavFor && asNavFor !== null ) {
	            asNavFor = $(asNavFor).not(_.$slider);
	        }
	
	        return asNavFor;
	
	    };
	
	    Slick.prototype.asNavFor = function(index) {
	
	        var _ = this,
	            asNavFor = _.getNavTarget();
	
	        if ( asNavFor !== null && typeof asNavFor === 'object' ) {
	            asNavFor.each(function() {
	                var target = $(this).slick('getSlick');
	                if(!target.unslicked) {
	                    target.slideHandler(index, true);
	                }
	            });
	        }
	
	    };
	
	    Slick.prototype.applyTransition = function(slide) {
	
	        var _ = this,
	            transition = {};
	
	        if (_.options.fade === false) {
	            transition[_.transitionType] = _.transformType + ' ' + _.options.speed + 'ms ' + _.options.cssEase;
	        } else {
	            transition[_.transitionType] = 'opacity ' + _.options.speed + 'ms ' + _.options.cssEase;
	        }
	
	        if (_.options.fade === false) {
	            _.$slideTrack.css(transition);
	        } else {
	            _.$slides.eq(slide).css(transition);
	        }
	
	    };
	
	    Slick.prototype.autoPlay = function() {
	
	        var _ = this;
	
	        _.autoPlayClear();
	
	        if ( _.slideCount > _.options.slidesToShow ) {
	            _.autoPlayTimer = setInterval( _.autoPlayIterator, _.options.autoplaySpeed );
	        }
	
	    };
	
	    Slick.prototype.autoPlayClear = function() {
	
	        var _ = this;
	
	        if (_.autoPlayTimer) {
	            clearInterval(_.autoPlayTimer);
	        }
	
	    };
	
	    Slick.prototype.autoPlayIterator = function() {
	
	        var _ = this,
	            slideTo = _.currentSlide + _.options.slidesToScroll;
	
	        if ( !_.paused && !_.interrupted && !_.focussed ) {
	
	            if ( _.options.infinite === false ) {
	
	                if ( _.direction === 1 && ( _.currentSlide + 1 ) === ( _.slideCount - 1 )) {
	                    _.direction = 0;
	                }
	
	                else if ( _.direction === 0 ) {
	
	                    slideTo = _.currentSlide - _.options.slidesToScroll;
	
	                    if ( _.currentSlide - 1 === 0 ) {
	                        _.direction = 1;
	                    }
	
	                }
	
	            }
	
	            _.slideHandler( slideTo );
	
	        }
	
	    };
	
	    Slick.prototype.buildArrows = function() {
	
	        var _ = this;
	
	        if (_.options.arrows === true ) {
	
	            _.$prevArrow = $(_.options.prevArrow).addClass('slick-arrow');
	            _.$nextArrow = $(_.options.nextArrow).addClass('slick-arrow');
	
	            if( _.slideCount > _.options.slidesToShow ) {
	
	                _.$prevArrow.removeClass('slick-hidden').removeAttr('aria-hidden tabindex');
	                _.$nextArrow.removeClass('slick-hidden').removeAttr('aria-hidden tabindex');
	
	                if (_.htmlExpr.test(_.options.prevArrow)) {
	                    _.$prevArrow.prependTo(_.options.appendArrows);
	                }
	
	                if (_.htmlExpr.test(_.options.nextArrow)) {
	                    _.$nextArrow.appendTo(_.options.appendArrows);
	                }
	
	                if (_.options.infinite !== true) {
	                    _.$prevArrow
	                        .addClass('slick-disabled')
	                        .attr('aria-disabled', 'true');
	                }
	
	            } else {
	
	                _.$prevArrow.add( _.$nextArrow )
	
	                    .addClass('slick-hidden')
	                    .attr({
	                        'aria-disabled': 'true',
	                        'tabindex': '-1'
	                    });
	
	            }
	
	        }
	
	    };
	
	    Slick.prototype.buildDots = function() {
	
	        var _ = this,
	            i, dot;
	
	        if (_.options.dots === true && _.slideCount > _.options.slidesToShow) {
	
	            _.$slider.addClass('slick-dotted');
	
	            dot = $('<ul />').addClass(_.options.dotsClass);
	
	            for (i = 0; i <= _.getDotCount(); i += 1) {
	                dot.append($('<li />').append(_.options.customPaging.call(this, _, i)));
	            }
	
	            _.$dots = dot.appendTo(_.options.appendDots);
	
	            _.$dots.find('li').first().addClass('slick-active');
	
	        }
	
	    };
	
	    Slick.prototype.buildOut = function() {
	
	        var _ = this;
	
	        _.$slides =
	            _.$slider
	                .children( _.options.slide + ':not(.slick-cloned)')
	                .addClass('slick-slide');
	
	        _.slideCount = _.$slides.length;
	
	        _.$slides.each(function(index, element) {
	            $(element)
	                .attr('data-slick-index', index)
	                .data('originalStyling', $(element).attr('style') || '');
	        });
	
	        _.$slider.addClass('slick-slider');
	
	        _.$slideTrack = (_.slideCount === 0) ?
	            $('<div class="slick-track"/>').appendTo(_.$slider) :
	            _.$slides.wrapAll('<div class="slick-track"/>').parent();
	
	        _.$list = _.$slideTrack.wrap(
	            '<div class="slick-list"/>').parent();
	        _.$slideTrack.css('opacity', 0);
	
	        if (_.options.centerMode === true || _.options.swipeToSlide === true) {
	            _.options.slidesToScroll = 1;
	        }
	
	        $('img[data-lazy]', _.$slider).not('[src]').addClass('slick-loading');
	
	        _.setupInfinite();
	
	        _.buildArrows();
	
	        _.buildDots();
	
	        _.updateDots();
	
	
	        _.setSlideClasses(typeof _.currentSlide === 'number' ? _.currentSlide : 0);
	
	        if (_.options.draggable === true) {
	            _.$list.addClass('draggable');
	        }
	
	    };
	
	    Slick.prototype.buildRows = function() {
	
	        var _ = this, a, b, c, newSlides, numOfSlides, originalSlides,slidesPerSection;
	
	        newSlides = document.createDocumentFragment();
	        originalSlides = _.$slider.children();
	
	        if(_.options.rows > 0) {
	
	            slidesPerSection = _.options.slidesPerRow * _.options.rows;
	            numOfSlides = Math.ceil(
	                originalSlides.length / slidesPerSection
	            );
	
	            for(a = 0; a < numOfSlides; a++){
	                var slide = document.createElement('div');
	                for(b = 0; b < _.options.rows; b++) {
	                    var row = document.createElement('div');
	                    for(c = 0; c < _.options.slidesPerRow; c++) {
	                        var target = (a * slidesPerSection + ((b * _.options.slidesPerRow) + c));
	                        if (originalSlides.get(target)) {
	                            row.appendChild(originalSlides.get(target));
	                        }
	                    }
	                    slide.appendChild(row);
	                }
	                newSlides.appendChild(slide);
	            }
	
	            _.$slider.empty().append(newSlides);
	            _.$slider.children().children().children()
	                .css({
	                    'width':(100 / _.options.slidesPerRow) + '%',
	                    'display': 'inline-block'
	                });
	
	        }
	
	    };
	
	    Slick.prototype.checkResponsive = function(initial, forceUpdate) {
	
	        var _ = this,
	            breakpoint, targetBreakpoint, respondToWidth, triggerBreakpoint = false;
	        var sliderWidth = _.$slider.width();
	        var windowWidth = window.innerWidth || $(window).width();
	
	        if (_.respondTo === 'window') {
	            respondToWidth = windowWidth;
	        } else if (_.respondTo === 'slider') {
	            respondToWidth = sliderWidth;
	        } else if (_.respondTo === 'min') {
	            respondToWidth = Math.min(windowWidth, sliderWidth);
	        }
	
	        if ( _.options.responsive &&
	            _.options.responsive.length &&
	            _.options.responsive !== null) {
	
	            targetBreakpoint = null;
	
	            for (breakpoint in _.breakpoints) {
	                if (_.breakpoints.hasOwnProperty(breakpoint)) {
	                    if (_.originalSettings.mobileFirst === false) {
	                        if (respondToWidth < _.breakpoints[breakpoint]) {
	                            targetBreakpoint = _.breakpoints[breakpoint];
	                        }
	                    } else {
	                        if (respondToWidth > _.breakpoints[breakpoint]) {
	                            targetBreakpoint = _.breakpoints[breakpoint];
	                        }
	                    }
	                }
	            }
	
	            if (targetBreakpoint !== null) {
	                if (_.activeBreakpoint !== null) {
	                    if (targetBreakpoint !== _.activeBreakpoint || forceUpdate) {
	                        _.activeBreakpoint =
	                            targetBreakpoint;
	                        if (_.breakpointSettings[targetBreakpoint] === 'unslick') {
	                            _.unslick(targetBreakpoint);
	                        } else {
	                            _.options = $.extend({}, _.originalSettings,
	                                _.breakpointSettings[
	                                    targetBreakpoint]);
	                            if (initial === true) {
	                                _.currentSlide = _.options.initialSlide;
	                            }
	                            _.refresh(initial);
	                        }
	                        triggerBreakpoint = targetBreakpoint;
	                    }
	                } else {
	                    _.activeBreakpoint = targetBreakpoint;
	                    if (_.breakpointSettings[targetBreakpoint] === 'unslick') {
	                        _.unslick(targetBreakpoint);
	                    } else {
	                        _.options = $.extend({}, _.originalSettings,
	                            _.breakpointSettings[
	                                targetBreakpoint]);
	                        if (initial === true) {
	                            _.currentSlide = _.options.initialSlide;
	                        }
	                        _.refresh(initial);
	                    }
	                    triggerBreakpoint = targetBreakpoint;
	                }
	            } else {
	                if (_.activeBreakpoint !== null) {
	                    _.activeBreakpoint = null;
	                    _.options = _.originalSettings;
	                    if (initial === true) {
	                        _.currentSlide = _.options.initialSlide;
	                    }
	                    _.refresh(initial);
	                    triggerBreakpoint = targetBreakpoint;
	                }
	            }
	
	            // only trigger breakpoints during an actual break. not on initialize.
	            if( !initial && triggerBreakpoint !== false ) {
	                _.$slider.trigger('breakpoint', [_, triggerBreakpoint]);
	            }
	        }
	
	    };
	
	    Slick.prototype.changeSlide = function(event, dontAnimate) {
	
	        var _ = this,
	            $target = $(event.currentTarget),
	            indexOffset, slideOffset, unevenOffset;
	
	        // If target is a link, prevent default action.
	        if($target.is('a')) {
	            event.preventDefault();
	        }
	
	        // If target is not the <li> element (ie: a child), find the <li>.
	        if(!$target.is('li')) {
	            $target = $target.closest('li');
	        }
	
	        unevenOffset = (_.slideCount % _.options.slidesToScroll !== 0);
	        indexOffset = unevenOffset ? 0 : (_.slideCount - _.currentSlide) % _.options.slidesToScroll;
	
	        switch (event.data.message) {
	
	            case 'previous':
	                slideOffset = indexOffset === 0 ? _.options.slidesToScroll : _.options.slidesToShow - indexOffset;
	                if (_.slideCount > _.options.slidesToShow) {
	                    _.slideHandler(_.currentSlide - slideOffset, false, dontAnimate);
	                }
	                break;
	
	            case 'next':
	                slideOffset = indexOffset === 0 ? _.options.slidesToScroll : indexOffset;
	                if (_.slideCount > _.options.slidesToShow) {
	                    _.slideHandler(_.currentSlide + slideOffset, false, dontAnimate);
	                }
	                break;
	
	            case 'index':
	                var index = event.data.index === 0 ? 0 :
	                    event.data.index || $target.index() * _.options.slidesToScroll;
	
	                _.slideHandler(_.checkNavigable(index), false, dontAnimate);
	                $target.children().trigger('focus');
	                break;
	
	            default:
	                return;
	        }
	
	    };
	
	    Slick.prototype.checkNavigable = function(index) {
	
	        var _ = this,
	            navigables, prevNavigable;
	
	        navigables = _.getNavigableIndexes();
	        prevNavigable = 0;
	        if (index > navigables[navigables.length - 1]) {
	            index = navigables[navigables.length - 1];
	        } else {
	            for (var n in navigables) {
	                if (index < navigables[n]) {
	                    index = prevNavigable;
	                    break;
	                }
	                prevNavigable = navigables[n];
	            }
	        }
	
	        return index;
	    };
	
	    Slick.prototype.cleanUpEvents = function() {
	
	        var _ = this;
	
	        if (_.options.dots && _.$dots !== null) {
	
	            $('li', _.$dots)
	                .off('click.slick', _.changeSlide)
	                .off('mouseenter.slick', $.proxy(_.interrupt, _, true))
	                .off('mouseleave.slick', $.proxy(_.interrupt, _, false));
	
	            if (_.options.accessibility === true) {
	                _.$dots.off('keydown.slick', _.keyHandler);
	            }
	        }
	
	        _.$slider.off('focus.slick blur.slick');
	
	        if (_.options.arrows === true && _.slideCount > _.options.slidesToShow) {
	            _.$prevArrow && _.$prevArrow.off('click.slick', _.changeSlide);
	            _.$nextArrow && _.$nextArrow.off('click.slick', _.changeSlide);
	
	            if (_.options.accessibility === true) {
	                _.$prevArrow && _.$prevArrow.off('keydown.slick', _.keyHandler);
	                _.$nextArrow && _.$nextArrow.off('keydown.slick', _.keyHandler);
	            }
	        }
	
	        _.$list.off('touchstart.slick mousedown.slick', _.swipeHandler);
	        _.$list.off('touchmove.slick mousemove.slick', _.swipeHandler);
	        _.$list.off('touchend.slick mouseup.slick', _.swipeHandler);
	        _.$list.off('touchcancel.slick mouseleave.slick', _.swipeHandler);
	
	        _.$list.off('click.slick', _.clickHandler);
	
	        $(document).off(_.visibilityChange, _.visibility);
	
	        _.cleanUpSlideEvents();
	
	        if (_.options.accessibility === true) {
	            _.$list.off('keydown.slick', _.keyHandler);
	        }
	
	        if (_.options.focusOnSelect === true) {
	            $(_.$slideTrack).children().off('click.slick', _.selectHandler);
	        }
	
	        $(window).off('orientationchange.slick.slick-' + _.instanceUid, _.orientationChange);
	
	        $(window).off('resize.slick.slick-' + _.instanceUid, _.resize);
	
	        $('[draggable!=true]', _.$slideTrack).off('dragstart', _.preventDefault);
	
	        $(window).off('load.slick.slick-' + _.instanceUid, _.setPosition);
	
	    };
	
	    Slick.prototype.cleanUpSlideEvents = function() {
	
	        var _ = this;
	
	        _.$list.off('mouseenter.slick', $.proxy(_.interrupt, _, true));
	        _.$list.off('mouseleave.slick', $.proxy(_.interrupt, _, false));
	
	    };
	
	    Slick.prototype.cleanUpRows = function() {
	
	        var _ = this, originalSlides;
	
	        if(_.options.rows > 0) {
	            originalSlides = _.$slides.children().children();
	            originalSlides.removeAttr('style');
	            _.$slider.empty().append(originalSlides);
	        }
	
	    };
	
	    Slick.prototype.clickHandler = function(event) {
	
	        var _ = this;
	
	        if (_.shouldClick === false) {
	            event.stopImmediatePropagation();
	            event.stopPropagation();
	            event.preventDefault();
	        }
	
	    };
	
	    Slick.prototype.destroy = function(refresh) {
	
	        var _ = this;
	
	        _.autoPlayClear();
	
	        _.touchObject = {};
	
	        _.cleanUpEvents();
	
	        $('.slick-cloned', _.$slider).detach();
	
	        if (_.$dots) {
	            _.$dots.remove();
	        }
	
	        if ( _.$prevArrow && _.$prevArrow.length ) {
	
	            _.$prevArrow
	                .removeClass('slick-disabled slick-arrow slick-hidden')
	                .removeAttr('aria-hidden aria-disabled tabindex')
	                .css('display','');
	
	            if ( _.htmlExpr.test( _.options.prevArrow )) {
	                _.$prevArrow.remove();
	            }
	        }
	
	        if ( _.$nextArrow && _.$nextArrow.length ) {
	
	            _.$nextArrow
	                .removeClass('slick-disabled slick-arrow slick-hidden')
	                .removeAttr('aria-hidden aria-disabled tabindex')
	                .css('display','');
	
	            if ( _.htmlExpr.test( _.options.nextArrow )) {
	                _.$nextArrow.remove();
	            }
	        }
	
	
	        if (_.$slides) {
	
	            _.$slides
	                .removeClass('slick-slide slick-active slick-center slick-visible slick-current')
	                .removeAttr('aria-hidden')
	                .removeAttr('data-slick-index')
	                .each(function(){
	                    $(this).attr('style', $(this).data('originalStyling'));
	                });
	
	            _.$slideTrack.children(this.options.slide).detach();
	
	            _.$slideTrack.detach();
	
	            _.$list.detach();
	
	            _.$slider.append(_.$slides);
	        }
	
	        _.cleanUpRows();
	
	        _.$slider.removeClass('slick-slider');
	        _.$slider.removeClass('slick-initialized');
	        _.$slider.removeClass('slick-dotted');
	
	        _.unslicked = true;
	
	        if(!refresh) {
	            _.$slider.trigger('destroy', [_]);
	        }
	
	    };
	
	    Slick.prototype.disableTransition = function(slide) {
	
	        var _ = this,
	            transition = {};
	
	        transition[_.transitionType] = '';
	
	        if (_.options.fade === false) {
	            _.$slideTrack.css(transition);
	        } else {
	            _.$slides.eq(slide).css(transition);
	        }
	
	    };
	
	    Slick.prototype.fadeSlide = function(slideIndex, callback) {
	
	        var _ = this;
	
	        if (_.cssTransitions === false) {
	
	            _.$slides.eq(slideIndex).css({
	                zIndex: _.options.zIndex
	            });
	
	            _.$slides.eq(slideIndex).animate({
	                opacity: 1
	            }, _.options.speed, _.options.easing, callback);
	
	        } else {
	
	            _.applyTransition(slideIndex);
	
	            _.$slides.eq(slideIndex).css({
	                opacity: 1,
	                zIndex: _.options.zIndex
	            });
	
	            if (callback) {
	                setTimeout(function() {
	
	                    _.disableTransition(slideIndex);
	
	                    callback.call();
	                }, _.options.speed);
	            }
	
	        }
	
	    };
	
	    Slick.prototype.fadeSlideOut = function(slideIndex) {
	
	        var _ = this;
	
	        if (_.cssTransitions === false) {
	
	            _.$slides.eq(slideIndex).animate({
	                opacity: 0,
	                zIndex: _.options.zIndex - 2
	            }, _.options.speed, _.options.easing);
	
	        } else {
	
	            _.applyTransition(slideIndex);
	
	            _.$slides.eq(slideIndex).css({
	                opacity: 0,
	                zIndex: _.options.zIndex - 2
	            });
	
	        }
	
	    };
	
	    Slick.prototype.filterSlides = Slick.prototype.slickFilter = function(filter) {
	
	        var _ = this;
	
	        if (filter !== null) {
	
	            _.$slidesCache = _.$slides;
	
	            _.unload();
	
	            _.$slideTrack.children(this.options.slide).detach();
	
	            _.$slidesCache.filter(filter).appendTo(_.$slideTrack);
	
	            _.reinit();
	
	        }
	
	    };
	
	    Slick.prototype.focusHandler = function() {
	
	        var _ = this;
	
	        _.$slider
	            .off('focus.slick blur.slick')
	            .on('focus.slick blur.slick', '*', function(event) {
	
	            event.stopImmediatePropagation();
	            var $sf = $(this);
	
	            setTimeout(function() {
	
	                if( _.options.pauseOnFocus ) {
	                    _.focussed = $sf.is(':focus');
	                    _.autoPlay();
	                }
	
	            }, 0);
	
	        });
	    };
	
	    Slick.prototype.getCurrent = Slick.prototype.slickCurrentSlide = function() {
	
	        var _ = this;
	        return _.currentSlide;
	
	    };
	
	    Slick.prototype.getDotCount = function() {
	
	        var _ = this;
	
	        var breakPoint = 0;
	        var counter = 0;
	        var pagerQty = 0;
	
	        if (_.options.infinite === true) {
	            if (_.slideCount <= _.options.slidesToShow) {
	                 ++pagerQty;
	            } else {
	                while (breakPoint < _.slideCount) {
	                    ++pagerQty;
	                    breakPoint = counter + _.options.slidesToScroll;
	                    counter += _.options.slidesToScroll <= _.options.slidesToShow ? _.options.slidesToScroll : _.options.slidesToShow;
	                }
	            }
	        } else if (_.options.centerMode === true) {
	            pagerQty = _.slideCount;
	        } else if(!_.options.asNavFor) {
	            pagerQty = 1 + Math.ceil((_.slideCount - _.options.slidesToShow) / _.options.slidesToScroll);
	        }else {
	            while (breakPoint < _.slideCount) {
	                ++pagerQty;
	                breakPoint = counter + _.options.slidesToScroll;
	                counter += _.options.slidesToScroll <= _.options.slidesToShow ? _.options.slidesToScroll : _.options.slidesToShow;
	            }
	        }
	
	        return pagerQty - 1;
	
	    };
	
	    Slick.prototype.getLeft = function(slideIndex) {
	
	        var _ = this,
	            targetLeft,
	            verticalHeight,
	            verticalOffset = 0,
	            targetSlide,
	            coef;
	
	        _.slideOffset = 0;
	        verticalHeight = _.$slides.first().outerHeight(true);
	
	        if (_.options.infinite === true) {
	            if (_.slideCount > _.options.slidesToShow) {
	                _.slideOffset = (_.slideWidth * _.options.slidesToShow) * -1;
	                coef = -1
	
	                if (_.options.vertical === true && _.options.centerMode === true) {
	                    if (_.options.slidesToShow === 2) {
	                        coef = -1.5;
	                    } else if (_.options.slidesToShow === 1) {
	                        coef = -2
	                    }
	                }
	                verticalOffset = (verticalHeight * _.options.slidesToShow) * coef;
	            }
	            if (_.slideCount % _.options.slidesToScroll !== 0) {
	                if (slideIndex + _.options.slidesToScroll > _.slideCount && _.slideCount > _.options.slidesToShow) {
	                    if (slideIndex > _.slideCount) {
	                        _.slideOffset = ((_.options.slidesToShow - (slideIndex - _.slideCount)) * _.slideWidth) * -1;
	                        verticalOffset = ((_.options.slidesToShow - (slideIndex - _.slideCount)) * verticalHeight) * -1;
	                    } else {
	                        _.slideOffset = ((_.slideCount % _.options.slidesToScroll) * _.slideWidth) * -1;
	                        verticalOffset = ((_.slideCount % _.options.slidesToScroll) * verticalHeight) * -1;
	                    }
	                }
	            }
	        } else {
	            if (slideIndex + _.options.slidesToShow > _.slideCount) {
	                _.slideOffset = ((slideIndex + _.options.slidesToShow) - _.slideCount) * _.slideWidth;
	                verticalOffset = ((slideIndex + _.options.slidesToShow) - _.slideCount) * verticalHeight;
	            }
	        }
	
	        if (_.slideCount <= _.options.slidesToShow) {
	            _.slideOffset = 0;
	            verticalOffset = 0;
	        }
	
	        if (_.options.centerMode === true && _.slideCount <= _.options.slidesToShow) {
	            _.slideOffset = ((_.slideWidth * Math.floor(_.options.slidesToShow)) / 2) - ((_.slideWidth * _.slideCount) / 2);
	        } else if (_.options.centerMode === true && _.options.infinite === true) {
	            _.slideOffset += _.slideWidth * Math.floor(_.options.slidesToShow / 2) - _.slideWidth;
	        } else if (_.options.centerMode === true) {
	            _.slideOffset = 0;
	            _.slideOffset += _.slideWidth * Math.floor(_.options.slidesToShow / 2);
	        }
	
	        if (_.options.vertical === false) {
	            targetLeft = ((slideIndex * _.slideWidth) * -1) + _.slideOffset;
	        } else {
	            targetLeft = ((slideIndex * verticalHeight) * -1) + verticalOffset;
	        }
	
	        if (_.options.variableWidth === true) {
	
	            if (_.slideCount <= _.options.slidesToShow || _.options.infinite === false) {
	                targetSlide = _.$slideTrack.children('.slick-slide').eq(slideIndex);
	            } else {
	                targetSlide = _.$slideTrack.children('.slick-slide').eq(slideIndex + _.options.slidesToShow);
	            }
	
	            if (_.options.rtl === true) {
	                if (targetSlide[0]) {
	                    targetLeft = (_.$slideTrack.width() - targetSlide[0].offsetLeft - targetSlide.width()) * -1;
	                } else {
	                    targetLeft =  0;
	                }
	            } else {
	                targetLeft = targetSlide[0] ? targetSlide[0].offsetLeft * -1 : 0;
	            }
	
	            if (_.options.centerMode === true) {
	                if (_.slideCount <= _.options.slidesToShow || _.options.infinite === false) {
	                    targetSlide = _.$slideTrack.children('.slick-slide').eq(slideIndex);
	                } else {
	                    targetSlide = _.$slideTrack.children('.slick-slide').eq(slideIndex + _.options.slidesToShow + 1);
	                }
	
	                if (_.options.rtl === true) {
	                    if (targetSlide[0]) {
	                        targetLeft = (_.$slideTrack.width() - targetSlide[0].offsetLeft - targetSlide.width()) * -1;
	                    } else {
	                        targetLeft =  0;
	                    }
	                } else {
	                    targetLeft = targetSlide[0] ? targetSlide[0].offsetLeft * -1 : 0;
	                }
	
	                targetLeft += (_.$list.width() - targetSlide.outerWidth()) / 2;
	            }
	        }
	
	        return targetLeft;
	
	    };
	
	    Slick.prototype.getOption = Slick.prototype.slickGetOption = function(option) {
	
	        var _ = this;
	
	        return _.options[option];
	
	    };
	
	    Slick.prototype.getNavigableIndexes = function() {
	
	        var _ = this,
	            breakPoint = 0,
	            counter = 0,
	            indexes = [],
	            max;
	
	        if (_.options.infinite === false) {
	            max = _.slideCount;
	        } else {
	            breakPoint = _.options.slidesToScroll * -1;
	            counter = _.options.slidesToScroll * -1;
	            max = _.slideCount * 2;
	        }
	
	        while (breakPoint < max) {
	            indexes.push(breakPoint);
	            breakPoint = counter + _.options.slidesToScroll;
	            counter += _.options.slidesToScroll <= _.options.slidesToShow ? _.options.slidesToScroll : _.options.slidesToShow;
	        }
	
	        return indexes;
	
	    };
	
	    Slick.prototype.getSlick = function() {
	
	        return this;
	
	    };
	
	    Slick.prototype.getSlideCount = function() {
	
	        var _ = this,
	            slidesTraversed, swipedSlide, centerOffset;
	
	        centerOffset = _.options.centerMode === true ? _.slideWidth * Math.floor(_.options.slidesToShow / 2) : 0;
	
	        if (_.options.swipeToSlide === true) {
	            _.$slideTrack.find('.slick-slide').each(function(index, slide) {
	                if (slide.offsetLeft - centerOffset + ($(slide).outerWidth() / 2) > (_.swipeLeft * -1)) {
	                    swipedSlide = slide;
	                    return false;
	                }
	            });
	
	            slidesTraversed = Math.abs($(swipedSlide).attr('data-slick-index') - _.currentSlide) || 1;
	
	            return slidesTraversed;
	
	        } else {
	            return _.options.slidesToScroll;
	        }
	
	    };
	
	    Slick.prototype.goTo = Slick.prototype.slickGoTo = function(slide, dontAnimate) {
	
	        var _ = this;
	
	        _.changeSlide({
	            data: {
	                message: 'index',
	                index: parseInt(slide)
	            }
	        }, dontAnimate);
	
	    };
	
	    Slick.prototype.init = function(creation) {
	
	        var _ = this;
	
	        if (!$(_.$slider).hasClass('slick-initialized')) {
	
	            $(_.$slider).addClass('slick-initialized');
	
	            _.buildRows();
	            _.buildOut();
	            _.setProps();
	            _.startLoad();
	            _.loadSlider();
	            _.initializeEvents();
	            _.updateArrows();
	            _.updateDots();
	            _.checkResponsive(true);
	            _.focusHandler();
	
	        }
	
	        if (creation) {
	            _.$slider.trigger('init', [_]);
	        }
	
	        if (_.options.accessibility === true) {
	            _.initADA();
	        }
	
	        if ( _.options.autoplay ) {
	
	            _.paused = false;
	            _.autoPlay();
	
	        }
	
	    };
	
	    Slick.prototype.initADA = function() {
	        var _ = this,
	                numDotGroups = Math.ceil(_.slideCount / _.options.slidesToShow),
	                tabControlIndexes = _.getNavigableIndexes().filter(function(val) {
	                    return (val >= 0) && (val < _.slideCount);
	                });
	
	        _.$slides.add(_.$slideTrack.find('.slick-cloned')).attr({
	            'aria-hidden': 'true',
	            'tabindex': '-1'
	        }).find('a, input, button, select').attr({
	            'tabindex': '-1'
	        });
	
	        if (_.$dots !== null) {
	            _.$slides.not(_.$slideTrack.find('.slick-cloned')).each(function(i) {
	                var slideControlIndex = tabControlIndexes.indexOf(i);
	
	                $(this).attr({
	                    'role': 'tabpanel',
	                    'id': 'slick-slide' + _.instanceUid + i,
	                    'tabindex': -1
	                });
	
	                if (slideControlIndex !== -1) {
	                   var ariaButtonControl = 'slick-slide-control' + _.instanceUid + slideControlIndex
	                   if ($('#' + ariaButtonControl).length) {
	                     $(this).attr({
	                         'aria-describedby': ariaButtonControl
	                     });
	                   }
	                }
	            });
	
	            _.$dots.attr('role', 'tablist').find('li').each(function(i) {
	                var mappedSlideIndex = tabControlIndexes[i];
	
	                $(this).attr({
	                    'role': 'presentation'
	                });
	
	                $(this).find('button').first().attr({
	                    'role': 'tab',
	                    'id': 'slick-slide-control' + _.instanceUid + i,
	                    'aria-controls': 'slick-slide' + _.instanceUid + mappedSlideIndex,
	                    'aria-label': (i + 1) + ' of ' + numDotGroups,
	                    'aria-selected': null,
	                    'tabindex': '-1'
	                });
	
	            }).eq(_.currentSlide).find('button').attr({
	                'aria-selected': 'true',
	                'tabindex': '0'
	            }).end();
	        }
	
	        for (var i=_.currentSlide, max=i+_.options.slidesToShow; i < max; i++) {
	          if (_.options.focusOnChange) {
	            _.$slides.eq(i).attr({'tabindex': '0'});
	          } else {
	            _.$slides.eq(i).removeAttr('tabindex');
	          }
	        }
	
	        _.activateADA();
	
	    };
	
	    Slick.prototype.initArrowEvents = function() {
	
	        var _ = this;
	
	        if (_.options.arrows === true && _.slideCount > _.options.slidesToShow) {
	            _.$prevArrow
	               .off('click.slick')
	               .on('click.slick', {
	                    message: 'previous'
	               }, _.changeSlide);
	            _.$nextArrow
	               .off('click.slick')
	               .on('click.slick', {
	                    message: 'next'
	               }, _.changeSlide);
	
	            if (_.options.accessibility === true) {
	                _.$prevArrow.on('keydown.slick', _.keyHandler);
	                _.$nextArrow.on('keydown.slick', _.keyHandler);
	            }
	        }
	
	    };
	
	    Slick.prototype.initDotEvents = function() {
	
	        var _ = this;
	
	        if (_.options.dots === true && _.slideCount > _.options.slidesToShow) {
	            $('li', _.$dots).on('click.slick', {
	                message: 'index'
	            }, _.changeSlide);
	
	            if (_.options.accessibility === true) {
	                _.$dots.on('keydown.slick', _.keyHandler);
	            }
	        }
	
	        if (_.options.dots === true && _.options.pauseOnDotsHover === true && _.slideCount > _.options.slidesToShow) {
	
	            $('li', _.$dots)
	                .on('mouseenter.slick', $.proxy(_.interrupt, _, true))
	                .on('mouseleave.slick', $.proxy(_.interrupt, _, false));
	
	        }
	
	    };
	
	    Slick.prototype.initSlideEvents = function() {
	
	        var _ = this;
	
	        if ( _.options.pauseOnHover ) {
	
	            _.$list.on('mouseenter.slick', $.proxy(_.interrupt, _, true));
	            _.$list.on('mouseleave.slick', $.proxy(_.interrupt, _, false));
	
	        }
	
	    };
	
	    Slick.prototype.initializeEvents = function() {
	
	        var _ = this;
	
	        _.initArrowEvents();
	
	        _.initDotEvents();
	        _.initSlideEvents();
	
	        _.$list.on('touchstart.slick mousedown.slick', {
	            action: 'start'
	        }, _.swipeHandler);
	        _.$list.on('touchmove.slick mousemove.slick', {
	            action: 'move'
	        }, _.swipeHandler);
	        _.$list.on('touchend.slick mouseup.slick', {
	            action: 'end'
	        }, _.swipeHandler);
	        _.$list.on('touchcancel.slick mouseleave.slick', {
	            action: 'end'
	        }, _.swipeHandler);
	
	        _.$list.on('click.slick', _.clickHandler);
	
	        $(document).on(_.visibilityChange, $.proxy(_.visibility, _));
	
	        if (_.options.accessibility === true) {
	            _.$list.on('keydown.slick', _.keyHandler);
	        }
	
	        if (_.options.focusOnSelect === true) {
	            $(_.$slideTrack).children().on('click.slick', _.selectHandler);
	        }
	
	        $(window).on('orientationchange.slick.slick-' + _.instanceUid, $.proxy(_.orientationChange, _));
	
	        $(window).on('resize.slick.slick-' + _.instanceUid, $.proxy(_.resize, _));
	
	        $('[draggable!=true]', _.$slideTrack).on('dragstart', _.preventDefault);
	
	        $(window).on('load.slick.slick-' + _.instanceUid, _.setPosition);
	        $(_.setPosition);
	
	    };
	
	    Slick.prototype.initUI = function() {
	
	        var _ = this;
	
	        if (_.options.arrows === true && _.slideCount > _.options.slidesToShow) {
	
	            _.$prevArrow.show();
	            _.$nextArrow.show();
	
	        }
	
	        if (_.options.dots === true && _.slideCount > _.options.slidesToShow) {
	
	            _.$dots.show();
	
	        }
	
	    };
	
	    Slick.prototype.keyHandler = function(event) {
	
	        var _ = this;
	         //Dont slide if the cursor is inside the form fields and arrow keys are pressed
	        if(!event.target.tagName.match('TEXTAREA|INPUT|SELECT')) {
	            if (event.keyCode === 37 && _.options.accessibility === true) {
	                _.changeSlide({
	                    data: {
	                        message: _.options.rtl === true ? 'next' :  'previous'
	                    }
	                });
	            } else if (event.keyCode === 39 && _.options.accessibility === true) {
	                _.changeSlide({
	                    data: {
	                        message: _.options.rtl === true ? 'previous' : 'next'
	                    }
	                });
	            }
	        }
	
	    };
	
	    Slick.prototype.lazyLoad = function() {
	
	        var _ = this,
	            loadRange, cloneRange, rangeStart, rangeEnd;
	
	        function loadImages(imagesScope) {
	
	            $('img[data-lazy]', imagesScope).each(function() {
	
	                var image = $(this),
	                    imageSource = $(this).attr('data-lazy'),
	                    imageSrcSet = $(this).attr('data-srcset'),
	                    imageSizes  = $(this).attr('data-sizes') || _.$slider.attr('data-sizes'),
	                    imageToLoad = document.createElement('img');
	
	                imageToLoad.onload = function() {
	
	                    image
	                        .animate({ opacity: 0 }, 100, function() {
	
	                            if (imageSrcSet) {
	                                image
	                                    .attr('srcset', imageSrcSet );
	
	                                if (imageSizes) {
	                                    image
	                                        .attr('sizes', imageSizes );
	                                }
	                            }
	
	                            image
	                                .attr('src', imageSource)
	                                .animate({ opacity: 1 }, 200, function() {
	                                    image
	                                        .removeAttr('data-lazy data-srcset data-sizes')
	                                        .removeClass('slick-loading');
	                                });
	                            _.$slider.trigger('lazyLoaded', [_, image, imageSource]);
	                        });
	
	                };
	
	                imageToLoad.onerror = function() {
	
	                    image
	                        .removeAttr( 'data-lazy' )
	                        .removeClass( 'slick-loading' )
	                        .addClass( 'slick-lazyload-error' );
	
	                    _.$slider.trigger('lazyLoadError', [ _, image, imageSource ]);
	
	                };
	
	                imageToLoad.src = imageSource;
	
	            });
	
	        }
	
	        if (_.options.centerMode === true) {
	            if (_.options.infinite === true) {
	                rangeStart = _.currentSlide + (_.options.slidesToShow / 2 + 1);
	                rangeEnd = rangeStart + _.options.slidesToShow + 2;
	            } else {
	                rangeStart = Math.max(0, _.currentSlide - (_.options.slidesToShow / 2 + 1));
	                rangeEnd = 2 + (_.options.slidesToShow / 2 + 1) + _.currentSlide;
	            }
	        } else {
	            rangeStart = _.options.infinite ? _.options.slidesToShow + _.currentSlide : _.currentSlide;
	            rangeEnd = Math.ceil(rangeStart + _.options.slidesToShow);
	            if (_.options.fade === true) {
	                if (rangeStart > 0) rangeStart--;
	                if (rangeEnd <= _.slideCount) rangeEnd++;
	            }
	        }
	
	        loadRange = _.$slider.find('.slick-slide').slice(rangeStart, rangeEnd);
	
	        if (_.options.lazyLoad === 'anticipated') {
	            var prevSlide = rangeStart - 1,
	                nextSlide = rangeEnd,
	                $slides = _.$slider.find('.slick-slide');
	
	            for (var i = 0; i < _.options.slidesToScroll; i++) {
	                if (prevSlide < 0) prevSlide = _.slideCount - 1;
	                loadRange = loadRange.add($slides.eq(prevSlide));
	                loadRange = loadRange.add($slides.eq(nextSlide));
	                prevSlide--;
	                nextSlide++;
	            }
	        }
	
	        loadImages(loadRange);
	
	        if (_.slideCount <= _.options.slidesToShow) {
	            cloneRange = _.$slider.find('.slick-slide');
	            loadImages(cloneRange);
	        } else
	        if (_.currentSlide >= _.slideCount - _.options.slidesToShow) {
	            cloneRange = _.$slider.find('.slick-cloned').slice(0, _.options.slidesToShow);
	            loadImages(cloneRange);
	        } else if (_.currentSlide === 0) {
	            cloneRange = _.$slider.find('.slick-cloned').slice(_.options.slidesToShow * -1);
	            loadImages(cloneRange);
	        }
	
	    };
	
	    Slick.prototype.loadSlider = function() {
	
	        var _ = this;
	
	        _.setPosition();
	
	        _.$slideTrack.css({
	            opacity: 1
	        });
	
	        _.$slider.removeClass('slick-loading');
	
	        _.initUI();
	
	        if (_.options.lazyLoad === 'progressive') {
	            _.progressiveLazyLoad();
	        }
	
	    };
	
	    Slick.prototype.next = Slick.prototype.slickNext = function() {
	
	        var _ = this;
	
	        _.changeSlide({
	            data: {
	                message: 'next'
	            }
	        });
	
	    };
	
	    Slick.prototype.orientationChange = function() {
	
	        var _ = this;
	
	        _.checkResponsive();
	        _.setPosition();
	
	    };
	
	    Slick.prototype.pause = Slick.prototype.slickPause = function() {
	
	        var _ = this;
	
	        _.autoPlayClear();
	        _.paused = true;
	
	    };
	
	    Slick.prototype.play = Slick.prototype.slickPlay = function() {
	
	        var _ = this;
	
	        _.autoPlay();
	        _.options.autoplay = true;
	        _.paused = false;
	        _.focussed = false;
	        _.interrupted = false;
	
	    };
	
	    Slick.prototype.postSlide = function(index) {
	
	        var _ = this;
	
	        if( !_.unslicked ) {
	
	            _.$slider.trigger('afterChange', [_, index]);
	
	            _.animating = false;
	
	            if (_.slideCount > _.options.slidesToShow) {
	                _.setPosition();
	            }
	
	            _.swipeLeft = null;
	
	            if ( _.options.autoplay ) {
	                _.autoPlay();
	            }
	
	            if (_.options.accessibility === true) {
	                _.initADA();
	
	                if (_.options.focusOnChange) {
	                    var $currentSlide = $(_.$slides.get(_.currentSlide));
	                    $currentSlide.attr('tabindex', 0).focus();
	                }
	            }
	
	        }
	
	    };
	
	    Slick.prototype.prev = Slick.prototype.slickPrev = function() {
	
	        var _ = this;
	
	        _.changeSlide({
	            data: {
	                message: 'previous'
	            }
	        });
	
	    };
	
	    Slick.prototype.preventDefault = function(event) {
	
	        event.preventDefault();
	
	    };
	
	    Slick.prototype.progressiveLazyLoad = function( tryCount ) {
	
	        tryCount = tryCount || 1;
	
	        var _ = this,
	            $imgsToLoad = $( 'img[data-lazy]', _.$slider ),
	            image,
	            imageSource,
	            imageSrcSet,
	            imageSizes,
	            imageToLoad;
	
	        if ( $imgsToLoad.length ) {
	
	            image = $imgsToLoad.first();
	            imageSource = image.attr('data-lazy');
	            imageSrcSet = image.attr('data-srcset');
	            imageSizes  = image.attr('data-sizes') || _.$slider.attr('data-sizes');
	            imageToLoad = document.createElement('img');
	
	            imageToLoad.onload = function() {
	
	                if (imageSrcSet) {
	                    image
	                        .attr('srcset', imageSrcSet );
	
	                    if (imageSizes) {
	                        image
	                            .attr('sizes', imageSizes );
	                    }
	                }
	
	                image
	                    .attr( 'src', imageSource )
	                    .removeAttr('data-lazy data-srcset data-sizes')
	                    .removeClass('slick-loading');
	
	                if ( _.options.adaptiveHeight === true ) {
	                    _.setPosition();
	                }
	
	                _.$slider.trigger('lazyLoaded', [ _, image, imageSource ]);
	                _.progressiveLazyLoad();
	
	            };
	
	            imageToLoad.onerror = function() {
	
	                if ( tryCount < 3 ) {
	
	                    /**
	                     * try to load the image 3 times,
	                     * leave a slight delay so we don't get
	                     * servers blocking the request.
	                     */
	                    setTimeout( function() {
	                        _.progressiveLazyLoad( tryCount + 1 );
	                    }, 500 );
	
	                } else {
	
	                    image
	                        .removeAttr( 'data-lazy' )
	                        .removeClass( 'slick-loading' )
	                        .addClass( 'slick-lazyload-error' );
	
	                    _.$slider.trigger('lazyLoadError', [ _, image, imageSource ]);
	
	                    _.progressiveLazyLoad();
	
	                }
	
	            };
	
	            imageToLoad.src = imageSource;
	
	        } else {
	
	            _.$slider.trigger('allImagesLoaded', [ _ ]);
	
	        }
	
	    };
	
	    Slick.prototype.refresh = function( initializing ) {
	
	        var _ = this, currentSlide, lastVisibleIndex;
	
	        lastVisibleIndex = _.slideCount - _.options.slidesToShow;
	
	        // in non-infinite sliders, we don't want to go past the
	        // last visible index.
	        if( !_.options.infinite && ( _.currentSlide > lastVisibleIndex )) {
	            _.currentSlide = lastVisibleIndex;
	        }
	
	        // if less slides than to show, go to start.
	        if ( _.slideCount <= _.options.slidesToShow ) {
	            _.currentSlide = 0;
	
	        }
	
	        currentSlide = _.currentSlide;
	
	        _.destroy(true);
	
	        $.extend(_, _.initials, { currentSlide: currentSlide });
	
	        _.init();
	
	        if( !initializing ) {
	
	            _.changeSlide({
	                data: {
	                    message: 'index',
	                    index: currentSlide
	                }
	            }, false);
	
	        }
	
	    };
	
	    Slick.prototype.registerBreakpoints = function() {
	
	        var _ = this, breakpoint, currentBreakpoint, l,
	            responsiveSettings = _.options.responsive || null;
	
	        if ( $.type(responsiveSettings) === 'array' && responsiveSettings.length ) {
	
	            _.respondTo = _.options.respondTo || 'window';
	
	            for ( breakpoint in responsiveSettings ) {
	
	                l = _.breakpoints.length-1;
	
	                if (responsiveSettings.hasOwnProperty(breakpoint)) {
	                    currentBreakpoint = responsiveSettings[breakpoint].breakpoint;
	
	                    // loop through the breakpoints and cut out any existing
	                    // ones with the same breakpoint number, we don't want dupes.
	                    while( l >= 0 ) {
	                        if( _.breakpoints[l] && _.breakpoints[l] === currentBreakpoint ) {
	                            _.breakpoints.splice(l,1);
	                        }
	                        l--;
	                    }
	
	                    _.breakpoints.push(currentBreakpoint);
	                    _.breakpointSettings[currentBreakpoint] = responsiveSettings[breakpoint].settings;
	
	                }
	
	            }
	
	            _.breakpoints.sort(function(a, b) {
	                return ( _.options.mobileFirst ) ? a-b : b-a;
	            });
	
	        }
	
	    };
	
	    Slick.prototype.reinit = function() {
	
	        var _ = this;
	
	        _.$slides =
	            _.$slideTrack
	                .children(_.options.slide)
	                .addClass('slick-slide');
	
	        _.slideCount = _.$slides.length;
	
	        if (_.currentSlide >= _.slideCount && _.currentSlide !== 0) {
	            _.currentSlide = _.currentSlide - _.options.slidesToScroll;
	        }
	
	        if (_.slideCount <= _.options.slidesToShow) {
	            _.currentSlide = 0;
	        }
	
	        _.registerBreakpoints();
	
	        _.setProps();
	        _.setupInfinite();
	        _.buildArrows();
	        _.updateArrows();
	        _.initArrowEvents();
	        _.buildDots();
	        _.updateDots();
	        _.initDotEvents();
	        _.cleanUpSlideEvents();
	        _.initSlideEvents();
	
	        _.checkResponsive(false, true);
	
	        if (_.options.focusOnSelect === true) {
	            $(_.$slideTrack).children().on('click.slick', _.selectHandler);
	        }
	
	        _.setSlideClasses(typeof _.currentSlide === 'number' ? _.currentSlide : 0);
	
	        _.setPosition();
	        _.focusHandler();
	
	        _.paused = !_.options.autoplay;
	        _.autoPlay();
	
	        _.$slider.trigger('reInit', [_]);
	
	    };
	
	    Slick.prototype.resize = function() {
	
	        var _ = this;
	
	        if ($(window).width() !== _.windowWidth) {
	            clearTimeout(_.windowDelay);
	            _.windowDelay = window.setTimeout(function() {
	                _.windowWidth = $(window).width();
	                _.checkResponsive();
	                if( !_.unslicked ) { _.setPosition(); }
	            }, 50);
	        }
	    };
	
	    Slick.prototype.removeSlide = Slick.prototype.slickRemove = function(index, removeBefore, removeAll) {
	
	        var _ = this;
	
	        if (typeof(index) === 'boolean') {
	            removeBefore = index;
	            index = removeBefore === true ? 0 : _.slideCount - 1;
	        } else {
	            index = removeBefore === true ? --index : index;
	        }
	
	        if (_.slideCount < 1 || index < 0 || index > _.slideCount - 1) {
	            return false;
	        }
	
	        _.unload();
	
	        if (removeAll === true) {
	            _.$slideTrack.children().remove();
	        } else {
	            _.$slideTrack.children(this.options.slide).eq(index).remove();
	        }
	
	        _.$slides = _.$slideTrack.children(this.options.slide);
	
	        _.$slideTrack.children(this.options.slide).detach();
	
	        _.$slideTrack.append(_.$slides);
	
	        _.$slidesCache = _.$slides;
	
	        _.reinit();
	
	    };
	
	    Slick.prototype.setCSS = function(position) {
	
	        var _ = this,
	            positionProps = {},
	            x, y;
	
	        if (_.options.rtl === true) {
	            position = -position;
	        }
	        x = _.positionProp == 'left' ? Math.ceil(position) + 'px' : '0px';
	        y = _.positionProp == 'top' ? Math.ceil(position) + 'px' : '0px';
	
	        positionProps[_.positionProp] = position;
	
	        if (_.transformsEnabled === false) {
	            _.$slideTrack.css(positionProps);
	        } else {
	            positionProps = {};
	            if (_.cssTransitions === false) {
	                positionProps[_.animType] = 'translate(' + x + ', ' + y + ')';
	                _.$slideTrack.css(positionProps);
	            } else {
	                positionProps[_.animType] = 'translate3d(' + x + ', ' + y + ', 0px)';
	                _.$slideTrack.css(positionProps);
	            }
	        }
	
	    };
	
	    Slick.prototype.setDimensions = function() {
	
	        var _ = this;
	
	        if (_.options.vertical === false) {
	            if (_.options.centerMode === true) {
	                _.$list.css({
	                    padding: ('0px ' + _.options.centerPadding)
	                });
	            }
	        } else {
	            _.$list.height(_.$slides.first().outerHeight(true) * _.options.slidesToShow);
	            if (_.options.centerMode === true) {
	                _.$list.css({
	                    padding: (_.options.centerPadding + ' 0px')
	                });
	            }
	        }
	
	        _.listWidth = _.$list.width();
	        _.listHeight = _.$list.height();
	
	
	        if (_.options.vertical === false && _.options.variableWidth === false) {
	            _.slideWidth = Math.ceil(_.listWidth / _.options.slidesToShow);
	            _.$slideTrack.width(Math.ceil((_.slideWidth * _.$slideTrack.children('.slick-slide').length)));
	
	        } else if (_.options.variableWidth === true) {
	            _.$slideTrack.width(5000 * _.slideCount);
	        } else {
	            _.slideWidth = Math.ceil(_.listWidth);
	            _.$slideTrack.height(Math.ceil((_.$slides.first().outerHeight(true) * _.$slideTrack.children('.slick-slide').length)));
	        }
	
	        var offset = _.$slides.first().outerWidth(true) - _.$slides.first().width();
	        if (_.options.variableWidth === false) _.$slideTrack.children('.slick-slide').width(_.slideWidth - offset);
	
	    };
	
	    Slick.prototype.setFade = function() {
	
	        var _ = this,
	            targetLeft;
	
	        _.$slides.each(function(index, element) {
	            targetLeft = (_.slideWidth * index) * -1;
	            if (_.options.rtl === true) {
	                $(element).css({
	                    position: 'relative',
	                    right: targetLeft,
	                    top: 0,
	                    zIndex: _.options.zIndex - 2,
	                    opacity: 0
	                });
	            } else {
	                $(element).css({
	                    position: 'relative',
	                    left: targetLeft,
	                    top: 0,
	                    zIndex: _.options.zIndex - 2,
	                    opacity: 0
	                });
	            }
	        });
	
	        _.$slides.eq(_.currentSlide).css({
	            zIndex: _.options.zIndex - 1,
	            opacity: 1
	        });
	
	    };
	
	    Slick.prototype.setHeight = function() {
	
	        var _ = this;
	
	        if (_.options.slidesToShow === 1 && _.options.adaptiveHeight === true && _.options.vertical === false) {
	            var targetHeight = _.$slides.eq(_.currentSlide).outerHeight(true);
	            _.$list.css('height', targetHeight);
	        }
	
	    };
	
	    Slick.prototype.setOption =
	    Slick.prototype.slickSetOption = function() {
	
	        /**
	         * accepts arguments in format of:
	         *
	         *  - for changing a single option's value:
	         *     .slick("setOption", option, value, refresh )
	         *
	         *  - for changing a set of responsive options:
	         *     .slick("setOption", 'responsive', [{}, ...], refresh )
	         *
	         *  - for updating multiple values at once (not responsive)
	         *     .slick("setOption", { 'option': value, ... }, refresh )
	         */
	
	        var _ = this, l, item, option, value, refresh = false, type;
	
	        if( $.type( arguments[0] ) === 'object' ) {
	
	            option =  arguments[0];
	            refresh = arguments[1];
	            type = 'multiple';
	
	        } else if ( $.type( arguments[0] ) === 'string' ) {
	
	            option =  arguments[0];
	            value = arguments[1];
	            refresh = arguments[2];
	
	            if ( arguments[0] === 'responsive' && $.type( arguments[1] ) === 'array' ) {
	
	                type = 'responsive';
	
	            } else if ( typeof arguments[1] !== 'undefined' ) {
	
	                type = 'single';
	
	            }
	
	        }
	
	        if ( type === 'single' ) {
	
	            _.options[option] = value;
	
	
	        } else if ( type === 'multiple' ) {
	
	            $.each( option , function( opt, val ) {
	
	                _.options[opt] = val;
	
	            });
	
	
	        } else if ( type === 'responsive' ) {
	
	            for ( item in value ) {
	
	                if( $.type( _.options.responsive ) !== 'array' ) {
	
	                    _.options.responsive = [ value[item] ];
	
	                } else {
	
	                    l = _.options.responsive.length-1;
	
	                    // loop through the responsive object and splice out duplicates.
	                    while( l >= 0 ) {
	
	                        if( _.options.responsive[l].breakpoint === value[item].breakpoint ) {
	
	                            _.options.responsive.splice(l,1);
	
	                        }
	
	                        l--;
	
	                    }
	
	                    _.options.responsive.push( value[item] );
	
	                }
	
	            }
	
	        }
	
	        if ( refresh ) {
	
	            _.unload();
	            _.reinit();
	
	        }
	
	    };
	
	    Slick.prototype.setPosition = function() {
	
	        var _ = this;
	
	        _.setDimensions();
	
	        _.setHeight();
	
	        if (_.options.fade === false) {
	            _.setCSS(_.getLeft(_.currentSlide));
	        } else {
	            _.setFade();
	        }
	
	        _.$slider.trigger('setPosition', [_]);
	
	    };
	
	    Slick.prototype.setProps = function() {
	
	        var _ = this,
	            bodyStyle = document.body.style;
	
	        _.positionProp = _.options.vertical === true ? 'top' : 'left';
	
	        if (_.positionProp === 'top') {
	            _.$slider.addClass('slick-vertical');
	        } else {
	            _.$slider.removeClass('slick-vertical');
	        }
	
	        if (bodyStyle.WebkitTransition !== undefined ||
	            bodyStyle.MozTransition !== undefined ||
	            bodyStyle.msTransition !== undefined) {
	            if (_.options.useCSS === true) {
	                _.cssTransitions = true;
	            }
	        }
	
	        if ( _.options.fade ) {
	            if ( typeof _.options.zIndex === 'number' ) {
	                if( _.options.zIndex < 3 ) {
	                    _.options.zIndex = 3;
	                }
	            } else {
	                _.options.zIndex = _.defaults.zIndex;
	            }
	        }
	
	        if (bodyStyle.OTransform !== undefined) {
	            _.animType = 'OTransform';
	            _.transformType = '-o-transform';
	            _.transitionType = 'OTransition';
	            if (bodyStyle.perspectiveProperty === undefined && bodyStyle.webkitPerspective === undefined) _.animType = false;
	        }
	        if (bodyStyle.MozTransform !== undefined) {
	            _.animType = 'MozTransform';
	            _.transformType = '-moz-transform';
	            _.transitionType = 'MozTransition';
	            if (bodyStyle.perspectiveProperty === undefined && bodyStyle.MozPerspective === undefined) _.animType = false;
	        }
	        if (bodyStyle.webkitTransform !== undefined) {
	            _.animType = 'webkitTransform';
	            _.transformType = '-webkit-transform';
	            _.transitionType = 'webkitTransition';
	            if (bodyStyle.perspectiveProperty === undefined && bodyStyle.webkitPerspective === undefined) _.animType = false;
	        }
	        if (bodyStyle.msTransform !== undefined) {
	            _.animType = 'msTransform';
	            _.transformType = '-ms-transform';
	            _.transitionType = 'msTransition';
	            if (bodyStyle.msTransform === undefined) _.animType = false;
	        }
	        if (bodyStyle.transform !== undefined && _.animType !== false) {
	            _.animType = 'transform';
	            _.transformType = 'transform';
	            _.transitionType = 'transition';
	        }
	        _.transformsEnabled = _.options.useTransform && (_.animType !== null && _.animType !== false);
	    };
	
	
	    Slick.prototype.setSlideClasses = function(index) {
	
	        var _ = this,
	            centerOffset, allSlides, indexOffset, remainder;
	
	        allSlides = _.$slider
	            .find('.slick-slide')
	            .removeClass('slick-active slick-center slick-current')
	            .attr('aria-hidden', 'true');
	
	        _.$slides
	            .eq(index)
	            .addClass('slick-current');
	
	        if (_.options.centerMode === true) {
	
	            var evenCoef = _.options.slidesToShow % 2 === 0 ? 1 : 0;
	
	            centerOffset = Math.floor(_.options.slidesToShow / 2);
	
	            if (_.options.infinite === true) {
	
	                if (index >= centerOffset && index <= (_.slideCount - 1) - centerOffset) {
	                    _.$slides
	                        .slice(index - centerOffset + evenCoef, index + centerOffset + 1)
	                        .addClass('slick-active')
	                        .attr('aria-hidden', 'false');
	
	                } else {
	
	                    indexOffset = _.options.slidesToShow + index;
	                    allSlides
	                        .slice(indexOffset - centerOffset + 1 + evenCoef, indexOffset + centerOffset + 2)
	                        .addClass('slick-active')
	                        .attr('aria-hidden', 'false');
	
	                }
	
	                if (index === 0) {
	
	                    allSlides
	                        .eq(allSlides.length - 1 - _.options.slidesToShow)
	                        .addClass('slick-center');
	
	                } else if (index === _.slideCount - 1) {
	
	                    allSlides
	                        .eq(_.options.slidesToShow)
	                        .addClass('slick-center');
	
	                }
	
	            }
	
	            _.$slides
	                .eq(index)
	                .addClass('slick-center');
	
	        } else {
	
	            if (index >= 0 && index <= (_.slideCount - _.options.slidesToShow)) {
	
	                _.$slides
	                    .slice(index, index + _.options.slidesToShow)
	                    .addClass('slick-active')
	                    .attr('aria-hidden', 'false');
	
	            } else if (allSlides.length <= _.options.slidesToShow) {
	
	                allSlides
	                    .addClass('slick-active')
	                    .attr('aria-hidden', 'false');
	
	            } else {
	
	                remainder = _.slideCount % _.options.slidesToShow;
	                indexOffset = _.options.infinite === true ? _.options.slidesToShow + index : index;
	
	                if (_.options.slidesToShow == _.options.slidesToScroll && (_.slideCount - index) < _.options.slidesToShow) {
	
	                    allSlides
	                        .slice(indexOffset - (_.options.slidesToShow - remainder), indexOffset + remainder)
	                        .addClass('slick-active')
	                        .attr('aria-hidden', 'false');
	
	                } else {
	
	                    allSlides
	                        .slice(indexOffset, indexOffset + _.options.slidesToShow)
	                        .addClass('slick-active')
	                        .attr('aria-hidden', 'false');
	
	                }
	
	            }
	
	        }
	
	        if (_.options.lazyLoad === 'ondemand' || _.options.lazyLoad === 'anticipated') {
	            _.lazyLoad();
	        }
	    };
	
	    Slick.prototype.setupInfinite = function() {
	
	        var _ = this,
	            i, slideIndex, infiniteCount;
	
	        if (_.options.fade === true) {
	            _.options.centerMode = false;
	        }
	
	        if (_.options.infinite === true && _.options.fade === false) {
	
	            slideIndex = null;
	
	            if (_.slideCount > _.options.slidesToShow) {
	
	                if (_.options.centerMode === true) {
	                    infiniteCount = _.options.slidesToShow + 1;
	                } else {
	                    infiniteCount = _.options.slidesToShow;
	                }
	
	                for (i = _.slideCount; i > (_.slideCount -
	                        infiniteCount); i -= 1) {
	                    slideIndex = i - 1;
	                    $(_.$slides[slideIndex]).clone(true).attr('id', '')
	                        .attr('data-slick-index', slideIndex - _.slideCount)
	                        .prependTo(_.$slideTrack).addClass('slick-cloned');
	                }
	                for (i = 0; i < infiniteCount  + _.slideCount; i += 1) {
	                    slideIndex = i;
	                    $(_.$slides[slideIndex]).clone(true).attr('id', '')
	                        .attr('data-slick-index', slideIndex + _.slideCount)
	                        .appendTo(_.$slideTrack).addClass('slick-cloned');
	                }
	                _.$slideTrack.find('.slick-cloned').find('[id]').each(function() {
	                    $(this).attr('id', '');
	                });
	
	            }
	
	        }
	
	    };
	
	    Slick.prototype.interrupt = function( toggle ) {
	
	        var _ = this;
	
	        if( !toggle ) {
	            _.autoPlay();
	        }
	        _.interrupted = toggle;
	
	    };
	
	    Slick.prototype.selectHandler = function(event) {
	
	        var _ = this;
	
	        var targetElement =
	            $(event.target).is('.slick-slide') ?
	                $(event.target) :
	                $(event.target).parents('.slick-slide');
	
	        var index = parseInt(targetElement.attr('data-slick-index'));
	
	        if (!index) index = 0;
	
	        if (_.slideCount <= _.options.slidesToShow) {
	
	            _.slideHandler(index, false, true);
	            return;
	
	        }
	
	        _.slideHandler(index);
	
	    };
	
	    Slick.prototype.slideHandler = function(index, sync, dontAnimate) {
	
	        var targetSlide, animSlide, oldSlide, slideLeft, targetLeft = null,
	            _ = this, navTarget;
	
	        sync = sync || false;
	
	        if (_.animating === true && _.options.waitForAnimate === true) {
	            return;
	        }
	
	        if (_.options.fade === true && _.currentSlide === index) {
	            return;
	        }
	
	        if (sync === false) {
	            _.asNavFor(index);
	        }
	
	        targetSlide = index;
	        targetLeft = _.getLeft(targetSlide);
	        slideLeft = _.getLeft(_.currentSlide);
	
	        _.currentLeft = _.swipeLeft === null ? slideLeft : _.swipeLeft;
	
	        if (_.options.infinite === false && _.options.centerMode === false && (index < 0 || index > _.getDotCount() * _.options.slidesToScroll)) {
	            if (_.options.fade === false) {
	                targetSlide = _.currentSlide;
	                if (dontAnimate !== true && _.slideCount > _.options.slidesToShow) {
	                    _.animateSlide(slideLeft, function() {
	                        _.postSlide(targetSlide);
	                    });
	                } else {
	                    _.postSlide(targetSlide);
	                }
	            }
	            return;
	        } else if (_.options.infinite === false && _.options.centerMode === true && (index < 0 || index > (_.slideCount - _.options.slidesToScroll))) {
	            if (_.options.fade === false) {
	                targetSlide = _.currentSlide;
	                if (dontAnimate !== true && _.slideCount > _.options.slidesToShow) {
	                    _.animateSlide(slideLeft, function() {
	                        _.postSlide(targetSlide);
	                    });
	                } else {
	                    _.postSlide(targetSlide);
	                }
	            }
	            return;
	        }
	
	        if ( _.options.autoplay ) {
	            clearInterval(_.autoPlayTimer);
	        }
	
	        if (targetSlide < 0) {
	            if (_.slideCount % _.options.slidesToScroll !== 0) {
	                animSlide = _.slideCount - (_.slideCount % _.options.slidesToScroll);
	            } else {
	                animSlide = _.slideCount + targetSlide;
	            }
	        } else if (targetSlide >= _.slideCount) {
	            if (_.slideCount % _.options.slidesToScroll !== 0) {
	                animSlide = 0;
	            } else {
	                animSlide = targetSlide - _.slideCount;
	            }
	        } else {
	            animSlide = targetSlide;
	        }
	
	        _.animating = true;
	
	        _.$slider.trigger('beforeChange', [_, _.currentSlide, animSlide]);
	
	        oldSlide = _.currentSlide;
	        _.currentSlide = animSlide;
	
	        _.setSlideClasses(_.currentSlide);
	
	        if ( _.options.asNavFor ) {
	
	            navTarget = _.getNavTarget();
	            navTarget = navTarget.slick('getSlick');
	
	            if ( navTarget.slideCount <= navTarget.options.slidesToShow ) {
	                navTarget.setSlideClasses(_.currentSlide);
	            }
	
	        }
	
	        _.updateDots();
	        _.updateArrows();
	
	        if (_.options.fade === true) {
	            if (dontAnimate !== true) {
	
	                _.fadeSlideOut(oldSlide);
	
	                _.fadeSlide(animSlide, function() {
	                    _.postSlide(animSlide);
	                });
	
	            } else {
	                _.postSlide(animSlide);
	            }
	            _.animateHeight();
	            return;
	        }
	
	        if (dontAnimate !== true && _.slideCount > _.options.slidesToShow) {
	            _.animateSlide(targetLeft, function() {
	                _.postSlide(animSlide);
	            });
	        } else {
	            _.postSlide(animSlide);
	        }
	
	    };
	
	    Slick.prototype.startLoad = function() {
	
	        var _ = this;
	
	        if (_.options.arrows === true && _.slideCount > _.options.slidesToShow) {
	
	            _.$prevArrow.hide();
	            _.$nextArrow.hide();
	
	        }
	
	        if (_.options.dots === true && _.slideCount > _.options.slidesToShow) {
	
	            _.$dots.hide();
	
	        }
	
	        _.$slider.addClass('slick-loading');
	
	    };
	
	    Slick.prototype.swipeDirection = function() {
	
	        var xDist, yDist, r, swipeAngle, _ = this;
	
	        xDist = _.touchObject.startX - _.touchObject.curX;
	        yDist = _.touchObject.startY - _.touchObject.curY;
	        r = Math.atan2(yDist, xDist);
	
	        swipeAngle = Math.round(r * 180 / Math.PI);
	        if (swipeAngle < 0) {
	            swipeAngle = 360 - Math.abs(swipeAngle);
	        }
	
	        if ((swipeAngle <= 45) && (swipeAngle >= 0)) {
	            return (_.options.rtl === false ? 'left' : 'right');
	        }
	        if ((swipeAngle <= 360) && (swipeAngle >= 315)) {
	            return (_.options.rtl === false ? 'left' : 'right');
	        }
	        if ((swipeAngle >= 135) && (swipeAngle <= 225)) {
	            return (_.options.rtl === false ? 'right' : 'left');
	        }
	        if (_.options.verticalSwiping === true) {
	            if ((swipeAngle >= 35) && (swipeAngle <= 135)) {
	                return 'down';
	            } else {
	                return 'up';
	            }
	        }
	
	        return 'vertical';
	
	    };
	
	    Slick.prototype.swipeEnd = function(event) {
	
	        var _ = this,
	            slideCount,
	            direction;
	
	        _.dragging = false;
	        _.swiping = false;
	
	        if (_.scrolling) {
	            _.scrolling = false;
	            return false;
	        }
	
	        _.interrupted = false;
	        _.shouldClick = ( _.touchObject.swipeLength > 10 ) ? false : true;
	
	        if ( _.touchObject.curX === undefined ) {
	            return false;
	        }
	
	        if ( _.touchObject.edgeHit === true ) {
	            _.$slider.trigger('edge', [_, _.swipeDirection() ]);
	        }
	
	        if ( _.touchObject.swipeLength >= _.touchObject.minSwipe ) {
	
	            direction = _.swipeDirection();
	
	            switch ( direction ) {
	
	                case 'left':
	                case 'down':
	
	                    slideCount =
	                        _.options.swipeToSlide ?
	                            _.checkNavigable( _.currentSlide + _.getSlideCount() ) :
	                            _.currentSlide + _.getSlideCount();
	
	                    _.currentDirection = 0;
	
	                    break;
	
	                case 'right':
	                case 'up':
	
	                    slideCount =
	                        _.options.swipeToSlide ?
	                            _.checkNavigable( _.currentSlide - _.getSlideCount() ) :
	                            _.currentSlide - _.getSlideCount();
	
	                    _.currentDirection = 1;
	
	                    break;
	
	                default:
	
	
	            }
	
	            if( direction != 'vertical' ) {
	
	                _.slideHandler( slideCount );
	                _.touchObject = {};
	                _.$slider.trigger('swipe', [_, direction ]);
	
	            }
	
	        } else {
	
	            if ( _.touchObject.startX !== _.touchObject.curX ) {
	
	                _.slideHandler( _.currentSlide );
	                _.touchObject = {};
	
	            }
	
	        }
	
	    };
	
	    Slick.prototype.swipeHandler = function(event) {
	
	        var _ = this;
	
	        if ((_.options.swipe === false) || ('ontouchend' in document && _.options.swipe === false)) {
	            return;
	        } else if (_.options.draggable === false && event.type.indexOf('mouse') !== -1) {
	            return;
	        }
	
	        _.touchObject.fingerCount = event.originalEvent && event.originalEvent.touches !== undefined ?
	            event.originalEvent.touches.length : 1;
	
	        _.touchObject.minSwipe = _.listWidth / _.options
	            .touchThreshold;
	
	        if (_.options.verticalSwiping === true) {
	            _.touchObject.minSwipe = _.listHeight / _.options
	                .touchThreshold;
	        }
	
	        switch (event.data.action) {
	
	            case 'start':
	                _.swipeStart(event);
	                break;
	
	            case 'move':
	                _.swipeMove(event);
	                break;
	
	            case 'end':
	                _.swipeEnd(event);
	                break;
	
	        }
	
	    };
	
	    Slick.prototype.swipeMove = function(event) {
	
	        var _ = this,
	            edgeWasHit = false,
	            curLeft, swipeDirection, swipeLength, positionOffset, touches, verticalSwipeLength;
	
	        touches = event.originalEvent !== undefined ? event.originalEvent.touches : null;
	
	        if (!_.dragging || _.scrolling || touches && touches.length !== 1) {
	            return false;
	        }
	
	        curLeft = _.getLeft(_.currentSlide);
	
	        _.touchObject.curX = touches !== undefined ? touches[0].pageX : event.clientX;
	        _.touchObject.curY = touches !== undefined ? touches[0].pageY : event.clientY;
	
	        _.touchObject.swipeLength = Math.round(Math.sqrt(
	            Math.pow(_.touchObject.curX - _.touchObject.startX, 2)));
	
	        verticalSwipeLength = Math.round(Math.sqrt(
	            Math.pow(_.touchObject.curY - _.touchObject.startY, 2)));
	
	        if (!_.options.verticalSwiping && !_.swiping && verticalSwipeLength > 4) {
	            _.scrolling = true;
	            return false;
	        }
	
	        if (_.options.verticalSwiping === true) {
	            _.touchObject.swipeLength = verticalSwipeLength;
	        }
	
	        swipeDirection = _.swipeDirection();
	
	        if (event.originalEvent !== undefined && _.touchObject.swipeLength > 4) {
	            _.swiping = true;
	            event.preventDefault();
	        }
	
	        positionOffset = (_.options.rtl === false ? 1 : -1) * (_.touchObject.curX > _.touchObject.startX ? 1 : -1);
	        if (_.options.verticalSwiping === true) {
	            positionOffset = _.touchObject.curY > _.touchObject.startY ? 1 : -1;
	        }
	
	
	        swipeLength = _.touchObject.swipeLength;
	
	        _.touchObject.edgeHit = false;
	
	        if (_.options.infinite === false) {
	            if ((_.currentSlide === 0 && swipeDirection === 'right') || (_.currentSlide >= _.getDotCount() && swipeDirection === 'left')) {
	                swipeLength = _.touchObject.swipeLength * _.options.edgeFriction;
	                _.touchObject.edgeHit = true;
	            }
	        }
	
	        if (_.options.vertical === false) {
	            _.swipeLeft = curLeft + swipeLength * positionOffset;
	        } else {
	            _.swipeLeft = curLeft + (swipeLength * (_.$list.height() / _.listWidth)) * positionOffset;
	        }
	        if (_.options.verticalSwiping === true) {
	            _.swipeLeft = curLeft + swipeLength * positionOffset;
	        }
	
	        if (_.options.fade === true || _.options.touchMove === false) {
	            return false;
	        }
	
	        if (_.animating === true) {
	            _.swipeLeft = null;
	            return false;
	        }
	
	        _.setCSS(_.swipeLeft);
	
	    };
	
	    Slick.prototype.swipeStart = function(event) {
	
	        var _ = this,
	            touches;
	
	        _.interrupted = true;
	
	        if (_.touchObject.fingerCount !== 1 || _.slideCount <= _.options.slidesToShow) {
	            _.touchObject = {};
	            return false;
	        }
	
	        if (event.originalEvent !== undefined && event.originalEvent.touches !== undefined) {
	            touches = event.originalEvent.touches[0];
	        }
	
	        _.touchObject.startX = _.touchObject.curX = touches !== undefined ? touches.pageX : event.clientX;
	        _.touchObject.startY = _.touchObject.curY = touches !== undefined ? touches.pageY : event.clientY;
	
	        _.dragging = true;
	
	    };
	
	    Slick.prototype.unfilterSlides = Slick.prototype.slickUnfilter = function() {
	
	        var _ = this;
	
	        if (_.$slidesCache !== null) {
	
	            _.unload();
	
	            _.$slideTrack.children(this.options.slide).detach();
	
	            _.$slidesCache.appendTo(_.$slideTrack);
	
	            _.reinit();
	
	        }
	
	    };
	
	    Slick.prototype.unload = function() {
	
	        var _ = this;
	
	        $('.slick-cloned', _.$slider).remove();
	
	        if (_.$dots) {
	            _.$dots.remove();
	        }
	
	        if (_.$prevArrow && _.htmlExpr.test(_.options.prevArrow)) {
	            _.$prevArrow.remove();
	        }
	
	        if (_.$nextArrow && _.htmlExpr.test(_.options.nextArrow)) {
	            _.$nextArrow.remove();
	        }
	
	        _.$slides
	            .removeClass('slick-slide slick-active slick-visible slick-current')
	            .attr('aria-hidden', 'true')
	            .css('width', '');
	
	    };
	
	    Slick.prototype.unslick = function(fromBreakpoint) {
	
	        var _ = this;
	        _.$slider.trigger('unslick', [_, fromBreakpoint]);
	        _.destroy();
	
	    };
	
	    Slick.prototype.updateArrows = function() {
	
	        var _ = this,
	            centerOffset;
	
	        centerOffset = Math.floor(_.options.slidesToShow / 2);
	
	        if ( _.options.arrows === true &&
	            _.slideCount > _.options.slidesToShow &&
	            !_.options.infinite ) {
	
	            _.$prevArrow.removeClass('slick-disabled').attr('aria-disabled', 'false');
	            _.$nextArrow.removeClass('slick-disabled').attr('aria-disabled', 'false');
	
	            if (_.currentSlide === 0) {
	
	                _.$prevArrow.addClass('slick-disabled').attr('aria-disabled', 'true');
	                _.$nextArrow.removeClass('slick-disabled').attr('aria-disabled', 'false');
	
	            } else if (_.currentSlide >= _.slideCount - _.options.slidesToShow && _.options.centerMode === false) {
	
	                _.$nextArrow.addClass('slick-disabled').attr('aria-disabled', 'true');
	                _.$prevArrow.removeClass('slick-disabled').attr('aria-disabled', 'false');
	
	            } else if (_.currentSlide >= _.slideCount - 1 && _.options.centerMode === true) {
	
	                _.$nextArrow.addClass('slick-disabled').attr('aria-disabled', 'true');
	                _.$prevArrow.removeClass('slick-disabled').attr('aria-disabled', 'false');
	
	            }
	
	        }
	
	    };
	
	    Slick.prototype.updateDots = function() {
	
	        var _ = this;
	
	        if (_.$dots !== null) {
	
	            _.$dots
	                .find('li')
	                    .removeClass('slick-active')
	                    .end();
	
	            _.$dots
	                .find('li')
	                .eq(Math.floor(_.currentSlide / _.options.slidesToScroll))
	                .addClass('slick-active');
	
	        }
	
	    };
	
	    Slick.prototype.visibility = function() {
	
	        var _ = this;
	
	        if ( _.options.autoplay ) {
	
	            if ( document[_.hidden] ) {
	
	                _.interrupted = true;
	
	            } else {
	
	                _.interrupted = false;
	
	            }
	
	        }
	
	    };
	
	    $.fn.slick = function() {
	        var _ = this,
	            opt = arguments[0],
	            args = Array.prototype.slice.call(arguments, 1),
	            l = _.length,
	            i,
	            ret;
	        for (i = 0; i < l; i++) {
	            if (typeof opt == 'object' || typeof opt == 'undefined')
	                _[i].slick = new Slick(_[i], opt);
	            else
	                ret = _[i].slick[opt].apply(_[i].slick, args);
	            if (typeof ret != 'undefined') return ret;
	        }
	        return _;
	    };
	
	}));


/***/ }),

/***/ 330:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 331:
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(__webpack_provided_window_dot_jQuery, $) {'use strict';
	
	__webpack_require__(961);
	
	__webpack_provided_window_dot_jQuery = __webpack_require__(8);
	__webpack_require__(332);
	
	module.exports = function () {
	  $('.fancybox').fancybox();
	};
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(8), __webpack_require__(8)))

/***/ }),

/***/ 332:
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(__webpack_provided_window_dot_jQuery) {'use strict';
	
	// ==================================================
	// fancyBox v3.0.47
	//
	// Licensed GPLv3 for open source use
	// or fancyBox Commercial License for commercial use
	//
	// http://fancyapps.com/fancybox/
	// Copyright 2017 fancyApps
	//
	// ==================================================
	!function (t, e, n, o) {
	    'use strict';
	    function s(t) {
	        var e = t.currentTarget,
	            o = t.data ? t.data.options : {},
	            s = t.data ? t.data.items : [],
	            i = '',
	            a = 0;t.preventDefault(), t.stopPropagation(), n(e).attr('data-fancybox') && (i = n(e).data('fancybox')), i ? (s = s.length ? s.filter('[data-fancybox="' + i + '"]') : n('[data-fancybox=' + i + ']'), a = s.index(e)) : s = [e], n.fancybox.open(s, o, a);
	    }if (!n) return o;var i = { speed: 330, loop: !0, opacity: 'auto', margin: [44, 0], gutter: 30, infobar: !0, buttons: !0, slideShow: !0, fullScreen: !0, thumbs: !0, closeBtn: !0, smallBtn: 'auto', image: { preload: 'auto', protect: !1 }, ajax: { settings: { data: { fancybox: !0 } } }, iframe: { tpl: '<iframe id="fancybox-frame{rnd}" name="fancybox-frame{rnd}" class="fancybox-iframe" frameborder="0" vspace="0" hspace="0" webkitAllowFullScreen mozallowfullscreen allowFullScreen allowtransparency="true" src=""></iframe>', preload: !0, scrolling: 'no', css: {} }, baseClass: '', slideClass: '', baseTpl: '<div class="fancybox-container" role="dialog" tabindex="-1"><div class="fancybox-bg"></div><div class="fancybox-controls"><div class="fancybox-infobar"><button data-fancybox-previous class="fancybox-button fancybox-button--left" title="Previous"></button><div class="fancybox-infobar__body"><span class="js-fancybox-index"></span>&nbsp;/&nbsp;<span class="js-fancybox-count"></span></div><button data-fancybox-next class="fancybox-button fancybox-button--right" title="Next"></button></div><div class="fancybox-buttons"><button data-fancybox-close class="fancybox-button fancybox-button--close" title="Close (Esc)"></button></div></div><div class="fancybox-slider-wrap"><div class="fancybox-slider"></div></div><div class="fancybox-caption-wrap"><div class="fancybox-caption"></div></div></div>', spinnerTpl: '<div class="fancybox-loading"></div>', errorTpl: '<div class="fancybox-error"><p>The requested content cannot be loaded. <br /> Please try again later.<p></div>', closeTpl: '<button data-fancybox-close class="fancybox-close-small"></button>', parentEl: 'body', touch: !0, keyboard: !0, focus: !0, closeClickOutside: !0, beforeLoad: n.noop, afterLoad: n.noop, beforeMove: n.noop, afterMove: n.noop, onComplete: n.noop, onInit: n.noop, beforeClose: n.noop, afterClose: n.noop, onActivate: n.noop, onDeactivate: n.noop },
	        a = n(t),
	        r = n(e),
	        c = 0,
	        l = function l(t) {
	        return t && t.hasOwnProperty && t instanceof n;
	    },
	        u = function () {
	        return t.requestAnimationFrame || t.webkitRequestAnimationFrame || t.mozRequestAnimationFrame || function (e) {
	            t.setTimeout(e, 1e3 / 60);
	        };
	    }(),
	        d = function d(o) {
	        var s;return 'function' == typeof n && o instanceof n && (o = o[0]), s = o.getBoundingClientRect(), s.bottom > 0 && s.right > 0 && s.left < (t.innerWidth || e.documentElement.clientWidth) && s.top < (t.innerHeight || e.documentElement.clientHeight);
	    },
	        p = function p(t, o, s) {
	        var a = this;a.opts = n.extend(!0, { index: s }, i, o || {}), a.id = a.opts.id || ++c, a.group = [], a.currIndex = parseInt(a.opts.index, 10) || 0, a.prevIndex = null, a.prevPos = null, a.currPos = 0, a.firstRun = null, a.createGroup(t), a.group.length && (a.$lastFocus = n(e.activeElement).blur(), a.slides = {}, a.init(t));
	    };n.extend(p.prototype, { init: function init() {
	            var t,
	                e,
	                o = this,
	                s = !1;o.scrollTop = r.scrollTop(), o.scrollLeft = r.scrollLeft(), n.fancybox.getInstance() || (t = n('body').width(), n('html').addClass('fancybox-enabled'), n.fancybox.isTouch ? (n.each(o.group, function (t, e) {
	                if ('image' !== e.type && 'iframe' !== e.type) return s = !0, !1;
	            }), s && n('body').css({ position: 'fixed', width: t, top: o.scrollTop * -1 })) : (t = n('body').width() - t, t > 1 && n('<style id="fancybox-noscroll" type="text/css">').html('.compensate-for-scrollbar, .fancybox-enabled body { margin-right: ' + t + 'px; }').appendTo('head'))), e = n(o.opts.baseTpl).attr('id', 'fancybox-container-' + o.id).data('FancyBox', o).addClass(o.opts.baseClass).hide().prependTo(o.opts.parentEl), o.$refs = { container: e, bg: e.find('.fancybox-bg'), controls: e.find('.fancybox-controls'), buttons: e.find('.fancybox-buttons'), slider_wrap: e.find('.fancybox-slider-wrap'), slider: e.find('.fancybox-slider'), caption: e.find('.fancybox-caption') }, o.trigger('onInit'), o.activate(), o.current || o.jumpTo(o.currIndex);
	        }, createGroup: function createGroup(t) {
	            var e = this,
	                s = n.makeArray(t);n.each(s, function (t, s) {
	                var i,
	                    a,
	                    r,
	                    c,
	                    l = {},
	                    u = {},
	                    d = [];n.isPlainObject(s) ? (l = s, u = s.opts || {}) : 'object' === n.type(s) && n(s).length ? (i = n(s), d = i.data(), u = 'options' in d ? d.options : {}, u = 'object' === n.type(u) ? u : {}, l.type = 'type' in d ? d.type : u.type, l.src = 'src' in d ? d.src : u.src || i.attr('href'), u.width = 'width' in d ? d.width : u.width, u.height = 'height' in d ? d.height : u.height, u.thumb = 'thumb' in d ? d.thumb : u.thumb, u.selector = 'selector' in d ? d.selector : u.selector, 'srcset' in d && (u.image = { srcset: d.srcset }), u.$orig = i) : l = { type: 'html', content: s + '' }, l.opts = n.extend(!0, {}, e.opts, u), a = l.type, r = l.src || '', a || (l.content ? a = 'html' : r.match(/(^data:image\/[a-z0-9+\/=]*,)|(\.(jp(e|g|eg)|gif|png|bmp|webp|svg|ico)((\?|#).*)?$)/i) ? a = 'image' : r.match(/\.(pdf)((\?|#).*)?$/i) ? a = 'pdf' : '#' === r.charAt(0) && (a = 'inline'), l.type = a), l.index = e.group.length, l.opts.$orig && !l.opts.$orig.length && delete l.opts.$orig, !l.opts.$thumb && l.opts.$orig && (l.opts.$thumb = l.opts.$orig.find('img:first')), l.opts.$thumb && !l.opts.$thumb.length && delete l.opts.$thumb, 'function' === n.type(l.opts.caption) ? l.opts.caption = l.opts.caption.apply(s, [e, l]) : 'caption' in d ? l.opts.caption = d.caption : u.$orig && (l.opts.caption = i.attr('title')), l.opts.caption = l.opts.caption === o ? '' : l.opts.caption + '', 'ajax' === a && (c = r.split(/\s+/, 2), c.length > 1 && (l.src = c.shift(), l.opts.selector = c.shift())), 'auto' == l.opts.smallBtn && (n.inArray(a, ['html', 'inline', 'ajax']) > -1 ? (l.opts.buttons = !1, l.opts.smallBtn = !0) : l.opts.smallBtn = !1), 'pdf' === a && (l.type = 'iframe', l.opts.closeBtn = !0, l.opts.smallBtn = !1, l.opts.iframe.preload = !1), l.opts.modal && n.extend(!0, l.opts, { infobar: 0, buttons: 0, keyboard: 0, slideShow: 0, fullScreen: 0, closeClickOutside: 0 }), e.group.push(l);
	            });
	        }, addEvents: function addEvents() {
	            var e = this;e.removeEvents(), e.$refs.container.on('click.fb-close', '[data-fancybox-close]', function (t) {
	                t.stopPropagation(), t.preventDefault(), e.close(t);
	            }).on('click.fb-previous', '[data-fancybox-previous]', function (t) {
	                t.stopPropagation(), t.preventDefault(), e.previous();
	            }).on('click.fb-next', '[data-fancybox-next]', function (t) {
	                t.stopPropagation(), t.preventDefault(), e.next();
	            }), n(t).on('orientationchange.fb resize.fb', function (t) {
	                u(function () {
	                    t && t.originalEvent && 'resize' === t.originalEvent.type ? e.update() : (e.$refs.slider_wrap.hide(), u(function () {
	                        e.$refs.slider_wrap.show(), e.update();
	                    }));
	                });
	            }), r.on('focusin.fb', function (t) {
	                var o = n.fancybox ? n.fancybox.getInstance() : null;!o || n(t.target).hasClass('fancybox-container') || n.contains(o.$refs.container[0], t.target) || (t.stopPropagation(), o.focus(), a.scrollTop(e.scrollTop).scrollLeft(e.scrollLeft));
	            }), r.on('keydown.fb', function (t) {
	                var o = e.current,
	                    s = t.keyCode || t.which;if (o && o.opts.keyboard && !n(t.target).is('input') && !n(t.target).is('textarea')) {
	                    if (8 === s || 27 === s) return t.preventDefault(), void e.close(t);switch (s) {case 37:case 38:
	                            t.preventDefault(), e.previous();break;case 39:case 40:
	                            t.preventDefault(), e.next();break;case 80:case 32:
	                            t.preventDefault(), e.SlideShow && (t.preventDefault(), e.SlideShow.toggle());break;case 70:
	                            e.FullScreen && (t.preventDefault(), e.FullScreen.toggle());break;case 71:
	                            e.Thumbs && (t.preventDefault(), e.Thumbs.toggle());}
	                }
	            });
	        }, removeEvents: function removeEvents() {
	            a.off('scroll.fb resize.fb orientationchange.fb'), r.off('keydown.fb focusin.fb click.fb-close'), this.$refs.container.off('click.fb-close click.fb-previous click.fb-next');
	        }, previous: function previous(t) {
	            this.jumpTo(this.currIndex - 1, t);
	        }, next: function next(t) {
	            this.jumpTo(this.currIndex + 1, t);
	        }, jumpTo: function jumpTo(t, e) {
	            var n,
	                s,
	                i,
	                a,
	                r = this;if (n = r.firstRun = null === r.firstRun, s = i = t = parseInt(t, 10), a = !!r.current && r.current.opts.loop, !r.isAnimating && (s != r.currIndex || n)) {
	                if (r.group.length > 1 && a) s %= r.group.length, s = s < 0 ? r.group.length + s : s, 2 == r.group.length ? i = t - r.currIndex + r.currPos : (i = s - r.currIndex + r.currPos, Math.abs(r.currPos - (i + r.group.length)) < Math.abs(r.currPos - i) ? i += r.group.length : Math.abs(r.currPos - (i - r.group.length)) < Math.abs(r.currPos - i) && (i -= r.group.length));else if (!r.group[s]) return void r.update(!1, !1, e);r.current && (r.current.$slide.removeClass('fancybox-slide--current fancybox-slide--complete'), r.updateSlide(r.current, !0)), r.prevIndex = r.currIndex, r.prevPos = r.currPos, r.currIndex = s, r.currPos = i, r.current = r.createSlide(i), r.group.length > 1 && ((r.opts.loop || i - 1 >= 0) && r.createSlide(i - 1), (r.opts.loop || i + 1 < r.group.length) && r.createSlide(i + 1)), r.current.isMoved = !1, r.current.isComplete = !1, e = parseInt(e === o ? 1.5 * r.current.opts.speed : e, 10), r.trigger('beforeMove'), r.updateControls(), n && (r.current.$slide.addClass('fancybox-slide--current'), r.$refs.container.show(), u(function () {
	                    r.$refs.bg.css('transition-duration', r.current.opts.speed + 'ms'), r.$refs.container.addClass('fancybox-container--ready');
	                })), r.update(!0, !1, n ? 0 : e, function () {
	                    r.afterMove();
	                }), r.loadSlide(r.current), n && r.current.$ghost || r.preload();
	            }
	        }, createSlide: function createSlide(t) {
	            var e,
	                o,
	                s,
	                i = this;if (o = t % i.group.length, o = o < 0 ? i.group.length + o : o, !i.slides[t] && i.group[o]) {
	                if (i.opts.loop && i.group.length > 2) for (var a in i.slides) {
	                    if (i.slides[a].index === o) return s = i.slides[a], s.pos = t, i.slides[t] = s, delete i.slides[a], i.updateSlide(s), s;
	                }e = n('<div class="fancybox-slide"></div>').appendTo(i.$refs.slider), i.slides[t] = n.extend(!0, {}, i.group[o], { pos: t, $slide: e, isMoved: !1, isLoaded: !1 });
	            }return i.slides[t];
	        }, zoomInOut: function zoomInOut(t, e, o) {
	            var s,
	                i,
	                a,
	                r = this,
	                c = r.current,
	                l = c.$placeholder,
	                u = c.opts.opacity,
	                p = c.opts.$thumb,
	                h = p ? p.offset() : 0,
	                f = c.$slide.offset();return !!(l && c.isMoved && h && d(p)) && !('In' === t && !r.firstRun) && (n.fancybox.stop(l), r.isAnimating = !0, s = { top: h.top - f.top + parseFloat(p.css('border-top-width') || 0), left: h.left - f.left + parseFloat(p.css('border-left-width') || 0), width: p.width(), height: p.height(), scaleX: 1, scaleY: 1 }, 'auto' == u && (u = Math.abs(c.width / c.height - s.width / s.height) > .1), 'In' === t ? (i = s, a = r.getFitPos(c), a.scaleX = a.width / i.width, a.scaleY = a.height / i.height, u && (i.opacity = .1, a.opacity = 1)) : (i = n.fancybox.getTranslate(l), a = s, c.$ghost && (c.$ghost.show(), c.$image && c.$image.remove()), i.scaleX = i.width / a.width, i.scaleY = i.height / a.height, i.width = a.width, i.height = a.height, u && (a.opacity = 0)), r.updateCursor(a.width, a.height), delete a.width, delete a.height, n.fancybox.setTranslate(l, i), l.show(), r.trigger('beforeZoom' + t), l.css('transition', 'all ' + e + 'ms'), n.fancybox.setTranslate(l, a), setTimeout(function () {
	                var e;l.css('transition', 'none'), e = n.fancybox.getTranslate(l), e.scaleX = 1, e.scaleY = 1, n.fancybox.setTranslate(l, e), r.trigger('afterZoom' + t), o.apply(r), r.isAnimating = !1;
	            }, e), !0);
	        }, canPan: function canPan() {
	            var t = this,
	                e = t.current,
	                n = e.$placeholder,
	                o = !1;return n && (o = t.getFitPos(e), o = Math.abs(n.width() - o.width) > 1 || Math.abs(n.height() - o.height) > 1), o;
	        }, isScaledDown: function isScaledDown() {
	            var t = this,
	                e = t.current,
	                o = e.$placeholder,
	                s = !1;return o && (s = n.fancybox.getTranslate(o), s = s.width < e.width || s.height < e.height), s;
	        }, scaleToActual: function scaleToActual(t, e, s) {
	            var i,
	                a,
	                r,
	                c,
	                l,
	                u = this,
	                d = u.current,
	                p = d.$placeholder,
	                h = parseInt(d.$slide.width(), 10),
	                f = parseInt(d.$slide.height(), 10),
	                g = d.width,
	                b = d.height;p && (u.isAnimating = !0, t = t === o ? .5 * h : t, e = e === o ? .5 * f : e, i = n.fancybox.getTranslate(p), c = g / i.width, l = b / i.height, a = .5 * h - .5 * g, r = .5 * f - .5 * b, g > h && (a = i.left * c - (t * c - t), a > 0 && (a = 0), a < h - g && (a = h - g)), b > f && (r = i.top * l - (e * l - e), r > 0 && (r = 0), r < f - b && (r = f - b)), u.updateCursor(g, b), n.fancybox.animate(p, null, { top: r, left: a, scaleX: c, scaleY: l }, s || d.opts.speed, function () {
	                u.isAnimating = !1;
	            }));
	        }, scaleToFit: function scaleToFit(t) {
	            var e,
	                o = this,
	                s = o.current,
	                i = s.$placeholder;i && (o.isAnimating = !0, e = o.getFitPos(s), o.updateCursor(e.width, e.height), n.fancybox.animate(i, null, { top: e.top, left: e.left, scaleX: e.width / i.width(), scaleY: e.height / i.height() }, t || s.opts.speed, function () {
	                o.isAnimating = !1;
	            }));
	        }, getFitPos: function getFitPos(t) {
	            var e,
	                o,
	                s,
	                i,
	                r,
	                c,
	                l,
	                u = t.$placeholder || t.$content,
	                d = t.width,
	                p = t.height,
	                h = t.opts.margin;return !(!u || !u.length || !d && !p) && ('number' === n.type(h) && (h = [h, h]), 2 == h.length && (h = [h[0], h[1], h[0], h[1]]), a.width() < 800 && (h = [0, 0, 0, 0]), e = parseInt(t.$slide.width(), 10) - (h[1] + h[3]), o = parseInt(t.$slide.height(), 10) - (h[0] + h[2]), s = Math.min(1, e / d, o / p), c = Math.floor(s * d), l = Math.floor(s * p), i = Math.floor(.5 * (o - l)) + h[0], r = Math.floor(.5 * (e - c)) + h[3], { top: i, left: r, width: c, height: l });
	        }, update: function update(t, e, o, s) {
	            var i,
	                a = this;a.isAnimating !== !0 && a.current && (i = a.current.pos * Math.floor(a.current.$slide.width()) * -1 - a.current.pos * a.current.opts.gutter, o = parseInt(o, 10) || 0, n.fancybox.stop(a.$refs.slider), t === !1 ? a.updateSlide(a.current, e) : n.each(a.slides, function (t, n) {
	                a.updateSlide(n, e);
	            }), o ? n.fancybox.animate(a.$refs.slider, null, { top: 0, left: i }, o, function () {
	                a.current.isMoved = !0, 'function' === n.type(s) && s.apply(a);
	            }) : (n.fancybox.setTranslate(a.$refs.slider, { top: 0, left: i }), a.current.isMoved = !0, 'function' === n.type(s) && s.apply(a)));
	        }, updateSlide: function updateSlide(t, e) {
	            var o,
	                s = this,
	                i = t.$placeholder;t = t || s.current, t && !s.isClosing && (o = t.pos * Math.floor(t.$slide.width()) + t.pos * t.opts.gutter, o !== t.leftPos && (n.fancybox.setTranslate(t.$slide, { top: 0, left: o }), t.leftPos = o), e !== !1 && i && (n.fancybox.setTranslate(i, s.getFitPos(t)), t.pos === s.currPos && s.updateCursor()), t.$slide.trigger('refresh'), s.trigger('onUpdate', t));
	        }, updateCursor: function updateCursor(t, e) {
	            var n,
	                s = this,
	                i = s.$refs.container.removeClass('fancybox-controls--canzoomIn fancybox-controls--canzoomOut fancybox-controls--canGrab');!s.isClosing && s.opts.touch && (n = t !== o && e !== o ? t < s.current.width && e < s.current.height : s.isScaledDown(), n ? i.addClass('fancybox-controls--canzoomIn') : s.group.length < 2 ? i.addClass('fancybox-controls--canzoomOut') : i.addClass('fancybox-controls--canGrab'));
	        }, loadSlide: function loadSlide(t) {
	            var e,
	                o,
	                s,
	                i = this;if (t && !t.isLoaded && !t.isLoading) {
	                switch (t.isLoading = !0, i.trigger('beforeLoad', t), e = t.type, o = t.$slide, o.off('refresh').trigger('onReset').addClass('fancybox-slide--' + (e || 'unknown')).addClass(t.opts.slideClass), e) {case 'image':
	                        i.setImage(t);break;case 'iframe':
	                        i.setIframe(t);break;case 'html':
	                        i.setContent(t, t.content);break;case 'inline':
	                        n(t.src).length ? i.setContent(t, n(t.src)) : i.setError(t);break;case 'ajax':
	                        i.showLoading(t), s = n.ajax(n.extend({}, t.opts.ajax.settings, { url: t.src, success: function success(e, n) {
	                                'success' === n && i.setContent(t, e);
	                            }, error: function error(e, n) {
	                                e && 'abort' !== n && i.setError(t);
	                            } })), o.one('onReset', function () {
	                            s.abort();
	                        });break;default:
	                        i.setError(t);}return !0;
	            }
	        }, setImage: function setImage(e) {
	            var o,
	                s,
	                i,
	                a,
	                r = this,
	                c = e.opts.image.srcset;if (e.isLoaded && !e.hasError) return void r.afterLoad(e);if (c) {
	                i = t.devicePixelRatio || 1, a = t.innerWidth * i, s = c.split(',').map(function (t) {
	                    var e = {};return t.trim().split(/\s+/).forEach(function (t, n) {
	                        var o = parseInt(t.substring(0, t.length - 1), 10);return 0 === n ? e.url = t : void (o && (e.value = o, e.postfix = t[t.length - 1]));
	                    }), e;
	                }), s.sort(function (t, e) {
	                    return t.value - e.value;
	                });for (var l = 0; l < s.length; l++) {
	                    var u = s[l];if ('w' === u.postfix && u.value >= a || 'x' === u.postfix && u.value >= i) {
	                        o = u;break;
	                    }
	                }!o && s.length && (o = s[s.length - 1]), o && (e.src = o.url, e.width && e.height && 'w' == o.postfix && (e.height = e.width / e.height * o.value, e.width = o.value));
	            }e.$placeholder = n('<div class="fancybox-placeholder"></div>').hide().appendTo(e.$slide), e.opts.preload !== !1 && e.opts.width && e.opts.height && (e.opts.thumb || e.opts.$thumb) ? (e.width = e.opts.width, e.height = e.opts.height, e.$ghost = n('<img />').one('load error', function () {
	                r.isClosing || (n('<img/>')[0].src = e.src, r.revealImage(e, function () {
	                    r.setBigImage(e), r.firstRun && e.index === r.currIndex && r.preload();
	                }));
	            }).addClass('fancybox-image').appendTo(e.$placeholder).attr('src', e.opts.thumb || e.opts.$thumb.attr('src'))) : r.setBigImage(e);
	        }, setBigImage: function setBigImage(t) {
	            var e = this,
	                o = n('<img />');t.$image = o.one('error', function () {
	                e.setError(t);
	            }).one('load', function () {
	                clearTimeout(t.timouts), t.timouts = null, e.isClosing || (t.width = this.naturalWidth, t.height = this.naturalHeight, t.opts.image.srcset && o.attr('sizes', '100vw').attr('srcset', t.opts.image.srcset), e.afterLoad(t), t.$ghost && (t.timouts = setTimeout(function () {
	                    t.$ghost.hide();
	                }, 350)));
	            }).addClass('fancybox-image').attr('src', t.src).appendTo(t.$placeholder), o[0].complete ? o.trigger('load') : o[0].error ? o.trigger('error') : t.timouts = setTimeout(function () {
	                o[0].complete || t.hasError || e.showLoading(t);
	            }, 150), t.opts.image.protect && n('<div class="fancybox-spaceball"></div>').appendTo(t.$placeholder).on('contextmenu.fb', function (t) {
	                return 2 == t.button && t.preventDefault(), !0;
	            });
	        }, revealImage: function revealImage(t, e) {
	            var o = this;return e = e || n.noop, 'image' !== t.type || t.hasError || t.isRevealed === !0 ? void e.apply(o) : (t.isRevealed = !0, void (t.pos === o.currPos && o.zoomInOut('In', t.opts.speed, e) || (t.$ghost && !t.isLoaded && o.updateSlide(t, !0), t.pos === o.currPos ? n.fancybox.animate(t.$placeholder, { opacity: 0 }, { opacity: 1 }, 300, e) : t.$placeholder.show(), e.apply(o))));
	        }, setIframe: function setIframe(t) {
	            var e,
	                s = this,
	                i = t.opts.iframe,
	                a = t.$slide;t.$content = n('<div class="fancybox-content"></div>').css(i.css).appendTo(a), e = n(i.tpl.replace(/\{rnd\}/g, new Date().getTime())).attr('scrolling', n.fancybox.isTouch ? 'auto' : i.scrolling).appendTo(t.$content), i.preload ? (t.$content.addClass('fancybox-tmp'), s.showLoading(t), e.on('load.fb error.fb', function (e) {
	                this.isReady = 1, t.$slide.trigger('refresh'), s.afterLoad(t);
	            }), a.on('refresh.fb', function () {
	                var n,
	                    s,
	                    a,
	                    r,
	                    c,
	                    l = t.$content;if (1 === e[0].isReady) {
	                    try {
	                        n = e.contents(), s = n.find('body');
	                    } catch (t) {}s && s.length && (i.css.width === o || i.css.height === o) && (a = e[0].contentWindow.document.documentElement.scrollWidth, r = Math.ceil(s.outerWidth(!0) + (l.width() - a)), c = Math.ceil(s.outerHeight(!0)), l.css({ width: i.css.width === o ? r + (l.outerWidth() - l.innerWidth()) : i.css.width, height: i.css.height === o ? c + (l.outerHeight() - l.innerHeight()) : i.css.height })), l.removeClass('fancybox-tmp');
	                }
	            })) : this.afterLoad(t), e.attr('src', t.src), t.opts.smallBtn && t.$content.prepend(t.opts.closeTpl), a.one('onReset', function () {
	                try {
	                    n(this).find('iframe').hide().attr('src', '//about:blank');
	                } catch (t) {}n(this).empty(), t.isLoaded = !1;
	            });
	        }, setContent: function setContent(t, e) {
	            var o = this;o.isClosing || (o.hideLoading(t), t.$slide.empty(), l(e) && e.parent().length ? (e.data('placeholder') && e.parents('.fancybox-slide').trigger('onReset'), e.data({ placeholder: n('<div></div>').hide().insertAfter(e) }).css('display', 'inline-block')) : ('string' === n.type(e) && (e = n('<div>').append(e).contents(), 3 === e[0].nodeType && (e = n('<div>').html(e))), t.opts.selector && (e = n('<div>').html(e).find(t.opts.selector))), t.$slide.one('onReset', function () {
	                var o = l(e) ? e.data('placeholder') : 0;o && (e.hide().replaceAll(o), e.data('placeholder', null)), t.hasError || (n(this).empty(), t.isLoaded = !1);
	            }), t.$content = n(e).appendTo(t.$slide), t.opts.smallBtn === !0 && t.$content.find('.fancybox-close-small').remove().end().eq(0).append(t.opts.closeTpl), this.afterLoad(t));
	        }, setError: function setError(t) {
	            t.hasError = !0, this.setContent(t, t.opts.errorTpl);
	        }, showLoading: function showLoading(t) {
	            var e = this;t = t || e.current, t && !t.$spinner && (t.$spinner = n(e.opts.spinnerTpl).appendTo(t.$slide));
	        }, hideLoading: function hideLoading(t) {
	            var e = this;t = t || e.current, t && t.$spinner && (t.$spinner.remove(), delete t.$spinner);
	        }, afterMove: function afterMove() {
	            var t = this,
	                e = t.current,
	                o = {};e && (e.$slide.siblings().trigger('onReset'), n.each(t.slides, function (e, n) {
	                n.pos >= t.currPos - 1 && n.pos <= t.currPos + 1 ? o[n.pos] = n : n && n.$slide.remove();
	            }), t.slides = o, t.trigger('afterMove'), e.isLoaded && t.complete());
	        }, afterLoad: function afterLoad(t) {
	            var e = this;e.isClosing || (t.isLoading = !1, t.isLoaded = !0, e.trigger('afterLoad', t), e.hideLoading(t), t.$ghost || e.updateSlide(t, !0), t.index === e.currIndex && t.isMoved ? e.complete() : t.$ghost || e.revealImage(t));
	        }, complete: function complete() {
	            var t = this,
	                e = t.current;t.revealImage(e, function () {
	                e.isComplete = !0, e.$slide.addClass('fancybox-slide--complete'), t.updateCursor(), t.trigger('onComplete'), e.opts.focus && 'image' !== e.type && 'iframe' !== e.type && t.focus();
	            });
	        }, preload: function preload() {
	            var t,
	                e,
	                n = this;n.group.length < 2 || (t = n.slides[n.currPos + 1], e = n.slides[n.currPos - 1], t && 'image' === t.type && n.loadSlide(t), e && 'image' === e.type && n.loadSlide(e));
	        }, focus: function focus() {
	            var t,
	                e = this.current;t = e && e.isComplete ? e.$slide.find('button,:input,[tabindex],a:not(".disabled")').filter(':visible:first') : null, t && t.length || (t = this.$refs.container), t.focus(), this.$refs.slider_wrap.scrollLeft(0), e && e.$slide.scrollTop(0);
	        }, activate: function activate() {
	            var t = this;n('.fancybox-container').each(function () {
	                var e = n(this).data('FancyBox');e && e.uid !== t.uid && !e.isClosing && e.trigger('onDeactivate');
	            }), t.current && (t.$refs.container.index() > 0 && t.$refs.container.prependTo(e.body), t.updateControls()), t.trigger('onActivate'), t.addEvents();
	        }, close: function close(t) {
	            var e = this,
	                o = e.current,
	                s = o.opts.speed,
	                i = n.proxy(function () {
	                e.cleanUp(t);
	            }, this);return !e.isAnimating && !e.isClosing && (e.trigger('beforeClose', t) === !1 ? (n.fancybox.stop(e.$refs.slider), void u(function () {
	                e.update(!0, !0, 150);
	            })) : (e.isClosing = !0, o.timouts && clearTimeout(o.timouts), t !== !0 && n.fancybox.stop(e.$refs.slider), e.$refs.container.removeClass('fancybox-container--active').addClass('fancybox-container--closing'), o.$slide.removeClass('fancybox-slide--complete').siblings().remove(), o.isMoved || o.$slide.css('overflow', 'visible'), e.removeEvents(), e.hideLoading(o), e.hideControls(), e.updateCursor(), e.$refs.bg.css('transition-duration', s + 'ms'), this.$refs.container.removeClass('fancybox-container--ready'), void (t === !0 ? setTimeout(i, s) : e.zoomInOut('Out', s, i) || n.fancybox.animate(e.$refs.container, null, { opacity: 0 }, s, 'easeInSine', i))));
	        }, cleanUp: function cleanUp(t) {
	            var e,
	                o = this;o.$refs.slider.children().trigger('onReset'), o.$refs.container.empty().remove(), o.trigger('afterClose', t), o.current = null, e = n.fancybox.getInstance(), e ? e.activate() : (n('html').removeClass('fancybox-enabled'), n('body').removeAttr('style'), a.scrollTop(o.scrollTop).scrollLeft(o.scrollLeft), n('#fancybox-noscroll').remove()), o.$lastFocus && o.$lastFocus.focus();
	        }, trigger: function trigger(t, o) {
	            var s,
	                i = Array.prototype.slice.call(arguments, 1),
	                a = this,
	                r = o && o.opts ? o : a.current;return r ? i.unshift(r) : r = a, i.unshift(a), n.isFunction(r.opts[t]) && (s = r.opts[t].apply(r, i)), s === !1 ? s : void ('afterClose' === t ? n(e).trigger(t + '.fb', i) : a.$refs.container.trigger(t + '.fb', i));
	        }, toggleControls: function toggleControls(t) {
	            this.isHiddenControls ? this.updateControls(t) : this.hideControls();
	        }, hideControls: function hideControls() {
	            this.isHiddenControls = !0, this.$refs.container.removeClass('fancybox-show-controls'), this.$refs.container.removeClass('fancybox-show-caption');
	        }, updateControls: function updateControls(t) {
	            var e = this,
	                o = e.$refs.container,
	                s = e.$refs.caption,
	                i = e.current,
	                a = i.index,
	                r = i.opts,
	                c = r.caption;this.isHiddenControls && t !== !0 || (this.isHiddenControls = !1, o.addClass('fancybox-show-controls').toggleClass('fancybox-show-infobar', !!r.infobar && e.group.length > 1).toggleClass('fancybox-show-buttons', !!r.buttons).toggleClass('fancybox-is-modal', !!r.modal), n('.fancybox-button--left', o).toggleClass('fancybox-button--disabled', !r.loop && a <= 0), n('.fancybox-button--right', o).toggleClass('fancybox-button--disabled', !r.loop && a >= e.group.length - 1), n('.fancybox-button--play', o).toggle(!!(r.slideShow && e.group.length > 1)), n('.fancybox-button--close', o).toggle(!!r.closeBtn), n('.js-fancybox-count', o).html(e.group.length), n('.js-fancybox-index', o).html(a + 1), i.$slide.trigger('refresh'), s && s.empty(), c && c.length ? (s.html(c), this.$refs.container.addClass('fancybox-show-caption '), e.$caption = s) : this.$refs.container.removeClass('fancybox-show-caption'));
	        } }), n.fancybox = { version: '3.0.47', defaults: i, getInstance: function getInstance(t) {
	            var e = n('.fancybox-container:not(".fancybox-container--closing"):first').data('FancyBox'),
	                o = Array.prototype.slice.call(arguments, 1);return e instanceof p && ('string' === n.type(t) ? e[t].apply(e, o) : 'function' === n.type(t) && t.apply(e, o), e);
	        }, open: function open(t, e, n) {
	            return new p(t, e, n);
	        }, close: function close(t) {
	            var e = this.getInstance();e && (e.close(), t === !0 && this.close());
	        }, isTouch: e.createTouch !== o && /Android|webOS|iPhone|iPad|iPod|BlackBerry/i.test(navigator.userAgent), use3d: function () {
	            var n = e.createElement('div');return t.getComputedStyle(n).getPropertyValue('transform') && !(e.documentMode && e.documentMode <= 11);
	        }(), getTranslate: function getTranslate(t) {
	            var e, n;return !(!t || !t.length) && (e = t.get(0).getBoundingClientRect(), n = t.eq(0).css('transform'), n && n.indexOf('matrix') !== -1 ? (n = n.split('(')[1], n = n.split(')')[0], n = n.split(',')) : n = [], n.length ? (n = n.length > 10 ? [n[13], n[12], n[0], n[5]] : [n[5], n[4], n[0], n[3]], n = n.map(parseFloat)) : n = [0, 0, 1, 1], { top: n[0], left: n[1], scaleX: n[2], scaleY: n[3], opacity: parseFloat(t.css('opacity')), width: e.width, height: e.height });
	        }, setTranslate: function setTranslate(t, e) {
	            var n = '',
	                s = {};if (t && e) return e.left === o && e.top === o || (n = (e.left === o ? t.position().top : e.left) + 'px, ' + (e.top === o ? t.position().top : e.top) + 'px', n = this.use3d ? 'translate3d(' + n + ', 0px)' : 'translate(' + n + ')'), e.scaleX !== o && e.scaleY !== o && (n = (n.length ? n + ' ' : '') + 'scale(' + e.scaleX + ', ' + e.scaleY + ')'), n.length && (s.transform = n), e.opacity !== o && (s.opacity = e.opacity), e.width !== o && (s.width = e.width), e.height !== o && (s.height = e.height), t.css(s);
	        }, easing: { easeOutCubic: function easeOutCubic(t, e, n, o) {
	                return n * ((t = t / o - 1) * t * t + 1) + e;
	            }, easeInCubic: function easeInCubic(t, e, n, o) {
	                return n * (t /= o) * t * t + e;
	            }, easeOutSine: function easeOutSine(t, e, n, o) {
	                return n * Math.sin(t / o * (Math.PI / 2)) + e;
	            }, easeInSine: function easeInSine(t, e, n, o) {
	                return -n * Math.cos(t / o * (Math.PI / 2)) + n + e;
	            } }, stop: function stop(t) {
	            t.removeData('animateID');
	        }, animate: function animate(t, e, s, i, a, r) {
	            var c,
	                l,
	                d,
	                p = this,
	                h = null,
	                f = 0,
	                g = function g() {
	                s.scaleX !== o && s.scaleY !== o && e && e.width !== o && e.height !== o && (s.width = e.width * s.scaleX, s.height = e.height * s.scaleY, s.scaleX = 1, s.scaleY = 1), p.setTranslate(t, s), r();
	            },
	                b = function b(n) {
	                if (c = [], l = 0, t.length && t.data('animateID') === d) {
	                    if (n = n || Date.now(), h && (l = n - h), h = n, f += l, f >= i) return void g();for (var r in s) {
	                        s.hasOwnProperty(r) && e[r] !== o && (e[r] == s[r] ? c[r] = s[r] : c[r] = p.easing[a](f, e[r], s[r] - e[r], i));
	                    }p.setTranslate(t, c), u(b);
	                }
	            };p.animateID = d = p.animateID === o ? 1 : p.animateID + 1, t.data('animateID', d), r === o && 'function' == n.type(a) && (r = a, a = o), a || (a = 'easeOutCubic'), r = r || n.noop, e ? this.setTranslate(t, e) : e = this.getTranslate(t), i ? (t.show(), u(b)) : g();
	        } }, n.fn.fancybox = function (t) {
	        return this.off('click.fb-start').on('click.fb-start', { items: this, options: t || {} }, s), this;
	    }, n(e).on('click.fb-start', '[data-fancybox]', s);
	}(window, document, __webpack_provided_window_dot_jQuery), function (t) {
	    'use strict';
	    var e = function e(_e, n, o) {
	        if (_e) return o = o || '', 'object' === t.type(o) && (o = t.param(o, !0)), t.each(n, function (t, n) {
	            _e = _e.replace('$' + t, n || '');
	        }), o.length && (_e += (_e.indexOf('?') > 0 ? '&' : '?') + o), _e;
	    },
	        n = { youtube: { matcher: /(youtube\.com|youtu\.be|youtube\-nocookie\.com)\/(watch\?(.*&)?v=|v\/|u\/|embed\/?)?(videoseries\?list=(.*)|[\w-]{11}|\?listType=(.*)&list=(.*))(.*)/i, params: { autoplay: 1, autohide: 1, fs: 1, rel: 0, hd: 1, wmode: 'transparent', enablejsapi: 1, html5: 1 }, paramPlace: 8, type: 'iframe', url: '//www.youtube.com/embed/$4', thumb: '//img.youtube.com/vi/$4/hqdefault.jpg' }, vimeo: { matcher: /^.+vimeo.com\/(.*\/)?([\d]+)(.*)?/, params: { autoplay: 1, hd: 1, show_title: 1, show_byline: 1, show_portrait: 0, fullscreen: 1, api: 1 }, paramPlace: 3, type: 'iframe', url: '//player.vimeo.com/video/$2' }, metacafe: { matcher: /metacafe.com\/watch\/(\d+)\/(.*)?/, type: 'iframe', url: '//www.metacafe.com/embed/$1/?ap=1' }, dailymotion: { matcher: /dailymotion.com\/video\/(.*)\/?(.*)/, params: { additionalInfos: 0, autoStart: 1 }, type: 'iframe', url: '//www.dailymotion.com/embed/video/$1' }, vine: { matcher: /vine.co\/v\/([a-zA-Z0-9\?\=\-]+)/, type: 'iframe', url: '//vine.co/v/$1/embed/simple' }, instagram: { matcher: /(instagr\.am|instagram\.com)\/p\/([a-zA-Z0-9_\-]+)\/?/i, type: 'image', url: '//$1/p/$2/media/?size=l' }, google_maps: { matcher: /(maps\.)?google\.([a-z]{2,3}(\.[a-z]{2})?)\/(((maps\/(place\/(.*)\/)?\@(.*),(\d+.?\d+?)z))|(\?ll=))(.*)?/i, type: 'iframe', url: function url(t) {
	                return '//maps.google.' + t[2] + '/?ll=' + (t[9] ? t[9] + '&z=' + Math.floor(t[10]) + (t[12] ? t[12].replace(/^\//, '&') : '') : t[12]) + '&output=' + (t[12] && t[12].indexOf('layer=c') > 0 ? 'svembed' : 'embed');
	            } } };t(document).on('onInit.fb', function (o, s) {
	        t.each(s.group, function (o, s) {
	            var i,
	                a,
	                r,
	                c,
	                l,
	                u,
	                d = s.src || '',
	                p = !1;s.type || (t.each(n, function (n, o) {
	                if (a = d.match(o.matcher), l = {}, u = n, a) {
	                    if (p = o.type, o.paramPlace && a[o.paramPlace]) {
	                        c = a[o.paramPlace], '?' == c[0] && (c = c.substring(1)), c = c.split('&');for (var h = 0; h < c.length; ++h) {
	                            var f = c[h].split('=', 2);2 == f.length && (l[f[0]] = decodeURIComponent(f[1].replace(/\+/g, ' ')));
	                        }
	                    }return r = t.extend(!0, {}, o.params, s.opts[n], l), d = 'function' === t.type(o.url) ? o.url.call(this, a, r, s) : e(o.url, a, r), i = 'function' === t.type(o.thumb) ? o.thumb.call(this, a, r, s) : e(o.thumb, a), 'vimeo' === u && (d = d.replace('&%23', '#')), !1;
	                }
	            }), p ? (s.src = d, s.type = p, s.opts.thumb || s.opts.$thumb && s.opts.$thumb.length || (s.opts.thumb = i), 'iframe' === p && (t.extend(!0, s.opts, { iframe: { preload: !1, scrolling: 'no' }, smallBtn: !1, closeBtn: !0, fullScreen: !1, slideShow: !1 }), s.opts.slideClass += ' fancybox-slide--video')) : s.type = 'iframe');
	        });
	    });
	}(__webpack_provided_window_dot_jQuery), function (t, e, n) {
	    'use strict';
	    var o = function () {
	        return t.requestAnimationFrame || t.webkitRequestAnimationFrame || t.mozRequestAnimationFrame || function (e) {
	            t.setTimeout(e, 1e3 / 60);
	        };
	    }(),
	        s = function s(e) {
	        var n = [];e = e.originalEvent || e || t.e, e = e.touches && e.touches.length ? e.touches : e.changedTouches && e.changedTouches.length ? e.changedTouches : [e];for (var o in e) {
	            e[o].pageX ? n.push({ x: e[o].pageX, y: e[o].pageY }) : e[o].clientX && n.push({ x: e[o].clientX, y: e[o].clientY });
	        }return n;
	    },
	        i = function i(t, e, n) {
	        return e && t ? 'x' === n ? t.x - e.x : 'y' === n ? t.y - e.y : Math.sqrt(Math.pow(t.x - e.x, 2) + Math.pow(t.y - e.y, 2)) : 0;
	    },
	        a = function a(t) {
	        return t.is('a') || t.is('button') || t.is('input') || t.is('select') || t.is('textarea') || n.isFunction(t.get(0).onclick);
	    },
	        r = function r(e) {
	        var n = t.getComputedStyle(e)['overflow-y'],
	            o = t.getComputedStyle(e)['overflow-x'],
	            s = ('scroll' === n || 'auto' === n) && e.scrollHeight > e.clientHeight,
	            i = ('scroll' === o || 'auto' === o) && e.scrollWidth > e.clientWidth;return s || i;
	    },
	        c = function c(t) {
	        for (var e = !1;;) {
	            if (e = r(t.get(0))) break;if (t = t.parent(), !t.length || t.hasClass('fancybox-slider') || t.is('body')) break;
	        }return e;
	    },
	        l = function l(t) {
	        var e = this;e.instance = t, e.$wrap = t.$refs.slider_wrap, e.$slider = t.$refs.slider, e.$container = t.$refs.container, e.destroy(), e.$wrap.on('touchstart.fb mousedown.fb', n.proxy(e, 'ontouchstart'));
	    };l.prototype.destroy = function () {
	        this.$wrap.off('touchstart.fb mousedown.fb touchmove.fb mousemove.fb touchend.fb touchcancel.fb mouseup.fb mouseleave.fb');
	    }, l.prototype.ontouchstart = function (e) {
	        var o = this,
	            r = n(e.target),
	            l = o.instance,
	            u = l.current,
	            d = u.$content || u.$placeholder;return o.startPoints = s(e), o.$target = r, o.$content = d, o.canvasWidth = Math.round(u.$slide[0].clientWidth), o.canvasHeight = Math.round(u.$slide[0].clientHeight), o.startEvent = e, e.originalEvent.clientX > o.canvasWidth + u.$slide.offset().left || (a(r) || a(r.parent()) || c(r) ? void 0 : u.opts.touch ? void (e.originalEvent && 2 == e.originalEvent.button || (e.stopPropagation(), e.preventDefault(), !u || o.instance.isAnimating || o.instance.isClosing || !o.startPoints || o.startPoints.length > 1 && !u.isMoved || (o.$wrap.off('touchmove.fb mousemove.fb', n.proxy(o, 'ontouchmove')), o.$wrap.off('touchend.fb touchcancel.fb mouseup.fb mouseleave.fb', n.proxy(o, 'ontouchend')), o.$wrap.on('touchend.fb touchcancel.fb mouseup.fb mouseleave.fb', n.proxy(o, 'ontouchend')), o.$wrap.on('touchmove.fb mousemove.fb', n.proxy(o, 'ontouchmove')), o.startTime = new Date().getTime(), o.distanceX = o.distanceY = o.distance = 0, o.canTap = !1, o.isPanning = !1, o.isSwiping = !1, o.isZooming = !1, o.sliderStartPos = n.fancybox.getTranslate(o.$slider), o.contentStartPos = n.fancybox.getTranslate(o.$content), o.contentLastPos = null, 1 !== o.startPoints.length || o.isZooming || (o.canTap = u.isMoved, 'image' === u.type && (o.contentStartPos.width > o.canvasWidth + 1 || o.contentStartPos.height > o.canvasHeight + 1) ? (n.fancybox.stop(o.$content), o.isPanning = !0) : (n.fancybox.stop(o.$slider), o.isSwiping = !0), o.$container.addClass('fancybox-controls--isGrabbing')), 2 === o.startPoints.length && u.isMoved && !u.hasError && 'image' === u.type && (u.isLoaded || u.$ghost) && (o.isZooming = !0, o.isSwiping = !1, o.isPanning = !1, n.fancybox.stop(o.$content), o.centerPointStartX = .5 * (o.startPoints[0].x + o.startPoints[1].x) - n(t).scrollLeft(), o.centerPointStartY = .5 * (o.startPoints[0].y + o.startPoints[1].y) - n(t).scrollTop(), o.percentageOfImageAtPinchPointX = (o.centerPointStartX - o.contentStartPos.left) / o.contentStartPos.width, o.percentageOfImageAtPinchPointY = (o.centerPointStartY - o.contentStartPos.top) / o.contentStartPos.height, o.startDistanceBetweenFingers = i(o.startPoints[0], o.startPoints[1]))))) : (o.endPoints = o.startPoints, o.ontap()));
	    }, l.prototype.ontouchmove = function (t) {
	        var e = this;t.preventDefault(), e.newPoints = s(t), e.newPoints && e.newPoints.length && (e.distanceX = i(e.newPoints[0], e.startPoints[0], 'x'), e.distanceY = i(e.newPoints[0], e.startPoints[0], 'y'), e.distance = i(e.newPoints[0], e.startPoints[0]), e.distance > 0 && (e.isSwiping ? e.onSwipe() : e.isPanning ? e.onPan() : e.isZooming && e.onZoom()));
	    }, l.prototype.onSwipe = function () {
	        var e,
	            s = this,
	            i = s.isSwiping,
	            a = s.sliderStartPos.left;i === !0 ? Math.abs(s.distance) > 10 && (s.instance.group.length < 2 ? s.isSwiping = 'y' : !s.instance.current.isMoved || s.instance.opts.touch.vertical === !1 || 'auto' === s.instance.opts.touch.vertical && n(t).width() > 800 ? s.isSwiping = 'x' : (e = Math.abs(180 * Math.atan2(s.distanceY, s.distanceX) / Math.PI), s.isSwiping = e > 45 && e < 135 ? 'y' : 'x'), s.canTap = !1, s.instance.current.isMoved = !1, s.startPoints = s.newPoints) : ('x' == i && (!s.instance.current.opts.loop && 0 === s.instance.current.index && s.distanceX > 0 ? a += Math.pow(s.distanceX, .8) : !s.instance.current.opts.loop && s.instance.current.index === s.instance.group.length - 1 && s.distanceX < 0 ? a -= Math.pow(-s.distanceX, .8) : a += s.distanceX), s.sliderLastPos = { top: 'x' == i ? 0 : s.sliderStartPos.top + s.distanceY, left: a }, o(function () {
	            n.fancybox.setTranslate(s.$slider, s.sliderLastPos);
	        }));
	    }, l.prototype.onPan = function () {
	        var t,
	            e,
	            s,
	            i = this;i.canTap = !1, t = i.contentStartPos.width > i.canvasWidth ? i.contentStartPos.left + i.distanceX : i.contentStartPos.left, e = i.contentStartPos.top + i.distanceY, s = i.limitMovement(t, e, i.contentStartPos.width, i.contentStartPos.height), s.scaleX = i.contentStartPos.scaleX, s.scaleY = i.contentStartPos.scaleY, i.contentLastPos = s, o(function () {
	            n.fancybox.setTranslate(i.$content, i.contentLastPos);
	        });
	    }, l.prototype.limitMovement = function (t, e, n, o) {
	        var s,
	            i,
	            a,
	            r,
	            c = this,
	            l = c.canvasWidth,
	            u = c.canvasHeight,
	            d = c.contentStartPos.left,
	            p = c.contentStartPos.top,
	            h = c.distanceX,
	            f = c.distanceY;return s = Math.max(0, .5 * l - .5 * n), i = Math.max(0, .5 * u - .5 * o), a = Math.min(l - n, .5 * l - .5 * n), r = Math.min(u - o, .5 * u - .5 * o), n > l && (h > 0 && t > s && (t = s - 1 + Math.pow(-s + d + h, .8) || 0), h < 0 && t < a && (t = a + 1 - Math.pow(a - d - h, .8) || 0)), o > u && (f > 0 && e > i && (e = i - 1 + Math.pow(-i + p + f, .8) || 0), f < 0 && e < r && (e = r + 1 - Math.pow(r - p - f, .8) || 0)), { top: e, left: t };
	    }, l.prototype.limitPosition = function (t, e, n, o) {
	        var s = this,
	            i = s.canvasWidth,
	            a = s.canvasHeight;return n > i ? (t = t > 0 ? 0 : t, t = t < i - n ? i - n : t) : t = Math.max(0, i / 2 - n / 2), o > a ? (e = e > 0 ? 0 : e, e = e < a - o ? a - o : e) : e = Math.max(0, a / 2 - o / 2), { top: e, left: t };
	    }, l.prototype.onZoom = function () {
	        var e = this,
	            s = e.contentStartPos.width,
	            a = e.contentStartPos.height,
	            r = e.contentStartPos.left,
	            c = e.contentStartPos.top,
	            l = i(e.newPoints[0], e.newPoints[1]),
	            u = l / e.startDistanceBetweenFingers,
	            d = Math.floor(s * u),
	            p = Math.floor(a * u),
	            h = (s - d) * e.percentageOfImageAtPinchPointX,
	            f = (a - p) * e.percentageOfImageAtPinchPointY,
	            g = (e.newPoints[0].x + e.newPoints[1].x) / 2 - n(t).scrollLeft(),
	            b = (e.newPoints[0].y + e.newPoints[1].y) / 2 - n(t).scrollTop(),
	            m = g - e.centerPointStartX,
	            y = b - e.centerPointStartY,
	            v = r + (h + m),
	            x = c + (f + y),
	            w = { top: x, left: v, scaleX: e.contentStartPos.scaleX * u, scaleY: e.contentStartPos.scaleY * u };e.canTap = !1, e.newWidth = d, e.newHeight = p, e.contentLastPos = w, o(function () {
	            n.fancybox.setTranslate(e.$content, e.contentLastPos);
	        });
	    }, l.prototype.ontouchend = function (t) {
	        var e = this,
	            o = e.instance.current,
	            i = Math.max(new Date().getTime() - e.startTime, 1),
	            a = e.isSwiping,
	            r = e.isPanning,
	            c = e.isZooming;return e.endPoints = s(t), e.$container.removeClass('fancybox-controls--isGrabbing'), e.$wrap.off('touchmove.fb mousemove.fb', n.proxy(this, 'ontouchmove')), e.$wrap.off('touchend.fb touchcancel.fb mouseup.fb mouseleave.fb', n.proxy(this, 'ontouchend')), e.isSwiping = !1, e.isPanning = !1, e.isZooming = !1, e.canTap ? e.ontap() : (e.velocityX = e.distanceX / i * .5, e.velocityY = e.distanceY / i * .5, e.speed = o.opts.speed || 330, e.speedX = Math.max(.75 * e.speed, Math.min(1.5 * e.speed, 1 / Math.abs(e.velocityX) * e.speed)), e.speedY = Math.max(.75 * e.speed, Math.min(1.5 * e.speed, 1 / Math.abs(e.velocityY) * e.speed)), void (r ? e.endPanning() : c ? e.endZooming() : e.endSwiping(a)));
	    }, l.prototype.endSwiping = function (t) {
	        var e = this;'y' == t && Math.abs(e.distanceY) > 50 ? (n.fancybox.animate(e.$slider, null, { top: e.sliderStartPos.top + e.distanceY + 150 * e.velocityY, left: e.sliderStartPos.left, opacity: 0 }, e.speedY), e.instance.close(!0)) : 'x' == t && e.distanceX > 50 ? e.instance.previous(e.speedX) : 'x' == t && e.distanceX < -50 ? e.instance.next(e.speedX) : e.instance.update(!1, !0, 150);
	    }, l.prototype.endPanning = function () {
	        var t,
	            e,
	            o,
	            s = this;s.contentLastPos && (t = s.contentLastPos.left + s.velocityX * s.speed * 2, e = s.contentLastPos.top + s.velocityY * s.speed * 2, o = s.limitPosition(t, e, s.contentStartPos.width, s.contentStartPos.height), o.width = s.contentStartPos.width, o.height = s.contentStartPos.height, n.fancybox.animate(s.$content, null, o, s.speed, 'easeOutSine'));
	    }, l.prototype.endZooming = function () {
	        var t,
	            e,
	            o,
	            s,
	            i = this,
	            a = i.instance.current,
	            r = i.newWidth,
	            c = i.newHeight;i.contentLastPos && (t = i.contentLastPos.left, e = i.contentLastPos.top, s = { top: e, left: t, width: r, height: c, scaleX: 1, scaleY: 1 }, n.fancybox.setTranslate(i.$content, s), r < i.canvasWidth && c < i.canvasHeight ? i.instance.scaleToFit(150) : r > a.width || c > a.height ? i.instance.scaleToActual(i.centerPointStartX, i.centerPointStartY, 150) : (o = i.limitPosition(t, e, r, c), n.fancybox.animate(i.$content, null, o, i.speed, 'easeOutSine')));
	    }, l.prototype.ontap = function () {
	        var t = this,
	            e = t.instance,
	            o = e.current,
	            s = t.endPoints[0].x,
	            i = t.endPoints[0].y;if (s -= t.$wrap.offset().left, i -= t.$wrap.offset().top, e.SlideShow && e.SlideShow.isActive && e.SlideShow.stop(), !n.fancybox.isTouch) return o.opts.closeClickOutside && t.$target.is('.fancybox-slide') ? void e.close(t.startEvent) : void ('image' == o.type && o.isMoved && (e.canPan() ? e.scaleToFit() : e.isScaledDown() ? e.scaleToActual(s, i) : e.group.length < 2 && e.close(t.startEvent)));if (t.tapped) {
	            if (clearTimeout(t.tapped), t.tapped = null, Math.abs(s - t.x) > 50 || Math.abs(i - t.y) > 50 || !o.isMoved) return this;'image' == o.type && (o.isLoaded || o.$ghost) && (e.canPan() ? e.scaleToFit() : e.isScaledDown() && e.scaleToActual(s, i));
	        } else t.x = s, t.y = i, t.tapped = setTimeout(function () {
	            t.tapped = null, e.toggleControls(!0);
	        }, 300);return this;
	    }, n(e).on('onActivate.fb', function (t, e) {
	        e && !e.Guestures && (e.Guestures = new l(e));
	    }), n(e).on('beforeClose.fb', function (t, e) {
	        e && e.Guestures && e.Guestures.destroy();
	    });
	}(window, document, __webpack_provided_window_dot_jQuery), function (t, e) {
	    'use strict';
	    var n = function n(t) {
	        this.instance = t, this.init();
	    };e.extend(n.prototype, { timer: null, isActive: !1, $button: null, speed: 3e3, init: function init() {
	            var t = this;t.$button = e('<button data-fancybox-play class="fancybox-button fancybox-button--play" title="Slideshow (P)"></button>').appendTo(t.instance.$refs.buttons), t.instance.$refs.container.on('click', '[data-fancybox-play]', function () {
	                t.toggle();
	            });
	        }, set: function set() {
	            var t = this;t.instance && t.instance.current && (t.instance.current.opts.loop || t.instance.currIndex < t.instance.group.length - 1) ? t.timer = setTimeout(function () {
	                t.instance.next();
	            }, t.instance.current.opts.slideShow.speed || t.speed) : t.stop();
	        }, clear: function clear() {
	            var t = this;clearTimeout(t.timer), t.timer = null;
	        }, start: function start() {
	            var t = this;t.stop(), t.instance && t.instance.current && (t.instance.current.opts.loop || t.instance.currIndex < t.instance.group.length - 1) && (t.instance.$refs.container.on({ 'beforeLoad.fb.player': e.proxy(t, 'clear'), 'onComplete.fb.player': e.proxy(t, 'set') }), t.isActive = !0, t.instance.current.isComplete && t.set(), t.instance.$refs.container.trigger('onPlayStart'), t.$button.addClass('fancybox-button--pause'));
	        }, stop: function stop() {
	            var t = this;t.clear(), t.instance.$refs.container.trigger('onPlayEnd').off('.player'), t.$button.removeClass('fancybox-button--pause'), t.isActive = !1;
	        }, toggle: function toggle() {
	            var t = this;t.isActive ? t.stop() : t.start();
	        } }), e(t).on('onInit.fb', function (t, e) {
	        e && e.group.length > 1 && e.opts.slideShow && !e.SlideShow && (e.SlideShow = new n(e));
	    }), e(t).on('beforeClose.fb onDeactivate.fb', function (t, e) {
	        e && e.SlideShow && e.SlideShow.stop();
	    });
	}(document, __webpack_provided_window_dot_jQuery), function (t, e) {
	    'use strict';
	    var n = function () {
	        var e,
	            n,
	            o,
	            s = [['requestFullscreen', 'exitFullscreen', 'fullscreenElement', 'fullscreenEnabled', 'fullscreenchange', 'fullscreenerror'], ['webkitRequestFullscreen', 'webkitExitFullscreen', 'webkitFullscreenElement', 'webkitFullscreenEnabled', 'webkitfullscreenchange', 'webkitfullscreenerror'], ['webkitRequestFullScreen', 'webkitCancelFullScreen', 'webkitCurrentFullScreenElement', 'webkitCancelFullScreen', 'webkitfullscreenchange', 'webkitfullscreenerror'], ['mozRequestFullScreen', 'mozCancelFullScreen', 'mozFullScreenElement', 'mozFullScreenEnabled', 'mozfullscreenchange', 'mozfullscreenerror'], ['msRequestFullscreen', 'msExitFullscreen', 'msFullscreenElement', 'msFullscreenEnabled', 'MSFullscreenChange', 'MSFullscreenError']],
	            i = {};for (n = 0; n < s.length; n++) {
	            if (e = s[n], e && e[1] in t) {
	                for (o = 0; o < e.length; o++) {
	                    i[s[0][o]] = e[o];
	                }return i;
	            }
	        }return !1;
	    }();if (n) {
	        var o = { request: function request(e) {
	                e = e || t.documentElement, e[n.requestFullscreen](e.ALLOW_KEYBOARD_INPUT);
	            }, exit: function exit() {
	                t[n.exitFullscreen]();
	            }, toggle: function toggle(t) {
	                this.isFullscreen() ? this.exit() : this.request(t);
	            }, isFullscreen: function isFullscreen() {
	                return Boolean(t[n.fullscreenElement]);
	            }, enabled: function enabled() {
	                return Boolean(t[n.fullscreenEnabled]);
	            } };e(t).on({ 'onInit.fb': function onInitFb(t, n) {
	                var s;n && n.opts.fullScreen && !n.FullScreen && (s = n.$refs.container, n.$refs.button_fs = e('<button data-fancybox-fullscreen class="fancybox-button fancybox-button--fullscreen" title="Full screen (F)"></button>').appendTo(n.$refs.buttons), s.on('click.fb-fullscreen', '[data-fancybox-fullscreen]', function (t) {
	                    t.stopPropagation(), t.preventDefault(), o.toggle(s[0]);
	                }), n.opts.fullScreen.requestOnStart === !0 && o.request(s[0]));
	            }, 'beforeMove.fb': function beforeMoveFb(t, e) {
	                e && e.$refs.button_fs && e.$refs.button_fs.toggle(!!e.current.opts.fullScreen);
	            }, 'beforeClose.fb': function beforeCloseFb() {
	                o.exit();
	            } }), e(t).on(n.fullscreenchange, function () {
	            var t = e.fancybox.getInstance(),
	                n = t ? t.current.$placeholder : null;n && (n.css('transition', 'none'), t.isAnimating = !1, t.update(!0, !0, 0));
	        });
	    }
	}(document, __webpack_provided_window_dot_jQuery), function (t, e) {
	    'use strict';
	    var n = function n(t) {
	        this.instance = t, this.init();
	    };e.extend(n.prototype, { $button: null, $grid: null, $list: null, isVisible: !1, init: function init() {
	            var t = this;t.$button = e('<button data-fancybox-thumbs class="fancybox-button fancybox-button--thumbs" title="Thumbnails (G)"></button>').appendTo(this.instance.$refs.buttons).on('touchend click', function (e) {
	                e.stopPropagation(), e.preventDefault(), t.toggle();
	            });
	        }, create: function create() {
	            var t,
	                n,
	                o = this.instance;this.$grid = e('<div class="fancybox-thumbs"></div>').appendTo(o.$refs.container), t = '<ul>', e.each(o.group, function (e, o) {
	                n = o.opts.thumb || (o.opts.$thumb ? o.opts.$thumb.attr('src') : null), n || 'image' !== o.type || (n = o.src), n && n.length && (t += '<li data-index="' + e + '"  tabindex="0" class="fancybox-thumbs-loading"><img data-src="' + n + '" /></li>');
	            }), t += '</ul>', this.$list = e(t).appendTo(this.$grid).on('click touchstart', 'li', function () {
	                o.jumpTo(e(this).data('index'));
	            }), this.$list.find('img').hide().one('load', function () {
	                var t,
	                    n,
	                    o,
	                    s,
	                    i = e(this).parent().removeClass('fancybox-thumbs-loading'),
	                    a = i.outerWidth(),
	                    r = i.outerHeight();t = this.naturalWidth || this.width, n = this.naturalHeight || this.height, o = t / a, s = n / r, o >= 1 && s >= 1 && (o > s ? (t /= s, n = r) : (t = a, n /= o)), e(this).css({ width: Math.floor(t), height: Math.floor(n), 'margin-top': Math.min(0, Math.floor(.3 * r - .3 * n)), 'margin-left': Math.min(0, Math.floor(.5 * a - .5 * t)) }).show();
	            }).each(function () {
	                this.src = e(this).data('src');
	            });
	        }, focus: function focus() {
	            this.instance.current && this.$list.children().removeClass('fancybox-thumbs-active').filter('[data-index="' + this.instance.current.index + '"]').addClass('fancybox-thumbs-active').focus();
	        }, close: function close() {
	            this.$grid.hide();
	        }, update: function update() {
	            this.instance.$refs.container.toggleClass('fancybox-container--thumbs', this.isVisible), this.isVisible ? (this.$grid || this.create(), this.$grid.show(), this.focus()) : this.$grid && this.$grid.hide(), this.instance.update();
	        }, hide: function hide() {
	            this.isVisible = !1, this.update();
	        }, show: function show() {
	            this.isVisible = !0, this.update();
	        }, toggle: function toggle() {
	            this.isVisible ? this.hide() : this.show();
	        } }), e(t).on('onInit.fb', function (t, e) {
	        var o = e.group[0],
	            s = e.group[1];e.opts.thumbs && !e.Thumbs && e.group.length > 1 && ('image' == o.type || o.opts.thumb || o.opts.$thumb) && ('image' == s.type || s.opts.thumb || s.opts.$thumb) && (e.Thumbs = new n(e));
	    }), e(t).on('beforeMove.fb', function (t, e, n) {
	        var o = e && e.Thumbs;o && (n.modal ? (o.$button.hide(), o.hide()) : (e.opts.thumbs.showOnStart === !0 && e.firstRun && o.show(), o.$button.show(), o.isVisible && o.focus()));
	    }), e(t).on('beforeClose.fb', function (t, e) {
	        e && e.Thumbs && (e.Thumbs.isVisible && e.opts.thumbs.hideOnClosing !== !1 && e.Thumbs.close(), e.Thumbs = null);
	    });
	}(document, __webpack_provided_window_dot_jQuery), function (t, e, n) {
	    'use strict';
	    function o() {
	        var t = e.location.hash.substr(1),
	            n = t.split('-'),
	            o = n.length > 1 && /^\+?\d+$/.test(n[n.length - 1]) ? parseInt(n.pop(-1), 10) || 1 : 1,
	            s = n.join('-');return o < 1 && (o = 1), { hash: t, index: o, gallery: s };
	    }function s(t) {
	        var e;'' !== t.gallery && (e = n("[data-fancybox='" + n.escapeSelector(t.gallery) + "']").eq(t.index - 1), e.length ? e.trigger('click') : n('#' + n.escapeSelector(t.gallery)).trigger('click'));
	    }function i(t) {
	        var e;return !!t && (e = t.current ? t.current.opts : t.opts, e.$orig ? e.$orig.data('fancybox') : e.hash || '');
	    }n.escapeSelector || (n.escapeSelector = function (t) {
	        var e = /([\0-\x1f\x7f]|^-?\d)|^-$|[^\x80-\uFFFF\w-]/g,
	            n = function n(t, e) {
	            return e ? '\0' === t ? '�' : t.slice(0, -1) + '\\' + t.charCodeAt(t.length - 1).toString(16) + ' ' : '\\' + t;
	        };return (t + '').replace(e, n);
	    });var a = null;n(function () {
	        setTimeout(function () {
	            n.fancybox.defaults.hash !== !1 && (n(e).on('hashchange.fb', function () {
	                var t = o();n.fancybox.getInstance() ? a && a !== t.gallery + '-' + t.index && (a = null, n.fancybox.close()) : '' !== t.gallery && s(t);
	            }), n(t).on({ 'onInit.fb': function onInitFb(t, e) {
	                    var n = o(),
	                        s = i(e);s && n.gallery && s == n.gallery && (e.currIndex = n.index - 1);
	                }, 'beforeMove.fb': function beforeMoveFb(n, o, s) {
	                    var r = i(o);r && '' !== r && (e.location.hash.indexOf(r) < 0 && (o.opts.origHash = e.location.hash), a = r + (o.group.length > 1 ? '-' + (s.index + 1) : ''), 'pushState' in history ? history.pushState('', t.title, e.location.pathname + e.location.search + '#' + a) : e.location.hash = a);
	                }, 'beforeClose.fb': function beforeCloseFb(n, o, s) {
	                    var r = i(o),
	                        c = o && o.opts.origHash ? o.opts.origHash : '';r && '' !== r && ('pushState' in history ? history.pushState('', t.title, e.location.pathname + e.location.search + c) : e.location.hash = c), a = null;
	                } }), s(o()));
	        }, 50);
	    });
	}(document, window, __webpack_provided_window_dot_jQuery);
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(8)))

/***/ }),

/***/ 333:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var $ = __webpack_require__(8);
	
	__webpack_require__(962);
	
	module.exports = function () {
	  var methods = {
	    init: function init() {
	      var platform = /(iphone|ipod|ipad)/.test(navigator.userAgent.toLowerCase()) ? ' ios' : '';
	      return this.each(function (i, el) {
	        $(el).wrap('<span class="fancyselect' + platform + '" />').before('<span class="arrows" />').before('<span class="selecttext" />').fadeTo(0, 0).focus(function () {
	          $(el).parent('span').addClass('focus');
	        }).blur(function () {
	          $(el).parent('span').removeClass('focus');
	        }).on('change keydown keyup', function () {
	          $(el).fancyselect('update');
	        }).fancyselect('update');
	        if ($(el).attr('disabled')) $(el).fancyselect('disable');
	      });
	    },
	    destroy: function destroy() {
	      return this.each(function (i, el) {
	        $(el).siblings('span').remove();
	        $(el).unwrap().fadeTo(0, 1).unbind('focus blur change keydown keyup');
	      });
	    },
	    enable: function enable() {
	      return this.each(function (i, el) {
	        $(el).removeAttr('disabled').parent().removeClass('disabled');
	      });
	    },
	    disable: function disable() {
	      return this.each(function (i, el) {
	        $(el).attr('disabled', 'disabled').parent().addClass('disabled');
	      });
	    },
	    update: function update() {
	      return this.each(function (i, el) {
	        $(el).prev('.selecttext').text($(el).children('option:selected').text());
	      });
	    }
	  };
	
	  $.fn.fancyselect = function (method) {
	    if (methods[method]) {
	      return methods[method].apply(this, Array.prototype.slice.call(arguments, 1));
	    } else if ((typeof method === 'undefined' ? 'undefined' : _typeof(method)) === 'object' || !method) {
	      return methods.init.apply(this, arguments);
	    } else {
	      $.error('Method ' + method + ' does not exist for .fancyselect()');
	    }
	  };
	
	  $('.sort_list').fancyselect();
	};

/***/ }),

/***/ 334:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var formsClass = 'pbz_form';
	
	var $ = __webpack_require__(8);
	var swal = __webpack_require__(953);
	__webpack_require__(342);
	__webpack_require__(346);
	
	__webpack_require__(963);
	
	module.exports = function () {
	    /**
	     * Сбор данных из формы
	     *
	     * @param options
	     * @returns {*}
	     */
	    $.fn.formData = function (options) {
	        if (this === undefined) {
	            return 'error';
	        }
	
	        var settings = $.extend({
	            'select_attr': 'name',
	            'textvalue': false,
	            'validator': false,
	            'invalid': false,
	            'valid': false,
	            'callback': false
	        }, options);
	
	        var send_obj = {};
	
	        var put = function put(key, val, title, obj) {
	            if (key.indexOf('[]') > -1 && key[key.length - 1] === ']' && key[key.length - 2] === '[') {
	                key = key.replace('[]', '');
	
	                if (send_obj[key] !== undefined && Object.prototype.toString.call(send_obj[key]) === '[object Array]') {
	                    send_obj[key].push({ val: val, title: title, obj: obj });
	                } else {
	                    send_obj[key] = [{ val: val, title: title, obj: obj }];
	                }
	            } else {
	                send_obj[key] = { val: val, title: title, obj: obj };
	            }
	            obj.rules = getValidateRules(obj);
	
	            if (settings.validator === false) settings.validator = {};
	
	            for (var rule in obj.rules) {
	                if (typeof settings.validator[key] == 'undefined') settings.validator[key] = [];
	                settings.validator[key][settings.validator[key].length] = rule;
	            }
	        };
	
	        var getValidateRules = function getValidateRules(obj) {
	            var data = obj.data(),
	                rules = {},
	                dataKey;
	            for (dataKey in data) {
	                if (dataKey.indexOf('validate') === 0) {
	                    rules[dataKey.replace('validate', '').toLowerCase()] = data[dataKey];
	                }
	            }
	
	            return rules;
	        };
	
	        // get text/hidden input and textarea
	        var txt = $('textarea:enabled, input[type=hidden]:enabled, input[type!=checkbox][type!=radio]:enabled', this);
	
	        $.each(txt, function (i, j) {
	            if ($(j).attr(settings.select_attr) !== undefined && $(j).not(':disabled')) {
	                put($(j).attr(settings.select_attr), $(j).val(), $(j).data('title'), $(j));
	            }
	        });
	
	        // get select
	        var select = $('select:enabled', this);
	
	        $.each(select, function (i, j) {
	            if ($(j).attr(settings.select_attr) !== undefined && $(j).not(':disabled')) {
	                if (settings.textvalue === true) {
	                    put($(j).attr(settings.select_attr), $(j).children('option:selected').text(), $(j).data('title'), $(j));
	                } else {
	                    put($(j).attr(settings.select_attr), $(j).val(), $(j).data('title'), $(j));
	                }
	            }
	        });
	
	        // get radiobuttons
	        var radio = $('input[type=radio]:checked:enabled', this);
	
	        $.each(radio, function (i, j) {
	            put($(j).attr('name'), $(j).attr('value'), $(j).data('title'), $(j));
	        });
	
	        // get checkboxes
	        var checkBox = $('input[type=checkbox]:checked:enabled', this);
	
	        // var checkData = {};
	        $.each(checkBox, function (i, j) {
	            // if(typeof checkData[$(j).attr('name')] === 'undefined'){
	            //     checkData[$(j).attr('name')] = {
	            //         title: $(j).data('title'),
	            //         object: $(j),
	            //         values: []
	            //     };
	            // }
	            //
	            // checkData[$(j).attr('name')].values.push($(j).attr('value'));
	            put($(j).attr('name'), $(j).attr('value'), $(j).data('title'), $(j));
	        });
	
	        // if(Object.keys(checkData).length){
	        //     for(var key in checkData) {
	        //         put(key, checkData[key].values.join('; '), checkData[key].title, checkData[key].object);
	        //     }
	        // }
	
	        // validation  ==============================================
	        var checkValid = function checkValid(val, rule) {
	            var re;
	
	            switch (rule) {
	
	                case 'email':
	                case 'required':
	                    return !(val === undefined || val.length === 0);
	
	                    re = /^(([^<>()[\]\.,;:\s@\"]+(\.[^<>()[\]\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
	                    return re.test(val);
	
	                case 'phone':
	                    re = /^\+?[-\(\)\d\s]{5,19}$/;
	                    return re.test(val);
	
	                case 'uaphone':
	                    re = /\+38 \(0[0-9]{2}\) [0-9]{3}-[0-9]{2}-[0-9]{2}/g;
	                    return re.test(val);
	
	                case 'ruphone':
	                    re = /\+7 \([0-9]{3}\) [0-9]{3}-[0-9]{2}-[0-9]{2}/g;
	                    return re.test(val);
	
	                case 'url':
	                    re = /^(https?:\/\/)?[a-z0-9~_\-\.]+\.[a-z]{2,9}(\/|:|\?[!-~]*)*?$/;
	                    return re.test(val);
	
	                case 'alpha':
	                    re = /^[a-zA-Z]+$/;
	                    return re.test(val);
	
	                case 'alpha_num':
	                    re = /^[a-zA-Z0-9]+$/;
	                    return re.test(val);
	
	                case 'alpha_dash':
	                    re = /^[-_a-zA-Z0-9]+$/;
	                    return re.test(val);
	            }
	
	            if (rule.indexOf(':') > -1) {
	                rule = rule.split(':');
	
	                switch (rule[0]) {
	                    case 'len':
	                        return rule.slice(1, rule.length).some(function (el) {
	                            return val.length == el;
	                        });
	
	                    case 'range_len':
	                        return val.length >= rule[1] && val.length <= rule[2];
	
	                    case 'max':
	                        return val <= rule[1];
	
	                    case 'min':
	                        return val >= rule[1];
	
	                    case 'range':
	                        return val >= rule[1] && val <= rule[2];
	
	                    case 'not':
	                        return val != rule[1];
	
	                    case 'is':
	                        return rule.slice(1, rule.length).some(function (el) {
	                            return val == send_obj[el];
	                        });
	
	                    case 'same':
	                        return val == send_obj[rule[1]];
	
	                    case 'diff':
	                        return val != send_obj[rule[1]];
	                }
	            }
	
	            return true;
	        };
	
	        var inValidEl = {};
	
	        if (settings.validator) {
	            for (var k in settings.validator) {
	                for (var i = 0; i < settings.validator[k].length; i++) {
	                    if (!checkValid(send_obj[k].val, settings.validator[k][i])) {
	                        if (inValidEl[k] === undefined) inValidEl[k] = [];
	                        inValidEl[k].push(settings.validator[k][i].split(':')[0]);
	                    }
	                }
	            }
	        }
	
	        if (!$.isEmptyObject(inValidEl) && settings.invalid) {
	            settings.invalid({ 'errors': inValidEl, obj: send_obj });
	            return false;
	        } else if (settings.valid) {
	            settings.valid();
	        }
	
	        // callback function =========================================
	        if (settings.callback) {
	            inValidEl = $.isEmptyObject(inValidEl) || inValidEl;
	            settings.callback(send_obj, inValidEl);
	        }
	
	        return send_obj;
	    };
	
	    /**
	     * Валидация
	     *
	     * @param options
	     */
	    $.fn.validateTooltip = function (options) {
	        var $this = $(this);
	        console.log($this);
	        var top = parseInt($this.offset().top - 34, 10);
	        var left = parseInt($this.offset().left + $this.width() / 2, 10);
	
	        $this.tooltip = $('<div class="validate-error" style="top:' + top + 'px; left:' + left + 'px">' + '<div class="animated"><div><i></i>' + options.text + '</div></div>' + '</div>');
	
	        $('body').append($this.tooltip);
	
	        $this.tooltip.find('.animated').addClass('shake');
	
	        $this.click(function () {
	            $this.tooltip.remove();
	        });
	    };
	
	    /**
	     * Отправка формы
	     */
	    $(document).on('submit', 'form.' + formsClass, function (e) {
	        e.preventDefault();
	        var form = $(this);
	        $('.validate-error').remove();
	        if (form.hasClass('reviews-form') && form.find('input[name=agree]:checked').length == 0) {
	            form.find('.checkbox').validateTooltip({
	                text: 'Обязательное поле'
	            });
	            return false;
	        }
	        if (form.hasClass('contacts-form') && form.find('input[name=agree]:checked').length == 0) {
	            form.find('.checkbox-agree').validateTooltip({
	                text: 'Обязательное поле'
	            });
	            return false;
	        }
	
	        if (!form.hasClass('disabled')) {
	            var data = form.formData({
	                validator: {},
	                invalid: function invalid(data) {
	                    for (var name in data.errors) {
	                        data.obj[name].obj.validateTooltip({
	                            text: data.obj[name].obj.rules[data.errors[name][0]]
	                        });
	                    }
	                }
	            });
	
	            for (var key in data) {
	                if (typeof data[key].length !== 'undefined' && typeof data[key][0] !== 'undefined') {
	                    var param = {
	                        title: data[key][0].title
	                    };
	                    var values = [];
	                    for (var i in data[key]) {
	                        values.push(data[key][i].val);
	                    }
	                    param.val = values.join(', ');
	                    data[key] = param;
	                }
	            }
	
	            if (form.attr('id') == 'registration' || form.attr('id') == 'login') {
	                if (data === false) {
	                    return false;
	                } else {
	                    var fd = new FormData(this);
	                }
	            } else {
	                if (form.hasClass('reviews-form') && form.find('input[type=radio]:checked:enabled').length == 0) {
	                    form.find('.rating').validateTooltip({
	                        text: 'Сделайте выбор!'
	                    });
	                    return false;
	                }
	
	                var files = {};
	                var isset_files = false;
	
	                if (data === false) {
	                    return false;
	                } else {
	                    for (var el in data) {
	                        if (typeof data[el].obj !== 'undefined' && data[el].obj[0].type == 'file') {
	                            isset_files = true;
	                            files[el] = data[el];
	                            delete data[el];
	                        } else delete data[el].obj;
	                    }
	                }
	
	                var info = getInfo();
	
	                $.extend(data, info);
	                var fd = new FormData();
	
	                if (isset_files) {
	                    for (var el in files) {
	                        var field = files[el].obj.get(0);
	                        for (var i = 0; i < field.files.length; i++) {
	                            fd.append(el, field.files[i]);
	                        }
	                    }
	                }
	
	                fd.append('data', JSON.stringify(data));
	            }
	
	            var url = form.attr('action') || '/api.php';
	            $.ajax({
	                url: url,
	                type: 'POST',
	                processData: false,
	                contentType: false,
	                // data: {data: JSON.stringify(data)},
	                data: fd,
	                dataType: 'json',
	                beforeSend: function beforeSend() {
	                    form.addClass('disabled');
	                    var submit = form.find('button[type="submit"]');
	                    if (submit.data('textsending')) {
	                        submit.html(submit.data('textsending'));
	                    } else {
	                        submit.html('Отправляем...');
	                    }
	                },
	                success: function success(response) {
	                    if (typeof dataLayer !== 'undefined') {
	                        var page = $(form).find('[name="tagmanager"]').val();
	                        if (typeof page !== 'undefined') {
	                            dataLayer.push({
	                                'event': 'VirtualPageview',
	                                'virtualPageURL': page,
	                                'virtualPageTitle': page.replace('/', '')
	                            });
	                        }
	                    }
	
	                    if (typeof response.status !== 'undefined' && response.status == 'success') {
	                        form.trigger('reset');
	                        var submit = form.find('button[type="submit"]');
	                        if (submit.data('textsent')) {
	                            submit.html(submit.data('textsent'));
	                        } else {
	                            submit.html('Отправлено');
	                        }
	                    }
	
	                    if (typeof response.status !== 'undefined' && response.status == 'success') {
	                        form.trigger('sent', response);
	                        if (typeof form.data('success-title') !== 'undefined' || typeof form.data('success-message') !== 'undefined') {
	                            swal(form.data('success-title'), form.data('success-message'), 'success');
	                        }
	                        if (typeof form.data('success-redirect') !== 'undefined') {
	                            window.location = form.data('success-redirect');
	                        }
	                    } else {
	                        form.trigger('error', response);
	                        if (form.attr('id') == 'registration' && typeof response.status === 'undefined') {
	                            for (var key in response) {
	                                form.find('[name="' + key + '"]').validateTooltip({
	                                    text: response[key]
	                                });
	                            }
	                        } else if (typeof form.data('error-title') !== 'undefined' || typeof form.data('error-message') !== 'undefined') {
	                            swal(form.data('error-title'), form.data('error-message'), 'error');
	                        }
	                    }
	                },
	                error: function error(response) {
	                    form.removeClass('disabled');
	                    form.find('button[type="submit"]').html('Не вышло :(');
	                    form.trigger('error', response);
	                    if (typeof form.data('error-title') !== 'undefined' || typeof form.data('error-message') !== 'undefined') {
	                        swal(form.data('error-title'), form.data('error-message'), 'error');
	                    }
	                }
	            });
	        }
	
	        return true;
	    });
	
	    // function toFormData(obj) {
	    //   var data = new FormData();
	    //
	    //   $.each(obj, function(key, value) {
	    //     data.append(key, value);
	    //   });
	    //
	    //   return data;
	    // }
	
	    function parseGetParams() {
	        var $_GET = {};
	        var __GET = window.location.search.substring(1).split('&');
	        for (var i = 0; i < __GET.length; i++) {
	            var getVar = __GET[i].split('=');
	            $_GET[getVar[0]] = typeof getVar[1] == 'undefined' ? '' : getVar[1];
	        }
	        return $_GET;
	    }
	
	    function getInfo() {
	        var keys = parseGetParams();
	        var host_s = window.location.host + window.location.pathname.slice(0, -1);
	        return {
	            history: { title: '', val: history.length },
	            js_user_agent: { title: '', val: getUserAgent(navigator.userAgent) },
	            get: { title: 'Страница', val: window.location.href },
	            /*  referer: {
	                title: 'Заявка пришла со страницы',
	                val: (typeof document.referrer == 'undefined' ? 'NULL' : document.referrer)
	              },*/
	            host: { title: '', val: host_s },
	            utm_source: {
	                title: 'Поисковая система',
	                val: typeof keys['utm_source'] == 'undefined' ? '' : keys['utm_source']
	            },
	            utm_campaign: {
	                title: 'Кампания',
	                val: typeof keys['utm_campaign'] == 'undefined' ? '' : keys['utm_campaign']
	            },
	            utm_term: {
	                title: 'Ключ',
	                val: typeof keys['utm_term'] == 'undefined' ? '' : decodeURIComponent(keys['utm_term'])
	            }
	        };
	    }
	
	    function getUserAgent(u) {
	        var ua = u.toLowerCase(),
	            is = function is(t) {
	            return ua.indexOf(t) > -1;
	        },
	            g = 'gecko',
	            w = 'webkit',
	            s = 'safari',
	            o = 'opera',
	            m = 'mobile',
	            h = document.documentElement,
	            b = [!/opera|webtv/i.test(ua) && /msie\s(\d)/.test(ua) ? 'ie ie' + RegExp.$1 : is('firefox/2') ? g + ' ff2' : is('firefox/3.5') ? g + ' ff3 ff3_5' : is('firefox/3.6') ? g + ' ff3 ff3_6' : is('firefox/3') ? g + ' ff3' : is('gecko/') ? g : is('opera') ? o + (/version\/(\d+)/.test(ua) ? ' ' + o + RegExp.$1 : /opera(\s|\/)(\d+)/.test(ua) ? ' ' + o + RegExp.$2 : '') : is('konqueror') ? 'konqueror' : is('blackberry') ? m + ' blackberry' : is('android') ? m + ' android' : is('chrome') ? w + ' chrome' : is('iron') ? w + ' iron' : is('applewebkit/') ? w + ' ' + s + (/version\/(\d+)/.test(ua) ? ' ' + s + RegExp.$1 : '') : is('mozilla/') ? g : '', is('j2me') ? m + ' j2me' : is('iphone') ? m + ' iphone' : is('ipod') ? m + ' ipod' : is('ipad') ? m + ' ipad' : is('mac') ? 'mac' : is('darwin') ? 'mac' : is('webtv') ? 'webtv' : is('win') ? 'win' + (is('windows nt 6.0') ? ' vista' : '') : is('freebsd') ? 'freebsd' : is('x11') || is('linux') ? 'linux' : '', 'js'];
	
	        var c = b.join(' ');
	        h.className += ' ' + c;
	        return c;
	    }
	
	    /**
	     * Удаление сообщений валидатора
	     */
	    $(document).on('click', function () {
	        $('body > .validate-error').remove();
	    });
	
	    /**
	     * Настройка селектов
	     */
	    $('form.' + formsClass + ' .chosen-select').each(function () {
	        var $this = $(this);
	        var settings = {};
	        if (_typeof($this.data('settings')) === 'object') {
	            settings = $this.data('settings');
	        }
	        $this.chosen(settings);
	
	        if (typeof $this.data('limit-error') !== 'undefined') {
	            $this.bind('chosen:maxselected', function () {
	                swal($this.data('limit-error'), '', 'error');
	                $('[type="submit"]').focus();
	            });
	        }
	    });
	
	    /**
	     * Маска телефона
	     */
	    $('form.' + formsClass + ' input[name="phone"]').each(function () {
	        var $this = $(this);
	        if (typeof $this.data('validate-uaphone') !== 'undefined') $this.mask('+38 (999) 999-99-99');
	
	        if (typeof $this.data('validate-ruphone') !== 'undefined') $this.mask('+7 (999) 999-99-99');
	    });
	};

/***/ }),

/***/ 335:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var $ = __webpack_require__(8);
	__webpack_require__(349);
	__webpack_require__(348);
	__webpack_require__(964);
	
	module.exports = function () {
	  function initjScrollPane() {
	    setTimeout(function () {
	      $('.jScrollPane:not(.jspScrollable)').each(function () {
	        var $this = $(this);
	
	        if ($this.height() > 0) {
	          $this.jScrollPane();
	        }
	      });
	    }, 100);
	  }
	
	  $(document).click(initjScrollPane);
	  initjScrollPane();
	};

/***/ }),

/***/ 336:
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(jQuery) {'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var $ = __webpack_require__(8);
	
	__webpack_require__(965);
	
	module.exports = function () {
	  /**
	   * Copyright 2010 Tim Down.
	   *
	   * Licensed under the Apache License, Version 2.0 (the "License");
	   * you may not use this file except in compliance with the License.
	   * You may obtain a copy of the License at
	   *
	   *      http://www.apache.org/licenses/LICENSE-2.0
	   *
	   * Unless required by applicable law or agreed to in writing, software
	   * distributed under the License is distributed on an "AS IS" BASIS,
	   * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	   * See the License for the specific language governing permissions and
	   * limitations under the License.
	   */
	
	  /**
	   * jshashtable
	   *
	   * jshashtable is a JavaScript implementation of a hash table. It creates a single constructor function called Hashtable
	   * in the global scope.
	   *
	   * Author: Tim Down <tim@timdown.co.uk>
	   * Version: 2.1
	   * Build date: 21 March 2010
	   * Website: http://www.timdown.co.uk/jshashtable
	   */
	
	  var Hashtable = function () {
	    var FUNCTION = 'function';
	
	    var arrayRemoveAt = _typeof(Array.prototype.splice) == FUNCTION ? function (arr, idx) {
	      arr.splice(idx, 1);
	    } : function (arr, idx) {
	      var itemsAfterDeleted, i, len;
	      if (idx === arr.length - 1) {
	        arr.length = idx;
	      } else {
	        itemsAfterDeleted = arr.slice(idx + 1);
	        arr.length = idx;
	        for (i = 0, len = itemsAfterDeleted.length; i < len; ++i) {
	          arr[idx + i] = itemsAfterDeleted[i];
	        }
	      }
	    };
	
	    function hashObject(obj) {
	      var hashCode;
	      if (typeof obj == 'string') {
	        return obj;
	      } else if (_typeof(obj.hashCode) == FUNCTION) {
	        // Check the hashCode method really has returned a string
	        hashCode = obj.hashCode();
	        return typeof hashCode == 'string' ? hashCode : hashObject(hashCode);
	      } else if (_typeof(obj.toString) == FUNCTION) {
	        return obj.toString();
	      } else {
	        try {
	          return String(obj);
	        } catch (ex) {
	          // For host objects (such as ActiveObjects in IE) that have no toString() method and throw an error when
	          // passed to String()
	          return Object.prototype.toString.call(obj);
	        }
	      }
	    }
	
	    function equals_fixedValueHasEquals(fixedValue, variableValue) {
	      return fixedValue.equals(variableValue);
	    }
	
	    function equals_fixedValueNoEquals(fixedValue, variableValue) {
	      return _typeof(variableValue.equals) == FUNCTION ? variableValue.equals(fixedValue) : fixedValue === variableValue;
	    }
	
	    function createKeyValCheck(kvStr) {
	      return function (kv) {
	        if (kv === null) {
	          throw new Error('null is not a valid ' + kvStr);
	        } else if (typeof kv == 'undefined') {
	          throw new Error(kvStr + ' must not be undefined');
	        }
	      };
	    }
	
	    var checkKey = createKeyValCheck('key'),
	        checkValue = createKeyValCheck('value');
	
	    /*----------------------------------------------------------------------------------------------------------------*/
	
	    function Bucket(hash, firstKey, firstValue, equalityFunction) {
	      this[0] = hash;
	      this.entries = [];
	      this.addEntry(firstKey, firstValue);
	
	      if (equalityFunction !== null) {
	        this.getEqualityFunction = function () {
	          return equalityFunction;
	        };
	      }
	    }
	
	    var EXISTENCE = 0,
	        ENTRY = 1,
	        ENTRY_INDEX_AND_VALUE = 2;
	
	    function createBucketSearcher(mode) {
	      return function (key) {
	        var i = this.entries.length,
	            entry,
	            equals = this.getEqualityFunction(key);
	        while (i--) {
	          entry = this.entries[i];
	          if (equals(key, entry[0])) {
	            switch (mode) {
	              case EXISTENCE:
	                return true;
	              case ENTRY:
	                return entry;
	              case ENTRY_INDEX_AND_VALUE:
	                return [i, entry[1]];
	            }
	          }
	        }
	        return false;
	      };
	    }
	
	    function createBucketLister(entryProperty) {
	      return function (aggregatedArr) {
	        var startIndex = aggregatedArr.length;
	        for (var i = 0, len = this.entries.length; i < len; ++i) {
	          aggregatedArr[startIndex + i] = this.entries[i][entryProperty];
	        }
	      };
	    }
	
	    Bucket.prototype = {
	      getEqualityFunction: function getEqualityFunction(searchValue) {
	        return _typeof(searchValue.equals) == FUNCTION ? equals_fixedValueHasEquals : equals_fixedValueNoEquals;
	      },
	
	      getEntryForKey: createBucketSearcher(ENTRY),
	
	      getEntryAndIndexForKey: createBucketSearcher(ENTRY_INDEX_AND_VALUE),
	
	      removeEntryForKey: function removeEntryForKey(key) {
	        var result = this.getEntryAndIndexForKey(key);
	        if (result) {
	          arrayRemoveAt(this.entries, result[0]);
	          return result[1];
	        }
	        return null;
	      },
	
	      addEntry: function addEntry(key, value) {
	        this.entries[this.entries.length] = [key, value];
	      },
	
	      keys: createBucketLister(0),
	
	      values: createBucketLister(1),
	
	      getEntries: function getEntries(entries) {
	        var startIndex = entries.length;
	        for (var i = 0, len = this.entries.length; i < len; ++i) {
	          // Clone the entry stored in the bucket before adding to array
	          entries[startIndex + i] = this.entries[i].slice(0);
	        }
	      },
	
	      containsKey: createBucketSearcher(EXISTENCE),
	
	      containsValue: function containsValue(value) {
	        var i = this.entries.length;
	        while (i--) {
	          if (value === this.entries[i][1]) {
	            return true;
	          }
	        }
	        return false;
	      }
	    };
	
	    /*----------------------------------------------------------------------------------------------------------------*/
	
	    // Supporting functions for searching hashtable buckets
	
	    function searchBuckets(buckets, hash) {
	      var i = buckets.length,
	          bucket;
	      while (i--) {
	        bucket = buckets[i];
	        if (hash === bucket[0]) {
	          return i;
	        }
	      }
	      return null;
	    }
	
	    function getBucketForHash(bucketsByHash, hash) {
	      var bucket = bucketsByHash[hash];
	
	      // Check that this is a genuine bucket and not something inherited from the bucketsByHash's prototype
	      return bucket && bucket instanceof Bucket ? bucket : null;
	    }
	
	    /*----------------------------------------------------------------------------------------------------------------*/
	
	    function Hashtable(hashingFunctionParam, equalityFunctionParam) {
	      var that = this;
	      var buckets = [];
	      var bucketsByHash = {};
	
	      var hashingFunction = (typeof hashingFunctionParam === 'undefined' ? 'undefined' : _typeof(hashingFunctionParam)) == FUNCTION ? hashingFunctionParam : hashObject;
	      var equalityFunction = (typeof equalityFunctionParam === 'undefined' ? 'undefined' : _typeof(equalityFunctionParam)) == FUNCTION ? equalityFunctionParam : null;
	
	      this.put = function (key, value) {
	        checkKey(key);
	        checkValue(value);
	        var hash = hashingFunction(key),
	            bucket,
	            bucketEntry,
	            oldValue = null;
	
	        // Check if a bucket exists for the bucket key
	        bucket = getBucketForHash(bucketsByHash, hash);
	        if (bucket) {
	          // Check this bucket to see if it already contains this key
	          bucketEntry = bucket.getEntryForKey(key);
	          if (bucketEntry) {
	            // This bucket entry is the current mapping of key to value, so replace old value and we're done.
	            oldValue = bucketEntry[1];
	            bucketEntry[1] = value;
	          } else {
	            // The bucket does not contain an entry for this key, so add one
	            bucket.addEntry(key, value);
	          }
	        } else {
	          // No bucket exists for the key, so create one and put our key/value mapping in
	          bucket = new Bucket(hash, key, value, equalityFunction);
	          buckets[buckets.length] = bucket;
	          bucketsByHash[hash] = bucket;
	        }
	        return oldValue;
	      };
	
	      this.get = function (key) {
	        checkKey(key);
	
	        var hash = hashingFunction(key);
	
	        // Check if a bucket exists for the bucket key
	        var bucket = getBucketForHash(bucketsByHash, hash);
	        if (bucket) {
	          // Check this bucket to see if it contains this key
	          var bucketEntry = bucket.getEntryForKey(key);
	          if (bucketEntry) {
	            // This bucket entry is the current mapping of key to value, so return the value.
	            return bucketEntry[1];
	          }
	        }
	        return null;
	      };
	
	      this.containsKey = function (key) {
	        checkKey(key);
	        var bucketKey = hashingFunction(key);
	
	        // Check if a bucket exists for the bucket key
	        var bucket = getBucketForHash(bucketsByHash, bucketKey);
	
	        return bucket ? bucket.containsKey(key) : false;
	      };
	
	      this.containsValue = function (value) {
	        checkValue(value);
	        var i = buckets.length;
	        while (i--) {
	          if (buckets[i].containsValue(value)) {
	            return true;
	          }
	        }
	        return false;
	      };
	
	      this.clear = function () {
	        buckets.length = 0;
	        bucketsByHash = {};
	      };
	
	      this.isEmpty = function () {
	        return !buckets.length;
	      };
	
	      var createBucketAggregator = function createBucketAggregator(bucketFuncName) {
	        return function () {
	          var aggregated = [],
	              i = buckets.length;
	          while (i--) {
	            buckets[i][bucketFuncName](aggregated);
	          }
	          return aggregated;
	        };
	      };
	
	      this.keys = createBucketAggregator('keys');
	      this.values = createBucketAggregator('values');
	      this.entries = createBucketAggregator('getEntries');
	
	      this.remove = function (key) {
	        checkKey(key);
	
	        var hash = hashingFunction(key),
	            bucketIndex,
	            oldValue = null;
	
	        // Check if a bucket exists for the bucket key
	        var bucket = getBucketForHash(bucketsByHash, hash);
	
	        if (bucket) {
	          // Remove entry from this bucket for this key
	          oldValue = bucket.removeEntryForKey(key);
	          if (oldValue !== null) {
	            // Entry was removed, so check if bucket is empty
	            if (!bucket.entries.length) {
	              // Bucket is empty, so remove it from the bucket collections
	              bucketIndex = searchBuckets(buckets, hash);
	              arrayRemoveAt(buckets, bucketIndex);
	              delete bucketsByHash[hash];
	            }
	          }
	        }
	        return oldValue;
	      };
	
	      this.size = function () {
	        var total = 0,
	            i = buckets.length;
	        while (i--) {
	          total += buckets[i].entries.length;
	        }
	        return total;
	      };
	
	      this.each = function (callback) {
	        var entries = that.entries(),
	            i = entries.length,
	            entry;
	        while (i--) {
	          entry = entries[i];
	          callback(entry[0], entry[1]);
	        }
	      };
	
	      this.putAll = function (hashtable, conflictCallback) {
	        var entries = hashtable.entries();
	        var entry,
	            key,
	            value,
	            thisValue,
	            i = entries.length;
	        var hasConflictCallback = (typeof conflictCallback === 'undefined' ? 'undefined' : _typeof(conflictCallback)) == FUNCTION;
	        while (i--) {
	          entry = entries[i];
	          key = entry[0];
	          value = entry[1];
	
	          // Check for a conflict. The default behaviour is to overwrite the value for an existing key
	          if (hasConflictCallback && (thisValue = that.get(key))) {
	            value = conflictCallback(key, thisValue, value);
	          }
	          that.put(key, value);
	        }
	      };
	
	      this.clone = function () {
	        var clone = new Hashtable(hashingFunctionParam, equalityFunctionParam);
	        clone.putAll(that);
	        return clone;
	      };
	    }
	
	    return Hashtable;
	  }();
	
	  $.baseClass = function (obj) {
	    obj = $(obj);
	    return obj.get(0).className.match(/([^ ]+)/)[1];
	  };
	
	  $.fn.addDependClass = function (className, delimiter) {
	    var options = {
	      delimiter: delimiter ? delimiter : '-'
	    };
	    return this.each(function () {
	      var baseClass = $.baseClass(this);
	      if (baseClass) $(this).addClass(baseClass + options.delimiter + className);
	    });
	  };
	
	  $.fn.removeDependClass = function (className, delimiter) {
	    var options = {
	      delimiter: delimiter ? delimiter : '-'
	    };
	    return this.each(function () {
	      var baseClass = $.baseClass(this);
	      if (baseClass) $(this).removeClass(baseClass + options.delimiter + className);
	    });
	  };
	
	  $.fn.toggleDependClass = function (className, delimiter) {
	    var options = {
	      delimiter: delimiter ? delimiter : '-'
	    };
	    return this.each(function () {
	      var baseClass = $.baseClass(this);
	      if (baseClass) if ($(this).is('.' + baseClass + options.delimiter + className)) $(this).removeClass(baseClass + options.delimiter + className);else $(this).addClass(baseClass + options.delimiter + className);
	    });
	  };
	
	  function Draggable() {
	    this._init.apply(this, arguments);
	  }
	
	  Draggable.prototype.oninit = function () {};
	
	  Draggable.prototype.events = function () {};
	
	  Draggable.prototype.onmousedown = function () {
	    this.ptr.css({ position: 'absolute' });
	  };
	
	  Draggable.prototype.onmousemove = function (evt, x, y) {
	    this.ptr.css({ left: x, top: y });
	  };
	
	  Draggable.prototype.onmouseup = function () {};
	
	  Draggable.prototype.isDefault = {
	    drag: false,
	    clicked: false,
	    toclick: true,
	    mouseup: false
	  };
	
	  Draggable.prototype._init = function () {
	    if (arguments.length > 0) {
	      this.ptr = $(arguments[0]);
	      this.outer = $('.draggable-outer');
	
	      this.is = {};
	      $.extend(this.is, this.isDefault);
	
	      var _offset = this.ptr.offset();
	      this.d = {
	        left: _offset.left,
	        top: _offset.top,
	        width: this.ptr.width(),
	        height: this.ptr.height()
	      };
	
	      this.oninit.apply(this, arguments);
	
	      this._events();
	    }
	  };
	
	  Draggable.prototype._getPageCoords = function (event) {
	    if (event.targetTouches && event.targetTouches[0]) {
	      return { x: event.targetTouches[0].pageX, y: event.targetTouches[0].pageY };
	    } else return { x: event.pageX, y: event.pageY };
	  };
	
	  Draggable.prototype._bindEvent = function (ptr, eventType, handler) {
	    var self = this;
	
	    if (this.supportTouches_) ptr.get(0).addEventListener(this.events_[eventType], handler, false);else ptr.bind(this.events_[eventType], handler);
	  };
	
	  Draggable.prototype._events = function () {
	    var self = this;
	
	    this.supportTouches_ = 'ontouchend' in document;
	    this.events_ = {
	      'click': this.supportTouches_ ? 'touchstart' : 'click',
	      'down': this.supportTouches_ ? 'touchstart' : 'mousedown',
	      'move': this.supportTouches_ ? 'touchmove' : 'mousemove',
	      'up': this.supportTouches_ ? 'touchend' : 'mouseup'
	    };
	
	    this._bindEvent($(document), 'move', function (event) {
	      if (self.is.drag) {
	        event.stopPropagation();
	        event.preventDefault();
	        self._mousemove(event);
	      }
	    });
	    this._bindEvent($(document), 'down', function (event) {
	      if (self.is.drag) {
	        event.stopPropagation();
	        event.preventDefault();
	      }
	    });
	    this._bindEvent($(document), 'up', function (event) {
	      self._mouseup(event);
	    });
	
	    this._bindEvent(this.ptr, 'down', function (event) {
	      self._mousedown(event);
	      return false;
	    });
	    this._bindEvent(this.ptr, 'up', function (event) {
	      self._mouseup(event);
	    });
	
	    this.ptr.find('a').click(function () {
	      self.is.clicked = true;
	
	      if (!self.is.toclick) {
	        self.is.toclick = true;
	        return false;
	      }
	    }).mousedown(function (event) {
	      self._mousedown(event);
	      return false;
	    });
	
	    this.events();
	  };
	
	  Draggable.prototype._mousedown = function (evt) {
	    this.is.drag = true;
	    this.is.clicked = false;
	    this.is.mouseup = false;
	
	    var _offset = this.ptr.offset();
	    var coords = this._getPageCoords(evt);
	    this.cx = coords.x - _offset.left;
	    this.cy = coords.y - _offset.top;
	
	    $.extend(this.d, {
	      left: _offset.left,
	      top: _offset.top,
	      width: this.ptr.width(),
	      height: this.ptr.height()
	    });
	
	    if (this.outer && this.outer.get(0)) {
	      this.outer.css({ height: Math.max(this.outer.height(), $(document.body).height()), overflow: 'hidden' });
	    }
	
	    this.onmousedown(evt);
	  };
	
	  Draggable.prototype._mousemove = function (evt) {
	    this.is.toclick = false;
	    var coords = this._getPageCoords(evt);
	    this.onmousemove(evt, coords.x - this.cx, coords.y - this.cy);
	  };
	
	  Draggable.prototype._mouseup = function (evt) {
	    var oThis = this;
	
	    if (this.is.drag) {
	      this.is.drag = false;
	
	      if (this.outer && this.outer.get(0)) {
	        if ($.browser.mozilla) {
	          this.outer.css({ overflow: 'hidden' });
	        } else {
	          this.outer.css({ overflow: 'visible' });
	        }
	
	        if ($.browser.msie && $.browser.version == '6.0') {
	          this.outer.css({ height: '100%' });
	        } else {
	          this.outer.css({ height: 'auto' });
	        }
	      }
	
	      this.onmouseup(evt);
	    }
	  };
	
	  window.Draggable = Draggable;
	
	  var cache = {};
	
	  var tmpl = function tmpl(str, data) {
	    // Figure out if we're getting a template, or if we need to
	    // load the template - and be sure to cache the result.
	    var fn = !/\W/.test(str) ? cache[str] = cache[str] || tmpl(document.getElementById(str).innerHTML) :
	
	    // Generate a reusable function that will serve as a template
	    // generator (and which will be cached).
	    new Function('obj', 'var p=[],print=function(){p.push.apply(p,arguments);};' +
	
	    // Introduce the data as local variables using with(){}
	    "with(obj){p.push('" +
	
	    // Convert the template into pure JavaScript
	    str.replace(/[\r\t\n]/g, ' ').split('<%').join('\t').replace(/((^|%>)[^\t]*)'/g, '$1\r').replace(/\t=(.*?)%>/g, "',$1,'").split('\t').join("');").split('%>').join("p.push('").split('\r').join("\\'") + "');}return p.join('');");
	
	    // Provide some basic currying to the user
	    return data ? fn(data) : fn;
	  };
	
	  /**
	   * jquery.slider - Slider ui control in jQuery
	   *
	   * Written by
	   * Egor Khmelev (hmelyoff@gmail.com)
	   *
	   * Licensed under the MIT (MIT-LICENSE.txt).
	   *
	   * @author Egor Khmelev
	   * @version 1.1.0-RELEASE ($Id$)
	   *
	   * Dependencies
	   *
	   * jQuery (http://jquery.com)
	   * jquery.numberformatter (http://code.google.com/p/jquery-numberformatter/)
	   * tmpl (http://ejohn.org/blog/javascript-micro-templating/)
	   * jquery.dependClass
	   * draggable
	   *
	   **/
	
	  function isArray(value) {
	    if (typeof value == 'undefined') return false;
	
	    if (value instanceof Array || !(value instanceof Object) && Object.prototype.toString.call(value) == '[object Array]' || typeof value.length == 'number' && typeof value.splice != 'undefined' && typeof value.propertyIsEnumerable != 'undefined' && !value.propertyIsEnumerable('splice')) {
	      return true;
	    }
	
	    return false;
	  }
	
	  $.slider = function (node, settings) {
	    var jNode = $(node);
	    if (!jNode.data('jslider')) jNode.data('jslider', new jSlider(node, settings));
	
	    return jNode.data('jslider');
	  };
	
	  $.fn.slider = function (action, opt_value) {
	    var returnValue,
	        args = arguments;
	
	    function isDef(val) {
	      return val !== undefined;
	    }
	
	    function isDefAndNotNull(val) {
	      return val != null;
	    }
	
	    this.each(function () {
	      var self = $.slider(this, action);
	
	      // do actions
	      if (typeof action == 'string') {
	        switch (action) {
	          case 'value':
	            if (isDef(args[1]) && isDef(args[2])) {
	              var pointers = self.getPointers();
	              if (isDefAndNotNull(pointers[0]) && isDefAndNotNull(args[1])) {
	                pointers[0].set(args[1]);
	                pointers[0].setIndexOver();
	              }
	
	              if (isDefAndNotNull(pointers[1]) && isDefAndNotNull(args[2])) {
	                pointers[1].set(args[2]);
	                pointers[1].setIndexOver();
	              }
	            } else if (isDef(args[1])) {
	              var pointers = self.getPointers();
	              if (isDefAndNotNull(pointers[0]) && isDefAndNotNull(args[1])) {
	                pointers[0].set(args[1]);
	                pointers[0].setIndexOver();
	              }
	            } else returnValue = self.getValue();
	
	            break;
	
	          case 'prc':
	            if (isDef(args[1]) && isDef(args[2])) {
	              var pointers = self.getPointers();
	              if (isDefAndNotNull(pointers[0]) && isDefAndNotNull(args[1])) {
	                pointers[0]._set(args[1]);
	                pointers[0].setIndexOver();
	              }
	
	              if (isDefAndNotNull(pointers[1]) && isDefAndNotNull(args[2])) {
	                pointers[1]._set(args[2]);
	                pointers[1].setIndexOver();
	              }
	            } else if (isDef(args[1])) {
	              var pointers = self.getPointers();
	              if (isDefAndNotNull(pointers[0]) && isDefAndNotNull(args[1])) {
	                pointers[0]._set(args[1]);
	                pointers[0].setIndexOver();
	              }
	            } else returnValue = self.getPrcValue();
	
	            break;
	
	          case 'calculatedValue':
	            var value = self.getValue().split(';');
	            returnValue = '';
	            for (var i = 0; i < value.length; i++) {
	              returnValue += (i > 0 ? ';' : '') + self.nice(value[i]);
	            }
	
	            break;
	
	          case 'skin':
	            self.setSkin(args[1]);
	
	            break;
	        }
	      }
	
	      // return actual object
	      else if (!action && !opt_value) {
	          if (!isArray(returnValue)) returnValue = [];
	
	          returnValue.push(self);
	        }
	    });
	
	    // flatten array just with one slider
	    if (isArray(returnValue) && returnValue.length == 1) returnValue = returnValue[0];
	
	    return returnValue || this;
	  };
	
	  var OPTIONS = {
	
	    settings: {
	      from: 1,
	      to: 10,
	      step: 1,
	      smooth: true,
	      limits: true,
	      round: 0,
	      format: { format: '#,##0.##' },
	      value: '5;7',
	      dimension: ''
	    },
	
	    className: 'jslider',
	    selector: '.jslider-',
	
	    template: tmpl('<span class="<%=className%>">' + '<table><tr><td>' + '<div class="<%=className%>-bg">' + '<i class="l"></i><i class="f"></i><i class="r"></i>' + '<i class="v"></i>' + '</div>' + '<div class="<%=className%>-pointer"></div>' + '<div class="<%=className%>-pointer <%=className%>-pointer-to"></div>' + '<div class="<%=className%>-label"><span><%=settings.from%></span></div>' + '<div class="<%=className%>-label <%=className%>-label-to"><span><%=settings.to%></span><%=settings.dimension%></div>' + '<div class="<%=className%>-value"><span></span><%=settings.dimension%></div>' + '<div class="<%=className%>-value <%=className%>-value-to"><span></span><%=settings.dimension%></div>' + '<div class="<%=className%>-scale"><%=scale%></div>' + '</td></tr></table>' + '</span>')
	
	  };
	
	  function jSlider() {
	    return this.init.apply(this, arguments);
	  }
	
	  jSlider.prototype.init = function (node, settings) {
	    this.settings = $.extend(true, {}, OPTIONS.settings, settings ? settings : {});
	
	    // obj.sliderHandler = this;
	    this.inputNode = $(node).hide();
	
	    this.settings.interval = this.settings.to - this.settings.from;
	    this.settings.value = this.inputNode.attr('value');
	
	    if (this.settings.calculate && $.isFunction(this.settings.calculate)) this.nice = this.settings.calculate;
	
	    if (this.settings.onstatechange && $.isFunction(this.settings.onstatechange)) this.onstatechange = this.settings.onstatechange;
	
	    this.is = {
	      init: false
	    };
	    this.o = {};
	
	    this.create();
	  };
	
	  jSlider.prototype.onstatechange = function () {};
	
	  jSlider.prototype.create = function () {
	    var $this = this;
	
	    this.domNode = $(OPTIONS.template({
	      className: OPTIONS.className,
	      settings: {
	        from: this.nice(this.settings.from),
	        to: this.nice(this.settings.to),
	        dimension: this.settings.dimension
	      },
	      scale: this.generateScale()
	    }));
	
	    this.inputNode.after(this.domNode);
	    this.drawScale();
	
	    // set skin class
	    if (this.settings.skin && this.settings.skin.length > 0) this.setSkin(this.settings.skin);
	
	    this.sizes = {
	      domWidth: this.domNode.width(),
	      domOffset: this.domNode.offset()
	    };
	
	    // find some objects
	    $.extend(this.o, {
	      pointers: {},
	      labels: {
	        0: {
	          o: this.domNode.find(OPTIONS.selector + 'value').not(OPTIONS.selector + 'value-to')
	        },
	        1: {
	          o: this.domNode.find(OPTIONS.selector + 'value').filter(OPTIONS.selector + 'value-to')
	        }
	      },
	      limits: {
	        0: this.domNode.find(OPTIONS.selector + 'label').not(OPTIONS.selector + 'label-to'),
	        1: this.domNode.find(OPTIONS.selector + 'label').filter(OPTIONS.selector + 'label-to')
	      }
	    });
	
	    $.extend(this.o.labels[0], {
	      value: this.o.labels[0].o.find('span')
	    });
	
	    $.extend(this.o.labels[1], {
	      value: this.o.labels[1].o.find('span')
	    });
	
	    if (!$this.settings.value.split(';')[1]) {
	      this.settings.single = true;
	      this.domNode.addDependClass('single');
	    }
	
	    if (!$this.settings.limits) this.domNode.addDependClass('limitless');
	
	    this.domNode.find(OPTIONS.selector + 'pointer').each(function (i) {
	      var value = $this.settings.value.split(';')[i];
	      if (value) {
	        $this.o.pointers[i] = new jSliderPointer(this, i, $this);
	
	        var prev = $this.settings.value.split(';')[i - 1];
	        if (prev && new Number(value) < new Number(prev)) value = prev;
	
	        value = value < $this.settings.from ? $this.settings.from : value;
	        value = value > $this.settings.to ? $this.settings.to : value;
	
	        $this.o.pointers[i].set(value, true);
	      }
	    });
	
	    this.o.value = this.domNode.find('.v');
	    this.is.init = true;
	
	    $.each(this.o.pointers, function (i) {
	      $this.redraw(this);
	    });
	
	    (function (self) {
	      $(window).resize(function () {
	        self.onresize();
	      });
	    })(this);
	  };
	
	  jSlider.prototype.setSkin = function (skin) {
	    if (this.skin_) this.domNode.removeDependClass(this.skin_, '_');
	
	    this.domNode.addDependClass(this.skin_ = skin, '_');
	  };
	
	  jSlider.prototype.setPointersIndex = function (i) {
	    $.each(this.getPointers(), function (i) {
	      this.index(i);
	    });
	  };
	
	  jSlider.prototype.getPointers = function () {
	    return this.o.pointers;
	  };
	
	  jSlider.prototype.generateScale = function () {
	    if (this.settings.scale && this.settings.scale.length > 0) {
	      var str = '';
	      var s = this.settings.scale;
	      var prc = Math.round(100 / (s.length - 1) * 10) / 10;
	      for (var i = 0; i < s.length; i++) {
	        str += '<span style="left: ' + i * prc + '%">' + (s[i] != '|' ? '<ins>' + s[i] + '</ins>' : '') + '</span>';
	      }
	      return str;
	    } else return '';
	
	    return '';
	  };
	
	  jSlider.prototype.drawScale = function () {
	    this.domNode.find(OPTIONS.selector + 'scale span ins').each(function () {
	      $(this).css({ marginLeft: -$(this).outerWidth() / 2 });
	    });
	  };
	
	  jSlider.prototype.onresize = function () {
	    var self = this;
	    this.sizes = {
	      domWidth: this.domNode.width(),
	      domOffset: this.domNode.offset()
	    };
	
	    $.each(this.o.pointers, function (i) {
	      self.redraw(this);
	    });
	  };
	
	  jSlider.prototype.update = function () {
	    this.onresize();
	    this.drawScale();
	  };
	
	  jSlider.prototype.limits = function (x, pointer) {
	    // smooth
	    if (!this.settings.smooth) {
	      var step = this.settings.step * 100 / this.settings.interval;
	      x = Math.round(x / step) * step;
	    }
	
	    var another = this.o.pointers[1 - pointer.uid];
	    if (another && pointer.uid && x < another.value.prc) x = another.value.prc;
	    if (another && !pointer.uid && x > another.value.prc) x = another.value.prc;
	
	    // base limit
	    if (x < 0) x = 0;
	    if (x > 100) x = 100;
	
	    return Math.round(x * 10) / 10;
	  };
	
	  jSlider.prototype.redraw = function (pointer) {
	    if (!this.is.init) return false;
	
	    this.setValue();
	
	    // redraw range line
	    if (this.o.pointers[0] && this.o.pointers[1]) this.o.value.css({
	      left: this.o.pointers[0].value.prc + '%',
	      width: this.o.pointers[1].value.prc - this.o.pointers[0].value.prc + '%'
	    });
	
	    this.o.labels[pointer.uid].value.html(this.nice(pointer.value.origin));
	
	    // redraw position of labels
	    this.redrawLabels(pointer);
	  };
	
	  jSlider.prototype.redrawLabels = function (pointer) {
	    function setPosition(label, sizes, prc) {
	      sizes.margin = -sizes.label / 2;
	
	      // left limit
	      var label_left = sizes.border + sizes.margin;
	      if (label_left < 0) sizes.margin -= label_left;
	
	      // right limit
	      if (sizes.border + sizes.label / 2 > self.sizes.domWidth) {
	        sizes.margin = 0;
	        sizes.right = true;
	      } else sizes.right = false;
	
	      label.o.css({ left: prc + '%', marginLeft: sizes.margin, right: 'auto' });
	      if (sizes.right) label.o.css({ left: 'auto', right: 0 });
	      return sizes;
	    }
	
	    var self = this;
	    var label = this.o.labels[pointer.uid];
	    var prc = pointer.value.prc;
	
	    var sizes = {
	      label: label.o.outerWidth(),
	      right: false,
	      border: prc * this.sizes.domWidth / 100
	    };
	
	    if (!this.settings.single) {
	      // glue if near;
	      var another = this.o.pointers[1 - pointer.uid];
	      var another_label = this.o.labels[another.uid];
	
	      switch (pointer.uid) {
	        case 0:
	          if (sizes.border + sizes.label / 2 > another_label.o.offset().left - this.sizes.domOffset.left) {
	            another_label.o.css({ visibility: 'hidden' });
	            another_label.value.html(this.nice(another.value.origin));
	
	            label.o.css({ visibility: 'visible' });
	
	            prc = (another.value.prc - prc) / 2 + prc;
	            if (another.value.prc != pointer.value.prc) {
	              label.value.html(this.nice(pointer.value.origin) + '&nbsp;&ndash;&nbsp;' + this.nice(another.value.origin));
	              sizes.label = label.o.outerWidth();
	              sizes.border = prc * this.sizes.domWidth / 100;
	            }
	          } else {
	            another_label.o.css({ visibility: 'visible' });
	          }
	          break;
	
	        case 1:
	          if (sizes.border - sizes.label / 2 < another_label.o.offset().left - this.sizes.domOffset.left + another_label.o.outerWidth()) {
	            another_label.o.css({ visibility: 'hidden' });
	            another_label.value.html(this.nice(another.value.origin));
	
	            label.o.css({ visibility: 'visible' });
	
	            prc = (prc - another.value.prc) / 2 + another.value.prc;
	            if (another.value.prc != pointer.value.prc) {
	              label.value.html(this.nice(another.value.origin) + '&nbsp;&ndash;&nbsp;' + this.nice(pointer.value.origin));
	              sizes.label = label.o.outerWidth();
	              sizes.border = prc * this.sizes.domWidth / 100;
	            }
	          } else {
	            another_label.o.css({ visibility: 'visible' });
	          }
	          break;
	      }
	    }
	
	    sizes = setPosition(label, sizes, prc);
	
	    /* draw second label */
	    if (another_label) {
	      var sizes = {
	        label: another_label.o.outerWidth(),
	        right: false,
	        border: another.value.prc * this.sizes.domWidth / 100
	      };
	      sizes = setPosition(another_label, sizes, another.value.prc);
	    }
	
	    this.redrawLimits();
	  };
	
	  jSlider.prototype.redrawLimits = function () {
	    if (this.settings.limits) {
	      var limits = [true, true];
	
	      for (key in this.o.pointers) {
	        if (!this.settings.single || key == 0) {
	          var pointer = this.o.pointers[key];
	          var label = this.o.labels[pointer.uid];
	          var label_left = label.o.offset().left - this.sizes.domOffset.left;
	
	          var limit = this.o.limits[0];
	          if (label_left < limit.outerWidth()) limits[0] = false;
	
	          var limit = this.o.limits[1];
	          if (label_left + label.o.outerWidth() > this.sizes.domWidth - limit.outerWidth()) limits[1] = false;
	        }
	      }
	
	      for (var i = 0; i < limits.length; i++) {
	        if (limits[i]) this.o.limits[i].fadeIn('fast');else this.o.limits[i].fadeOut('fast');
	      }
	    }
	  };
	
	  jSlider.prototype.setValue = function () {
	    var value = this.getValue();
	    this.inputNode.attr('value', value);
	    this.onstatechange.call(this, value);
	  };
	
	  jSlider.prototype.getValue = function () {
	    if (!this.is.init) return false;
	    var $this = this;
	
	    var value = '';
	    $.each(this.o.pointers, function (i) {
	      if (this.value.prc != undefined && !isNaN(this.value.prc)) value += (i > 0 ? ';' : '') + $this.prcToValue(this.value.prc);
	    });
	    return value;
	  };
	
	  jSlider.prototype.getPrcValue = function () {
	    if (!this.is.init) return false;
	    var $this = this;
	
	    var value = '';
	    $.each(this.o.pointers, function (i) {
	      if (this.value.prc != undefined && !isNaN(this.value.prc)) value += (i > 0 ? ';' : '') + this.value.prc;
	    });
	    return value;
	  };
	
	  jSlider.prototype.prcToValue = function (prc) {
	    if (this.settings.heterogeneity && this.settings.heterogeneity.length > 0) {
	      var h = this.settings.heterogeneity;
	
	      var _start = 0;
	      var _from = this.settings.from;
	
	      for (var i = 0; i <= h.length; i++) {
	        if (h[i]) var v = h[i].split('/');else var v = [100, this.settings.to];
	
	        v[0] = new Number(v[0]);
	        v[1] = new Number(v[1]);
	
	        if (prc >= _start && prc <= v[0]) {
	          var value = _from + (prc - _start) * (v[1] - _from) / (v[0] - _start);
	        }
	
	        _start = v[0];
	        _from = v[1];
	      }
	    } else {
	      var value = this.settings.from + prc * this.settings.interval / 100;
	    }
	
	    return this.round(value);
	  };
	
	  jSlider.prototype.valueToPrc = function (value, pointer) {
	    if (this.settings.heterogeneity && this.settings.heterogeneity.length > 0) {
	      var h = this.settings.heterogeneity;
	
	      var _start = 0;
	      var _from = this.settings.from;
	
	      for (var i = 0; i <= h.length; i++) {
	        if (h[i]) var v = h[i].split('/');else var v = [100, this.settings.to];
	        v[0] = new Number(v[0]);
	        v[1] = new Number(v[1]);
	
	        if (value >= _from && value <= v[1]) {
	          var prc = pointer.limits(_start + (value - _from) * (v[0] - _start) / (v[1] - _from));
	        }
	
	        _start = v[0];
	        _from = v[1];
	      }
	    } else {
	      var prc = pointer.limits((value - this.settings.from) * 100 / this.settings.interval);
	    }
	
	    return prc;
	  };
	
	  jSlider.prototype.round = function (value) {
	    value = Math.round(value / this.settings.step) * this.settings.step;
	    if (this.settings.round) value = Math.round(value * Math.pow(10, this.settings.round)) / Math.pow(10, this.settings.round);else value = Math.round(value);
	    return value;
	  };
	
	  jSlider.prototype.nice = function (value) {
	    value = value.toString().replace(/,/gi, '.').replace(/ /gi, '');
	
	    if ($.formatNumber) {
	      return $.formatNumber(new Number(value), this.settings.format || {}).replace(/-/gi, '&minus;');
	    } else {
	      return new Number(value);
	    }
	  };
	
	  function jSliderPointer() {
	    Draggable.apply(this, arguments);
	  }
	
	  jSliderPointer.prototype = new Draggable();
	
	  jSliderPointer.prototype.oninit = function (ptr, id, _constructor) {
	    this.uid = id;
	    this.parent = _constructor;
	    this.value = {};
	    this.settings = this.parent.settings;
	  };
	
	  jSliderPointer.prototype.onmousedown = function (evt) {
	    this._parent = {
	      offset: this.parent.domNode.offset(),
	      width: this.parent.domNode.width()
	    };
	    this.ptr.addDependClass('hover');
	    this.setIndexOver();
	  };
	
	  jSliderPointer.prototype.onmousemove = function (evt, x) {
	    var coords = this._getPageCoords(evt);
	    this._set(this.calc(coords.x));
	  };
	
	  jSliderPointer.prototype.onmouseup = function (evt) {
	    if (this.parent.settings.callback && $.isFunction(this.parent.settings.callback)) this.parent.settings.callback.call(this.parent, this.parent.getValue());
	
	    this.ptr.removeDependClass('hover');
	  };
	
	  jSliderPointer.prototype.setIndexOver = function () {
	    this.parent.setPointersIndex(1);
	    this.index(2);
	  };
	
	  jSliderPointer.prototype.index = function (i) {
	    this.ptr.css({ zIndex: i });
	  };
	
	  jSliderPointer.prototype.limits = function (x) {
	    return this.parent.limits(x, this);
	  };
	
	  jSliderPointer.prototype.calc = function (coords) {
	    var x = this.limits((coords - this._parent.offset.left) * 100 / this._parent.width);
	    return x;
	  };
	
	  jSliderPointer.prototype.set = function (value, opt_origin) {
	    this.value.origin = this.parent.round(value);
	    this._set(this.parent.valueToPrc(value, this), opt_origin);
	  };
	
	  jSliderPointer.prototype._set = function (prc, opt_origin) {
	    if (!opt_origin) this.value.origin = this.parent.prcToValue(prc);
	
	    this.value.prc = prc;
	    this.ptr.css({ left: prc + '%' });
	    this.parent.redraw(this);
	  };
	
	  var nfLocales = new Hashtable();
	
	  var nfLocalesLikeUS = ['ae', 'au', 'ca', 'cn', 'eg', 'gb', 'hk', 'il', 'in', 'jp', 'sk', 'th', 'tw', 'us'];
	  var nfLocalesLikeDE = ['at', 'br', 'de', 'dk', 'es', 'gr', 'it', 'nl', 'pt', 'tr', 'vn'];
	  var nfLocalesLikeFR = ['cz', 'fi', 'fr', 'ru', 'se', 'pl'];
	  var nfLocalesLikeCH = ['ch'];
	
	  var nfLocaleFormatting = [['.', ','], [',', '.'], [',', ' '], ['.', "'"]];
	  var nfAllLocales = [nfLocalesLikeUS, nfLocalesLikeDE, nfLocalesLikeFR, nfLocalesLikeCH];
	
	  function FormatData(dec, group, neg) {
	    this.dec = dec;
	    this.group = group;
	    this.neg = neg;
	  }
	
	  function init() {
	    // write the arrays into the hashtable
	    for (var localeGroupIdx = 0; localeGroupIdx < nfAllLocales.length; localeGroupIdx++) {
	      var localeGroup = nfAllLocales[localeGroupIdx];
	      for (var i = 0; i < localeGroup.length; i++) {
	        nfLocales.put(localeGroup[i], localeGroupIdx);
	      }
	    }
	  }
	
	  function formatCodes(locale, isFullLocale) {
	    if (nfLocales.size() == 0) init();
	
	    // default values
	    var dec = '.';
	    var group = ',';
	    var neg = '-';
	
	    if (isFullLocale == false) {
	      // Extract and convert to lower-case any language code from a real 'locale' formatted string, if not use as-is
	      // (To prevent locale format like : "fr_FR", "en_US", "de_DE", "fr_FR", "en-US", "de-DE")
	      if (locale.indexOf('_') != -1) locale = locale.split('_')[1].toLowerCase();else if (locale.indexOf('-') != -1) locale = locale.split('-')[1].toLowerCase();
	    }
	
	    // hashtable lookup to match locale with codes
	    var codesIndex = nfLocales.get(locale);
	    if (codesIndex) {
	      var codes = nfLocaleFormatting[codesIndex];
	      if (codes) {
	        dec = codes[0];
	        group = codes[1];
	      }
	    }
	    return new FormatData(dec, group, neg);
	  }
	
	  /*	Formatting Methods	*/
	
	  /**
	   * Formats anything containing a number in standard js number notation.
	   *
	   * @param {Object}	options			The formatting options to use
	   * @param {Boolean}	writeBack		(true) If the output value should be written back to the subject
	   * @param {Boolean} giveReturnValue	(true) If the function should return the output string
	   */
	  jQuery.fn.formatNumber = function (options, writeBack, giveReturnValue) {
	    return this.each(function () {
	      // enforce defaults
	      if (writeBack == null) writeBack = true;
	      if (giveReturnValue == null) giveReturnValue = true;
	
	      // get text
	      var text;
	      if (jQuery(this).is(':input')) text = new String(jQuery(this).val());else text = new String(jQuery(this).text());
	
	      // format
	      var returnString = jQuery.formatNumber(text, options);
	
	      // set formatted string back, only if a success
	      //			if (returnString) {
	      if (writeBack) {
	        if (jQuery(this).is(':input')) jQuery(this).val(returnString);else jQuery(this).text(returnString);
	      }
	      if (giveReturnValue) return returnString;
	      //			}
	      //			return '';
	    });
	  };
	
	  /**
	   * First parses a string and reformats it with the given options.
	   *
	   * @param {Object} numberString
	   * @param {Object} options
	   */
	  jQuery.formatNumber = function (numberString, options) {
	    var options = jQuery.extend({}, jQuery.fn.formatNumber.defaults, options);
	    var formatData = formatCodes(options.locale.toLowerCase(), options.isFullLocale);
	
	    var dec = formatData.dec;
	    var group = formatData.group;
	    var neg = formatData.neg;
	
	    var validFormat = '0#-,.';
	
	    // strip all the invalid characters at the beginning and the end
	    // of the format, and we'll stick them back on at the end
	    // make a special case for the negative sign "-" though, so
	    // we can have formats like -$23.32
	    var prefix = '';
	    var negativeInFront = false;
	    for (var i = 0; i < options.format.length; i++) {
	      if (validFormat.indexOf(options.format.charAt(i)) == -1) prefix = prefix + options.format.charAt(i);else if (i == 0 && options.format.charAt(i) == '-') {
	        negativeInFront = true;
	        continue;
	      } else break;
	    }
	    var suffix = '';
	    for (var i = options.format.length - 1; i >= 0; i--) {
	      if (validFormat.indexOf(options.format.charAt(i)) == -1) suffix = options.format.charAt(i) + suffix;else break;
	    }
	
	    options.format = options.format.substring(prefix.length);
	    options.format = options.format.substring(0, options.format.length - suffix.length);
	
	    // now we need to convert it into a number
	    // while (numberString.indexOf(group) > -1)
	    //	numberString = numberString.replace(group, '');
	    // var number = new Number(numberString.replace(dec, ".").replace(neg, "-"));
	    var number = new Number(numberString);
	
	    return jQuery._formatNumber(number, options, suffix, prefix, negativeInFront);
	  };
	
	  /**
	   * Formats a Number object into a string, using the given formatting options
	   *
	   * @param {Object} numberString
	   * @param {Object} options
	   */
	  jQuery._formatNumber = function (number, options, suffix, prefix, negativeInFront) {
	    var options = jQuery.extend({}, jQuery.fn.formatNumber.defaults, options);
	    var formatData = formatCodes(options.locale.toLowerCase(), options.isFullLocale);
	
	    var dec = formatData.dec;
	    var group = formatData.group;
	    var neg = formatData.neg;
	
	    var forcedToZero = false;
	    if (isNaN(number)) {
	      if (options.nanForceZero == true) {
	        number = 0;
	        forcedToZero = true;
	      } else return null;
	    }
	
	    // special case for percentages
	    if (suffix == '%') number = number * 100;
	
	    var returnString = '';
	    if (options.format.indexOf('.') > -1) {
	      var decimalPortion = dec;
	      var decimalFormat = options.format.substring(options.format.lastIndexOf('.') + 1);
	
	      // round or truncate number as needed
	      if (options.round == true) number = new Number(number.toFixed(decimalFormat.length));else {
	        var numStr = number.toString();
	        numStr = numStr.substring(0, numStr.lastIndexOf('.') + decimalFormat.length + 1);
	        number = new Number(numStr);
	      }
	
	      var decimalValue = number % 1;
	      var decimalString = new String(decimalValue.toFixed(decimalFormat.length));
	      decimalString = decimalString.substring(decimalString.lastIndexOf('.') + 1);
	
	      for (var i = 0; i < decimalFormat.length; i++) {
	        if (decimalFormat.charAt(i) == '#' && decimalString.charAt(i) != '0') {
	          decimalPortion += decimalString.charAt(i);
	          continue;
	        } else if (decimalFormat.charAt(i) == '#' && decimalString.charAt(i) == '0') {
	          var notParsed = decimalString.substring(i);
	          if (notParsed.match('[1-9]')) {
	            decimalPortion += decimalString.charAt(i);
	            continue;
	          } else break;
	        } else if (decimalFormat.charAt(i) == '0') decimalPortion += decimalString.charAt(i);
	      }
	      returnString += decimalPortion;
	    } else number = Math.round(number);
	
	    var ones = Math.floor(number);
	    if (number < 0) ones = Math.ceil(number);
	
	    var onesFormat = '';
	    if (options.format.indexOf('.') == -1) onesFormat = options.format;else onesFormat = options.format.substring(0, options.format.indexOf('.'));
	
	    var onePortion = '';
	    if (!(ones == 0 && onesFormat.substr(onesFormat.length - 1) == '#') || forcedToZero) {
	      // find how many digits are in the group
	      var oneText = new String(Math.abs(ones));
	      var groupLength = 9999;
	      if (onesFormat.lastIndexOf(',') != -1) groupLength = onesFormat.length - onesFormat.lastIndexOf(',') - 1;
	      var groupCount = 0;
	      for (var i = oneText.length - 1; i > -1; i--) {
	        onePortion = oneText.charAt(i) + onePortion;
	        groupCount++;
	        if (groupCount == groupLength && i != 0) {
	          onePortion = group + onePortion;
	          groupCount = 0;
	        }
	      }
	
	      // account for any pre-data padding
	      if (onesFormat.length > onePortion.length) {
	        var padStart = onesFormat.indexOf('0');
	        if (padStart != -1) {
	          var padLen = onesFormat.length - padStart;
	
	          // pad to left with 0's or group char
	          var pos = onesFormat.length - onePortion.length - 1;
	          while (onePortion.length < padLen) {
	            var padChar = onesFormat.charAt(pos);
	            // replace with real group char if needed
	            if (padChar == ',') padChar = group;
	            onePortion = padChar + onePortion;
	            pos--;
	          }
	        }
	      }
	    }
	
	    if (!onePortion && onesFormat.indexOf('0', onesFormat.length - 1) !== -1) onePortion = '0';
	
	    returnString = onePortion + returnString;
	
	    // handle special case where negative is in front of the invalid characters
	    if (number < 0 && negativeInFront && prefix.length > 0) prefix = neg + prefix;else if (number < 0) returnString = neg + returnString;
	
	    if (!options.decimalSeparatorAlwaysShown) {
	      if (returnString.lastIndexOf(dec) == returnString.length - 1) {
	        returnString = returnString.substring(0, returnString.length - 1);
	      }
	    }
	    returnString = prefix + returnString + suffix;
	    return returnString;
	  };
	
	  /*	Parsing Methods	*/
	
	  /**
	   * Parses a number of given format from the element and returns a Number object.
	   * @param {Object} options
	   */
	  jQuery.fn.parseNumber = function (options, writeBack, giveReturnValue) {
	    // enforce defaults
	    if (writeBack == null) writeBack = true;
	    if (giveReturnValue == null) giveReturnValue = true;
	
	    // get text
	    var text;
	    if (jQuery(this).is(':input')) text = new String(jQuery(this).val());else text = new String(jQuery(this).text());
	
	    // parse text
	    var number = jQuery.parseNumber(text, options);
	
	    if (number) {
	      if (writeBack) {
	        if (jQuery(this).is(':input')) jQuery(this).val(number.toString());else jQuery(this).text(number.toString());
	      }
	      if (giveReturnValue) return number;
	    }
	  };
	
	  /**
	   * Parses a string of given format into a Number object.
	   *
	   * @param {Object} string
	   * @param {Object} options
	   */
	  jQuery.parseNumber = function (numberString, options) {
	    var options = jQuery.extend({}, jQuery.fn.parseNumber.defaults, options);
	    var formatData = formatCodes(options.locale.toLowerCase(), options.isFullLocale);
	
	    var dec = formatData.dec;
	    var group = formatData.group;
	    var neg = formatData.neg;
	
	    var valid = '1234567890.-';
	
	    // now we need to convert it into a number
	    while (numberString.indexOf(group) > -1) {
	      numberString = numberString.replace(group, '');
	    }numberString = numberString.replace(dec, '.').replace(neg, '-');
	    var validText = '';
	    var hasPercent = false;
	    if (numberString.charAt(numberString.length - 1) == '%' || options.isPercentage == true) hasPercent = true;
	    for (var i = 0; i < numberString.length; i++) {
	      if (valid.indexOf(numberString.charAt(i)) > -1) validText = validText + numberString.charAt(i);
	    }
	    var number = new Number(validText);
	    if (hasPercent) {
	      number = number / 100;
	      var decimalPos = validText.indexOf('.');
	      if (decimalPos != -1) {
	        var decimalPoints = validText.length - decimalPos - 1;
	        number = number.toFixed(decimalPoints + 2);
	      } else {
	        number = number.toFixed(validText.length - 1);
	      }
	    }
	
	    return number;
	  };
	
	  jQuery.fn.parseNumber.defaults = {
	    locale: 'us',
	    decimalSeparatorAlwaysShown: false,
	    isPercentage: false,
	    isFullLocale: false
	  };
	
	  jQuery.fn.formatNumber.defaults = {
	    format: '#,###.00',
	    locale: 'us',
	    decimalSeparatorAlwaysShown: false,
	    nanForceZero: true,
	    round: true,
	    isFullLocale: false
	  };
	
	  Number.prototype.toFixed = function (precision) {
	    return jQuery._roundNumber(this, precision);
	  };
	
	  jQuery._roundNumber = function (number, decimalPlaces) {
	    var power = Math.pow(10, decimalPlaces || 0);
	    var value = String(Math.round(number * power) / power);
	
	    // ensure the decimal places are there
	    if (decimalPlaces > 0) {
	      var dp = value.indexOf('.');
	      if (dp == -1) {
	        value += '.';
	        dp = 0;
	      } else {
	        dp = value.length - (dp + 1);
	      }
	
	      while (dp < decimalPlaces) {
	        value += '0';
	        dp++;
	      }
	    }
	    return value;
	  };
	
	  $('.rangeSlider').each(function () {
	    var $this = $(this);
	    var settings = {};
	
	    if (_typeof($this.data('settings')) == 'object') {
	      settings = $this.data('settings');
	    }
	
	    $this.slider(settings);
	  });
	};
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(8)))

/***/ }),

/***/ 337:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	__webpack_require__(966);
	
	var $ = __webpack_require__(8);
	__webpack_require__(351);
	// require('lg-thumbnail');
	// require('lg-autoplay');
	__webpack_require__(350);
	// require('lg-fullscreen');
	// require('lg-pager');
	// require('lg-zoom');
	// require('lg-hash');
	// require('lg-share');
	
	module.exports = function () {
	  $('.lightgallery').each(function () {
	    var $this = $(this);
	    var settings = {};
	    if (_typeof($this.data('lightgallery-settings')) == 'object') {
	      settings = $this.data('lightgallery-settings');
	    }
	
	    $(this).lightGallery(settings);
	  });
	};

/***/ }),

/***/ 338:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var $ = __webpack_require__(8);
	__webpack_require__(352);
	__webpack_require__(967);
	__webpack_require__(244);
	__webpack_require__(330);
	
	module.exports = function () {
	  $('.popup-btn').each(function (index, obj) {
	    var $this = $(obj);
	
	    var settings = {};
	
	    settings.type = 'inline';
	    if ($this.data('type') !== '') {
	      settings.type = $this.data('type');
	    }
	
	    if (settings.type == 'inline') {
	      var slider = $($this.data('mfp-src')).find('.slick-slider');
	
	      if (slider.length) {
	        settings.callbacks = {
	          open: function open() {
	            slider.slick();
	          }
	        };
	      }
	    }
	
	    $this.magnificPopup(settings);
	  });
	};

/***/ }),

/***/ 339:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var $ = __webpack_require__(8);
	__webpack_require__(244);
	__webpack_require__(330);
	
	module.exports = function () {
	  $('.slick-slider').each(function () {
	    var $this = $(this);
	    if ($this.parents('.hidden').length == 0) {
	      $this.slick();
	    }
	  });
	
	  $('.video-next').on('click', function () {
	    $('.video-slider').slick('slickNext');
	  });
	
	  $('.video-prev').on('click', function () {
	    $('.video-slider').slick('slickPrev');
	  });
	};

/***/ }),

/***/ 340:
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(jQuery) {'use strict';
	
	(function ($) {
	  'use strict';
	
	  $.fn.succinct = function (options) {
	    var settings = $.extend({
	      size: 240,
	      omission: '...',
	      ignore: true
	    }, options);
	    return this.each(function () {
	      var textDefault,
	          textTruncated,
	          elements = $(this),
	          regex = /[!-\/:-@\[-`{-~]$/,
	          init = function init() {
	        elements.each(function () {
	          textDefault = $(this).html();
	          if (textDefault.length > settings.size) {
	            textTruncated = $.trim(textDefault).substring(0, settings.size).split(' ').slice(0, -1).join(' ');
	
	            if (settings.ignore) {
	              textTruncated = textTruncated.replace(regex, '');
	            }
	            $(this).html(textTruncated + settings.omission);
	          }
	        });
	      };
	      init();
	    });
	  };
	})(jQuery);
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(8)))

/***/ }),

/***/ 341:
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(jQuery) {/*!
	 * Bootstrap v3.3.7 (http://getbootstrap.com)
	 * Copyright 2011-2016 Twitter, Inc.
	 * Licensed under the MIT license
	 */
	
	if (typeof jQuery === 'undefined') {
	  throw new Error('Bootstrap\'s JavaScript requires jQuery')
	}
	
	+function ($) {
	  'use strict';
	  var version = $.fn.jquery.split(' ')[0].split('.')
	  if ((version[0] < 2 && version[1] < 9) || (version[0] == 1 && version[1] == 9 && version[2] < 1) || (version[0] > 3)) {
	    throw new Error('Bootstrap\'s JavaScript requires jQuery version 1.9.1 or higher, but lower than version 4')
	  }
	}(jQuery);
	
	/* ========================================================================
	 * Bootstrap: transition.js v3.3.7
	 * http://getbootstrap.com/javascript/#transitions
	 * ========================================================================
	 * Copyright 2011-2016 Twitter, Inc.
	 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
	 * ======================================================================== */
	
	
	+function ($) {
	  'use strict';
	
	  // CSS TRANSITION SUPPORT (Shoutout: http://www.modernizr.com/)
	  // ============================================================
	
	  function transitionEnd() {
	    var el = document.createElement('bootstrap')
	
	    var transEndEventNames = {
	      WebkitTransition : 'webkitTransitionEnd',
	      MozTransition    : 'transitionend',
	      OTransition      : 'oTransitionEnd otransitionend',
	      transition       : 'transitionend'
	    }
	
	    for (var name in transEndEventNames) {
	      if (el.style[name] !== undefined) {
	        return { end: transEndEventNames[name] }
	      }
	    }
	
	    return false // explicit for ie8 (  ._.)
	  }
	
	  // http://blog.alexmaccaw.com/css-transitions
	  $.fn.emulateTransitionEnd = function (duration) {
	    var called = false
	    var $el = this
	    $(this).one('bsTransitionEnd', function () { called = true })
	    var callback = function () { if (!called) $($el).trigger($.support.transition.end) }
	    setTimeout(callback, duration)
	    return this
	  }
	
	  $(function () {
	    $.support.transition = transitionEnd()
	
	    if (!$.support.transition) return
	
	    $.event.special.bsTransitionEnd = {
	      bindType: $.support.transition.end,
	      delegateType: $.support.transition.end,
	      handle: function (e) {
	        if ($(e.target).is(this)) return e.handleObj.handler.apply(this, arguments)
	      }
	    }
	  })
	
	}(jQuery);
	
	/* ========================================================================
	 * Bootstrap: alert.js v3.3.7
	 * http://getbootstrap.com/javascript/#alerts
	 * ========================================================================
	 * Copyright 2011-2016 Twitter, Inc.
	 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
	 * ======================================================================== */
	
	
	+function ($) {
	  'use strict';
	
	  // ALERT CLASS DEFINITION
	  // ======================
	
	  var dismiss = '[data-dismiss="alert"]'
	  var Alert   = function (el) {
	    $(el).on('click', dismiss, this.close)
	  }
	
	  Alert.VERSION = '3.3.7'
	
	  Alert.TRANSITION_DURATION = 150
	
	  Alert.prototype.close = function (e) {
	    var $this    = $(this)
	    var selector = $this.attr('data-target')
	
	    if (!selector) {
	      selector = $this.attr('href')
	      selector = selector && selector.replace(/.*(?=#[^\s]*$)/, '') // strip for ie7
	    }
	
	    var $parent = $(selector === '#' ? [] : selector)
	
	    if (e) e.preventDefault()
	
	    if (!$parent.length) {
	      $parent = $this.closest('.alert')
	    }
	
	    $parent.trigger(e = $.Event('close.bs.alert'))
	
	    if (e.isDefaultPrevented()) return
	
	    $parent.removeClass('in')
	
	    function removeElement() {
	      // detach from parent, fire event then clean up data
	      $parent.detach().trigger('closed.bs.alert').remove()
	    }
	
	    $.support.transition && $parent.hasClass('fade') ?
	      $parent
	        .one('bsTransitionEnd', removeElement)
	        .emulateTransitionEnd(Alert.TRANSITION_DURATION) :
	      removeElement()
	  }
	
	
	  // ALERT PLUGIN DEFINITION
	  // =======================
	
	  function Plugin(option) {
	    return this.each(function () {
	      var $this = $(this)
	      var data  = $this.data('bs.alert')
	
	      if (!data) $this.data('bs.alert', (data = new Alert(this)))
	      if (typeof option == 'string') data[option].call($this)
	    })
	  }
	
	  var old = $.fn.alert
	
	  $.fn.alert             = Plugin
	  $.fn.alert.Constructor = Alert
	
	
	  // ALERT NO CONFLICT
	  // =================
	
	  $.fn.alert.noConflict = function () {
	    $.fn.alert = old
	    return this
	  }
	
	
	  // ALERT DATA-API
	  // ==============
	
	  $(document).on('click.bs.alert.data-api', dismiss, Alert.prototype.close)
	
	}(jQuery);
	
	/* ========================================================================
	 * Bootstrap: button.js v3.3.7
	 * http://getbootstrap.com/javascript/#buttons
	 * ========================================================================
	 * Copyright 2011-2016 Twitter, Inc.
	 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
	 * ======================================================================== */
	
	
	+function ($) {
	  'use strict';
	
	  // BUTTON PUBLIC CLASS DEFINITION
	  // ==============================
	
	  var Button = function (element, options) {
	    this.$element  = $(element)
	    this.options   = $.extend({}, Button.DEFAULTS, options)
	    this.isLoading = false
	  }
	
	  Button.VERSION  = '3.3.7'
	
	  Button.DEFAULTS = {
	    loadingText: 'loading...'
	  }
	
	  Button.prototype.setState = function (state) {
	    var d    = 'disabled'
	    var $el  = this.$element
	    var val  = $el.is('input') ? 'val' : 'html'
	    var data = $el.data()
	
	    state += 'Text'
	
	    if (data.resetText == null) $el.data('resetText', $el[val]())
	
	    // push to event loop to allow forms to submit
	    setTimeout($.proxy(function () {
	      $el[val](data[state] == null ? this.options[state] : data[state])
	
	      if (state == 'loadingText') {
	        this.isLoading = true
	        $el.addClass(d).attr(d, d).prop(d, true)
	      } else if (this.isLoading) {
	        this.isLoading = false
	        $el.removeClass(d).removeAttr(d).prop(d, false)
	      }
	    }, this), 0)
	  }
	
	  Button.prototype.toggle = function () {
	    var changed = true
	    var $parent = this.$element.closest('[data-toggle="buttons"]')
	
	    if ($parent.length) {
	      var $input = this.$element.find('input')
	      if ($input.prop('type') == 'radio') {
	        if ($input.prop('checked')) changed = false
	        $parent.find('.active').removeClass('active')
	        this.$element.addClass('active')
	      } else if ($input.prop('type') == 'checkbox') {
	        if (($input.prop('checked')) !== this.$element.hasClass('active')) changed = false
	        this.$element.toggleClass('active')
	      }
	      $input.prop('checked', this.$element.hasClass('active'))
	      if (changed) $input.trigger('change')
	    } else {
	      this.$element.attr('aria-pressed', !this.$element.hasClass('active'))
	      this.$element.toggleClass('active')
	    }
	  }
	
	
	  // BUTTON PLUGIN DEFINITION
	  // ========================
	
	  function Plugin(option) {
	    return this.each(function () {
	      var $this   = $(this)
	      var data    = $this.data('bs.button')
	      var options = typeof option == 'object' && option
	
	      if (!data) $this.data('bs.button', (data = new Button(this, options)))
	
	      if (option == 'toggle') data.toggle()
	      else if (option) data.setState(option)
	    })
	  }
	
	  var old = $.fn.button
	
	  $.fn.button             = Plugin
	  $.fn.button.Constructor = Button
	
	
	  // BUTTON NO CONFLICT
	  // ==================
	
	  $.fn.button.noConflict = function () {
	    $.fn.button = old
	    return this
	  }
	
	
	  // BUTTON DATA-API
	  // ===============
	
	  $(document)
	    .on('click.bs.button.data-api', '[data-toggle^="button"]', function (e) {
	      var $btn = $(e.target).closest('.btn')
	      Plugin.call($btn, 'toggle')
	      if (!($(e.target).is('input[type="radio"], input[type="checkbox"]'))) {
	        // Prevent double click on radios, and the double selections (so cancellation) on checkboxes
	        e.preventDefault()
	        // The target component still receive the focus
	        if ($btn.is('input,button')) $btn.trigger('focus')
	        else $btn.find('input:visible,button:visible').first().trigger('focus')
	      }
	    })
	    .on('focus.bs.button.data-api blur.bs.button.data-api', '[data-toggle^="button"]', function (e) {
	      $(e.target).closest('.btn').toggleClass('focus', /^focus(in)?$/.test(e.type))
	    })
	
	}(jQuery);
	
	/* ========================================================================
	 * Bootstrap: carousel.js v3.3.7
	 * http://getbootstrap.com/javascript/#carousel
	 * ========================================================================
	 * Copyright 2011-2016 Twitter, Inc.
	 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
	 * ======================================================================== */
	
	
	+function ($) {
	  'use strict';
	
	  // CAROUSEL CLASS DEFINITION
	  // =========================
	
	  var Carousel = function (element, options) {
	    this.$element    = $(element)
	    this.$indicators = this.$element.find('.carousel-indicators')
	    this.options     = options
	    this.paused      = null
	    this.sliding     = null
	    this.interval    = null
	    this.$active     = null
	    this.$items      = null
	
	    this.options.keyboard && this.$element.on('keydown.bs.carousel', $.proxy(this.keydown, this))
	
	    this.options.pause == 'hover' && !('ontouchstart' in document.documentElement) && this.$element
	      .on('mouseenter.bs.carousel', $.proxy(this.pause, this))
	      .on('mouseleave.bs.carousel', $.proxy(this.cycle, this))
	  }
	
	  Carousel.VERSION  = '3.3.7'
	
	  Carousel.TRANSITION_DURATION = 600
	
	  Carousel.DEFAULTS = {
	    interval: 5000,
	    pause: 'hover',
	    wrap: true,
	    keyboard: true
	  }
	
	  Carousel.prototype.keydown = function (e) {
	    if (/input|textarea/i.test(e.target.tagName)) return
	    switch (e.which) {
	      case 37: this.prev(); break
	      case 39: this.next(); break
	      default: return
	    }
	
	    e.preventDefault()
	  }
	
	  Carousel.prototype.cycle = function (e) {
	    e || (this.paused = false)
	
	    this.interval && clearInterval(this.interval)
	
	    this.options.interval
	      && !this.paused
	      && (this.interval = setInterval($.proxy(this.next, this), this.options.interval))
	
	    return this
	  }
	
	  Carousel.prototype.getItemIndex = function (item) {
	    this.$items = item.parent().children('.item')
	    return this.$items.index(item || this.$active)
	  }
	
	  Carousel.prototype.getItemForDirection = function (direction, active) {
	    var activeIndex = this.getItemIndex(active)
	    var willWrap = (direction == 'prev' && activeIndex === 0)
	                || (direction == 'next' && activeIndex == (this.$items.length - 1))
	    if (willWrap && !this.options.wrap) return active
	    var delta = direction == 'prev' ? -1 : 1
	    var itemIndex = (activeIndex + delta) % this.$items.length
	    return this.$items.eq(itemIndex)
	  }
	
	  Carousel.prototype.to = function (pos) {
	    var that        = this
	    var activeIndex = this.getItemIndex(this.$active = this.$element.find('.item.active'))
	
	    if (pos > (this.$items.length - 1) || pos < 0) return
	
	    if (this.sliding)       return this.$element.one('slid.bs.carousel', function () { that.to(pos) }) // yes, "slid"
	    if (activeIndex == pos) return this.pause().cycle()
	
	    return this.slide(pos > activeIndex ? 'next' : 'prev', this.$items.eq(pos))
	  }
	
	  Carousel.prototype.pause = function (e) {
	    e || (this.paused = true)
	
	    if (this.$element.find('.next, .prev').length && $.support.transition) {
	      this.$element.trigger($.support.transition.end)
	      this.cycle(true)
	    }
	
	    this.interval = clearInterval(this.interval)
	
	    return this
	  }
	
	  Carousel.prototype.next = function () {
	    if (this.sliding) return
	    return this.slide('next')
	  }
	
	  Carousel.prototype.prev = function () {
	    if (this.sliding) return
	    return this.slide('prev')
	  }
	
	  Carousel.prototype.slide = function (type, next) {
	    var $active   = this.$element.find('.item.active')
	    var $next     = next || this.getItemForDirection(type, $active)
	    var isCycling = this.interval
	    var direction = type == 'next' ? 'left' : 'right'
	    var that      = this
	
	    if ($next.hasClass('active')) return (this.sliding = false)
	
	    var relatedTarget = $next[0]
	    var slideEvent = $.Event('slide.bs.carousel', {
	      relatedTarget: relatedTarget,
	      direction: direction
	    })
	    this.$element.trigger(slideEvent)
	    if (slideEvent.isDefaultPrevented()) return
	
	    this.sliding = true
	
	    isCycling && this.pause()
	
	    if (this.$indicators.length) {
	      this.$indicators.find('.active').removeClass('active')
	      var $nextIndicator = $(this.$indicators.children()[this.getItemIndex($next)])
	      $nextIndicator && $nextIndicator.addClass('active')
	    }
	
	    var slidEvent = $.Event('slid.bs.carousel', { relatedTarget: relatedTarget, direction: direction }) // yes, "slid"
	    if ($.support.transition && this.$element.hasClass('slide')) {
	      $next.addClass(type)
	      $next[0].offsetWidth // force reflow
	      $active.addClass(direction)
	      $next.addClass(direction)
	      $active
	        .one('bsTransitionEnd', function () {
	          $next.removeClass([type, direction].join(' ')).addClass('active')
	          $active.removeClass(['active', direction].join(' '))
	          that.sliding = false
	          setTimeout(function () {
	            that.$element.trigger(slidEvent)
	          }, 0)
	        })
	        .emulateTransitionEnd(Carousel.TRANSITION_DURATION)
	    } else {
	      $active.removeClass('active')
	      $next.addClass('active')
	      this.sliding = false
	      this.$element.trigger(slidEvent)
	    }
	
	    isCycling && this.cycle()
	
	    return this
	  }
	
	
	  // CAROUSEL PLUGIN DEFINITION
	  // ==========================
	
	  function Plugin(option) {
	    return this.each(function () {
	      var $this   = $(this)
	      var data    = $this.data('bs.carousel')
	      var options = $.extend({}, Carousel.DEFAULTS, $this.data(), typeof option == 'object' && option)
	      var action  = typeof option == 'string' ? option : options.slide
	
	      if (!data) $this.data('bs.carousel', (data = new Carousel(this, options)))
	      if (typeof option == 'number') data.to(option)
	      else if (action) data[action]()
	      else if (options.interval) data.pause().cycle()
	    })
	  }
	
	  var old = $.fn.carousel
	
	  $.fn.carousel             = Plugin
	  $.fn.carousel.Constructor = Carousel
	
	
	  // CAROUSEL NO CONFLICT
	  // ====================
	
	  $.fn.carousel.noConflict = function () {
	    $.fn.carousel = old
	    return this
	  }
	
	
	  // CAROUSEL DATA-API
	  // =================
	
	  var clickHandler = function (e) {
	    var href
	    var $this   = $(this)
	    var $target = $($this.attr('data-target') || (href = $this.attr('href')) && href.replace(/.*(?=#[^\s]+$)/, '')) // strip for ie7
	    if (!$target.hasClass('carousel')) return
	    var options = $.extend({}, $target.data(), $this.data())
	    var slideIndex = $this.attr('data-slide-to')
	    if (slideIndex) options.interval = false
	
	    Plugin.call($target, options)
	
	    if (slideIndex) {
	      $target.data('bs.carousel').to(slideIndex)
	    }
	
	    e.preventDefault()
	  }
	
	  $(document)
	    .on('click.bs.carousel.data-api', '[data-slide]', clickHandler)
	    .on('click.bs.carousel.data-api', '[data-slide-to]', clickHandler)
	
	  $(window).on('load', function () {
	    $('[data-ride="carousel"]').each(function () {
	      var $carousel = $(this)
	      Plugin.call($carousel, $carousel.data())
	    })
	  })
	
	}(jQuery);
	
	/* ========================================================================
	 * Bootstrap: collapse.js v3.3.7
	 * http://getbootstrap.com/javascript/#collapse
	 * ========================================================================
	 * Copyright 2011-2016 Twitter, Inc.
	 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
	 * ======================================================================== */
	
	/* jshint latedef: false */
	
	+function ($) {
	  'use strict';
	
	  // COLLAPSE PUBLIC CLASS DEFINITION
	  // ================================
	
	  var Collapse = function (element, options) {
	    this.$element      = $(element)
	    this.options       = $.extend({}, Collapse.DEFAULTS, options)
	    this.$trigger      = $('[data-toggle="collapse"][href="#' + element.id + '"],' +
	                           '[data-toggle="collapse"][data-target="#' + element.id + '"]')
	    this.transitioning = null
	
	    if (this.options.parent) {
	      this.$parent = this.getParent()
	    } else {
	      this.addAriaAndCollapsedClass(this.$element, this.$trigger)
	    }
	
	    if (this.options.toggle) this.toggle()
	  }
	
	  Collapse.VERSION  = '3.3.7'
	
	  Collapse.TRANSITION_DURATION = 350
	
	  Collapse.DEFAULTS = {
	    toggle: true
	  }
	
	  Collapse.prototype.dimension = function () {
	    var hasWidth = this.$element.hasClass('width')
	    return hasWidth ? 'width' : 'height'
	  }
	
	  Collapse.prototype.show = function () {
	    if (this.transitioning || this.$element.hasClass('in')) return
	
	    var activesData
	    var actives = this.$parent && this.$parent.children('.panel').children('.in, .collapsing')
	
	    if (actives && actives.length) {
	      activesData = actives.data('bs.collapse')
	      if (activesData && activesData.transitioning) return
	    }
	
	    var startEvent = $.Event('show.bs.collapse')
	    this.$element.trigger(startEvent)
	    if (startEvent.isDefaultPrevented()) return
	
	    if (actives && actives.length) {
	      Plugin.call(actives, 'hide')
	      activesData || actives.data('bs.collapse', null)
	    }
	
	    var dimension = this.dimension()
	
	    this.$element
	      .removeClass('collapse')
	      .addClass('collapsing')[dimension](0)
	      .attr('aria-expanded', true)
	
	    this.$trigger
	      .removeClass('collapsed')
	      .attr('aria-expanded', true)
	
	    this.transitioning = 1
	
	    var complete = function () {
	      this.$element
	        .removeClass('collapsing')
	        .addClass('collapse in')[dimension]('')
	      this.transitioning = 0
	      this.$element
	        .trigger('shown.bs.collapse')
	    }
	
	    if (!$.support.transition) return complete.call(this)
	
	    var scrollSize = $.camelCase(['scroll', dimension].join('-'))
	
	    this.$element
	      .one('bsTransitionEnd', $.proxy(complete, this))
	      .emulateTransitionEnd(Collapse.TRANSITION_DURATION)[dimension](this.$element[0][scrollSize])
	  }
	
	  Collapse.prototype.hide = function () {
	    if (this.transitioning || !this.$element.hasClass('in')) return
	
	    var startEvent = $.Event('hide.bs.collapse')
	    this.$element.trigger(startEvent)
	    if (startEvent.isDefaultPrevented()) return
	
	    var dimension = this.dimension()
	
	    this.$element[dimension](this.$element[dimension]())[0].offsetHeight
	
	    this.$element
	      .addClass('collapsing')
	      .removeClass('collapse in')
	      .attr('aria-expanded', false)
	
	    this.$trigger
	      .addClass('collapsed')
	      .attr('aria-expanded', false)
	
	    this.transitioning = 1
	
	    var complete = function () {
	      this.transitioning = 0
	      this.$element
	        .removeClass('collapsing')
	        .addClass('collapse')
	        .trigger('hidden.bs.collapse')
	    }
	
	    if (!$.support.transition) return complete.call(this)
	
	    this.$element
	      [dimension](0)
	      .one('bsTransitionEnd', $.proxy(complete, this))
	      .emulateTransitionEnd(Collapse.TRANSITION_DURATION)
	  }
	
	  Collapse.prototype.toggle = function () {
	    this[this.$element.hasClass('in') ? 'hide' : 'show']()
	  }
	
	  Collapse.prototype.getParent = function () {
	    return $(this.options.parent)
	      .find('[data-toggle="collapse"][data-parent="' + this.options.parent + '"]')
	      .each($.proxy(function (i, element) {
	        var $element = $(element)
	        this.addAriaAndCollapsedClass(getTargetFromTrigger($element), $element)
	      }, this))
	      .end()
	  }
	
	  Collapse.prototype.addAriaAndCollapsedClass = function ($element, $trigger) {
	    var isOpen = $element.hasClass('in')
	
	    $element.attr('aria-expanded', isOpen)
	    $trigger
	      .toggleClass('collapsed', !isOpen)
	      .attr('aria-expanded', isOpen)
	  }
	
	  function getTargetFromTrigger($trigger) {
	    var href
	    var target = $trigger.attr('data-target')
	      || (href = $trigger.attr('href')) && href.replace(/.*(?=#[^\s]+$)/, '') // strip for ie7
	
	    return $(target)
	  }
	
	
	  // COLLAPSE PLUGIN DEFINITION
	  // ==========================
	
	  function Plugin(option) {
	    return this.each(function () {
	      var $this   = $(this)
	      var data    = $this.data('bs.collapse')
	      var options = $.extend({}, Collapse.DEFAULTS, $this.data(), typeof option == 'object' && option)
	
	      if (!data && options.toggle && /show|hide/.test(option)) options.toggle = false
	      if (!data) $this.data('bs.collapse', (data = new Collapse(this, options)))
	      if (typeof option == 'string') data[option]()
	    })
	  }
	
	  var old = $.fn.collapse
	
	  $.fn.collapse             = Plugin
	  $.fn.collapse.Constructor = Collapse
	
	
	  // COLLAPSE NO CONFLICT
	  // ====================
	
	  $.fn.collapse.noConflict = function () {
	    $.fn.collapse = old
	    return this
	  }
	
	
	  // COLLAPSE DATA-API
	  // =================
	
	  $(document).on('click.bs.collapse.data-api', '[data-toggle="collapse"]', function (e) {
	    var $this   = $(this)
	
	    if (!$this.attr('data-target')) e.preventDefault()
	
	    var $target = getTargetFromTrigger($this)
	    var data    = $target.data('bs.collapse')
	    var option  = data ? 'toggle' : $this.data()
	
	    Plugin.call($target, option)
	  })
	
	}(jQuery);
	
	/* ========================================================================
	 * Bootstrap: dropdown.js v3.3.7
	 * http://getbootstrap.com/javascript/#dropdowns
	 * ========================================================================
	 * Copyright 2011-2016 Twitter, Inc.
	 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
	 * ======================================================================== */
	
	
	+function ($) {
	  'use strict';
	
	  // DROPDOWN CLASS DEFINITION
	  // =========================
	
	  var backdrop = '.dropdown-backdrop'
	  var toggle   = '[data-toggle="dropdown"]'
	  var Dropdown = function (element) {
	    $(element).on('click.bs.dropdown', this.toggle)
	  }
	
	  Dropdown.VERSION = '3.3.7'
	
	  function getParent($this) {
	    var selector = $this.attr('data-target')
	
	    if (!selector) {
	      selector = $this.attr('href')
	      selector = selector && /#[A-Za-z]/.test(selector) && selector.replace(/.*(?=#[^\s]*$)/, '') // strip for ie7
	    }
	
	    var $parent = selector && $(selector)
	
	    return $parent && $parent.length ? $parent : $this.parent()
	  }
	
	  function clearMenus(e) {
	    if (e && e.which === 3) return
	    $(backdrop).remove()
	    $(toggle).each(function () {
	      var $this         = $(this)
	      var $parent       = getParent($this)
	      var relatedTarget = { relatedTarget: this }
	
	      if (!$parent.hasClass('open')) return
	
	      if (e && e.type == 'click' && /input|textarea/i.test(e.target.tagName) && $.contains($parent[0], e.target)) return
	
	      $parent.trigger(e = $.Event('hide.bs.dropdown', relatedTarget))
	
	      if (e.isDefaultPrevented()) return
	
	      $this.attr('aria-expanded', 'false')
	      $parent.removeClass('open').trigger($.Event('hidden.bs.dropdown', relatedTarget))
	    })
	  }
	
	  Dropdown.prototype.toggle = function (e) {
	    var $this = $(this)
	
	    if ($this.is('.disabled, :disabled')) return
	
	    var $parent  = getParent($this)
	    var isActive = $parent.hasClass('open')
	
	    clearMenus()
	
	    if (!isActive) {
	      if ('ontouchstart' in document.documentElement && !$parent.closest('.navbar-nav').length) {
	        // if mobile we use a backdrop because click events don't delegate
	        $(document.createElement('div'))
	          .addClass('dropdown-backdrop')
	          .insertAfter($(this))
	          .on('click', clearMenus)
	      }
	
	      var relatedTarget = { relatedTarget: this }
	      $parent.trigger(e = $.Event('show.bs.dropdown', relatedTarget))
	
	      if (e.isDefaultPrevented()) return
	
	      $this
	        .trigger('focus')
	        .attr('aria-expanded', 'true')
	
	      $parent
	        .toggleClass('open')
	        .trigger($.Event('shown.bs.dropdown', relatedTarget))
	    }
	
	    return false
	  }
	
	  Dropdown.prototype.keydown = function (e) {
	    if (!/(38|40|27|32)/.test(e.which) || /input|textarea/i.test(e.target.tagName)) return
	
	    var $this = $(this)
	
	    e.preventDefault()
	    e.stopPropagation()
	
	    if ($this.is('.disabled, :disabled')) return
	
	    var $parent  = getParent($this)
	    var isActive = $parent.hasClass('open')
	
	    if (!isActive && e.which != 27 || isActive && e.which == 27) {
	      if (e.which == 27) $parent.find(toggle).trigger('focus')
	      return $this.trigger('click')
	    }
	
	    var desc = ' li:not(.disabled):visible a'
	    var $items = $parent.find('.dropdown-menu' + desc)
	
	    if (!$items.length) return
	
	    var index = $items.index(e.target)
	
	    if (e.which == 38 && index > 0)                 index--         // up
	    if (e.which == 40 && index < $items.length - 1) index++         // down
	    if (!~index)                                    index = 0
	
	    $items.eq(index).trigger('focus')
	  }
	
	
	  // DROPDOWN PLUGIN DEFINITION
	  // ==========================
	
	  function Plugin(option) {
	    return this.each(function () {
	      var $this = $(this)
	      var data  = $this.data('bs.dropdown')
	
	      if (!data) $this.data('bs.dropdown', (data = new Dropdown(this)))
	      if (typeof option == 'string') data[option].call($this)
	    })
	  }
	
	  var old = $.fn.dropdown
	
	  $.fn.dropdown             = Plugin
	  $.fn.dropdown.Constructor = Dropdown
	
	
	  // DROPDOWN NO CONFLICT
	  // ====================
	
	  $.fn.dropdown.noConflict = function () {
	    $.fn.dropdown = old
	    return this
	  }
	
	
	  // APPLY TO STANDARD DROPDOWN ELEMENTS
	  // ===================================
	
	  $(document)
	    .on('click.bs.dropdown.data-api', clearMenus)
	    .on('click.bs.dropdown.data-api', '.dropdown form', function (e) { e.stopPropagation() })
	    .on('click.bs.dropdown.data-api', toggle, Dropdown.prototype.toggle)
	    .on('keydown.bs.dropdown.data-api', toggle, Dropdown.prototype.keydown)
	    .on('keydown.bs.dropdown.data-api', '.dropdown-menu', Dropdown.prototype.keydown)
	
	}(jQuery);
	
	/* ========================================================================
	 * Bootstrap: modal.js v3.3.7
	 * http://getbootstrap.com/javascript/#modals
	 * ========================================================================
	 * Copyright 2011-2016 Twitter, Inc.
	 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
	 * ======================================================================== */
	
	
	+function ($) {
	  'use strict';
	
	  // MODAL CLASS DEFINITION
	  // ======================
	
	  var Modal = function (element, options) {
	    this.options             = options
	    this.$body               = $(document.body)
	    this.$element            = $(element)
	    this.$dialog             = this.$element.find('.modal-dialog')
	    this.$backdrop           = null
	    this.isShown             = null
	    this.originalBodyPad     = null
	    this.scrollbarWidth      = 0
	    this.ignoreBackdropClick = false
	
	    if (this.options.remote) {
	      this.$element
	        .find('.modal-content')
	        .load(this.options.remote, $.proxy(function () {
	          this.$element.trigger('loaded.bs.modal')
	        }, this))
	    }
	  }
	
	  Modal.VERSION  = '3.3.7'
	
	  Modal.TRANSITION_DURATION = 300
	  Modal.BACKDROP_TRANSITION_DURATION = 150
	
	  Modal.DEFAULTS = {
	    backdrop: true,
	    keyboard: true,
	    show: true
	  }
	
	  Modal.prototype.toggle = function (_relatedTarget) {
	    return this.isShown ? this.hide() : this.show(_relatedTarget)
	  }
	
	  Modal.prototype.show = function (_relatedTarget) {
	    var that = this
	    var e    = $.Event('show.bs.modal', { relatedTarget: _relatedTarget })
	
	    this.$element.trigger(e)
	
	    if (this.isShown || e.isDefaultPrevented()) return
	
	    this.isShown = true
	
	    this.checkScrollbar()
	    this.setScrollbar()
	    this.$body.addClass('modal-open')
	
	    this.escape()
	    this.resize()
	
	    this.$element.on('click.dismiss.bs.modal', '[data-dismiss="modal"]', $.proxy(this.hide, this))
	
	    this.$dialog.on('mousedown.dismiss.bs.modal', function () {
	      that.$element.one('mouseup.dismiss.bs.modal', function (e) {
	        if ($(e.target).is(that.$element)) that.ignoreBackdropClick = true
	      })
	    })
	
	    this.backdrop(function () {
	      var transition = $.support.transition && that.$element.hasClass('fade')
	
	      if (!that.$element.parent().length) {
	        that.$element.appendTo(that.$body) // don't move modals dom position
	      }
	
	      that.$element
	        .show()
	        .scrollTop(0)
	
	      that.adjustDialog()
	
	      if (transition) {
	        that.$element[0].offsetWidth // force reflow
	      }
	
	      that.$element.addClass('in')
	
	      that.enforceFocus()
	
	      var e = $.Event('shown.bs.modal', { relatedTarget: _relatedTarget })
	
	      transition ?
	        that.$dialog // wait for modal to slide in
	          .one('bsTransitionEnd', function () {
	            that.$element.trigger('focus').trigger(e)
	          })
	          .emulateTransitionEnd(Modal.TRANSITION_DURATION) :
	        that.$element.trigger('focus').trigger(e)
	    })
	  }
	
	  Modal.prototype.hide = function (e) {
	    if (e) e.preventDefault()
	
	    e = $.Event('hide.bs.modal')
	
	    this.$element.trigger(e)
	
	    if (!this.isShown || e.isDefaultPrevented()) return
	
	    this.isShown = false
	
	    this.escape()
	    this.resize()
	
	    $(document).off('focusin.bs.modal')
	
	    this.$element
	      .removeClass('in')
	      .off('click.dismiss.bs.modal')
	      .off('mouseup.dismiss.bs.modal')
	
	    this.$dialog.off('mousedown.dismiss.bs.modal')
	
	    $.support.transition && this.$element.hasClass('fade') ?
	      this.$element
	        .one('bsTransitionEnd', $.proxy(this.hideModal, this))
	        .emulateTransitionEnd(Modal.TRANSITION_DURATION) :
	      this.hideModal()
	  }
	
	  Modal.prototype.enforceFocus = function () {
	    $(document)
	      .off('focusin.bs.modal') // guard against infinite focus loop
	      .on('focusin.bs.modal', $.proxy(function (e) {
	        if (document !== e.target &&
	            this.$element[0] !== e.target &&
	            !this.$element.has(e.target).length) {
	          this.$element.trigger('focus')
	        }
	      }, this))
	  }
	
	  Modal.prototype.escape = function () {
	    if (this.isShown && this.options.keyboard) {
	      this.$element.on('keydown.dismiss.bs.modal', $.proxy(function (e) {
	        e.which == 27 && this.hide()
	      }, this))
	    } else if (!this.isShown) {
	      this.$element.off('keydown.dismiss.bs.modal')
	    }
	  }
	
	  Modal.prototype.resize = function () {
	    if (this.isShown) {
	      $(window).on('resize.bs.modal', $.proxy(this.handleUpdate, this))
	    } else {
	      $(window).off('resize.bs.modal')
	    }
	  }
	
	  Modal.prototype.hideModal = function () {
	    var that = this
	    this.$element.hide()
	    this.backdrop(function () {
	      that.$body.removeClass('modal-open')
	      that.resetAdjustments()
	      that.resetScrollbar()
	      that.$element.trigger('hidden.bs.modal')
	    })
	  }
	
	  Modal.prototype.removeBackdrop = function () {
	    this.$backdrop && this.$backdrop.remove()
	    this.$backdrop = null
	  }
	
	  Modal.prototype.backdrop = function (callback) {
	    var that = this
	    var animate = this.$element.hasClass('fade') ? 'fade' : ''
	
	    if (this.isShown && this.options.backdrop) {
	      var doAnimate = $.support.transition && animate
	
	      this.$backdrop = $(document.createElement('div'))
	        .addClass('modal-backdrop ' + animate)
	        .appendTo(this.$body)
	
	      this.$element.on('click.dismiss.bs.modal', $.proxy(function (e) {
	        if (this.ignoreBackdropClick) {
	          this.ignoreBackdropClick = false
	          return
	        }
	        if (e.target !== e.currentTarget) return
	        this.options.backdrop == 'static'
	          ? this.$element[0].focus()
	          : this.hide()
	      }, this))
	
	      if (doAnimate) this.$backdrop[0].offsetWidth // force reflow
	
	      this.$backdrop.addClass('in')
	
	      if (!callback) return
	
	      doAnimate ?
	        this.$backdrop
	          .one('bsTransitionEnd', callback)
	          .emulateTransitionEnd(Modal.BACKDROP_TRANSITION_DURATION) :
	        callback()
	
	    } else if (!this.isShown && this.$backdrop) {
	      this.$backdrop.removeClass('in')
	
	      var callbackRemove = function () {
	        that.removeBackdrop()
	        callback && callback()
	      }
	      $.support.transition && this.$element.hasClass('fade') ?
	        this.$backdrop
	          .one('bsTransitionEnd', callbackRemove)
	          .emulateTransitionEnd(Modal.BACKDROP_TRANSITION_DURATION) :
	        callbackRemove()
	
	    } else if (callback) {
	      callback()
	    }
	  }
	
	  // these following methods are used to handle overflowing modals
	
	  Modal.prototype.handleUpdate = function () {
	    this.adjustDialog()
	  }
	
	  Modal.prototype.adjustDialog = function () {
	    var modalIsOverflowing = this.$element[0].scrollHeight > document.documentElement.clientHeight
	
	    this.$element.css({
	      paddingLeft:  !this.bodyIsOverflowing && modalIsOverflowing ? this.scrollbarWidth : '',
	      paddingRight: this.bodyIsOverflowing && !modalIsOverflowing ? this.scrollbarWidth : ''
	    })
	  }
	
	  Modal.prototype.resetAdjustments = function () {
	    this.$element.css({
	      paddingLeft: '',
	      paddingRight: ''
	    })
	  }
	
	  Modal.prototype.checkScrollbar = function () {
	    var fullWindowWidth = window.innerWidth
	    if (!fullWindowWidth) { // workaround for missing window.innerWidth in IE8
	      var documentElementRect = document.documentElement.getBoundingClientRect()
	      fullWindowWidth = documentElementRect.right - Math.abs(documentElementRect.left)
	    }
	    this.bodyIsOverflowing = document.body.clientWidth < fullWindowWidth
	    this.scrollbarWidth = this.measureScrollbar()
	  }
	
	  Modal.prototype.setScrollbar = function () {
	    var bodyPad = parseInt((this.$body.css('padding-right') || 0), 10)
	    this.originalBodyPad = document.body.style.paddingRight || ''
	    if (this.bodyIsOverflowing) this.$body.css('padding-right', bodyPad + this.scrollbarWidth)
	  }
	
	  Modal.prototype.resetScrollbar = function () {
	    this.$body.css('padding-right', this.originalBodyPad)
	  }
	
	  Modal.prototype.measureScrollbar = function () { // thx walsh
	    var scrollDiv = document.createElement('div')
	    scrollDiv.className = 'modal-scrollbar-measure'
	    this.$body.append(scrollDiv)
	    var scrollbarWidth = scrollDiv.offsetWidth - scrollDiv.clientWidth
	    this.$body[0].removeChild(scrollDiv)
	    return scrollbarWidth
	  }
	
	
	  // MODAL PLUGIN DEFINITION
	  // =======================
	
	  function Plugin(option, _relatedTarget) {
	    return this.each(function () {
	      var $this   = $(this)
	      var data    = $this.data('bs.modal')
	      var options = $.extend({}, Modal.DEFAULTS, $this.data(), typeof option == 'object' && option)
	
	      if (!data) $this.data('bs.modal', (data = new Modal(this, options)))
	      if (typeof option == 'string') data[option](_relatedTarget)
	      else if (options.show) data.show(_relatedTarget)
	    })
	  }
	
	  var old = $.fn.modal
	
	  $.fn.modal             = Plugin
	  $.fn.modal.Constructor = Modal
	
	
	  // MODAL NO CONFLICT
	  // =================
	
	  $.fn.modal.noConflict = function () {
	    $.fn.modal = old
	    return this
	  }
	
	
	  // MODAL DATA-API
	  // ==============
	
	  $(document).on('click.bs.modal.data-api', '[data-toggle="modal"]', function (e) {
	    var $this   = $(this)
	    var href    = $this.attr('href')
	    var $target = $($this.attr('data-target') || (href && href.replace(/.*(?=#[^\s]+$)/, ''))) // strip for ie7
	    var option  = $target.data('bs.modal') ? 'toggle' : $.extend({ remote: !/#/.test(href) && href }, $target.data(), $this.data())
	
	    if ($this.is('a')) e.preventDefault()
	
	    $target.one('show.bs.modal', function (showEvent) {
	      if (showEvent.isDefaultPrevented()) return // only register focus restorer if modal will actually get shown
	      $target.one('hidden.bs.modal', function () {
	        $this.is(':visible') && $this.trigger('focus')
	      })
	    })
	    Plugin.call($target, option, this)
	  })
	
	}(jQuery);
	
	/* ========================================================================
	 * Bootstrap: tooltip.js v3.3.7
	 * http://getbootstrap.com/javascript/#tooltip
	 * Inspired by the original jQuery.tipsy by Jason Frame
	 * ========================================================================
	 * Copyright 2011-2016 Twitter, Inc.
	 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
	 * ======================================================================== */
	
	
	+function ($) {
	  'use strict';
	
	  // TOOLTIP PUBLIC CLASS DEFINITION
	  // ===============================
	
	  var Tooltip = function (element, options) {
	    this.type       = null
	    this.options    = null
	    this.enabled    = null
	    this.timeout    = null
	    this.hoverState = null
	    this.$element   = null
	    this.inState    = null
	
	    this.init('tooltip', element, options)
	  }
	
	  Tooltip.VERSION  = '3.3.7'
	
	  Tooltip.TRANSITION_DURATION = 150
	
	  Tooltip.DEFAULTS = {
	    animation: true,
	    placement: 'top',
	    selector: false,
	    template: '<div class="tooltip" role="tooltip"><div class="tooltip-arrow"></div><div class="tooltip-inner"></div></div>',
	    trigger: 'hover focus',
	    title: '',
	    delay: 0,
	    html: false,
	    container: false,
	    viewport: {
	      selector: 'body',
	      padding: 0
	    }
	  }
	
	  Tooltip.prototype.init = function (type, element, options) {
	    this.enabled   = true
	    this.type      = type
	    this.$element  = $(element)
	    this.options   = this.getOptions(options)
	    this.$viewport = this.options.viewport && $($.isFunction(this.options.viewport) ? this.options.viewport.call(this, this.$element) : (this.options.viewport.selector || this.options.viewport))
	    this.inState   = { click: false, hover: false, focus: false }
	
	    if (this.$element[0] instanceof document.constructor && !this.options.selector) {
	      throw new Error('`selector` option must be specified when initializing ' + this.type + ' on the window.document object!')
	    }
	
	    var triggers = this.options.trigger.split(' ')
	
	    for (var i = triggers.length; i--;) {
	      var trigger = triggers[i]
	
	      if (trigger == 'click') {
	        this.$element.on('click.' + this.type, this.options.selector, $.proxy(this.toggle, this))
	      } else if (trigger != 'manual') {
	        var eventIn  = trigger == 'hover' ? 'mouseenter' : 'focusin'
	        var eventOut = trigger == 'hover' ? 'mouseleave' : 'focusout'
	
	        this.$element.on(eventIn  + '.' + this.type, this.options.selector, $.proxy(this.enter, this))
	        this.$element.on(eventOut + '.' + this.type, this.options.selector, $.proxy(this.leave, this))
	      }
	    }
	
	    this.options.selector ?
	      (this._options = $.extend({}, this.options, { trigger: 'manual', selector: '' })) :
	      this.fixTitle()
	  }
	
	  Tooltip.prototype.getDefaults = function () {
	    return Tooltip.DEFAULTS
	  }
	
	  Tooltip.prototype.getOptions = function (options) {
	    options = $.extend({}, this.getDefaults(), this.$element.data(), options)
	
	    if (options.delay && typeof options.delay == 'number') {
	      options.delay = {
	        show: options.delay,
	        hide: options.delay
	      }
	    }
	
	    return options
	  }
	
	  Tooltip.prototype.getDelegateOptions = function () {
	    var options  = {}
	    var defaults = this.getDefaults()
	
	    this._options && $.each(this._options, function (key, value) {
	      if (defaults[key] != value) options[key] = value
	    })
	
	    return options
	  }
	
	  Tooltip.prototype.enter = function (obj) {
	    var self = obj instanceof this.constructor ?
	      obj : $(obj.currentTarget).data('bs.' + this.type)
	
	    if (!self) {
	      self = new this.constructor(obj.currentTarget, this.getDelegateOptions())
	      $(obj.currentTarget).data('bs.' + this.type, self)
	    }
	
	    if (obj instanceof $.Event) {
	      self.inState[obj.type == 'focusin' ? 'focus' : 'hover'] = true
	    }
	
	    if (self.tip().hasClass('in') || self.hoverState == 'in') {
	      self.hoverState = 'in'
	      return
	    }
	
	    clearTimeout(self.timeout)
	
	    self.hoverState = 'in'
	
	    if (!self.options.delay || !self.options.delay.show) return self.show()
	
	    self.timeout = setTimeout(function () {
	      if (self.hoverState == 'in') self.show()
	    }, self.options.delay.show)
	  }
	
	  Tooltip.prototype.isInStateTrue = function () {
	    for (var key in this.inState) {
	      if (this.inState[key]) return true
	    }
	
	    return false
	  }
	
	  Tooltip.prototype.leave = function (obj) {
	    var self = obj instanceof this.constructor ?
	      obj : $(obj.currentTarget).data('bs.' + this.type)
	
	    if (!self) {
	      self = new this.constructor(obj.currentTarget, this.getDelegateOptions())
	      $(obj.currentTarget).data('bs.' + this.type, self)
	    }
	
	    if (obj instanceof $.Event) {
	      self.inState[obj.type == 'focusout' ? 'focus' : 'hover'] = false
	    }
	
	    if (self.isInStateTrue()) return
	
	    clearTimeout(self.timeout)
	
	    self.hoverState = 'out'
	
	    if (!self.options.delay || !self.options.delay.hide) return self.hide()
	
	    self.timeout = setTimeout(function () {
	      if (self.hoverState == 'out') self.hide()
	    }, self.options.delay.hide)
	  }
	
	  Tooltip.prototype.show = function () {
	    var e = $.Event('show.bs.' + this.type)
	
	    if (this.hasContent() && this.enabled) {
	      this.$element.trigger(e)
	
	      var inDom = $.contains(this.$element[0].ownerDocument.documentElement, this.$element[0])
	      if (e.isDefaultPrevented() || !inDom) return
	      var that = this
	
	      var $tip = this.tip()
	
	      var tipId = this.getUID(this.type)
	
	      this.setContent()
	      $tip.attr('id', tipId)
	      this.$element.attr('aria-describedby', tipId)
	
	      if (this.options.animation) $tip.addClass('fade')
	
	      var placement = typeof this.options.placement == 'function' ?
	        this.options.placement.call(this, $tip[0], this.$element[0]) :
	        this.options.placement
	
	      var autoToken = /\s?auto?\s?/i
	      var autoPlace = autoToken.test(placement)
	      if (autoPlace) placement = placement.replace(autoToken, '') || 'top'
	
	      $tip
	        .detach()
	        .css({ top: 0, left: 0, display: 'block' })
	        .addClass(placement)
	        .data('bs.' + this.type, this)
	
	      this.options.container ? $tip.appendTo(this.options.container) : $tip.insertAfter(this.$element)
	      this.$element.trigger('inserted.bs.' + this.type)
	
	      var pos          = this.getPosition()
	      var actualWidth  = $tip[0].offsetWidth
	      var actualHeight = $tip[0].offsetHeight
	
	      if (autoPlace) {
	        var orgPlacement = placement
	        var viewportDim = this.getPosition(this.$viewport)
	
	        placement = placement == 'bottom' && pos.bottom + actualHeight > viewportDim.bottom ? 'top'    :
	                    placement == 'top'    && pos.top    - actualHeight < viewportDim.top    ? 'bottom' :
	                    placement == 'right'  && pos.right  + actualWidth  > viewportDim.width  ? 'left'   :
	                    placement == 'left'   && pos.left   - actualWidth  < viewportDim.left   ? 'right'  :
	                    placement
	
	        $tip
	          .removeClass(orgPlacement)
	          .addClass(placement)
	      }
	
	      var calculatedOffset = this.getCalculatedOffset(placement, pos, actualWidth, actualHeight)
	
	      this.applyPlacement(calculatedOffset, placement)
	
	      var complete = function () {
	        var prevHoverState = that.hoverState
	        that.$element.trigger('shown.bs.' + that.type)
	        that.hoverState = null
	
	        if (prevHoverState == 'out') that.leave(that)
	      }
	
	      $.support.transition && this.$tip.hasClass('fade') ?
	        $tip
	          .one('bsTransitionEnd', complete)
	          .emulateTransitionEnd(Tooltip.TRANSITION_DURATION) :
	        complete()
	    }
	  }
	
	  Tooltip.prototype.applyPlacement = function (offset, placement) {
	    var $tip   = this.tip()
	    var width  = $tip[0].offsetWidth
	    var height = $tip[0].offsetHeight
	
	    // manually read margins because getBoundingClientRect includes difference
	    var marginTop = parseInt($tip.css('margin-top'), 10)
	    var marginLeft = parseInt($tip.css('margin-left'), 10)
	
	    // we must check for NaN for ie 8/9
	    if (isNaN(marginTop))  marginTop  = 0
	    if (isNaN(marginLeft)) marginLeft = 0
	
	    offset.top  += marginTop
	    offset.left += marginLeft
	
	    // $.fn.offset doesn't round pixel values
	    // so we use setOffset directly with our own function B-0
	    $.offset.setOffset($tip[0], $.extend({
	      using: function (props) {
	        $tip.css({
	          top: Math.round(props.top),
	          left: Math.round(props.left)
	        })
	      }
	    }, offset), 0)
	
	    $tip.addClass('in')
	
	    // check to see if placing tip in new offset caused the tip to resize itself
	    var actualWidth  = $tip[0].offsetWidth
	    var actualHeight = $tip[0].offsetHeight
	
	    if (placement == 'top' && actualHeight != height) {
	      offset.top = offset.top + height - actualHeight
	    }
	
	    var delta = this.getViewportAdjustedDelta(placement, offset, actualWidth, actualHeight)
	
	    if (delta.left) offset.left += delta.left
	    else offset.top += delta.top
	
	    var isVertical          = /top|bottom/.test(placement)
	    var arrowDelta          = isVertical ? delta.left * 2 - width + actualWidth : delta.top * 2 - height + actualHeight
	    var arrowOffsetPosition = isVertical ? 'offsetWidth' : 'offsetHeight'
	
	    $tip.offset(offset)
	    this.replaceArrow(arrowDelta, $tip[0][arrowOffsetPosition], isVertical)
	  }
	
	  Tooltip.prototype.replaceArrow = function (delta, dimension, isVertical) {
	    this.arrow()
	      .css(isVertical ? 'left' : 'top', 50 * (1 - delta / dimension) + '%')
	      .css(isVertical ? 'top' : 'left', '')
	  }
	
	  Tooltip.prototype.setContent = function () {
	    var $tip  = this.tip()
	    var title = this.getTitle()
	
	    $tip.find('.tooltip-inner')[this.options.html ? 'html' : 'text'](title)
	    $tip.removeClass('fade in top bottom left right')
	  }
	
	  Tooltip.prototype.hide = function (callback) {
	    var that = this
	    var $tip = $(this.$tip)
	    var e    = $.Event('hide.bs.' + this.type)
	
	    function complete() {
	      if (that.hoverState != 'in') $tip.detach()
	      if (that.$element) { // TODO: Check whether guarding this code with this `if` is really necessary.
	        that.$element
	          .removeAttr('aria-describedby')
	          .trigger('hidden.bs.' + that.type)
	      }
	      callback && callback()
	    }
	
	    this.$element.trigger(e)
	
	    if (e.isDefaultPrevented()) return
	
	    $tip.removeClass('in')
	
	    $.support.transition && $tip.hasClass('fade') ?
	      $tip
	        .one('bsTransitionEnd', complete)
	        .emulateTransitionEnd(Tooltip.TRANSITION_DURATION) :
	      complete()
	
	    this.hoverState = null
	
	    return this
	  }
	
	  Tooltip.prototype.fixTitle = function () {
	    var $e = this.$element
	    if ($e.attr('title') || typeof $e.attr('data-original-title') != 'string') {
	      $e.attr('data-original-title', $e.attr('title') || '').attr('title', '')
	    }
	  }
	
	  Tooltip.prototype.hasContent = function () {
	    return this.getTitle()
	  }
	
	  Tooltip.prototype.getPosition = function ($element) {
	    $element   = $element || this.$element
	
	    var el     = $element[0]
	    var isBody = el.tagName == 'BODY'
	
	    var elRect    = el.getBoundingClientRect()
	    if (elRect.width == null) {
	      // width and height are missing in IE8, so compute them manually; see https://github.com/twbs/bootstrap/issues/14093
	      elRect = $.extend({}, elRect, { width: elRect.right - elRect.left, height: elRect.bottom - elRect.top })
	    }
	    var isSvg = window.SVGElement && el instanceof window.SVGElement
	    // Avoid using $.offset() on SVGs since it gives incorrect results in jQuery 3.
	    // See https://github.com/twbs/bootstrap/issues/20280
	    var elOffset  = isBody ? { top: 0, left: 0 } : (isSvg ? null : $element.offset())
	    var scroll    = { scroll: isBody ? document.documentElement.scrollTop || document.body.scrollTop : $element.scrollTop() }
	    var outerDims = isBody ? { width: $(window).width(), height: $(window).height() } : null
	
	    return $.extend({}, elRect, scroll, outerDims, elOffset)
	  }
	
	  Tooltip.prototype.getCalculatedOffset = function (placement, pos, actualWidth, actualHeight) {
	    return placement == 'bottom' ? { top: pos.top + pos.height,   left: pos.left + pos.width / 2 - actualWidth / 2 } :
	           placement == 'top'    ? { top: pos.top - actualHeight, left: pos.left + pos.width / 2 - actualWidth / 2 } :
	           placement == 'left'   ? { top: pos.top + pos.height / 2 - actualHeight / 2, left: pos.left - actualWidth } :
	        /* placement == 'right' */ { top: pos.top + pos.height / 2 - actualHeight / 2, left: pos.left + pos.width }
	
	  }
	
	  Tooltip.prototype.getViewportAdjustedDelta = function (placement, pos, actualWidth, actualHeight) {
	    var delta = { top: 0, left: 0 }
	    if (!this.$viewport) return delta
	
	    var viewportPadding = this.options.viewport && this.options.viewport.padding || 0
	    var viewportDimensions = this.getPosition(this.$viewport)
	
	    if (/right|left/.test(placement)) {
	      var topEdgeOffset    = pos.top - viewportPadding - viewportDimensions.scroll
	      var bottomEdgeOffset = pos.top + viewportPadding - viewportDimensions.scroll + actualHeight
	      if (topEdgeOffset < viewportDimensions.top) { // top overflow
	        delta.top = viewportDimensions.top - topEdgeOffset
	      } else if (bottomEdgeOffset > viewportDimensions.top + viewportDimensions.height) { // bottom overflow
	        delta.top = viewportDimensions.top + viewportDimensions.height - bottomEdgeOffset
	      }
	    } else {
	      var leftEdgeOffset  = pos.left - viewportPadding
	      var rightEdgeOffset = pos.left + viewportPadding + actualWidth
	      if (leftEdgeOffset < viewportDimensions.left) { // left overflow
	        delta.left = viewportDimensions.left - leftEdgeOffset
	      } else if (rightEdgeOffset > viewportDimensions.right) { // right overflow
	        delta.left = viewportDimensions.left + viewportDimensions.width - rightEdgeOffset
	      }
	    }
	
	    return delta
	  }
	
	  Tooltip.prototype.getTitle = function () {
	    var title
	    var $e = this.$element
	    var o  = this.options
	
	    title = $e.attr('data-original-title')
	      || (typeof o.title == 'function' ? o.title.call($e[0]) :  o.title)
	
	    return title
	  }
	
	  Tooltip.prototype.getUID = function (prefix) {
	    do prefix += ~~(Math.random() * 1000000)
	    while (document.getElementById(prefix))
	    return prefix
	  }
	
	  Tooltip.prototype.tip = function () {
	    if (!this.$tip) {
	      this.$tip = $(this.options.template)
	      if (this.$tip.length != 1) {
	        throw new Error(this.type + ' `template` option must consist of exactly 1 top-level element!')
	      }
	    }
	    return this.$tip
	  }
	
	  Tooltip.prototype.arrow = function () {
	    return (this.$arrow = this.$arrow || this.tip().find('.tooltip-arrow'))
	  }
	
	  Tooltip.prototype.enable = function () {
	    this.enabled = true
	  }
	
	  Tooltip.prototype.disable = function () {
	    this.enabled = false
	  }
	
	  Tooltip.prototype.toggleEnabled = function () {
	    this.enabled = !this.enabled
	  }
	
	  Tooltip.prototype.toggle = function (e) {
	    var self = this
	    if (e) {
	      self = $(e.currentTarget).data('bs.' + this.type)
	      if (!self) {
	        self = new this.constructor(e.currentTarget, this.getDelegateOptions())
	        $(e.currentTarget).data('bs.' + this.type, self)
	      }
	    }
	
	    if (e) {
	      self.inState.click = !self.inState.click
	      if (self.isInStateTrue()) self.enter(self)
	      else self.leave(self)
	    } else {
	      self.tip().hasClass('in') ? self.leave(self) : self.enter(self)
	    }
	  }
	
	  Tooltip.prototype.destroy = function () {
	    var that = this
	    clearTimeout(this.timeout)
	    this.hide(function () {
	      that.$element.off('.' + that.type).removeData('bs.' + that.type)
	      if (that.$tip) {
	        that.$tip.detach()
	      }
	      that.$tip = null
	      that.$arrow = null
	      that.$viewport = null
	      that.$element = null
	    })
	  }
	
	
	  // TOOLTIP PLUGIN DEFINITION
	  // =========================
	
	  function Plugin(option) {
	    return this.each(function () {
	      var $this   = $(this)
	      var data    = $this.data('bs.tooltip')
	      var options = typeof option == 'object' && option
	
	      if (!data && /destroy|hide/.test(option)) return
	      if (!data) $this.data('bs.tooltip', (data = new Tooltip(this, options)))
	      if (typeof option == 'string') data[option]()
	    })
	  }
	
	  var old = $.fn.tooltip
	
	  $.fn.tooltip             = Plugin
	  $.fn.tooltip.Constructor = Tooltip
	
	
	  // TOOLTIP NO CONFLICT
	  // ===================
	
	  $.fn.tooltip.noConflict = function () {
	    $.fn.tooltip = old
	    return this
	  }
	
	}(jQuery);
	
	/* ========================================================================
	 * Bootstrap: popover.js v3.3.7
	 * http://getbootstrap.com/javascript/#popovers
	 * ========================================================================
	 * Copyright 2011-2016 Twitter, Inc.
	 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
	 * ======================================================================== */
	
	
	+function ($) {
	  'use strict';
	
	  // POPOVER PUBLIC CLASS DEFINITION
	  // ===============================
	
	  var Popover = function (element, options) {
	    this.init('popover', element, options)
	  }
	
	  if (!$.fn.tooltip) throw new Error('Popover requires tooltip.js')
	
	  Popover.VERSION  = '3.3.7'
	
	  Popover.DEFAULTS = $.extend({}, $.fn.tooltip.Constructor.DEFAULTS, {
	    placement: 'right',
	    trigger: 'click',
	    content: '',
	    template: '<div class="popover" role="tooltip"><div class="arrow"></div><h3 class="popover-title"></h3><div class="popover-content"></div></div>'
	  })
	
	
	  // NOTE: POPOVER EXTENDS tooltip.js
	  // ================================
	
	  Popover.prototype = $.extend({}, $.fn.tooltip.Constructor.prototype)
	
	  Popover.prototype.constructor = Popover
	
	  Popover.prototype.getDefaults = function () {
	    return Popover.DEFAULTS
	  }
	
	  Popover.prototype.setContent = function () {
	    var $tip    = this.tip()
	    var title   = this.getTitle()
	    var content = this.getContent()
	
	    $tip.find('.popover-title')[this.options.html ? 'html' : 'text'](title)
	    $tip.find('.popover-content').children().detach().end()[ // we use append for html objects to maintain js events
	      this.options.html ? (typeof content == 'string' ? 'html' : 'append') : 'text'
	    ](content)
	
	    $tip.removeClass('fade top bottom left right in')
	
	    // IE8 doesn't accept hiding via the `:empty` pseudo selector, we have to do
	    // this manually by checking the contents.
	    if (!$tip.find('.popover-title').html()) $tip.find('.popover-title').hide()
	  }
	
	  Popover.prototype.hasContent = function () {
	    return this.getTitle() || this.getContent()
	  }
	
	  Popover.prototype.getContent = function () {
	    var $e = this.$element
	    var o  = this.options
	
	    return $e.attr('data-content')
	      || (typeof o.content == 'function' ?
	            o.content.call($e[0]) :
	            o.content)
	  }
	
	  Popover.prototype.arrow = function () {
	    return (this.$arrow = this.$arrow || this.tip().find('.arrow'))
	  }
	
	
	  // POPOVER PLUGIN DEFINITION
	  // =========================
	
	  function Plugin(option) {
	    return this.each(function () {
	      var $this   = $(this)
	      var data    = $this.data('bs.popover')
	      var options = typeof option == 'object' && option
	
	      if (!data && /destroy|hide/.test(option)) return
	      if (!data) $this.data('bs.popover', (data = new Popover(this, options)))
	      if (typeof option == 'string') data[option]()
	    })
	  }
	
	  var old = $.fn.popover
	
	  $.fn.popover             = Plugin
	  $.fn.popover.Constructor = Popover
	
	
	  // POPOVER NO CONFLICT
	  // ===================
	
	  $.fn.popover.noConflict = function () {
	    $.fn.popover = old
	    return this
	  }
	
	}(jQuery);
	
	/* ========================================================================
	 * Bootstrap: scrollspy.js v3.3.7
	 * http://getbootstrap.com/javascript/#scrollspy
	 * ========================================================================
	 * Copyright 2011-2016 Twitter, Inc.
	 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
	 * ======================================================================== */
	
	
	+function ($) {
	  'use strict';
	
	  // SCROLLSPY CLASS DEFINITION
	  // ==========================
	
	  function ScrollSpy(element, options) {
	    this.$body          = $(document.body)
	    this.$scrollElement = $(element).is(document.body) ? $(window) : $(element)
	    this.options        = $.extend({}, ScrollSpy.DEFAULTS, options)
	    this.selector       = (this.options.target || '') + ' .nav li > a'
	    this.offsets        = []
	    this.targets        = []
	    this.activeTarget   = null
	    this.scrollHeight   = 0
	
	    this.$scrollElement.on('scroll.bs.scrollspy', $.proxy(this.process, this))
	    this.refresh()
	    this.process()
	  }
	
	  ScrollSpy.VERSION  = '3.3.7'
	
	  ScrollSpy.DEFAULTS = {
	    offset: 10
	  }
	
	  ScrollSpy.prototype.getScrollHeight = function () {
	    return this.$scrollElement[0].scrollHeight || Math.max(this.$body[0].scrollHeight, document.documentElement.scrollHeight)
	  }
	
	  ScrollSpy.prototype.refresh = function () {
	    var that          = this
	    var offsetMethod  = 'offset'
	    var offsetBase    = 0
	
	    this.offsets      = []
	    this.targets      = []
	    this.scrollHeight = this.getScrollHeight()
	
	    if (!$.isWindow(this.$scrollElement[0])) {
	      offsetMethod = 'position'
	      offsetBase   = this.$scrollElement.scrollTop()
	    }
	
	    this.$body
	      .find(this.selector)
	      .map(function () {
	        var $el   = $(this)
	        var href  = $el.data('target') || $el.attr('href')
	        var $href = /^#./.test(href) && $(href)
	
	        return ($href
	          && $href.length
	          && $href.is(':visible')
	          && [[$href[offsetMethod]().top + offsetBase, href]]) || null
	      })
	      .sort(function (a, b) { return a[0] - b[0] })
	      .each(function () {
	        that.offsets.push(this[0])
	        that.targets.push(this[1])
	      })
	  }
	
	  ScrollSpy.prototype.process = function () {
	    var scrollTop    = this.$scrollElement.scrollTop() + this.options.offset
	    var scrollHeight = this.getScrollHeight()
	    var maxScroll    = this.options.offset + scrollHeight - this.$scrollElement.height()
	    var offsets      = this.offsets
	    var targets      = this.targets
	    var activeTarget = this.activeTarget
	    var i
	
	    if (this.scrollHeight != scrollHeight) {
	      this.refresh()
	    }
	
	    if (scrollTop >= maxScroll) {
	      return activeTarget != (i = targets[targets.length - 1]) && this.activate(i)
	    }
	
	    if (activeTarget && scrollTop < offsets[0]) {
	      this.activeTarget = null
	      return this.clear()
	    }
	
	    for (i = offsets.length; i--;) {
	      activeTarget != targets[i]
	        && scrollTop >= offsets[i]
	        && (offsets[i + 1] === undefined || scrollTop < offsets[i + 1])
	        && this.activate(targets[i])
	    }
	  }
	
	  ScrollSpy.prototype.activate = function (target) {
	    this.activeTarget = target
	
	    this.clear()
	
	    var selector = this.selector +
	      '[data-target="' + target + '"],' +
	      this.selector + '[href="' + target + '"]'
	
	    var active = $(selector)
	      .parents('li')
	      .addClass('active')
	
	    if (active.parent('.dropdown-menu').length) {
	      active = active
	        .closest('li.dropdown')
	        .addClass('active')
	    }
	
	    active.trigger('activate.bs.scrollspy')
	  }
	
	  ScrollSpy.prototype.clear = function () {
	    $(this.selector)
	      .parentsUntil(this.options.target, '.active')
	      .removeClass('active')
	  }
	
	
	  // SCROLLSPY PLUGIN DEFINITION
	  // ===========================
	
	  function Plugin(option) {
	    return this.each(function () {
	      var $this   = $(this)
	      var data    = $this.data('bs.scrollspy')
	      var options = typeof option == 'object' && option
	
	      if (!data) $this.data('bs.scrollspy', (data = new ScrollSpy(this, options)))
	      if (typeof option == 'string') data[option]()
	    })
	  }
	
	  var old = $.fn.scrollspy
	
	  $.fn.scrollspy             = Plugin
	  $.fn.scrollspy.Constructor = ScrollSpy
	
	
	  // SCROLLSPY NO CONFLICT
	  // =====================
	
	  $.fn.scrollspy.noConflict = function () {
	    $.fn.scrollspy = old
	    return this
	  }
	
	
	  // SCROLLSPY DATA-API
	  // ==================
	
	  $(window).on('load.bs.scrollspy.data-api', function () {
	    $('[data-spy="scroll"]').each(function () {
	      var $spy = $(this)
	      Plugin.call($spy, $spy.data())
	    })
	  })
	
	}(jQuery);
	
	/* ========================================================================
	 * Bootstrap: tab.js v3.3.7
	 * http://getbootstrap.com/javascript/#tabs
	 * ========================================================================
	 * Copyright 2011-2016 Twitter, Inc.
	 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
	 * ======================================================================== */
	
	
	+function ($) {
	  'use strict';
	
	  // TAB CLASS DEFINITION
	  // ====================
	
	  var Tab = function (element) {
	    // jscs:disable requireDollarBeforejQueryAssignment
	    this.element = $(element)
	    // jscs:enable requireDollarBeforejQueryAssignment
	  }
	
	  Tab.VERSION = '3.3.7'
	
	  Tab.TRANSITION_DURATION = 150
	
	  Tab.prototype.show = function () {
	    var $this    = this.element
	    var $ul      = $this.closest('ul:not(.dropdown-menu)')
	    var selector = $this.data('target')
	
	    if (!selector) {
	      selector = $this.attr('href')
	      selector = selector && selector.replace(/.*(?=#[^\s]*$)/, '') // strip for ie7
	    }
	
	    if ($this.parent('li').hasClass('active')) return
	
	    var $previous = $ul.find('.active:last a')
	    var hideEvent = $.Event('hide.bs.tab', {
	      relatedTarget: $this[0]
	    })
	    var showEvent = $.Event('show.bs.tab', {
	      relatedTarget: $previous[0]
	    })
	
	    $previous.trigger(hideEvent)
	    $this.trigger(showEvent)
	
	    if (showEvent.isDefaultPrevented() || hideEvent.isDefaultPrevented()) return
	
	    var $target = $(selector)
	
	    this.activate($this.closest('li'), $ul)
	    this.activate($target, $target.parent(), function () {
	      $previous.trigger({
	        type: 'hidden.bs.tab',
	        relatedTarget: $this[0]
	      })
	      $this.trigger({
	        type: 'shown.bs.tab',
	        relatedTarget: $previous[0]
	      })
	    })
	  }
	
	  Tab.prototype.activate = function (element, container, callback) {
	    var $active    = container.find('> .active')
	    var transition = callback
	      && $.support.transition
	      && ($active.length && $active.hasClass('fade') || !!container.find('> .fade').length)
	
	    function next() {
	      $active
	        .removeClass('active')
	        .find('> .dropdown-menu > .active')
	          .removeClass('active')
	        .end()
	        .find('[data-toggle="tab"]')
	          .attr('aria-expanded', false)
	
	      element
	        .addClass('active')
	        .find('[data-toggle="tab"]')
	          .attr('aria-expanded', true)
	
	      if (transition) {
	        element[0].offsetWidth // reflow for transition
	        element.addClass('in')
	      } else {
	        element.removeClass('fade')
	      }
	
	      if (element.parent('.dropdown-menu').length) {
	        element
	          .closest('li.dropdown')
	            .addClass('active')
	          .end()
	          .find('[data-toggle="tab"]')
	            .attr('aria-expanded', true)
	      }
	
	      callback && callback()
	    }
	
	    $active.length && transition ?
	      $active
	        .one('bsTransitionEnd', next)
	        .emulateTransitionEnd(Tab.TRANSITION_DURATION) :
	      next()
	
	    $active.removeClass('in')
	  }
	
	
	  // TAB PLUGIN DEFINITION
	  // =====================
	
	  function Plugin(option) {
	    return this.each(function () {
	      var $this = $(this)
	      var data  = $this.data('bs.tab')
	
	      if (!data) $this.data('bs.tab', (data = new Tab(this)))
	      if (typeof option == 'string') data[option]()
	    })
	  }
	
	  var old = $.fn.tab
	
	  $.fn.tab             = Plugin
	  $.fn.tab.Constructor = Tab
	
	
	  // TAB NO CONFLICT
	  // ===============
	
	  $.fn.tab.noConflict = function () {
	    $.fn.tab = old
	    return this
	  }
	
	
	  // TAB DATA-API
	  // ============
	
	  var clickHandler = function (e) {
	    e.preventDefault()
	    Plugin.call($(this), 'show')
	  }
	
	  $(document)
	    .on('click.bs.tab.data-api', '[data-toggle="tab"]', clickHandler)
	    .on('click.bs.tab.data-api', '[data-toggle="pill"]', clickHandler)
	
	}(jQuery);
	
	/* ========================================================================
	 * Bootstrap: affix.js v3.3.7
	 * http://getbootstrap.com/javascript/#affix
	 * ========================================================================
	 * Copyright 2011-2016 Twitter, Inc.
	 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
	 * ======================================================================== */
	
	
	+function ($) {
	  'use strict';
	
	  // AFFIX CLASS DEFINITION
	  // ======================
	
	  var Affix = function (element, options) {
	    this.options = $.extend({}, Affix.DEFAULTS, options)
	
	    this.$target = $(this.options.target)
	      .on('scroll.bs.affix.data-api', $.proxy(this.checkPosition, this))
	      .on('click.bs.affix.data-api',  $.proxy(this.checkPositionWithEventLoop, this))
	
	    this.$element     = $(element)
	    this.affixed      = null
	    this.unpin        = null
	    this.pinnedOffset = null
	
	    this.checkPosition()
	  }
	
	  Affix.VERSION  = '3.3.7'
	
	  Affix.RESET    = 'affix affix-top affix-bottom'
	
	  Affix.DEFAULTS = {
	    offset: 0,
	    target: window
	  }
	
	  Affix.prototype.getState = function (scrollHeight, height, offsetTop, offsetBottom) {
	    var scrollTop    = this.$target.scrollTop()
	    var position     = this.$element.offset()
	    var targetHeight = this.$target.height()
	
	    if (offsetTop != null && this.affixed == 'top') return scrollTop < offsetTop ? 'top' : false
	
	    if (this.affixed == 'bottom') {
	      if (offsetTop != null) return (scrollTop + this.unpin <= position.top) ? false : 'bottom'
	      return (scrollTop + targetHeight <= scrollHeight - offsetBottom) ? false : 'bottom'
	    }
	
	    var initializing   = this.affixed == null
	    var colliderTop    = initializing ? scrollTop : position.top
	    var colliderHeight = initializing ? targetHeight : height
	
	    if (offsetTop != null && scrollTop <= offsetTop) return 'top'
	    if (offsetBottom != null && (colliderTop + colliderHeight >= scrollHeight - offsetBottom)) return 'bottom'
	
	    return false
	  }
	
	  Affix.prototype.getPinnedOffset = function () {
	    if (this.pinnedOffset) return this.pinnedOffset
	    this.$element.removeClass(Affix.RESET).addClass('affix')
	    var scrollTop = this.$target.scrollTop()
	    var position  = this.$element.offset()
	    return (this.pinnedOffset = position.top - scrollTop)
	  }
	
	  Affix.prototype.checkPositionWithEventLoop = function () {
	    setTimeout($.proxy(this.checkPosition, this), 1)
	  }
	
	  Affix.prototype.checkPosition = function () {
	    if (!this.$element.is(':visible')) return
	
	    var height       = this.$element.height()
	    var offset       = this.options.offset
	    var offsetTop    = offset.top
	    var offsetBottom = offset.bottom
	    var scrollHeight = Math.max($(document).height(), $(document.body).height())
	
	    if (typeof offset != 'object')         offsetBottom = offsetTop = offset
	    if (typeof offsetTop == 'function')    offsetTop    = offset.top(this.$element)
	    if (typeof offsetBottom == 'function') offsetBottom = offset.bottom(this.$element)
	
	    var affix = this.getState(scrollHeight, height, offsetTop, offsetBottom)
	
	    if (this.affixed != affix) {
	      if (this.unpin != null) this.$element.css('top', '')
	
	      var affixType = 'affix' + (affix ? '-' + affix : '')
	      var e         = $.Event(affixType + '.bs.affix')
	
	      this.$element.trigger(e)
	
	      if (e.isDefaultPrevented()) return
	
	      this.affixed = affix
	      this.unpin = affix == 'bottom' ? this.getPinnedOffset() : null
	
	      this.$element
	        .removeClass(Affix.RESET)
	        .addClass(affixType)
	        .trigger(affixType.replace('affix', 'affixed') + '.bs.affix')
	    }
	
	    if (affix == 'bottom') {
	      this.$element.offset({
	        top: scrollHeight - height - offsetBottom
	      })
	    }
	  }
	
	
	  // AFFIX PLUGIN DEFINITION
	  // =======================
	
	  function Plugin(option) {
	    return this.each(function () {
	      var $this   = $(this)
	      var data    = $this.data('bs.affix')
	      var options = typeof option == 'object' && option
	
	      if (!data) $this.data('bs.affix', (data = new Affix(this, options)))
	      if (typeof option == 'string') data[option]()
	    })
	  }
	
	  var old = $.fn.affix
	
	  $.fn.affix             = Plugin
	  $.fn.affix.Constructor = Affix
	
	
	  // AFFIX NO CONFLICT
	  // =================
	
	  $.fn.affix.noConflict = function () {
	    $.fn.affix = old
	    return this
	  }
	
	
	  // AFFIX DATA-API
	  // ==============
	
	  $(window).on('load', function () {
	    $('[data-spy="affix"]').each(function () {
	      var $spy = $(this)
	      var data = $spy.data()
	
	      data.offset = data.offset || {}
	
	      if (data.offsetBottom != null) data.offset.bottom = data.offsetBottom
	      if (data.offsetTop    != null) data.offset.top    = data.offsetTop
	
	      Plugin.call($spy, data)
	    })
	  })
	
	}(jQuery);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(8)))

/***/ }),

/***/ 342:
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(jQuery) {(function() {
	  var $, AbstractChosen, Chosen, SelectParser,
	    bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
	    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
	    hasProp = {}.hasOwnProperty;
	
	  SelectParser = (function() {
	    function SelectParser() {
	      this.options_index = 0;
	      this.parsed = [];
	    }
	
	    SelectParser.prototype.add_node = function(child) {
	      if (child.nodeName.toUpperCase() === "OPTGROUP") {
	        return this.add_group(child);
	      } else {
	        return this.add_option(child);
	      }
	    };
	
	    SelectParser.prototype.add_group = function(group) {
	      var group_position, i, len, option, ref, results1;
	      group_position = this.parsed.length;
	      this.parsed.push({
	        array_index: group_position,
	        group: true,
	        label: group.label,
	        title: group.title ? group.title : void 0,
	        children: 0,
	        disabled: group.disabled,
	        classes: group.className
	      });
	      ref = group.childNodes;
	      results1 = [];
	      for (i = 0, len = ref.length; i < len; i++) {
	        option = ref[i];
	        results1.push(this.add_option(option, group_position, group.disabled));
	      }
	      return results1;
	    };
	
	    SelectParser.prototype.add_option = function(option, group_position, group_disabled) {
	      if (option.nodeName.toUpperCase() === "OPTION") {
	        if (option.text !== "") {
	          if (group_position != null) {
	            this.parsed[group_position].children += 1;
	          }
	          this.parsed.push({
	            array_index: this.parsed.length,
	            options_index: this.options_index,
	            value: option.value,
	            text: option.text,
	            html: option.innerHTML,
	            title: option.title ? option.title : void 0,
	            selected: option.selected,
	            disabled: group_disabled === true ? group_disabled : option.disabled,
	            group_array_index: group_position,
	            group_label: group_position != null ? this.parsed[group_position].label : null,
	            classes: option.className,
	            style: option.style.cssText
	          });
	        } else {
	          this.parsed.push({
	            array_index: this.parsed.length,
	            options_index: this.options_index,
	            empty: true
	          });
	        }
	        return this.options_index += 1;
	      }
	    };
	
	    return SelectParser;
	
	  })();
	
	  SelectParser.select_to_array = function(select) {
	    var child, i, len, parser, ref;
	    parser = new SelectParser();
	    ref = select.childNodes;
	    for (i = 0, len = ref.length; i < len; i++) {
	      child = ref[i];
	      parser.add_node(child);
	    }
	    return parser.parsed;
	  };
	
	  AbstractChosen = (function() {
	    function AbstractChosen(form_field, options1) {
	      this.form_field = form_field;
	      this.options = options1 != null ? options1 : {};
	      this.label_click_handler = bind(this.label_click_handler, this);
	      if (!AbstractChosen.browser_is_supported()) {
	        return;
	      }
	      this.is_multiple = this.form_field.multiple;
	      this.set_default_text();
	      this.set_default_values();
	      this.setup();
	      this.set_up_html();
	      this.register_observers();
	      this.on_ready();
	    }
	
	    AbstractChosen.prototype.set_default_values = function() {
	      this.click_test_action = (function(_this) {
	        return function(evt) {
	          return _this.test_active_click(evt);
	        };
	      })(this);
	      this.activate_action = (function(_this) {
	        return function(evt) {
	          return _this.activate_field(evt);
	        };
	      })(this);
	      this.active_field = false;
	      this.mouse_on_container = false;
	      this.results_showing = false;
	      this.result_highlighted = null;
	      this.is_rtl = this.options.rtl || /\bchosen-rtl\b/.test(this.form_field.className);
	      this.allow_single_deselect = (this.options.allow_single_deselect != null) && (this.form_field.options[0] != null) && this.form_field.options[0].text === "" ? this.options.allow_single_deselect : false;
	      this.disable_search_threshold = this.options.disable_search_threshold || 0;
	      this.disable_search = this.options.disable_search || false;
	      this.enable_split_word_search = this.options.enable_split_word_search != null ? this.options.enable_split_word_search : true;
	      this.group_search = this.options.group_search != null ? this.options.group_search : true;
	      this.search_contains = this.options.search_contains || false;
	      this.single_backstroke_delete = this.options.single_backstroke_delete != null ? this.options.single_backstroke_delete : true;
	      this.max_selected_options = this.options.max_selected_options || Infinity;
	      this.inherit_select_classes = this.options.inherit_select_classes || false;
	      this.display_selected_options = this.options.display_selected_options != null ? this.options.display_selected_options : true;
	      this.display_disabled_options = this.options.display_disabled_options != null ? this.options.display_disabled_options : true;
	      this.include_group_label_in_selected = this.options.include_group_label_in_selected || false;
	      this.max_shown_results = this.options.max_shown_results || Number.POSITIVE_INFINITY;
	      this.case_sensitive_search = this.options.case_sensitive_search || false;
	      return this.hide_results_on_select = this.options.hide_results_on_select != null ? this.options.hide_results_on_select : true;
	    };
	
	    AbstractChosen.prototype.set_default_text = function() {
	      if (this.form_field.getAttribute("data-placeholder")) {
	        this.default_text = this.form_field.getAttribute("data-placeholder");
	      } else if (this.is_multiple) {
	        this.default_text = this.options.placeholder_text_multiple || this.options.placeholder_text || AbstractChosen.default_multiple_text;
	      } else {
	        this.default_text = this.options.placeholder_text_single || this.options.placeholder_text || AbstractChosen.default_single_text;
	      }
	      this.default_text = this.escape_html(this.default_text);
	      return this.results_none_found = this.form_field.getAttribute("data-no_results_text") || this.options.no_results_text || AbstractChosen.default_no_result_text;
	    };
	
	    AbstractChosen.prototype.choice_label = function(item) {
	      if (this.include_group_label_in_selected && (item.group_label != null)) {
	        return "<b class='group-name'>" + item.group_label + "</b>" + item.html;
	      } else {
	        return item.html;
	      }
	    };
	
	    AbstractChosen.prototype.mouse_enter = function() {
	      return this.mouse_on_container = true;
	    };
	
	    AbstractChosen.prototype.mouse_leave = function() {
	      return this.mouse_on_container = false;
	    };
	
	    AbstractChosen.prototype.input_focus = function(evt) {
	      if (this.is_multiple) {
	        if (!this.active_field) {
	          return setTimeout(((function(_this) {
	            return function() {
	              return _this.container_mousedown();
	            };
	          })(this)), 50);
	        }
	      } else {
	        if (!this.active_field) {
	          return this.activate_field();
	        }
	      }
	    };
	
	    AbstractChosen.prototype.input_blur = function(evt) {
	      if (!this.mouse_on_container) {
	        this.active_field = false;
	        return setTimeout(((function(_this) {
	          return function() {
	            return _this.blur_test();
	          };
	        })(this)), 100);
	      }
	    };
	
	    AbstractChosen.prototype.label_click_handler = function(evt) {
	      if (this.is_multiple) {
	        return this.container_mousedown(evt);
	      } else {
	        return this.activate_field();
	      }
	    };
	
	    AbstractChosen.prototype.results_option_build = function(options) {
	      var content, data, data_content, i, len, ref, shown_results;
	      content = '';
	      shown_results = 0;
	      ref = this.results_data;
	      for (i = 0, len = ref.length; i < len; i++) {
	        data = ref[i];
	        data_content = '';
	        if (data.group) {
	          data_content = this.result_add_group(data);
	        } else {
	          data_content = this.result_add_option(data);
	        }
	        if (data_content !== '') {
	          shown_results++;
	          content += data_content;
	        }
	        if (options != null ? options.first : void 0) {
	          if (data.selected && this.is_multiple) {
	            this.choice_build(data);
	          } else if (data.selected && !this.is_multiple) {
	            this.single_set_selected_text(this.choice_label(data));
	          }
	        }
	        if (shown_results >= this.max_shown_results) {
	          break;
	        }
	      }
	      return content;
	    };
	
	    AbstractChosen.prototype.result_add_option = function(option) {
	      var classes, option_el;
	      if (!option.search_match) {
	        return '';
	      }
	      if (!this.include_option_in_results(option)) {
	        return '';
	      }
	      classes = [];
	      if (!option.disabled && !(option.selected && this.is_multiple)) {
	        classes.push("active-result");
	      }
	      if (option.disabled && !(option.selected && this.is_multiple)) {
	        classes.push("disabled-result");
	      }
	      if (option.selected) {
	        classes.push("result-selected");
	      }
	      if (option.group_array_index != null) {
	        classes.push("group-option");
	      }
	      if (option.classes !== "") {
	        classes.push(option.classes);
	      }
	      option_el = document.createElement("li");
	      option_el.className = classes.join(" ");
	      if (option.style) {
	        option_el.style.cssText = option.style;
	      }
	      option_el.setAttribute("data-option-array-index", option.array_index);
	      option_el.innerHTML = option.highlighted_html || option.html;
	      if (option.title) {
	        option_el.title = option.title;
	      }
	      return this.outerHTML(option_el);
	    };
	
	    AbstractChosen.prototype.result_add_group = function(group) {
	      var classes, group_el;
	      if (!(group.search_match || group.group_match)) {
	        return '';
	      }
	      if (!(group.active_options > 0)) {
	        return '';
	      }
	      classes = [];
	      classes.push("group-result");
	      if (group.classes) {
	        classes.push(group.classes);
	      }
	      group_el = document.createElement("li");
	      group_el.className = classes.join(" ");
	      group_el.innerHTML = group.highlighted_html || this.escape_html(group.label);
	      if (group.title) {
	        group_el.title = group.title;
	      }
	      return this.outerHTML(group_el);
	    };
	
	    AbstractChosen.prototype.results_update_field = function() {
	      this.set_default_text();
	      if (!this.is_multiple) {
	        this.results_reset_cleanup();
	      }
	      this.result_clear_highlight();
	      this.results_build();
	      if (this.results_showing) {
	        return this.winnow_results();
	      }
	    };
	
	    AbstractChosen.prototype.reset_single_select_options = function() {
	      var i, len, ref, result, results1;
	      ref = this.results_data;
	      results1 = [];
	      for (i = 0, len = ref.length; i < len; i++) {
	        result = ref[i];
	        if (result.selected) {
	          results1.push(result.selected = false);
	        } else {
	          results1.push(void 0);
	        }
	      }
	      return results1;
	    };
	
	    AbstractChosen.prototype.results_toggle = function() {
	      if (this.results_showing) {
	        return this.results_hide();
	      } else {
	        return this.results_show();
	      }
	    };
	
	    AbstractChosen.prototype.results_search = function(evt) {
	      if (this.results_showing) {
	        return this.winnow_results();
	      } else {
	        return this.results_show();
	      }
	    };
	
	    AbstractChosen.prototype.winnow_results = function(options) {
	      var escapedQuery, fix, i, len, option, prefix, query, ref, regex, results, results_group, search_match, startpos, suffix, text;
	      this.no_results_clear();
	      results = 0;
	      query = this.get_search_text();
	      escapedQuery = query.replace(/[-[\]{}()*+?.,\\^$|#\s]/g, "\\$&");
	      regex = this.get_search_regex(escapedQuery);
	      ref = this.results_data;
	      for (i = 0, len = ref.length; i < len; i++) {
	        option = ref[i];
	        option.search_match = false;
	        results_group = null;
	        search_match = null;
	        option.highlighted_html = '';
	        if (this.include_option_in_results(option)) {
	          if (option.group) {
	            option.group_match = false;
	            option.active_options = 0;
	          }
	          if ((option.group_array_index != null) && this.results_data[option.group_array_index]) {
	            results_group = this.results_data[option.group_array_index];
	            if (results_group.active_options === 0 && results_group.search_match) {
	              results += 1;
	            }
	            results_group.active_options += 1;
	          }
	          text = option.group ? option.label : option.text;
	          if (!(option.group && !this.group_search)) {
	            search_match = this.search_string_match(text, regex);
	            option.search_match = search_match != null;
	            if (option.search_match && !option.group) {
	              results += 1;
	            }
	            if (option.search_match) {
	              if (query.length) {
	                startpos = search_match.index;
	                prefix = text.slice(0, startpos);
	                fix = text.slice(startpos, startpos + query.length);
	                suffix = text.slice(startpos + query.length);
	                option.highlighted_html = (this.escape_html(prefix)) + "<em>" + (this.escape_html(fix)) + "</em>" + (this.escape_html(suffix));
	              }
	              if (results_group != null) {
	                results_group.group_match = true;
	              }
	            } else if ((option.group_array_index != null) && this.results_data[option.group_array_index].search_match) {
	              option.search_match = true;
	            }
	          }
	        }
	      }
	      this.result_clear_highlight();
	      if (results < 1 && query.length) {
	        this.update_results_content("");
	        return this.no_results(query);
	      } else {
	        this.update_results_content(this.results_option_build());
	        if (!(options != null ? options.skip_highlight : void 0)) {
	          return this.winnow_results_set_highlight();
	        }
	      }
	    };
	
	    AbstractChosen.prototype.get_search_regex = function(escaped_search_string) {
	      var regex_flag, regex_string;
	      regex_string = this.search_contains ? escaped_search_string : "(^|\\s|\\b)" + escaped_search_string + "[^\\s]*";
	      if (!(this.enable_split_word_search || this.search_contains)) {
	        regex_string = "^" + regex_string;
	      }
	      regex_flag = this.case_sensitive_search ? "" : "i";
	      return new RegExp(regex_string, regex_flag);
	    };
	
	    AbstractChosen.prototype.search_string_match = function(search_string, regex) {
	      var match;
	      match = regex.exec(search_string);
	      if (!this.search_contains && (match != null ? match[1] : void 0)) {
	        match.index += 1;
	      }
	      return match;
	    };
	
	    AbstractChosen.prototype.choices_count = function() {
	      var i, len, option, ref;
	      if (this.selected_option_count != null) {
	        return this.selected_option_count;
	      }
	      this.selected_option_count = 0;
	      ref = this.form_field.options;
	      for (i = 0, len = ref.length; i < len; i++) {
	        option = ref[i];
	        if (option.selected) {
	          this.selected_option_count += 1;
	        }
	      }
	      return this.selected_option_count;
	    };
	
	    AbstractChosen.prototype.choices_click = function(evt) {
	      evt.preventDefault();
	      this.activate_field();
	      if (!(this.results_showing || this.is_disabled)) {
	        return this.results_show();
	      }
	    };
	
	    AbstractChosen.prototype.keydown_checker = function(evt) {
	      var ref, stroke;
	      stroke = (ref = evt.which) != null ? ref : evt.keyCode;
	      this.search_field_scale();
	      if (stroke !== 8 && this.pending_backstroke) {
	        this.clear_backstroke();
	      }
	      switch (stroke) {
	        case 8:
	          this.backstroke_length = this.get_search_field_value().length;
	          break;
	        case 9:
	          if (this.results_showing && !this.is_multiple) {
	            this.result_select(evt);
	          }
	          this.mouse_on_container = false;
	          break;
	        case 13:
	          if (this.results_showing) {
	            evt.preventDefault();
	          }
	          break;
	        case 27:
	          if (this.results_showing) {
	            evt.preventDefault();
	          }
	          break;
	        case 32:
	          if (this.disable_search) {
	            evt.preventDefault();
	          }
	          break;
	        case 38:
	          evt.preventDefault();
	          this.keyup_arrow();
	          break;
	        case 40:
	          evt.preventDefault();
	          this.keydown_arrow();
	          break;
	      }
	    };
	
	    AbstractChosen.prototype.keyup_checker = function(evt) {
	      var ref, stroke;
	      stroke = (ref = evt.which) != null ? ref : evt.keyCode;
	      this.search_field_scale();
	      switch (stroke) {
	        case 8:
	          if (this.is_multiple && this.backstroke_length < 1 && this.choices_count() > 0) {
	            this.keydown_backstroke();
	          } else if (!this.pending_backstroke) {
	            this.result_clear_highlight();
	            this.results_search();
	          }
	          break;
	        case 13:
	          evt.preventDefault();
	          if (this.results_showing) {
	            this.result_select(evt);
	          }
	          break;
	        case 27:
	          if (this.results_showing) {
	            this.results_hide();
	          }
	          break;
	        case 9:
	        case 16:
	        case 17:
	        case 18:
	        case 38:
	        case 40:
	        case 91:
	          break;
	        default:
	          this.results_search();
	          break;
	      }
	    };
	
	    AbstractChosen.prototype.clipboard_event_checker = function(evt) {
	      if (this.is_disabled) {
	        return;
	      }
	      return setTimeout(((function(_this) {
	        return function() {
	          return _this.results_search();
	        };
	      })(this)), 50);
	    };
	
	    AbstractChosen.prototype.container_width = function() {
	      if (this.options.width != null) {
	        return this.options.width;
	      } else {
	        return this.form_field.offsetWidth + "px";
	      }
	    };
	
	    AbstractChosen.prototype.include_option_in_results = function(option) {
	      if (this.is_multiple && (!this.display_selected_options && option.selected)) {
	        return false;
	      }
	      if (!this.display_disabled_options && option.disabled) {
	        return false;
	      }
	      if (option.empty) {
	        return false;
	      }
	      return true;
	    };
	
	    AbstractChosen.prototype.search_results_touchstart = function(evt) {
	      this.touch_started = true;
	      return this.search_results_mouseover(evt);
	    };
	
	    AbstractChosen.prototype.search_results_touchmove = function(evt) {
	      this.touch_started = false;
	      return this.search_results_mouseout(evt);
	    };
	
	    AbstractChosen.prototype.search_results_touchend = function(evt) {
	      if (this.touch_started) {
	        return this.search_results_mouseup(evt);
	      }
	    };
	
	    AbstractChosen.prototype.outerHTML = function(element) {
	      var tmp;
	      if (element.outerHTML) {
	        return element.outerHTML;
	      }
	      tmp = document.createElement("div");
	      tmp.appendChild(element);
	      return tmp.innerHTML;
	    };
	
	    AbstractChosen.prototype.get_single_html = function() {
	      return "<a class=\"chosen-single chosen-default\">\n  <input class=\"chosen-focus-input\" type=\"text\" autocomplete=\"off\" />\n  <span>" + this.default_text + "</span>\n  <div><b></b></div>\n</a>\n<div class=\"chosen-drop\">\n  <div class=\"chosen-search\">\n    <input class=\"chosen-search-input\" type=\"text\" autocomplete=\"off\" />\n  </div>\n  <ul class=\"chosen-results\"></ul>\n</div>";
	    };
	
	    AbstractChosen.prototype.get_multi_html = function() {
	      return "<ul class=\"chosen-choices\">\n  <li class=\"search-field\">\n    <input class=\"chosen-search-input\" type=\"text\" autocomplete=\"off\" value=\"" + this.default_text + "\" />\n  </li>\n</ul>\n<div class=\"chosen-drop\">\n  <ul class=\"chosen-results\"></ul>\n</div>";
	    };
	
	    AbstractChosen.prototype.get_no_results_html = function(terms) {
	      return "<li class=\"no-results\">\n  " + this.results_none_found + " <span>" + (this.escape_html(terms)) + "</span>\n</li>";
	    };
	
	    AbstractChosen.browser_is_supported = function() {
	      if ("Microsoft Internet Explorer" === window.navigator.appName) {
	        return document.documentMode >= 8;
	      }
	      if (/iP(od|hone)/i.test(window.navigator.userAgent) || /IEMobile/i.test(window.navigator.userAgent) || /Windows Phone/i.test(window.navigator.userAgent) || /BlackBerry/i.test(window.navigator.userAgent) || /BB10/i.test(window.navigator.userAgent) || /Android.*Mobile/i.test(window.navigator.userAgent)) {
	        return false;
	      }
	      return true;
	    };
	
	    AbstractChosen.default_multiple_text = "Select Some Options";
	
	    AbstractChosen.default_single_text = "Select an Option";
	
	    AbstractChosen.default_no_result_text = "No results match";
	
	    return AbstractChosen;
	
	  })();
	
	  $ = jQuery;
	
	  $.fn.extend({
	    chosen: function(options) {
	      if (!AbstractChosen.browser_is_supported()) {
	        return this;
	      }
	      return this.each(function(input_field) {
	        var $this, chosen;
	        $this = $(this);
	        chosen = $this.data('chosen');
	        if (options === 'destroy') {
	          if (chosen instanceof Chosen) {
	            chosen.destroy();
	          }
	          return;
	        }
	        if (!(chosen instanceof Chosen)) {
	          $this.data('chosen', new Chosen(this, options));
	        }
	      });
	    }
	  });
	
	  Chosen = (function(superClass) {
	    extend(Chosen, superClass);
	
	    function Chosen() {
	      return Chosen.__super__.constructor.apply(this, arguments);
	    }
	
	    Chosen.prototype.setup = function() {
	      this.form_field_jq = $(this.form_field);
	      return this.current_selectedIndex = this.form_field.selectedIndex;
	    };
	
	    Chosen.prototype.set_up_html = function() {
	      var container_classes, container_props;
	      container_classes = ["chosen-container"];
	      container_classes.push("chosen-container-" + (this.is_multiple ? "multi" : "single"));
	      if (this.inherit_select_classes && this.form_field.className) {
	        container_classes.push(this.form_field.className);
	      }
	      if (this.is_rtl) {
	        container_classes.push("chosen-rtl");
	      }
	      container_props = {
	        'class': container_classes.join(' '),
	        'title': this.form_field.title
	      };
	      if (this.form_field.id.length) {
	        container_props.id = this.form_field.id.replace(/[^\w]/g, '_') + "_chosen";
	      }
	      this.container = $("<div />", container_props);
	      this.container.width(this.container_width());
	      if (this.is_multiple) {
	        this.container.html(this.get_multi_html());
	      } else {
	        this.container.html(this.get_single_html());
	      }
	      this.form_field_jq.hide().after(this.container);
	      this.dropdown = this.container.find('div.chosen-drop').first();
	      this.search_field = this.container.find('input.chosen-search-input');
	      this.focus_field = this.container.find('input.chosen-focus-input');
	      this.search_results = this.container.find('ul.chosen-results').first();
	      this.search_field_scale();
	      this.search_no_results = this.container.find('li.no-results').first();
	      if (this.is_multiple) {
	        this.search_choices = this.container.find('ul.chosen-choices').first();
	        this.search_container = this.container.find('li.search-field').first();
	      } else {
	        this.search_container = this.container.find('div.chosen-search').first();
	        this.selected_item = this.container.find('.chosen-single').first();
	      }
	      this.results_build();
	      this.set_tab_index();
	      return this.set_label_behavior();
	    };
	
	    Chosen.prototype.on_ready = function() {
	      return this.form_field_jq.trigger("chosen:ready", {
	        chosen: this
	      });
	    };
	
	    Chosen.prototype.register_observers = function() {
	      var transfer_value;
	      this.container.on('touchstart.chosen', (function(_this) {
	        return function(evt) {
	          _this.container_mousedown(evt);
	        };
	      })(this));
	      this.container.on('touchend.chosen', (function(_this) {
	        return function(evt) {
	          _this.container_mouseup(evt);
	        };
	      })(this));
	      this.container.on('mousedown.chosen', (function(_this) {
	        return function(evt) {
	          _this.container_mousedown(evt);
	        };
	      })(this));
	      this.container.on('mouseup.chosen', (function(_this) {
	        return function(evt) {
	          _this.container_mouseup(evt);
	        };
	      })(this));
	      this.container.on('mouseenter.chosen', (function(_this) {
	        return function(evt) {
	          _this.mouse_enter(evt);
	        };
	      })(this));
	      this.container.on('mouseleave.chosen', (function(_this) {
	        return function(evt) {
	          _this.mouse_leave(evt);
	        };
	      })(this));
	      this.search_results.on('mouseup.chosen', (function(_this) {
	        return function(evt) {
	          _this.search_results_mouseup(evt);
	        };
	      })(this));
	      this.search_results.on('mouseover.chosen', (function(_this) {
	        return function(evt) {
	          _this.search_results_mouseover(evt);
	        };
	      })(this));
	      this.search_results.on('mouseout.chosen', (function(_this) {
	        return function(evt) {
	          _this.search_results_mouseout(evt);
	        };
	      })(this));
	      this.search_results.on('mousewheel.chosen DOMMouseScroll.chosen', (function(_this) {
	        return function(evt) {
	          _this.search_results_mousewheel(evt);
	        };
	      })(this));
	      this.search_results.on('touchstart.chosen', (function(_this) {
	        return function(evt) {
	          _this.search_results_touchstart(evt);
	        };
	      })(this));
	      this.search_results.on('touchmove.chosen', (function(_this) {
	        return function(evt) {
	          _this.search_results_touchmove(evt);
	        };
	      })(this));
	      this.search_results.on('touchend.chosen', (function(_this) {
	        return function(evt) {
	          _this.search_results_touchend(evt);
	        };
	      })(this));
	      this.form_field_jq.on("chosen:updated.chosen", (function(_this) {
	        return function(evt) {
	          _this.results_update_field(evt);
	        };
	      })(this));
	      this.form_field_jq.on("chosen:activate.chosen", (function(_this) {
	        return function(evt) {
	          _this.activate_field(evt);
	        };
	      })(this));
	      this.form_field_jq.on("chosen:open.chosen", (function(_this) {
	        return function(evt) {
	          _this.container_mousedown(evt);
	        };
	      })(this));
	      this.form_field_jq.on("chosen:close.chosen", (function(_this) {
	        return function(evt) {
	          _this.close_field(evt);
	        };
	      })(this));
	      this.search_field.on('blur.chosen', (function(_this) {
	        return function(evt) {
	          _this.input_blur(evt);
	        };
	      })(this));
	      this.search_field.on('keyup.chosen', (function(_this) {
	        return function(evt) {
	          _this.keyup_checker(evt);
	        };
	      })(this));
	      this.search_field.on('keydown.chosen', (function(_this) {
	        return function(evt) {
	          _this.keydown_checker(evt);
	        };
	      })(this));
	      this.search_field.on('focus.chosen', (function(_this) {
	        return function(evt) {
	          _this.input_focus(evt);
	        };
	      })(this));
	      this.search_field.on('cut.chosen', (function(_this) {
	        return function(evt) {
	          _this.clipboard_event_checker(evt);
	        };
	      })(this));
	      this.search_field.on('paste.chosen', (function(_this) {
	        return function(evt) {
	          _this.clipboard_event_checker(evt);
	        };
	      })(this));
	      if (this.is_multiple) {
	        return this.search_choices.on('click.chosen', (function(_this) {
	          return function(evt) {
	            _this.choices_click(evt);
	          };
	        })(this));
	      } else {
	        this.container.on('click.chosen', function(evt) {
	          evt.preventDefault();
	        });
	        this.focus_field.on('blur.chosen', (function(_this) {
	          return function(evt) {
	            _this.input_blur(evt);
	          };
	        })(this));
	        this.focus_field.on('focus.chosen', (function(_this) {
	          return function(evt) {
	            _this.input_focus(evt);
	          };
	        })(this));
	        transfer_value = (function(_this) {
	          return function() {
	            _this.search_field.val(_this.focus_field.val());
	            return _this.focus_field.val('');
	          };
	        })(this);
	        this.focus_field.on('keyup.chosen', (function(_this) {
	          return function(evt) {
	            transfer_value();
	            _this.keyup_checker(evt);
	          };
	        })(this));
	        this.focus_field.on('keydown.chosen', (function(_this) {
	          return function(evt) {
	            transfer_value();
	            _this.keydown_checker(evt);
	          };
	        })(this));
	        this.focus_field.on('cut.chosen', (function(_this) {
	          return function(evt) {
	            setTimeout(transfer_value, 0);
	            _this.clipboard_event_checker(evt);
	          };
	        })(this));
	        return this.focus_field.on('paste.chosen', (function(_this) {
	          return function(evt) {
	            setTimeout(transfer_value, 0);
	            _this.clipboard_event_checker(evt);
	          };
	        })(this));
	      }
	    };
	
	    Chosen.prototype.destroy = function() {
	      $(this.container[0].ownerDocument).off('click.chosen', this.click_test_action);
	      if (this.form_field_label.length > 0) {
	        this.form_field_label.off('click.chosen');
	      }
	      if (this.search_field[0].tabIndex) {
	        this.form_field_jq[0].tabIndex = this.search_field[0].tabIndex;
	      }
	      this.container.remove();
	      this.form_field_jq.removeData('chosen');
	      return this.form_field_jq.show();
	    };
	
	    Chosen.prototype.search_field_disabled = function() {
	      this.is_disabled = this.form_field.disabled || this.form_field_jq.parents('fieldset').is(':disabled');
	      this.container.toggleClass('chosen-disabled', this.is_disabled);
	      this.search_field[0].disabled = this.is_disabled;
	      if (!this.is_multiple) {
	        this.selected_item.off('focus.chosen', this.activate_field);
	      }
	      if (this.is_disabled) {
	        return this.close_field();
	      } else if (!this.is_multiple) {
	        return this.selected_item.on('focus.chosen', this.activate_field);
	      }
	    };
	
	    Chosen.prototype.container_mousedown = function(evt) {
	      var ref;
	      if (this.is_disabled) {
	        return;
	      }
	      if (evt && ((ref = evt.type) === 'mousedown' || ref === 'touchstart') && !this.results_showing) {
	        evt.preventDefault();
	      }
	      if (!((evt != null) && ($(evt.target)).hasClass("search-choice-close"))) {
	        if (!this.active_field) {
	          if (this.is_multiple) {
	            this.search_field.val("");
	          }
	          $(this.container[0].ownerDocument).on('click.chosen', this.click_test_action);
	          this.results_show();
	        } else if (!this.is_multiple && evt && (($(evt.target)[0] === this.selected_item[0]) || $(evt.target).parents("a.chosen-single").length)) {
	          evt.preventDefault();
	          this.results_toggle();
	        }
	        return this.activate_field();
	      }
	    };
	
	    Chosen.prototype.container_mouseup = function(evt) {
	      if (evt.target.nodeName === "ABBR" && !this.is_disabled) {
	        return this.results_reset(evt);
	      }
	    };
	
	    Chosen.prototype.search_results_mousewheel = function(evt) {
	      var delta;
	      if (evt.originalEvent) {
	        delta = evt.originalEvent.deltaY || -evt.originalEvent.wheelDelta || evt.originalEvent.detail;
	      }
	      if (delta != null) {
	        evt.preventDefault();
	        if (evt.type === 'DOMMouseScroll') {
	          delta = delta * 40;
	        }
	        return this.search_results.scrollTop(delta + this.search_results.scrollTop());
	      }
	    };
	
	    Chosen.prototype.blur_test = function(evt) {
	      if (!this.active_field && this.container.hasClass("chosen-container-active")) {
	        return this.close_field();
	      }
	    };
	
	    Chosen.prototype.close_field = function() {
	      $(this.container[0].ownerDocument).off("click.chosen", this.click_test_action);
	      this.active_field = false;
	      this.results_hide();
	      this.container.removeClass("chosen-container-active");
	      this.clear_backstroke();
	      this.show_search_field_default();
	      this.search_field_scale();
	      return this.search_field.blur();
	    };
	
	    Chosen.prototype.activate_field = function() {
	      if (this.is_disabled) {
	        return;
	      }
	      this.container.addClass("chosen-container-active");
	      this.active_field = true;
	      return this.search_field.focus();
	    };
	
	    Chosen.prototype.test_active_click = function(evt) {
	      var active_container;
	      active_container = $(evt.target).closest('.chosen-container');
	      if (active_container.length && this.container[0] === active_container[0]) {
	        return this.active_field = true;
	      } else {
	        return this.close_field();
	      }
	    };
	
	    Chosen.prototype.results_build = function() {
	      this.parsing = true;
	      this.selected_option_count = null;
	      this.results_data = SelectParser.select_to_array(this.form_field);
	      if (this.is_multiple) {
	        this.search_choices.find("li.search-choice").remove();
	      } else {
	        this.single_set_selected_text();
	        if (this.disable_search || this.form_field.options.length <= this.disable_search_threshold) {
	          this.search_field[0].readOnly = true;
	          this.focus_field[0].readOnly = true;
	          this.container.addClass("chosen-container-single-nosearch");
	        } else {
	          this.search_field[0].readOnly = false;
	          this.focus_field[0].readOnly = false;
	          this.container.removeClass("chosen-container-single-nosearch");
	        }
	      }
	      this.update_results_content(this.results_option_build({
	        first: true
	      }));
	      this.search_field_disabled();
	      this.show_search_field_default();
	      this.search_field_scale();
	      return this.parsing = false;
	    };
	
	    Chosen.prototype.result_do_highlight = function(el) {
	      var high_bottom, high_top, maxHeight, visible_bottom, visible_top;
	      if (el.length) {
	        this.result_clear_highlight();
	        this.result_highlight = el;
	        this.result_highlight.addClass("highlighted");
	        maxHeight = parseInt(this.search_results.css("maxHeight"), 10);
	        visible_top = this.search_results.scrollTop();
	        visible_bottom = maxHeight + visible_top;
	        high_top = this.result_highlight.position().top + this.search_results.scrollTop();
	        high_bottom = high_top + this.result_highlight.outerHeight();
	        if (high_bottom >= visible_bottom) {
	          return this.search_results.scrollTop((high_bottom - maxHeight) > 0 ? high_bottom - maxHeight : 0);
	        } else if (high_top < visible_top) {
	          return this.search_results.scrollTop(high_top);
	        }
	      }
	    };
	
	    Chosen.prototype.result_clear_highlight = function() {
	      if (this.result_highlight) {
	        this.result_highlight.removeClass("highlighted");
	      }
	      return this.result_highlight = null;
	    };
	
	    Chosen.prototype.results_show = function() {
	      if (this.is_multiple && this.max_selected_options <= this.choices_count()) {
	        this.form_field_jq.trigger("chosen:maxselected", {
	          chosen: this
	        });
	        return false;
	      }
	      this.container.addClass("chosen-with-drop");
	      this.results_showing = true;
	      this.search_field.focus();
	      this.search_field.val(this.get_search_field_value());
	      this.winnow_results();
	      return this.form_field_jq.trigger("chosen:showing_dropdown", {
	        chosen: this
	      });
	    };
	
	    Chosen.prototype.update_results_content = function(content) {
	      return this.search_results.html(content);
	    };
	
	    Chosen.prototype.results_hide = function() {
	      if (this.results_showing) {
	        this.result_clear_highlight();
	        setTimeout(((function(_this) {
	          return function() {
	            return _this.focus_field.focus();
	          };
	        })(this)), 0);
	        this.container.removeClass("chosen-with-drop");
	        this.form_field_jq.trigger("chosen:hiding_dropdown", {
	          chosen: this
	        });
	      }
	      return this.results_showing = false;
	    };
	
	    Chosen.prototype.set_tab_index = function(el) {
	      var ref, ti;
	      if (this.form_field.tabIndex) {
	        ti = this.form_field.tabIndex;
	        this.form_field.tabIndex = -1;
	        this.search_field[0].tabIndex = ti;
	        return (ref = this.focus_field[0]) != null ? ref.tabIndex = ti : void 0;
	      }
	    };
	
	    Chosen.prototype.set_label_behavior = function() {
	      this.form_field_label = this.form_field_jq.parents("label");
	      if (!this.form_field_label.length && this.form_field.id.length) {
	        this.form_field_label = $("label[for='" + this.form_field.id + "']");
	      }
	      if (this.form_field_label.length > 0) {
	        return this.form_field_label.on('click.chosen', this.label_click_handler);
	      }
	    };
	
	    Chosen.prototype.show_search_field_default = function() {
	      if (this.is_multiple && this.choices_count() < 1 && !this.active_field) {
	        this.search_field.val(this.default_text);
	        return this.search_field.addClass("default");
	      } else {
	        this.search_field.val("");
	        return this.search_field.removeClass("default");
	      }
	    };
	
	    Chosen.prototype.search_results_mouseup = function(evt) {
	      var target;
	      target = $(evt.target).hasClass("active-result") ? $(evt.target) : $(evt.target).parents(".active-result").first();
	      if (target.length) {
	        this.result_highlight = target;
	        this.result_select(evt);
	        return this.search_field.focus();
	      }
	    };
	
	    Chosen.prototype.search_results_mouseover = function(evt) {
	      var target;
	      target = $(evt.target).hasClass("active-result") ? $(evt.target) : $(evt.target).parents(".active-result").first();
	      if (target) {
	        return this.result_do_highlight(target);
	      }
	    };
	
	    Chosen.prototype.search_results_mouseout = function(evt) {
	      if ($(evt.target).hasClass("active-result") || $(evt.target).parents('.active-result').first()) {
	        return this.result_clear_highlight();
	      }
	    };
	
	    Chosen.prototype.choice_build = function(item) {
	      var choice, close_link;
	      choice = $('<li />', {
	        "class": "search-choice"
	      }).html("<span>" + (this.choice_label(item)) + "</span>");
	      if (item.disabled) {
	        choice.addClass('search-choice-disabled');
	      } else {
	        close_link = $('<a />', {
	          "class": 'search-choice-close',
	          'data-option-array-index': item.array_index
	        });
	        close_link.on('click.chosen', (function(_this) {
	          return function(evt) {
	            return _this.choice_destroy_link_click(evt);
	          };
	        })(this));
	        choice.append(close_link);
	      }
	      return this.search_container.before(choice);
	    };
	
	    Chosen.prototype.choice_destroy_link_click = function(evt) {
	      evt.preventDefault();
	      evt.stopPropagation();
	      if (!this.is_disabled) {
	        return this.choice_destroy($(evt.target));
	      }
	    };
	
	    Chosen.prototype.choice_destroy = function(link) {
	      if (this.result_deselect(link[0].getAttribute("data-option-array-index"))) {
	        if (this.active_field) {
	          this.search_field.focus();
	        } else {
	          this.show_search_field_default();
	        }
	        if (this.is_multiple && this.choices_count() > 0 && this.get_search_field_value().length < 1) {
	          this.results_hide();
	        }
	        link.parents('li').first().remove();
	        return this.search_field_scale();
	      }
	    };
	
	    Chosen.prototype.results_reset = function() {
	      this.reset_single_select_options();
	      this.form_field.options[0].selected = true;
	      this.single_set_selected_text();
	      this.show_search_field_default();
	      this.results_reset_cleanup();
	      this.trigger_form_field_change();
	      if (this.active_field) {
	        return this.results_hide();
	      }
	    };
	
	    Chosen.prototype.results_reset_cleanup = function() {
	      this.current_selectedIndex = this.form_field.selectedIndex;
	      return this.selected_item.find("abbr").remove();
	    };
	
	    Chosen.prototype.result_select = function(evt) {
	      var high, item;
	      if (this.result_highlight) {
	        high = this.result_highlight;
	        this.result_clear_highlight();
	        if (this.is_multiple && this.max_selected_options <= this.choices_count()) {
	          this.form_field_jq.trigger("chosen:maxselected", {
	            chosen: this
	          });
	          return false;
	        }
	        if (this.is_multiple) {
	          high.removeClass("active-result");
	        } else {
	          this.reset_single_select_options();
	        }
	        high.addClass("result-selected");
	        item = this.results_data[high[0].getAttribute("data-option-array-index")];
	        item.selected = true;
	        this.form_field.options[item.options_index].selected = true;
	        this.selected_option_count = null;
	        if (this.is_multiple) {
	          this.choice_build(item);
	        } else {
	          this.single_set_selected_text(this.choice_label(item));
	        }
	        if (this.is_multiple && (!this.hide_results_on_select || (evt.metaKey || evt.ctrlKey))) {
	          if (evt.metaKey || evt.ctrlKey) {
	            this.winnow_results({
	              skip_highlight: true
	            });
	          } else {
	            this.search_field.val("");
	            this.winnow_results();
	          }
	        } else {
	          this.results_hide();
	          this.show_search_field_default();
	        }
	        if (this.is_multiple || this.form_field.selectedIndex !== this.current_selectedIndex) {
	          this.trigger_form_field_change({
	            selected: this.form_field.options[item.options_index].value
	          });
	        }
	        this.current_selectedIndex = this.form_field.selectedIndex;
	        evt.preventDefault();
	        return this.search_field_scale();
	      }
	    };
	
	    Chosen.prototype.single_set_selected_text = function(text) {
	      if (text == null) {
	        text = this.default_text;
	      }
	      if (text === this.default_text) {
	        this.selected_item.addClass("chosen-default");
	      } else {
	        this.single_deselect_control_build();
	        this.selected_item.removeClass("chosen-default");
	      }
	      return this.selected_item.find("span").html(text);
	    };
	
	    Chosen.prototype.result_deselect = function(pos) {
	      var result_data;
	      result_data = this.results_data[pos];
	      if (!this.form_field.options[result_data.options_index].disabled) {
	        result_data.selected = false;
	        this.form_field.options[result_data.options_index].selected = false;
	        this.selected_option_count = null;
	        this.result_clear_highlight();
	        if (this.results_showing) {
	          this.winnow_results();
	        }
	        this.trigger_form_field_change({
	          deselected: this.form_field.options[result_data.options_index].value
	        });
	        this.search_field_scale();
	        return true;
	      } else {
	        return false;
	      }
	    };
	
	    Chosen.prototype.single_deselect_control_build = function() {
	      if (!this.allow_single_deselect) {
	        return;
	      }
	      if (!this.selected_item.find("abbr").length) {
	        this.selected_item.find("span").first().after("<abbr class=\"search-choice-close\"></abbr>");
	      }
	      return this.selected_item.addClass("chosen-single-with-deselect");
	    };
	
	    Chosen.prototype.get_search_field_value = function() {
	      return this.search_field.val();
	    };
	
	    Chosen.prototype.get_search_text = function() {
	      return $.trim(this.get_search_field_value());
	    };
	
	    Chosen.prototype.escape_html = function(text) {
	      return $('<div/>').text(text).html();
	    };
	
	    Chosen.prototype.winnow_results_set_highlight = function() {
	      var do_high, selected_results;
	      selected_results = !this.is_multiple ? this.search_results.find(".result-selected.active-result") : [];
	      do_high = selected_results.length ? selected_results.first() : this.search_results.find(".active-result").first();
	      if (do_high != null) {
	        return this.result_do_highlight(do_high);
	      }
	    };
	
	    Chosen.prototype.no_results = function(terms) {
	      var no_results_html;
	      no_results_html = this.get_no_results_html(terms);
	      this.search_results.append(no_results_html);
	      return this.form_field_jq.trigger("chosen:no_results", {
	        chosen: this
	      });
	    };
	
	    Chosen.prototype.no_results_clear = function() {
	      return this.search_results.find(".no-results").remove();
	    };
	
	    Chosen.prototype.keydown_arrow = function() {
	      var next_sib;
	      if (this.results_showing && this.result_highlight) {
	        next_sib = this.result_highlight.nextAll("li.active-result").first();
	        if (next_sib) {
	          return this.result_do_highlight(next_sib);
	        }
	      } else {
	        return this.results_show();
	      }
	    };
	
	    Chosen.prototype.keyup_arrow = function() {
	      var prev_sibs;
	      if (!this.results_showing && !this.is_multiple) {
	        return this.results_show();
	      } else if (this.result_highlight) {
	        prev_sibs = this.result_highlight.prevAll("li.active-result");
	        if (prev_sibs.length) {
	          return this.result_do_highlight(prev_sibs.first());
	        } else {
	          if (this.choices_count() > 0) {
	            this.results_hide();
	          }
	          return this.result_clear_highlight();
	        }
	      }
	    };
	
	    Chosen.prototype.keydown_backstroke = function() {
	      var next_available_destroy;
	      if (this.pending_backstroke) {
	        this.choice_destroy(this.pending_backstroke.find("a").first());
	        return this.clear_backstroke();
	      } else {
	        next_available_destroy = this.search_container.siblings("li.search-choice").last();
	        if (next_available_destroy.length && !next_available_destroy.hasClass("search-choice-disabled")) {
	          this.pending_backstroke = next_available_destroy;
	          if (this.single_backstroke_delete) {
	            return this.keydown_backstroke();
	          } else {
	            return this.pending_backstroke.addClass("search-choice-focus");
	          }
	        }
	      }
	    };
	
	    Chosen.prototype.clear_backstroke = function() {
	      if (this.pending_backstroke) {
	        this.pending_backstroke.removeClass("search-choice-focus");
	      }
	      return this.pending_backstroke = null;
	    };
	
	    Chosen.prototype.search_field_scale = function() {
	      var div, i, len, style, style_block, styles, width;
	      if (!this.is_multiple) {
	        return;
	      }
	      style_block = {
	        position: 'absolute',
	        left: '-1000px',
	        top: '-1000px',
	        display: 'none',
	        whiteSpace: 'pre'
	      };
	      styles = ['fontSize', 'fontStyle', 'fontWeight', 'fontFamily', 'lineHeight', 'textTransform', 'letterSpacing'];
	      for (i = 0, len = styles.length; i < len; i++) {
	        style = styles[i];
	        style_block[style] = this.search_field.css(style);
	      }
	      div = $('<div />').css(style_block);
	      div.text(this.get_search_field_value());
	      $('body').append(div);
	      width = div.width() + 25;
	      div.remove();
	      if (this.container.is(':visible')) {
	        width = Math.min(this.container.outerWidth() - 10, width);
	      }
	      return this.search_field.width(width);
	    };
	
	    Chosen.prototype.trigger_form_field_change = function(extra) {
	      this.form_field_jq.trigger("input", extra);
	      return this.form_field_jq.trigger("change", extra);
	    };
	
	    return Chosen;
	
	  })(AbstractChosen);
	
	}).call(this);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(8)))

/***/ }),

/***/ 346:
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (factory) {
	    if (true) {
	        // AMD. Register as an anonymous module.
	        !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(8)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	    } else if (typeof exports === 'object') {
	        // Node/CommonJS
	        factory(require('jquery'));
	    } else {
	        // Browser globals
	        factory(jQuery);
	    }
	}(function ($) {
	
	var ua = navigator.userAgent,
		iPhone = /iphone/i.test(ua),
		chrome = /chrome/i.test(ua),
		android = /android/i.test(ua),
		caretTimeoutId;
	
	$.mask = {
		//Predefined character definitions
		definitions: {
			'9': "[0-9]",
			'a': "[A-Za-z]",
			'*': "[A-Za-z0-9]"
		},
		autoclear: true,
		dataName: "rawMaskFn",
		placeholder: '_'
	};
	
	$.fn.extend({
		//Helper Function for Caret positioning
		caret: function(begin, end) {
			var range;
	
			if (this.length === 0 || this.is(":hidden") || this.get(0) !== document.activeElement) {
				return;
			}
	
			if (typeof begin == 'number') {
				end = (typeof end === 'number') ? end : begin;
				return this.each(function() {
					if (this.setSelectionRange) {
						this.setSelectionRange(begin, end);
					} else if (this.createTextRange) {
						range = this.createTextRange();
						range.collapse(true);
						range.moveEnd('character', end);
						range.moveStart('character', begin);
						range.select();
					}
				});
			} else {
				if (this[0].setSelectionRange) {
					begin = this[0].selectionStart;
					end = this[0].selectionEnd;
				} else if (document.selection && document.selection.createRange) {
					range = document.selection.createRange();
					begin = 0 - range.duplicate().moveStart('character', -100000);
					end = begin + range.text.length;
				}
				return { begin: begin, end: end };
			}
		},
		unmask: function() {
			return this.trigger("unmask");
		},
		mask: function(mask, settings) {
			var input,
				defs,
				tests,
				partialPosition,
				firstNonMaskPos,
	            lastRequiredNonMaskPos,
	            len,
	            oldVal;
	
			if (!mask && this.length > 0) {
				input = $(this[0]);
	            var fn = input.data($.mask.dataName)
				return fn?fn():undefined;
			}
	
			settings = $.extend({
				autoclear: $.mask.autoclear,
				placeholder: $.mask.placeholder, // Load default placeholder
				completed: null
			}, settings);
	
	
			defs = $.mask.definitions;
			tests = [];
			partialPosition = len = mask.length;
			firstNonMaskPos = null;
	
			mask = String(mask);
	
			$.each(mask.split(""), function(i, c) {
				if (c == '?') {
					len--;
					partialPosition = i;
				} else if (defs[c]) {
					tests.push(new RegExp(defs[c]));
					if (firstNonMaskPos === null) {
						firstNonMaskPos = tests.length - 1;
					}
	                if(i < partialPosition){
	                    lastRequiredNonMaskPos = tests.length - 1;
	                }
				} else {
					tests.push(null);
				}
			});
	
			return this.trigger("unmask").each(function() {
				var input = $(this),
					buffer = $.map(
	    				mask.split(""),
	    				function(c, i) {
	    					if (c != '?') {
	    						return defs[c] ? getPlaceholder(i) : c;
	    					}
	    				}),
					defaultBuffer = buffer.join(''),
					focusText = input.val();
	
	            function tryFireCompleted(){
	                if (!settings.completed) {
	                    return;
	                }
	
	                for (var i = firstNonMaskPos; i <= lastRequiredNonMaskPos; i++) {
	                    if (tests[i] && buffer[i] === getPlaceholder(i)) {
	                        return;
	                    }
	                }
	                settings.completed.call(input);
	            }
	
	            function getPlaceholder(i){
	                if(i < settings.placeholder.length)
	                    return settings.placeholder.charAt(i);
	                return settings.placeholder.charAt(0);
	            }
	
				function seekNext(pos) {
					while (++pos < len && !tests[pos]);
					return pos;
				}
	
				function seekPrev(pos) {
					while (--pos >= 0 && !tests[pos]);
					return pos;
				}
	
				function shiftL(begin,end) {
					var i,
						j;
	
					if (begin<0) {
						return;
					}
	
					for (i = begin, j = seekNext(end); i < len; i++) {
						if (tests[i]) {
							if (j < len && tests[i].test(buffer[j])) {
								buffer[i] = buffer[j];
								buffer[j] = getPlaceholder(j);
							} else {
								break;
							}
	
							j = seekNext(j);
						}
					}
					writeBuffer();
					input.caret(Math.max(firstNonMaskPos, begin));
				}
	
				function shiftR(pos) {
					var i,
						c,
						j,
						t;
	
					for (i = pos, c = getPlaceholder(pos); i < len; i++) {
						if (tests[i]) {
							j = seekNext(i);
							t = buffer[i];
							buffer[i] = c;
							if (j < len && tests[j].test(t)) {
								c = t;
							} else {
								break;
							}
						}
					}
				}
	
				function androidInputEvent(e) {
					var curVal = input.val();
					var pos = input.caret();
					if (oldVal && oldVal.length && oldVal.length > curVal.length ) {
						// a deletion or backspace happened
						checkVal(true);
						while (pos.begin > 0 && !tests[pos.begin-1])
							pos.begin--;
						if (pos.begin === 0)
						{
							while (pos.begin < firstNonMaskPos && !tests[pos.begin])
								pos.begin++;
						}
						input.caret(pos.begin,pos.begin);
					} else {
						var pos2 = checkVal(true);
						var lastEnteredValue = curVal.charAt(pos.begin);
						if (pos.begin < len){
							if(!tests[pos.begin]){
								pos.begin++;
								if(tests[pos.begin].test(lastEnteredValue)){
									pos.begin++;
								}
							}else{
								if(tests[pos.begin].test(lastEnteredValue)){
									pos.begin++;
								}
							}
						}
						input.caret(pos.begin,pos.begin);
					}
					tryFireCompleted();
				}
	
	
				function blurEvent(e) {
	                checkVal();
	
	                if (input.val() != focusText)
	                    input.change();
	            }
	
				function keydownEvent(e) {
	                if (input.prop("readonly")){
	                    return;
	                }
	
					var k = e.which || e.keyCode,
						pos,
						begin,
						end;
	                    oldVal = input.val();
					//backspace, delete, and escape get special treatment
					if (k === 8 || k === 46 || (iPhone && k === 127)) {
						pos = input.caret();
						begin = pos.begin;
						end = pos.end;
	
						if (end - begin === 0) {
							begin=k!==46?seekPrev(begin):(end=seekNext(begin-1));
							end=k===46?seekNext(end):end;
						}
						clearBuffer(begin, end);
						shiftL(begin, end - 1);
	
						e.preventDefault();
					} else if( k === 13 ) { // enter
						blurEvent.call(this, e);
					} else if (k === 27) { // escape
						input.val(focusText);
						input.caret(0, checkVal());
						e.preventDefault();
					}
				}
	
				function keypressEvent(e) {
	                if (input.prop("readonly")){
	                    return;
	                }
	
					var k = e.which || e.keyCode,
						pos = input.caret(),
						p,
						c,
						next;
	
					if (e.ctrlKey || e.altKey || e.metaKey || k < 32) {//Ignore
						return;
					} else if ( k && k !== 13 ) {
						if (pos.end - pos.begin !== 0){
							clearBuffer(pos.begin, pos.end);
							shiftL(pos.begin, pos.end-1);
						}
	
						p = seekNext(pos.begin - 1);
						if (p < len) {
							c = String.fromCharCode(k);
							if (tests[p].test(c)) {
								shiftR(p);
	
								buffer[p] = c;
								writeBuffer();
								next = seekNext(p);
	
								if(android){
									//Path for CSP Violation on FireFox OS 1.1
									var proxy = function() {
										$.proxy($.fn.caret,input,next)();
									};
	
									setTimeout(proxy,0);
								}else{
									input.caret(next);
								}
	                            if(pos.begin <= lastRequiredNonMaskPos){
			                         tryFireCompleted();
	                             }
							}
						}
						e.preventDefault();
					}
				}
	
				function clearBuffer(start, end) {
					var i;
					for (i = start; i < end && i < len; i++) {
						if (tests[i]) {
							buffer[i] = getPlaceholder(i);
						}
					}
				}
	
				function writeBuffer() { input.val(buffer.join('')); }
	
				function checkVal(allow) {
					//try to place characters where they belong
					var test = input.val(),
						lastMatch = -1,
						i,
						c,
						pos;
	
					for (i = 0, pos = 0; i < len; i++) {
						if (tests[i]) {
							buffer[i] = getPlaceholder(i);
							while (pos++ < test.length) {
								c = test.charAt(pos - 1);
								if (tests[i].test(c)) {
									buffer[i] = c;
									lastMatch = i;
									break;
								}
							}
							if (pos > test.length) {
								clearBuffer(i + 1, len);
								break;
							}
						} else {
	                        if (buffer[i] === test.charAt(pos)) {
	                            pos++;
	                        }
	                        if( i < partialPosition){
	                            lastMatch = i;
	                        }
						}
					}
					if (allow) {
						writeBuffer();
					} else if (lastMatch + 1 < partialPosition) {
						if (settings.autoclear || buffer.join('') === defaultBuffer) {
							// Invalid value. Remove it and replace it with the
							// mask, which is the default behavior.
							if(input.val()) input.val("");
							clearBuffer(0, len);
						} else {
							// Invalid value, but we opt to show the value to the
							// user and allow them to correct their mistake.
							writeBuffer();
						}
					} else {
						writeBuffer();
						input.val(input.val().substring(0, lastMatch + 1));
					}
					return (partialPosition ? i : firstNonMaskPos);
				}
	
				input.data($.mask.dataName,function(){
					return $.map(buffer, function(c, i) {
						return tests[i]&&c!=getPlaceholder(i) ? c : null;
					}).join('');
				});
	
	
				input
					.one("unmask", function() {
						input
							.off(".mask")
							.removeData($.mask.dataName);
					})
					.on("focus.mask", function() {
	                    if (input.prop("readonly")){
	                        return;
	                    }
	
						clearTimeout(caretTimeoutId);
						var pos;
	
						focusText = input.val();
	
						pos = checkVal();
	
						caretTimeoutId = setTimeout(function(){
	                        if(input.get(0) !== document.activeElement){
	                            return;
	                        }
							writeBuffer();
							if (pos == mask.replace("?","").length) {
								input.caret(0, pos);
							} else {
								input.caret(pos);
							}
						}, 10);
					})
					.on("blur.mask", blurEvent)
					.on("keydown.mask", keydownEvent)
					.on("keypress.mask", keypressEvent)
					.on("input.mask paste.mask", function() {
	                    if (input.prop("readonly")){
	                        return;
	                    }
	
						setTimeout(function() {
							var pos=checkVal(true);
							input.caret(pos);
	                        tryFireCompleted();
						}, 0);
					});
	                if (chrome && android)
	                {
	                    input
	                        .off('input.mask')
	                        .on('input.mask', androidInputEvent);
	                }
					checkVal(); //Perform initial check for existing values
			});
		}
	});
	}));


/***/ }),

/***/ 348:
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
	 * jScrollPane - v2.1.3 - 2018-04-04
	 * http://jscrollpane.kelvinluck.com/
	 *
	 * Copyright (c) 2014 Kelvin Luck
	 * Copyright (c) 2017-2018 Tuukka Pasanen
	 * Dual licensed under the MIT or GPL licenses.
	 */
	
	// Script: jScrollPane - cross browser customisable scrollbars
	//
	// *Version: 2.1.3, Last updated: 2018-04-04*
	//
	// Project Home - http://jscrollpane.kelvinluck.com/
	// GitHub       - http://github.com/vitch/jScrollPane
	// Source       - http://github.com/vitch/jScrollPane/raw/master/script/jquery.jscrollpane.js
	// (Minified)   - http://github.com/vitch/jScrollPane/raw/master/script/jquery.jscrollpane.min.js
	//
	// About: License
	//
	// Copyright (c) 2017 Kelvin Luck
	// Copyright (c) 2017-2018 Tuukka Pasanen
	// Dual licensed under the MIT or GPL Version 2 licenses.
	// http://jscrollpane.kelvinluck.com/MIT-LICENSE.txt
	// http://jscrollpane.kelvinluck.com/GPL-LICENSE.txt
	//
	// About: Examples
	//
	// All examples and demos are available through the jScrollPane example site at:
	// http://jscrollpane.kelvinluck.com/
	//
	// About: Support and Testing
	//
	// This plugin is tested on the browsers below and has been found to work reliably on them. If you run
	// into a problem on one of the supported browsers then please visit the support section on the jScrollPane
	// website (http://jscrollpane.kelvinluck.com/) for more information on getting support. You are also
	// welcome to fork the project on GitHub if you can contribute a fix for a given issue.
	//
	// jQuery Versions - jQuery 3.x. Although script should work from jQuery 1.1 and up but no promises are made.
	// Browsers Tested - See jQuery browser support page: https://jquery.com/browser-support/. Only modern
	//                   browsers are supported.
	//
	// About: Release History
	//
	// 2.1.3       - (2018-04-04) No changes from Release Candidate 2 so making release
	// 2.1.3-rc.2  - (2018-03-13) Now using 'script/jquery.jscrollpane.min.js' main
	//                            in package.json rather than 'Gruntfile.js'
	// 2.1.3-rc.1  - (2018-03-05) Moving Gruntfile.js to root and example HTML
	//                            to subdirectory examples
	// 2.1.2       - (2018-02-16) Just on console.log remove and Release!
	//                            This version should play nicely with NPM
	// 2.1.2-rc.2  - (2018-02-03) Update package.json main-tag
	// 2.1.2-rc.1  - (2018-01-18) Release on NPM.
	// 2.1.1       - (2018-01-12) As everyone stays silent then we just release! No changes from RC.1
	// 2.1.1-rc.1  - (2017-12-23) Started to slowly merge stuff (HO HO HO Merry Christmas!)
	//             * Merged
	//             - #349 - ScrollPane reinitialization should adapt to changed container size
	//             - #335 Set drag bar width/height with .css instead of .width/.height
	//             - #297 added two settings: always show HScroll and VScroll
	//             * Bugs
	//             - #8 Make it possible to tell a scrollbar to be "always on"
	// 2.1.0  - (2017-12-16) Update jQuery to version 3.x
	// 2.0.23 - (2016-01-28) Various
	// 2.0.22 - (2015-04-25) Resolve a memory leak due to an event handler that isn't cleaned up in destroy (thanks @timjnh)
	// 2.0.21 - (2015-02-24) Simplify UMD pattern: fixes browserify when loading jQuery outside of bundle
	// 2.0.20 - (2014-10-23) Adds AMD support (thanks @carlosrberto) and support for overflow-x/overflow-y (thanks @darimpulso)
	// 2.0.19 - (2013-11-16) Changes for more reliable scroll amount with latest mousewheel plugin (thanks @brandonaaron)
	// 2.0.18 - (2013-10-23) Fix for issue with gutters and scrollToElement (thanks @Dubiy)
	// 2.0.17 - (2013-08-17) Working correctly when box-sizing is set to border-box (thanks @pieht)
	// 2.0.16 - (2013-07-30) Resetting left position when scroll is removed. Fixes #189
	// 2.0.15 - (2013-07-29) Fixed issue with scrollToElement where the destX and destY are undefined.
	// 2.0.14 - (2013-05-01) Updated to most recent mouse wheel plugin (see #106) and related changes for sensible scroll speed
	// 2.0.13 - (2013-05-01) Switched to semver compatible version name
	
	(function (factory) {
	  if ( true ) {
	      // AMD. Register as an anonymous module.
	      !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(8)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  } else if (typeof exports === 'object') {
	      // Node/CommonJS style for Browserify
	      module.exports = factory(require('jquery'));
	  } else {
	      // Browser globals
	      factory(jQuery);
	  }
	}(function($){
	
		$.fn.jScrollPane = function(settings)
		{
			// JScrollPane "class" - public methods are available through $('selector').data('jsp')
			function JScrollPane(elem, s)
			{
				var settings, jsp = this, pane, paneWidth, paneHeight, container, contentWidth, contentHeight,
					percentInViewH, percentInViewV, isScrollableV, isScrollableH, verticalDrag, dragMaxY,
					verticalDragPosition, horizontalDrag, dragMaxX, horizontalDragPosition,
					verticalBar, verticalTrack, scrollbarWidth, verticalTrackHeight, verticalDragHeight, arrowUp, arrowDown,
					horizontalBar, horizontalTrack, horizontalTrackWidth, horizontalDragWidth, arrowLeft, arrowRight,
					reinitialiseInterval, originalPadding, originalPaddingTotalWidth, previousContentWidth,
					wasAtTop = true, wasAtLeft = true, wasAtBottom = false, wasAtRight = false,
					originalElement = elem.clone(false, false).empty(),
					mwEvent = $.fn.mwheelIntent ? 'mwheelIntent.jsp' : 'mousewheel.jsp';
	
				if (elem.css('box-sizing') === 'border-box') {
					originalPadding = 0;
					originalPaddingTotalWidth = 0;
				} else {
					originalPadding = elem.css('paddingTop') + ' ' +
										elem.css('paddingRight') + ' ' +
										elem.css('paddingBottom') + ' ' +
										elem.css('paddingLeft');
					originalPaddingTotalWidth = (parseInt(elem.css('paddingLeft'), 10) || 0) +
												(parseInt(elem.css('paddingRight'), 10) || 0);
				}
	
				function initialise(s)
				{
	
					var /*firstChild, lastChild, */isMaintainingPositon, lastContentX, lastContentY,
							hasContainingSpaceChanged, originalScrollTop, originalScrollLeft,
							newPaneWidth, newPaneHeight, maintainAtBottom = false, maintainAtRight = false;
	
					settings = s;
	
					if (pane === undefined) {
						originalScrollTop = elem.scrollTop();
						originalScrollLeft = elem.scrollLeft();
	
						elem.css(
							{
								overflow: 'hidden',
								padding: 0
							}
						);
						// TODO: Deal with where width/ height is 0 as it probably means the element is hidden and we should
						// come back to it later and check once it is unhidden...
						paneWidth = elem.innerWidth() + originalPaddingTotalWidth;
						paneHeight = elem.innerHeight();
	
						elem.width(paneWidth);
	
						pane = $('<div class="jspPane" />').css('padding', originalPadding).append(elem.children());
						container = $('<div class="jspContainer" />')
							.css({
								'width': paneWidth + 'px',
								'height': paneHeight + 'px'
							}
						).append(pane).appendTo(elem);
	
						/*
						// Move any margins from the first and last children up to the container so they can still
						// collapse with neighbouring elements as they would before jScrollPane
						firstChild = pane.find(':first-child');
						lastChild = pane.find(':last-child');
						elem.css(
							{
								'margin-top': firstChild.css('margin-top'),
								'margin-bottom': lastChild.css('margin-bottom')
							}
						);
						firstChild.css('margin-top', 0);
						lastChild.css('margin-bottom', 0);
						*/
					} else {
						elem.css('width', '');
	
						// To measure the required dimensions accurately, temporarily override the CSS positioning
						// of the container and pane.
						container.css({width: 'auto', height: 'auto'});
						pane.css('position', 'static');
	
						newPaneWidth = elem.innerWidth() + originalPaddingTotalWidth;
						newPaneHeight = elem.innerHeight();
						pane.css('position', 'absolute');
	
						maintainAtBottom = settings.stickToBottom && isCloseToBottom();
						maintainAtRight  = settings.stickToRight  && isCloseToRight();
	
						hasContainingSpaceChanged = newPaneWidth !== paneWidth || newPaneHeight !== paneHeight;
	
						paneWidth = newPaneWidth;
						paneHeight = newPaneHeight;
						container.css({width: paneWidth, height: paneHeight});
	
						// If nothing changed since last check...
						if (!hasContainingSpaceChanged && previousContentWidth == contentWidth && pane.outerHeight() == contentHeight) {
							elem.width(paneWidth);
							return;
						}
						previousContentWidth = contentWidth;
	
						pane.css('width', '');
						elem.width(paneWidth);
	
						container.find('>.jspVerticalBar,>.jspHorizontalBar').remove().end();
					}
	
					pane.css('overflow', 'auto');
					if (s.contentWidth) {
						contentWidth = s.contentWidth;
					} else {
						contentWidth = pane[0].scrollWidth;
					}
					contentHeight = pane[0].scrollHeight;
					pane.css('overflow', '');
	
					percentInViewH = contentWidth / paneWidth;
					percentInViewV = contentHeight / paneHeight;
					isScrollableV = percentInViewV > 1 || settings.alwaysShowVScroll;
					isScrollableH = percentInViewH > 1 || settings.alwaysShowHScroll;
	
					if (!(isScrollableH || isScrollableV)) {
						elem.removeClass('jspScrollable');
						pane.css({
	            top: 0,
	            left: 0,
							width: container.width() - originalPaddingTotalWidth
						});
						removeMousewheel();
						removeFocusHandler();
						removeKeyboardNav();
						removeClickOnTrack();
					} else {
						elem.addClass('jspScrollable');
	
						isMaintainingPositon = settings.maintainPosition && (verticalDragPosition || horizontalDragPosition);
						if (isMaintainingPositon) {
							lastContentX = contentPositionX();
							lastContentY = contentPositionY();
						}
	
						initialiseVerticalScroll();
						initialiseHorizontalScroll();
						resizeScrollbars();
	
						if (isMaintainingPositon) {
							scrollToX(maintainAtRight  ? (contentWidth  - paneWidth ) : lastContentX, false);
							scrollToY(maintainAtBottom ? (contentHeight - paneHeight) : lastContentY, false);
						}
	
						initFocusHandler();
						initMousewheel();
						initTouch();
	
						if (settings.enableKeyboardNavigation) {
							initKeyboardNav();
						}
						if (settings.clickOnTrack) {
							initClickOnTrack();
						}
	
						observeHash();
						if (settings.hijackInternalLinks) {
							hijackInternalLinks();
						}
					}
	
					if (settings.autoReinitialise && !reinitialiseInterval) {
						reinitialiseInterval = setInterval(
							function()
							{
								initialise(settings);
							},
							settings.autoReinitialiseDelay
						);
					} else if (!settings.autoReinitialise && reinitialiseInterval) {
						clearInterval(reinitialiseInterval);
					}
	
	        if(originalScrollTop && elem.scrollTop(0)) {
	          scrollToY(originalScrollTop, false);
	        }
	
					if(originalScrollLeft && elem.scrollLeft(0)) {
	          scrollToX(originalScrollLeft, false);
	        }
	
					elem.trigger('jsp-initialised', [isScrollableH || isScrollableV]);
				}
	
				function initialiseVerticalScroll()
				{
					if (isScrollableV) {
	
						container.append(
							$('<div class="jspVerticalBar" />').append(
								$('<div class="jspCap jspCapTop" />'),
								$('<div class="jspTrack" />').append(
									$('<div class="jspDrag" />').append(
										$('<div class="jspDragTop" />'),
										$('<div class="jspDragBottom" />')
									)
								),
								$('<div class="jspCap jspCapBottom" />')
							)
						);
	
						verticalBar = container.find('>.jspVerticalBar');
						verticalTrack = verticalBar.find('>.jspTrack');
						verticalDrag = verticalTrack.find('>.jspDrag');
	
						if (settings.showArrows) {
							arrowUp = $('<a class="jspArrow jspArrowUp" />').on(
								'mousedown.jsp', getArrowScroll(0, -1)
							).on('click.jsp', nil);
							arrowDown = $('<a class="jspArrow jspArrowDown" />').on(
								'mousedown.jsp', getArrowScroll(0, 1)
							).on('click.jsp', nil);
							if (settings.arrowScrollOnHover) {
								arrowUp.on('mouseover.jsp', getArrowScroll(0, -1, arrowUp));
								arrowDown.on('mouseover.jsp', getArrowScroll(0, 1, arrowDown));
							}
	
							appendArrows(verticalTrack, settings.verticalArrowPositions, arrowUp, arrowDown);
						}
	
						verticalTrackHeight = paneHeight;
						container.find('>.jspVerticalBar>.jspCap:visible,>.jspVerticalBar>.jspArrow').each(
							function()
							{
								verticalTrackHeight -= $(this).outerHeight();
							}
						);
	
	
						verticalDrag.on(
	                                                "mouseenter",
							function()
							{
								verticalDrag.addClass('jspHover');
							}
	                                        ).on(
	                                                "mouseleave",
							function()
							{
								verticalDrag.removeClass('jspHover');
							}
						).on(
							'mousedown.jsp',
							function(e)
							{
								// Stop IE from allowing text selection
								$('html').on('dragstart.jsp selectstart.jsp', nil);
	
								verticalDrag.addClass('jspActive');
	
								var startY = e.pageY - verticalDrag.position().top;
	
								$('html').on(
									'mousemove.jsp',
									function(e)
									{
										positionDragY(e.pageY - startY, false);
									}
								).on('mouseup.jsp mouseleave.jsp', cancelDrag);
								return false;
							}
						);
						sizeVerticalScrollbar();
					}
				}
	
				function sizeVerticalScrollbar()
				{
					verticalTrack.height(verticalTrackHeight + 'px');
					verticalDragPosition = 0;
					scrollbarWidth = settings.verticalGutter + verticalTrack.outerWidth();
	
					// Make the pane thinner to allow for the vertical scrollbar
					pane.width(paneWidth - scrollbarWidth - originalPaddingTotalWidth);
	
					// Add margin to the left of the pane if scrollbars are on that side (to position
					// the scrollbar on the left or right set it's left or right property in CSS)
					try {
						if (verticalBar.position().left === 0) {
							pane.css('margin-left', scrollbarWidth + 'px');
						}
					} catch (err) {
					}
				}
	
				function initialiseHorizontalScroll()
				{
					if (isScrollableH) {
	
						container.append(
							$('<div class="jspHorizontalBar" />').append(
								$('<div class="jspCap jspCapLeft" />'),
								$('<div class="jspTrack" />').append(
									$('<div class="jspDrag" />').append(
										$('<div class="jspDragLeft" />'),
										$('<div class="jspDragRight" />')
									)
								),
								$('<div class="jspCap jspCapRight" />')
							)
						);
	
						horizontalBar = container.find('>.jspHorizontalBar');
						horizontalTrack = horizontalBar.find('>.jspTrack');
						horizontalDrag = horizontalTrack.find('>.jspDrag');
	
						if (settings.showArrows) {
							arrowLeft = $('<a class="jspArrow jspArrowLeft" />').on(
								'mousedown.jsp', getArrowScroll(-1, 0)
							).on('click.jsp', nil);
							arrowRight = $('<a class="jspArrow jspArrowRight" />').on(
								'mousedown.jsp', getArrowScroll(1, 0)
							).on('click.jsp', nil);
							if (settings.arrowScrollOnHover) {
								arrowLeft.on('mouseover.jsp', getArrowScroll(-1, 0, arrowLeft));
								arrowRight.on('mouseover.jsp', getArrowScroll(1, 0, arrowRight));
							}
							appendArrows(horizontalTrack, settings.horizontalArrowPositions, arrowLeft, arrowRight);
						}
	
						horizontalDrag.on(
	                                                "mouseenter",
							function()
							{
								horizontalDrag.addClass('jspHover');
							}
	                                        ).on(
	                                                "mouseleave",
							function()
							{
								horizontalDrag.removeClass('jspHover');
							}
						).on(
							'mousedown.jsp',
							function(e)
							{
								// Stop IE from allowing text selection
								$('html').on('dragstart.jsp selectstart.jsp', nil);
	
								horizontalDrag.addClass('jspActive');
	
								var startX = e.pageX - horizontalDrag.position().left;
	
								$('html').on(
									'mousemove.jsp',
									function(e)
									{
										positionDragX(e.pageX - startX, false);
									}
								).on('mouseup.jsp mouseleave.jsp', cancelDrag);
								return false;
							}
						);
						horizontalTrackWidth = container.innerWidth();
						sizeHorizontalScrollbar();
					}
				}
	
				function sizeHorizontalScrollbar()
				{
					container.find('>.jspHorizontalBar>.jspCap:visible,>.jspHorizontalBar>.jspArrow').each(
						function()
						{
							horizontalTrackWidth -= $(this).outerWidth();
						}
					);
	
					horizontalTrack.width(horizontalTrackWidth + 'px');
					horizontalDragPosition = 0;
				}
	
				function resizeScrollbars()
				{
					if (isScrollableH && isScrollableV) {
						var horizontalTrackHeight = horizontalTrack.outerHeight(),
							verticalTrackWidth = verticalTrack.outerWidth();
						verticalTrackHeight -= horizontalTrackHeight;
						$(horizontalBar).find('>.jspCap:visible,>.jspArrow').each(
							function()
							{
								horizontalTrackWidth += $(this).outerWidth();
							}
						);
						horizontalTrackWidth -= verticalTrackWidth;
						paneHeight -= verticalTrackWidth;
						paneWidth -= horizontalTrackHeight;
						horizontalTrack.parent().append(
							$('<div class="jspCorner" />').css('width', horizontalTrackHeight + 'px')
						);
						sizeVerticalScrollbar();
						sizeHorizontalScrollbar();
					}
					// reflow content
					if (isScrollableH) {
						pane.width((container.outerWidth() - originalPaddingTotalWidth) + 'px');
					}
					contentHeight = pane.outerHeight();
					percentInViewV = contentHeight / paneHeight;
	
					if (isScrollableH) {
						horizontalDragWidth = Math.ceil(1 / percentInViewH * horizontalTrackWidth);
						if (horizontalDragWidth > settings.horizontalDragMaxWidth) {
							horizontalDragWidth = settings.horizontalDragMaxWidth;
						} else if (horizontalDragWidth < settings.horizontalDragMinWidth) {
							horizontalDragWidth = settings.horizontalDragMinWidth;
						}
						horizontalDrag.css('width', horizontalDragWidth + 'px');
						dragMaxX = horizontalTrackWidth - horizontalDragWidth;
						_positionDragX(horizontalDragPosition); // To update the state for the arrow buttons
					}
					if (isScrollableV) {
						verticalDragHeight = Math.ceil(1 / percentInViewV * verticalTrackHeight);
						if (verticalDragHeight > settings.verticalDragMaxHeight) {
							verticalDragHeight = settings.verticalDragMaxHeight;
						} else if (verticalDragHeight < settings.verticalDragMinHeight) {
							verticalDragHeight = settings.verticalDragMinHeight;
						}
						verticalDrag.css('height', verticalDragHeight + 'px');
						dragMaxY = verticalTrackHeight - verticalDragHeight;
						_positionDragY(verticalDragPosition); // To update the state for the arrow buttons
					}
				}
	
				function appendArrows(ele, p, a1, a2)
				{
					var p1 = "before", p2 = "after", aTemp;
	
					// Sniff for mac... Is there a better way to determine whether the arrows would naturally appear
					// at the top or the bottom of the bar?
					if (p == "os") {
						p = /Mac/.test(navigator.platform) ? "after" : "split";
					}
					if (p == p1) {
						p2 = p;
					} else if (p == p2) {
						p1 = p;
						aTemp = a1;
						a1 = a2;
						a2 = aTemp;
					}
	
					ele[p1](a1)[p2](a2);
				}
	
				function getArrowScroll(dirX, dirY, ele)
				{
					return function()
					{
						arrowScroll(dirX, dirY, this, ele);
						this.blur();
						return false;
					};
				}
	
				function arrowScroll(dirX, dirY, arrow, ele)
				{
					arrow = $(arrow).addClass('jspActive');
	
					var eve,
						scrollTimeout,
						isFirst = true,
						doScroll = function()
						{
							if (dirX !== 0) {
								jsp.scrollByX(dirX * settings.arrowButtonSpeed);
							}
							if (dirY !== 0) {
								jsp.scrollByY(dirY * settings.arrowButtonSpeed);
							}
							scrollTimeout = setTimeout(doScroll, isFirst ? settings.initialDelay : settings.arrowRepeatFreq);
							isFirst = false;
						};
	
					doScroll();
	
					eve = ele ? 'mouseout.jsp' : 'mouseup.jsp';
					ele = ele || $('html');
					ele.on(
						eve,
						function()
						{
							arrow.removeClass('jspActive');
							if(scrollTimeout) {
	              clearTimeout(scrollTimeout);
	            }
							scrollTimeout = null;
							ele.off(eve);
						}
					);
				}
	
				function initClickOnTrack()
				{
					removeClickOnTrack();
					if (isScrollableV) {
						verticalTrack.on(
							'mousedown.jsp',
							function(e)
							{
								if (e.originalTarget === undefined || e.originalTarget == e.currentTarget) {
									var clickedTrack = $(this),
										offset = clickedTrack.offset(),
										direction = e.pageY - offset.top - verticalDragPosition,
										scrollTimeout,
										isFirst = true,
										doScroll = function()
										{
											var offset = clickedTrack.offset(),
												pos = e.pageY - offset.top - verticalDragHeight / 2,
												contentDragY = paneHeight * settings.scrollPagePercent,
												dragY = dragMaxY * contentDragY / (contentHeight - paneHeight);
											if (direction < 0) {
												if (verticalDragPosition - dragY > pos) {
													jsp.scrollByY(-contentDragY);
												} else {
													positionDragY(pos);
												}
											} else if (direction > 0) {
												if (verticalDragPosition + dragY < pos) {
													jsp.scrollByY(contentDragY);
												} else {
													positionDragY(pos);
												}
											} else {
												cancelClick();
												return;
											}
											scrollTimeout = setTimeout(doScroll, isFirst ? settings.initialDelay : settings.trackClickRepeatFreq);
											isFirst = false;
										},
										cancelClick = function()
										{
											if(scrollTimeout) {
	                      clearTimeout(scrollTimeout);
	                    }
											scrollTimeout = null;
											$(document).off('mouseup.jsp', cancelClick);
										};
									doScroll();
									$(document).on('mouseup.jsp', cancelClick);
									return false;
								}
							}
						);
					}
	
					if (isScrollableH) {
						horizontalTrack.on(
							'mousedown.jsp',
							function(e)
							{
								if (e.originalTarget === undefined || e.originalTarget == e.currentTarget) {
									var clickedTrack = $(this),
										offset = clickedTrack.offset(),
										direction = e.pageX - offset.left - horizontalDragPosition,
										scrollTimeout,
										isFirst = true,
										doScroll = function()
										{
											var offset = clickedTrack.offset(),
												pos = e.pageX - offset.left - horizontalDragWidth / 2,
												contentDragX = paneWidth * settings.scrollPagePercent,
												dragX = dragMaxX * contentDragX / (contentWidth - paneWidth);
											if (direction < 0) {
												if (horizontalDragPosition - dragX > pos) {
													jsp.scrollByX(-contentDragX);
												} else {
													positionDragX(pos);
												}
											} else if (direction > 0) {
												if (horizontalDragPosition + dragX < pos) {
													jsp.scrollByX(contentDragX);
												} else {
													positionDragX(pos);
												}
											} else {
												cancelClick();
												return;
											}
											scrollTimeout = setTimeout(doScroll, isFirst ? settings.initialDelay : settings.trackClickRepeatFreq);
											isFirst = false;
										},
										cancelClick = function()
										{
											if(scrollTimeout) {
	                      clearTimeout(scrollTimeout);
	                    }
											scrollTimeout = null;
											$(document).off('mouseup.jsp', cancelClick);
										};
									doScroll();
									$(document).on('mouseup.jsp', cancelClick);
									return false;
								}
							}
						);
					}
				}
	
				function removeClickOnTrack()
				{
					if (horizontalTrack) {
						horizontalTrack.off('mousedown.jsp');
					}
					if (verticalTrack) {
						verticalTrack.off('mousedown.jsp');
					}
				}
	
				function cancelDrag()
				{
					$('html').off('dragstart.jsp selectstart.jsp mousemove.jsp mouseup.jsp mouseleave.jsp');
	
					if (verticalDrag) {
						verticalDrag.removeClass('jspActive');
					}
					if (horizontalDrag) {
						horizontalDrag.removeClass('jspActive');
					}
				}
	
				function positionDragY(destY, animate)
				{
					if (!isScrollableV) {
						return;
					}
					if (destY < 0) {
						destY = 0;
					} else if (destY > dragMaxY) {
						destY = dragMaxY;
					}
	
					// allow for devs to prevent the JSP from being scrolled
					var willScrollYEvent = new $.Event("jsp-will-scroll-y");
					elem.trigger(willScrollYEvent, [destY]);
	
					if (willScrollYEvent.isDefaultPrevented()) {
						return;
					}
	
					var tmpVerticalDragPosition = destY || 0;
	
					var isAtTop = tmpVerticalDragPosition === 0,
						isAtBottom = tmpVerticalDragPosition == dragMaxY,
						percentScrolled = destY/ dragMaxY,
						destTop = -percentScrolled * (contentHeight - paneHeight);
	
					// can't just check if(animate) because false is a valid value that could be passed in...
					if (animate === undefined) {
						animate = settings.animateScroll;
					}
					if (animate) {
						jsp.animate(verticalDrag, 'top', destY,	_positionDragY, function() {
							elem.trigger('jsp-user-scroll-y', [-destTop, isAtTop, isAtBottom]);
						});
					} else {
						verticalDrag.css('top', destY);
						_positionDragY(destY);
						elem.trigger('jsp-user-scroll-y', [-destTop, isAtTop, isAtBottom]);
					}
	
				}
	
				function _positionDragY(destY)
				{
					if (destY === undefined) {
						destY = verticalDrag.position().top;
					}
	
					container.scrollTop(0);
					verticalDragPosition = destY || 0;
	
					var isAtTop = verticalDragPosition === 0,
						isAtBottom = verticalDragPosition == dragMaxY,
						percentScrolled = destY/ dragMaxY,
						destTop = -percentScrolled * (contentHeight - paneHeight);
	
					if (wasAtTop != isAtTop || wasAtBottom != isAtBottom) {
						wasAtTop = isAtTop;
						wasAtBottom = isAtBottom;
						elem.trigger('jsp-arrow-change', [wasAtTop, wasAtBottom, wasAtLeft, wasAtRight]);
					}
	
					updateVerticalArrows(isAtTop, isAtBottom);
					pane.css('top', destTop);
					elem.trigger('jsp-scroll-y', [-destTop, isAtTop, isAtBottom]).trigger('scroll');
				}
	
				function positionDragX(destX, animate)
				{
					if (!isScrollableH) {
						return;
					}
					if (destX < 0) {
						destX = 0;
					} else if (destX > dragMaxX) {
						destX = dragMaxX;
					}
	
	
					// allow for devs to prevent the JSP from being scrolled
					var willScrollXEvent = new $.Event("jsp-will-scroll-x");
					elem.trigger(willScrollXEvent, [destX]);
	
					if (willScrollXEvent.isDefaultPrevented()) {
						return;
					}
	
					var tmpHorizontalDragPosition = destX ||0;
	
					var isAtLeft = tmpHorizontalDragPosition === 0,
						isAtRight = tmpHorizontalDragPosition == dragMaxX,
						percentScrolled = destX / dragMaxX,
						destLeft = -percentScrolled * (contentWidth - paneWidth);
	
					if (animate === undefined) {
						animate = settings.animateScroll;
					}
					if (animate) {
						jsp.animate(horizontalDrag, 'left', destX,	_positionDragX, function() {
							elem.trigger('jsp-user-scroll-x', [-destLeft, isAtLeft, isAtRight]);
						});
					} else {
						horizontalDrag.css('left', destX);
						_positionDragX(destX);
						elem.trigger('jsp-user-scroll-x', [-destLeft, isAtLeft, isAtRight]);
					}
				}
	
				function _positionDragX(destX)
				{
					if (destX === undefined) {
						destX = horizontalDrag.position().left;
					}
	
					container.scrollTop(0);
					horizontalDragPosition = destX ||0;
	
					var isAtLeft = horizontalDragPosition === 0,
						isAtRight = horizontalDragPosition == dragMaxX,
						percentScrolled = destX / dragMaxX,
						destLeft = -percentScrolled * (contentWidth - paneWidth);
	
					if (wasAtLeft != isAtLeft || wasAtRight != isAtRight) {
						wasAtLeft = isAtLeft;
						wasAtRight = isAtRight;
						elem.trigger('jsp-arrow-change', [wasAtTop, wasAtBottom, wasAtLeft, wasAtRight]);
					}
	
					updateHorizontalArrows(isAtLeft, isAtRight);
					pane.css('left', destLeft);
					elem.trigger('jsp-scroll-x', [-destLeft, isAtLeft, isAtRight]).trigger('scroll');
				}
	
				function updateVerticalArrows(isAtTop, isAtBottom)
				{
					if (settings.showArrows) {
						arrowUp[isAtTop ? 'addClass' : 'removeClass']('jspDisabled');
						arrowDown[isAtBottom ? 'addClass' : 'removeClass']('jspDisabled');
					}
				}
	
				function updateHorizontalArrows(isAtLeft, isAtRight)
				{
					if (settings.showArrows) {
						arrowLeft[isAtLeft ? 'addClass' : 'removeClass']('jspDisabled');
						arrowRight[isAtRight ? 'addClass' : 'removeClass']('jspDisabled');
					}
				}
	
				function scrollToY(destY, animate)
				{
					var percentScrolled = destY / (contentHeight - paneHeight);
					positionDragY(percentScrolled * dragMaxY, animate);
				}
	
				function scrollToX(destX, animate)
				{
					var percentScrolled = destX / (contentWidth - paneWidth);
					positionDragX(percentScrolled * dragMaxX, animate);
				}
	
				function scrollToElement(ele, stickToTop, animate)
				{
					var e, eleHeight, eleWidth, eleTop = 0, eleLeft = 0, viewportTop, viewportLeft, maxVisibleEleTop, maxVisibleEleLeft, destY, destX;
	
					// Legal hash values aren't necessarily legal jQuery selectors so we need to catch any
					// errors from the lookup...
					try {
						e = $(ele);
					} catch (err) {
						return;
					}
					eleHeight = e.outerHeight();
					eleWidth= e.outerWidth();
	
					container.scrollTop(0);
					container.scrollLeft(0);
	
					// loop through parents adding the offset top of any elements that are relatively positioned between
					// the focused element and the jspPane so we can get the true distance from the top
					// of the focused element to the top of the scrollpane...
					while (!e.is('.jspPane')) {
						eleTop += e.position().top;
						eleLeft += e.position().left;
						e = e.offsetParent();
						if (/^body|html$/i.test(e[0].nodeName)) {
							// we ended up too high in the document structure. Quit!
							return;
						}
					}
	
					viewportTop = contentPositionY();
					maxVisibleEleTop = viewportTop + paneHeight;
					if (eleTop < viewportTop || stickToTop) { // element is above viewport
						destY = eleTop - settings.horizontalGutter;
					} else if (eleTop + eleHeight > maxVisibleEleTop) { // element is below viewport
						destY = eleTop - paneHeight + eleHeight + settings.horizontalGutter;
					}
					if (!isNaN(destY)) {
						scrollToY(destY, animate);
					}
	
					viewportLeft = contentPositionX();
		            maxVisibleEleLeft = viewportLeft + paneWidth;
		            if (eleLeft < viewportLeft || stickToTop) { // element is to the left of viewport
		                destX = eleLeft - settings.horizontalGutter;
		            } else if (eleLeft + eleWidth > maxVisibleEleLeft) { // element is to the right viewport
		                destX = eleLeft - paneWidth + eleWidth + settings.horizontalGutter;
		            }
		            if (!isNaN(destX)) {
		                scrollToX(destX, animate);
		            }
	
				}
	
				function contentPositionX()
				{
					return -pane.position().left;
				}
	
				function contentPositionY()
				{
					return -pane.position().top;
				}
	
				function isCloseToBottom()
				{
					var scrollableHeight = contentHeight - paneHeight;
					return (scrollableHeight > 20) && (scrollableHeight - contentPositionY() < 10);
				}
	
				function isCloseToRight()
				{
					var scrollableWidth = contentWidth - paneWidth;
					return (scrollableWidth > 20) && (scrollableWidth - contentPositionX() < 10);
				}
	
				function initMousewheel()
				{
					container.off(mwEvent).on(
						mwEvent,
						function (event, delta, deltaX, deltaY) {
	
	                        if (!horizontalDragPosition) horizontalDragPosition = 0;
	                        if (!verticalDragPosition) verticalDragPosition = 0;
	
							var dX = horizontalDragPosition, dY = verticalDragPosition, factor = event.deltaFactor || settings.mouseWheelSpeed;
							jsp.scrollBy(deltaX * factor, -deltaY * factor, false);
							// return true if there was no movement so rest of screen can scroll
							return dX == horizontalDragPosition && dY == verticalDragPosition;
						}
					);
				}
	
				function removeMousewheel()
				{
					container.off(mwEvent);
				}
	
				function nil()
				{
					return false;
				}
	
				function initFocusHandler()
				{
					pane.find(':input,a').off('focus.jsp').on(
						'focus.jsp',
						function(e)
						{
							scrollToElement(e.target, false);
						}
					);
				}
	
				function removeFocusHandler()
				{
					pane.find(':input,a').off('focus.jsp');
				}
	
				function initKeyboardNav()
				{
					var keyDown, elementHasScrolled, validParents = [];
					if(isScrollableH) {
	          validParents.push(horizontalBar[0]);
	        }
	
					if(isScrollableV) {
	          validParents.push(verticalBar[0]);
	        }
	
					// IE also focuses elements that don't have tabindex set.
					pane.on(
						'focus.jsp',
						function()
						{
							elem.focus();
						}
					);
	
					elem.attr('tabindex', 0)
						.off('keydown.jsp keypress.jsp')
						.on(
							'keydown.jsp',
							function(e)
							{
								if (e.target !== this && !(validParents.length && $(e.target).closest(validParents).length)){
									return;
								}
								var dX = horizontalDragPosition, dY = verticalDragPosition;
								switch(e.keyCode) {
									case 40: // down
									case 38: // up
									case 34: // page down
									case 32: // space
									case 33: // page up
									case 39: // right
									case 37: // left
										keyDown = e.keyCode;
										keyDownHandler();
										break;
									case 35: // end
										scrollToY(contentHeight - paneHeight);
										keyDown = null;
										break;
									case 36: // home
										scrollToY(0);
										keyDown = null;
										break;
								}
	
								elementHasScrolled = e.keyCode == keyDown && dX != horizontalDragPosition || dY != verticalDragPosition;
								return !elementHasScrolled;
							}
						).on(
							'keypress.jsp', // For FF/ OSX so that we can cancel the repeat key presses if the JSP scrolls...
							function(e)
							{
								if (e.keyCode == keyDown) {
									keyDownHandler();
								}
								// If the keypress is not related to the area, ignore it. Fixes problem with inputs inside scrolled area. Copied from line 955.
								if (e.target !== this && !(validParents.length && $(e.target).closest(validParents).length)){
									return;
								}
								return !elementHasScrolled;
							}
						);
	
					if (settings.hideFocus) {
						elem.css('outline', 'none');
						if ('hideFocus' in container[0]){
							elem.attr('hideFocus', true);
						}
					} else {
						elem.css('outline', '');
						if ('hideFocus' in container[0]){
							elem.attr('hideFocus', false);
						}
					}
	
					function keyDownHandler()
					{
						var dX = horizontalDragPosition, dY = verticalDragPosition;
						switch(keyDown) {
							case 40: // down
								jsp.scrollByY(settings.keyboardSpeed, false);
								break;
							case 38: // up
								jsp.scrollByY(-settings.keyboardSpeed, false);
								break;
							case 34: // page down
							case 32: // space
								jsp.scrollByY(paneHeight * settings.scrollPagePercent, false);
								break;
							case 33: // page up
								jsp.scrollByY(-paneHeight * settings.scrollPagePercent, false);
								break;
							case 39: // right
								jsp.scrollByX(settings.keyboardSpeed, false);
								break;
							case 37: // left
								jsp.scrollByX(-settings.keyboardSpeed, false);
								break;
						}
	
						elementHasScrolled = dX != horizontalDragPosition || dY != verticalDragPosition;
						return elementHasScrolled;
					}
				}
	
				function removeKeyboardNav()
				{
					elem.attr('tabindex', '-1')
						.removeAttr('tabindex')
						.off('keydown.jsp keypress.jsp');
	
					pane.off('.jsp');
				}
	
				function observeHash()
				{
					if (location.hash && location.hash.length > 1) {
						var e,
							retryInt,
							hash = escape(location.hash.substr(1)) // hash must be escaped to prevent XSS
							;
						try {
							e = $('#' + hash + ', a[name="' + hash + '"]');
						} catch (err) {
							return;
						}
	
						if (e.length && pane.find(hash)) {
							// nasty workaround but it appears to take a little while before the hash has done its thing
							// to the rendered page so we just wait until the container's scrollTop has been messed up.
							if (container.scrollTop() === 0) {
								retryInt = setInterval(
									function()
									{
										if (container.scrollTop() > 0) {
											scrollToElement(e, true);
											$(document).scrollTop(container.position().top);
											clearInterval(retryInt);
										}
									},
									50
								);
							} else {
								scrollToElement(e, true);
								$(document).scrollTop(container.position().top);
							}
						}
					}
				}
	
				function hijackInternalLinks()
				{
					// only register the link handler once
					if ($(document.body).data('jspHijack')) {
						return;
					}
	
					// remember that the handler was bound
					$(document.body).data('jspHijack', true);
	
					// use live handler to also capture newly created links
					$(document.body).delegate('a[href*="#"]', 'click', function(event) {
						// does the link point to the same page?
						// this also takes care of cases with a <base>-Tag or Links not starting with the hash #
						// e.g. <a href="index.html#test"> when the current url already is index.html
						var href = this.href.substr(0, this.href.indexOf('#')),
							locationHref = location.href,
							hash,
							element,
							container,
							jsp,
							scrollTop,
							elementTop;
						if (location.href.indexOf('#') !== -1) {
							locationHref = location.href.substr(0, location.href.indexOf('#'));
						}
						if (href !== locationHref) {
							// the link points to another page
							return;
						}
	
						// check if jScrollPane should handle this click event
						hash = escape(this.href.substr(this.href.indexOf('#') + 1));
	
						// find the element on the page
						try {
							element = $('#' + hash + ', a[name="' + hash + '"]');
						} catch (e) {
							// hash is not a valid jQuery identifier
							return;
						}
	
						if (!element.length) {
							// this link does not point to an element on this page
							return;
						}
	
						container = element.closest('.jspScrollable');
						jsp = container.data('jsp');
	
						// jsp might be another jsp instance than the one, that bound this event
						// remember: this event is only bound once for all instances.
						jsp.scrollToElement(element, true);
	
						if (container[0].scrollIntoView) {
							// also scroll to the top of the container (if it is not visible)
							scrollTop = $(window).scrollTop();
							elementTop = element.offset().top;
							if (elementTop < scrollTop || elementTop > scrollTop + $(window).height()) {
								container[0].scrollIntoView();
							}
						}
	
						// jsp handled this event, prevent the browser default (scrolling :P)
						event.preventDefault();
					});
				}
	
				// Init touch on iPad, iPhone, iPod, Android
				function initTouch()
				{
					var startX,
						startY,
						touchStartX,
						touchStartY,
						moved,
						moving = false;
	
					container.off('touchstart.jsp touchmove.jsp touchend.jsp click.jsp-touchclick').on(
						'touchstart.jsp',
						function(e)
						{
							var touch = e.originalEvent.touches[0];
							startX = contentPositionX();
							startY = contentPositionY();
							touchStartX = touch.pageX;
							touchStartY = touch.pageY;
							moved = false;
							moving = true;
						}
					).on(
						'touchmove.jsp',
						function(ev)
						{
							if(!moving) {
								return;
							}
	
							var touchPos = ev.originalEvent.touches[0],
								dX = horizontalDragPosition, dY = verticalDragPosition;
	
							jsp.scrollTo(startX + touchStartX - touchPos.pageX, startY + touchStartY - touchPos.pageY);
	
							moved = moved || Math.abs(touchStartX - touchPos.pageX) > 5 || Math.abs(touchStartY - touchPos.pageY) > 5;
	
							// return true if there was no movement so rest of screen can scroll
							return dX == horizontalDragPosition && dY == verticalDragPosition;
						}
					).on(
						'touchend.jsp',
						function(e)
						{
							moving = false;
							/*if(moved) {
								return false;
							}*/
						}
					).on(
						'click.jsp-touchclick',
						function(e)
						{
							if(moved) {
								moved = false;
								return false;
							}
						}
					);
				}
	
				function destroy(){
					var currentY = contentPositionY(),
						currentX = contentPositionX();
					elem.removeClass('jspScrollable').off('.jsp');
					pane.off('.jsp');
					elem.replaceWith(originalElement.append(pane.children()));
					originalElement.scrollTop(currentY);
					originalElement.scrollLeft(currentX);
	
					// clear reinitialize timer if active
					if (reinitialiseInterval) {
						clearInterval(reinitialiseInterval);
					}
				}
	
				// Public API
				$.extend(
					jsp,
					{
						// Reinitialises the scroll pane (if it's internal dimensions have changed since the last time it
						// was initialised). The settings object which is passed in will override any settings from the
						// previous time it was initialised - if you don't pass any settings then the ones from the previous
						// initialisation will be used.
						reinitialise: function(s)
						{
							s = $.extend({}, settings, s);
							initialise(s);
						},
						// Scrolls the specified element (a jQuery object, DOM node or jQuery selector string) into view so
						// that it can be seen within the viewport. If stickToTop is true then the element will appear at
						// the top of the viewport, if it is false then the viewport will scroll as little as possible to
						// show the element. You can also specify if you want animation to occur. If you don't provide this
						// argument then the animateScroll value from the settings object is used instead.
						scrollToElement: function(ele, stickToTop, animate)
						{
							scrollToElement(ele, stickToTop, animate);
						},
						// Scrolls the pane so that the specified co-ordinates within the content are at the top left
						// of the viewport. animate is optional and if not passed then the value of animateScroll from
						// the settings object this jScrollPane was initialised with is used.
						scrollTo: function(destX, destY, animate)
						{
							scrollToX(destX, animate);
							scrollToY(destY, animate);
						},
						// Scrolls the pane so that the specified co-ordinate within the content is at the left of the
						// viewport. animate is optional and if not passed then the value of animateScroll from the settings
						// object this jScrollPane was initialised with is used.
						scrollToX: function(destX, animate)
						{
							scrollToX(destX, animate);
						},
						// Scrolls the pane so that the specified co-ordinate within the content is at the top of the
						// viewport. animate is optional and if not passed then the value of animateScroll from the settings
						// object this jScrollPane was initialised with is used.
						scrollToY: function(destY, animate)
						{
							scrollToY(destY, animate);
						},
						// Scrolls the pane to the specified percentage of its maximum horizontal scroll position. animate
						// is optional and if not passed then the value of animateScroll from the settings object this
						// jScrollPane was initialised with is used.
						scrollToPercentX: function(destPercentX, animate)
						{
							scrollToX(destPercentX * (contentWidth - paneWidth), animate);
						},
						// Scrolls the pane to the specified percentage of its maximum vertical scroll position. animate
						// is optional and if not passed then the value of animateScroll from the settings object this
						// jScrollPane was initialised with is used.
						scrollToPercentY: function(destPercentY, animate)
						{
							scrollToY(destPercentY * (contentHeight - paneHeight), animate);
						},
						// Scrolls the pane by the specified amount of pixels. animate is optional and if not passed then
						// the value of animateScroll from the settings object this jScrollPane was initialised with is used.
						scrollBy: function(deltaX, deltaY, animate)
						{
							jsp.scrollByX(deltaX, animate);
							jsp.scrollByY(deltaY, animate);
						},
						// Scrolls the pane by the specified amount of pixels. animate is optional and if not passed then
						// the value of animateScroll from the settings object this jScrollPane was initialised with is used.
						scrollByX: function(deltaX, animate)
						{
							var destX = contentPositionX() + Math[deltaX<0 ? 'floor' : 'ceil'](deltaX),
								percentScrolled = destX / (contentWidth - paneWidth);
							positionDragX(percentScrolled * dragMaxX, animate);
						},
						// Scrolls the pane by the specified amount of pixels. animate is optional and if not passed then
						// the value of animateScroll from the settings object this jScrollPane was initialised with is used.
						scrollByY: function(deltaY, animate)
						{
							var destY = contentPositionY() + Math[deltaY<0 ? 'floor' : 'ceil'](deltaY),
								percentScrolled = destY / (contentHeight - paneHeight);
							positionDragY(percentScrolled * dragMaxY, animate);
						},
						// Positions the horizontal drag at the specified x position (and updates the viewport to reflect
						// this). animate is optional and if not passed then the value of animateScroll from the settings
						// object this jScrollPane was initialised with is used.
						positionDragX: function(x, animate)
						{
							positionDragX(x, animate);
						},
						// Positions the vertical drag at the specified y position (and updates the viewport to reflect
						// this). animate is optional and if not passed then the value of animateScroll from the settings
						// object this jScrollPane was initialised with is used.
						positionDragY: function(y, animate)
						{
							positionDragY(y, animate);
						},
						// This method is called when jScrollPane is trying to animate to a new position. You can override
						// it if you want to provide advanced animation functionality. It is passed the following arguments:
						//  * ele          - the element whose position is being animated
						//  * prop         - the property that is being animated
						//  * value        - the value it's being animated to
						//  * stepCallback - a function that you must execute each time you update the value of the property
						//  * completeCallback - a function that will be executed after the animation had finished
						// You can use the default implementation (below) as a starting point for your own implementation.
						animate: function(ele, prop, value, stepCallback, completeCallback)
						{
							var params = {};
							params[prop] = value;
							ele.animate(
								params,
								{
									'duration'	: settings.animateDuration,
									'easing'	: settings.animateEase,
									'queue'		: false,
									'step'		: stepCallback,
									'complete'	: completeCallback
								}
							);
						},
						// Returns the current x position of the viewport with regards to the content pane.
						getContentPositionX: function()
						{
							return contentPositionX();
						},
						// Returns the current y position of the viewport with regards to the content pane.
						getContentPositionY: function()
						{
							return contentPositionY();
						},
						// Returns the width of the content within the scroll pane.
						getContentWidth: function()
						{
							return contentWidth;
						},
						// Returns the height of the content within the scroll pane.
						getContentHeight: function()
						{
							return contentHeight;
						},
						// Returns the horizontal position of the viewport within the pane content.
						getPercentScrolledX: function()
						{
							return contentPositionX() / (contentWidth - paneWidth);
						},
						// Returns the vertical position of the viewport within the pane content.
						getPercentScrolledY: function()
						{
							return contentPositionY() / (contentHeight - paneHeight);
						},
						// Returns whether or not this scrollpane has a horizontal scrollbar.
						getIsScrollableH: function()
						{
							return isScrollableH;
						},
						// Returns whether or not this scrollpane has a vertical scrollbar.
						getIsScrollableV: function()
						{
							return isScrollableV;
						},
						// Gets a reference to the content pane. It is important that you use this method if you want to
						// edit the content of your jScrollPane as if you access the element directly then you may have some
						// problems (as your original element has had additional elements for the scrollbars etc added into
						// it).
						getContentPane: function()
						{
							return pane;
						},
						// Scrolls this jScrollPane down as far as it can currently scroll. If animate isn't passed then the
						// animateScroll value from settings is used instead.
						scrollToBottom: function(animate)
						{
							positionDragY(dragMaxY, animate);
						},
						// Hijacks the links on the page which link to content inside the scrollpane. If you have changed
						// the content of your page (e.g. via AJAX) and want to make sure any new anchor links to the
						// contents of your scroll pane will work then call this function.
						hijackInternalLinks: $.noop,
						// Removes the jScrollPane and returns the page to the state it was in before jScrollPane was
						// initialised.
						destroy: function()
						{
								destroy();
						}
					}
				);
	
				initialise(s);
			}
	
			// Pluginifying code...
			settings = $.extend({}, $.fn.jScrollPane.defaults, settings);
	
			// Apply default speed
			$.each(['arrowButtonSpeed', 'trackClickSpeed', 'keyboardSpeed'], function() {
				settings[this] = settings[this] || settings.speed;
			});
	
			return this.each(
				function()
				{
					var elem = $(this), jspApi = elem.data('jsp');
					if (jspApi) {
						jspApi.reinitialise(settings);
					} else {
						$("script",elem).filter('[type="text/javascript"],:not([type])').remove();
						jspApi = new JScrollPane(elem, settings);
						elem.data('jsp', jspApi);
					}
				}
			);
		};
	
		$.fn.jScrollPane.defaults = {
			showArrows					: false,
			maintainPosition			: true,
			stickToBottom				: false,
			stickToRight				: false,
			clickOnTrack				: true,
			autoReinitialise			: false,
			autoReinitialiseDelay		: 500,
			verticalDragMinHeight		: 0,
			verticalDragMaxHeight		: 99999,
			horizontalDragMinWidth		: 0,
			horizontalDragMaxWidth		: 99999,
			contentWidth				: undefined,
			animateScroll				: false,
			animateDuration				: 300,
			animateEase					: 'linear',
			hijackInternalLinks			: false,
			verticalGutter				: 4,
			horizontalGutter			: 4,
			mouseWheelSpeed				: 3,
			arrowButtonSpeed			: 0,
			arrowRepeatFreq				: 50,
			arrowScrollOnHover			: false,
			trackClickSpeed				: 0,
			trackClickRepeatFreq		: 70,
			verticalArrowPositions		: 'split',
			horizontalArrowPositions	: 'split',
			enableKeyboardNavigation	: true,
			hideFocus					: false,
			keyboardSpeed				: 0,
			initialDelay                : 300,        // Delay before starting repeating
			speed						: 30,		// Default speed when others falsey
			scrollPagePercent			: 0.8,		// Percent of visible area scrolled when pageUp/Down or track area pressed
			alwaysShowVScroll			: false,
			alwaysShowHScroll			: false,
		};
	
	}));


/***/ }),

/***/ 349:
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
	 * jQuery Mousewheel 3.1.12
	 *
	 * Copyright 2014 jQuery Foundation and other contributors
	 * Released under the MIT license.
	 * http://jquery.org/license
	 */
	
	(function (factory) {
	    if ( true ) {
	        // AMD. Register as an anonymous module.
	        !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(8)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	    } else if (typeof exports === 'object') {
	        // Node/CommonJS style for Browserify
	        module.exports = factory;
	    } else {
	        // Browser globals
	        factory(jQuery);
	    }
	}(function ($) {
	
	    var toFix  = ['wheel', 'mousewheel', 'DOMMouseScroll', 'MozMousePixelScroll'],
	        toBind = ( 'onwheel' in document || document.documentMode >= 9 ) ?
	                    ['wheel'] : ['mousewheel', 'DomMouseScroll', 'MozMousePixelScroll'],
	        slice  = Array.prototype.slice,
	        nullLowestDeltaTimeout, lowestDelta;
	
	    if ( $.event.fixHooks ) {
	        for ( var i = toFix.length; i; ) {
	            $.event.fixHooks[ toFix[--i] ] = $.event.mouseHooks;
	        }
	    }
	
	    var special = $.event.special.mousewheel = {
	        version: '3.1.12',
	
	        setup: function() {
	            if ( this.addEventListener ) {
	                for ( var i = toBind.length; i; ) {
	                    this.addEventListener( toBind[--i], handler, false );
	                }
	            } else {
	                this.onmousewheel = handler;
	            }
	            // Store the line height and page height for this particular element
	            $.data(this, 'mousewheel-line-height', special.getLineHeight(this));
	            $.data(this, 'mousewheel-page-height', special.getPageHeight(this));
	        },
	
	        teardown: function() {
	            if ( this.removeEventListener ) {
	                for ( var i = toBind.length; i; ) {
	                    this.removeEventListener( toBind[--i], handler, false );
	                }
	            } else {
	                this.onmousewheel = null;
	            }
	            // Clean up the data we added to the element
	            $.removeData(this, 'mousewheel-line-height');
	            $.removeData(this, 'mousewheel-page-height');
	        },
	
	        getLineHeight: function(elem) {
	            var $elem = $(elem),
	                $parent = $elem['offsetParent' in $.fn ? 'offsetParent' : 'parent']();
	            if (!$parent.length) {
	                $parent = $('body');
	            }
	            return parseInt($parent.css('fontSize'), 10) || parseInt($elem.css('fontSize'), 10) || 16;
	        },
	
	        getPageHeight: function(elem) {
	            return $(elem).height();
	        },
	
	        settings: {
	            adjustOldDeltas: true, // see shouldAdjustOldDeltas() below
	            normalizeOffset: true  // calls getBoundingClientRect for each event
	        }
	    };
	
	    $.fn.extend({
	        mousewheel: function(fn) {
	            return fn ? this.bind('mousewheel', fn) : this.trigger('mousewheel');
	        },
	
	        unmousewheel: function(fn) {
	            return this.unbind('mousewheel', fn);
	        }
	    });
	
	
	    function handler(event) {
	        var orgEvent   = event || window.event,
	            args       = slice.call(arguments, 1),
	            delta      = 0,
	            deltaX     = 0,
	            deltaY     = 0,
	            absDelta   = 0,
	            offsetX    = 0,
	            offsetY    = 0;
	        event = $.event.fix(orgEvent);
	        event.type = 'mousewheel';
	
	        // Old school scrollwheel delta
	        if ( 'detail'      in orgEvent ) { deltaY = orgEvent.detail * -1;      }
	        if ( 'wheelDelta'  in orgEvent ) { deltaY = orgEvent.wheelDelta;       }
	        if ( 'wheelDeltaY' in orgEvent ) { deltaY = orgEvent.wheelDeltaY;      }
	        if ( 'wheelDeltaX' in orgEvent ) { deltaX = orgEvent.wheelDeltaX * -1; }
	
	        // Firefox < 17 horizontal scrolling related to DOMMouseScroll event
	        if ( 'axis' in orgEvent && orgEvent.axis === orgEvent.HORIZONTAL_AXIS ) {
	            deltaX = deltaY * -1;
	            deltaY = 0;
	        }
	
	        // Set delta to be deltaY or deltaX if deltaY is 0 for backwards compatabilitiy
	        delta = deltaY === 0 ? deltaX : deltaY;
	
	        // New school wheel delta (wheel event)
	        if ( 'deltaY' in orgEvent ) {
	            deltaY = orgEvent.deltaY * -1;
	            delta  = deltaY;
	        }
	        if ( 'deltaX' in orgEvent ) {
	            deltaX = orgEvent.deltaX;
	            if ( deltaY === 0 ) { delta  = deltaX * -1; }
	        }
	
	        // No change actually happened, no reason to go any further
	        if ( deltaY === 0 && deltaX === 0 ) { return; }
	
	        // Need to convert lines and pages to pixels if we aren't already in pixels
	        // There are three delta modes:
	        //   * deltaMode 0 is by pixels, nothing to do
	        //   * deltaMode 1 is by lines
	        //   * deltaMode 2 is by pages
	        if ( orgEvent.deltaMode === 1 ) {
	            var lineHeight = $.data(this, 'mousewheel-line-height');
	            delta  *= lineHeight;
	            deltaY *= lineHeight;
	            deltaX *= lineHeight;
	        } else if ( orgEvent.deltaMode === 2 ) {
	            var pageHeight = $.data(this, 'mousewheel-page-height');
	            delta  *= pageHeight;
	            deltaY *= pageHeight;
	            deltaX *= pageHeight;
	        }
	
	        // Store lowest absolute delta to normalize the delta values
	        absDelta = Math.max( Math.abs(deltaY), Math.abs(deltaX) );
	
	        if ( !lowestDelta || absDelta < lowestDelta ) {
	            lowestDelta = absDelta;
	
	            // Adjust older deltas if necessary
	            if ( shouldAdjustOldDeltas(orgEvent, absDelta) ) {
	                lowestDelta /= 40;
	            }
	        }
	
	        // Adjust older deltas if necessary
	        if ( shouldAdjustOldDeltas(orgEvent, absDelta) ) {
	            // Divide all the things by 40!
	            delta  /= 40;
	            deltaX /= 40;
	            deltaY /= 40;
	        }
	
	        // Get a whole, normalized value for the deltas
	        delta  = Math[ delta  >= 1 ? 'floor' : 'ceil' ](delta  / lowestDelta);
	        deltaX = Math[ deltaX >= 1 ? 'floor' : 'ceil' ](deltaX / lowestDelta);
	        deltaY = Math[ deltaY >= 1 ? 'floor' : 'ceil' ](deltaY / lowestDelta);
	
	        // Normalise offsetX and offsetY properties
	        if ( special.settings.normalizeOffset && this.getBoundingClientRect ) {
	            var boundingRect = this.getBoundingClientRect();
	            offsetX = event.clientX - boundingRect.left;
	            offsetY = event.clientY - boundingRect.top;
	        }
	
	        // Add information to the event object
	        event.deltaX = deltaX;
	        event.deltaY = deltaY;
	        event.deltaFactor = lowestDelta;
	        event.offsetX = offsetX;
	        event.offsetY = offsetY;
	        // Go ahead and set deltaMode to 0 since we converted to pixels
	        // Although this is a little odd since we overwrite the deltaX/Y
	        // properties with normalized deltas.
	        event.deltaMode = 0;
	
	        // Add event and delta to the front of the arguments
	        args.unshift(event, delta, deltaX, deltaY);
	
	        // Clearout lowestDelta after sometime to better
	        // handle multiple device types that give different
	        // a different lowestDelta
	        // Ex: trackpad = 3 and mouse wheel = 120
	        if (nullLowestDeltaTimeout) { clearTimeout(nullLowestDeltaTimeout); }
	        nullLowestDeltaTimeout = setTimeout(nullLowestDelta, 200);
	
	        return ($.event.dispatch || $.event.handle).apply(this, args);
	    }
	
	    function nullLowestDelta() {
	        lowestDelta = null;
	    }
	
	    function shouldAdjustOldDeltas(orgEvent, absDelta) {
	        // If this is an older event and the delta is divisable by 120,
	        // then we are assuming that the browser is treating this as an
	        // older mouse wheel event and that we should divide the deltas
	        // by 40 to try and get a more usable deltaFactor.
	        // Side note, this actually impacts the reported scroll distance
	        // in older browsers and can cause scrolling to be slower than native.
	        // Turn this off by setting $.event.special.mousewheel.settings.adjustOldDeltas to false.
	        return special.settings.adjustOldDeltas && orgEvent.type === 'mousewheel' && absDelta % 120 === 0;
	    }
	
	}));


/***/ }),

/***/ 350:
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*! lg-video - v1.2.1 - 2018-03-08
	* http://sachinchoolur.github.io/lightGallery
	* Copyright (c) 2018 Sachin N; Licensed GPLv3 */
	
	(function (root, factory) {
	  if (true) {
	    // AMD. Register as an anonymous module unless amdModuleId is set
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(8)], __WEBPACK_AMD_DEFINE_RESULT__ = function (a0) {
	      return (factory(a0));
	    }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  } else if (typeof module === 'object' && module.exports) {
	    // Node. Does not work with strict CommonJS, but
	    // only CommonJS-like environments that support module.exports,
	    // like Node.
	    module.exports = factory(require('jquery'));
	  } else {
	    factory(root["jQuery"]);
	  }
	}(this, function ($) {
	
	(function() {
	    
	        'use strict';
	    
	        var defaults = {
	            videoMaxWidth: '855px',
	
	            autoplayFirstVideo: true,
	
	            youtubePlayerParams: false,
	            vimeoPlayerParams: false,
	            dailymotionPlayerParams: false,
	            vkPlayerParams: false,
	
	            videojs: false,
	            videojsOptions: {}
	        };
	    
	        var Video = function(element) {
	    
	            this.core = $(element).data('lightGallery');
	    
	            this.$el = $(element);
	            this.core.s = $.extend({}, defaults, this.core.s);
	            this.videoLoaded = false;
	    
	            this.init();
	    
	            return this;
	        };
	    
	        Video.prototype.init = function() {
	            var _this = this;
	    
	            // Event triggered when video url found without poster
	            _this.core.$el.on('hasVideo.lg.tm', onHasVideo.bind(this));
	    
	            // Set max width for video
	            _this.core.$el.on('onAferAppendSlide.lg.tm', onAferAppendSlide.bind(this));
	    
	            if (_this.core.doCss() && (_this.core.$items.length > 1) && (_this.core.s.enableSwipe || _this.core.s.enableDrag)) {
	                _this.core.$el.on('onSlideClick.lg.tm', function() {
	                    var $el = _this.core.$slide.eq(_this.core.index);
	                    _this.loadVideoOnclick($el);
	                });
	            } else {
	    
	                // For IE 9 and bellow
	                _this.core.$slide.on('click.lg', function() {
	                    _this.loadVideoOnclick($(this));
	                });
	            }
	    
	            _this.core.$el.on('onBeforeSlide.lg.tm', onBeforeSlide.bind(this));
	    
	            _this.core.$el.on('onAfterSlide.lg.tm', function(event, prevIndex) {
	                _this.core.$slide.eq(prevIndex).removeClass('lg-video-playing');
	            });
	        };
	    
	        Video.prototype.loadVideo = function(src, addClass, noPoster, index, html) {
	            var video = '';
	            var autoplay = 1;
	            var a = '';
	            var isVideo = this.core.isVideo(src, index) || {};
	    
	            // Enable autoplay based on setting for first video if poster doesn't exist
	            if (noPoster) {
	                if (this.videoLoaded) {
	                    autoplay = 0;
	                } else {
	                    autoplay = this.core.s.autoplayFirstVideo ? 1 : 0;
	                }
	            }
	    
	            if (isVideo.youtube) {
	    
	                a = '?wmode=opaque&autoplay=' + autoplay + '&enablejsapi=1';
	                if (this.core.s.youtubePlayerParams) {
	                    a = a + '&' + $.param(this.core.s.youtubePlayerParams);
	                }
	    
	                video = '<iframe class="lg-video-object lg-youtube ' + addClass + '" width="560" height="315" src="//www.youtube.com/embed/' + isVideo.youtube[1] + a + '" frameborder="0" allowfullscreen></iframe>';
	    
	            } else if (isVideo.vimeo) {
	    
	                a = '?autoplay=' + autoplay + '&api=1';
	                if (this.core.s.vimeoPlayerParams) {
	                    a = a + '&' + $.param(this.core.s.vimeoPlayerParams);
	                }
	    
	                video = '<iframe class="lg-video-object lg-vimeo ' + addClass + '" width="560" height="315"  src="//player.vimeo.com/video/' + isVideo.vimeo[1] + a + '" frameborder="0" webkitAllowFullScreen mozallowfullscreen allowFullScreen></iframe>';
	    
	            } else if (isVideo.dailymotion) {
	    
	                a = '?wmode=opaque&autoplay=' + autoplay + '&api=postMessage';
	                if (this.core.s.dailymotionPlayerParams) {
	                    a = a + '&' + $.param(this.core.s.dailymotionPlayerParams);
	                }
	    
	                video = '<iframe class="lg-video-object lg-dailymotion ' + addClass + '" width="560" height="315" src="//www.dailymotion.com/embed/video/' + isVideo.dailymotion[1] + a + '" frameborder="0" allowfullscreen></iframe>';
	    
	            } else if (isVideo.html5) {
	                var fL = html.substring(0, 1);
	                if (fL === '.' || fL === '#') {
	                    html = $(html).html();
	                }
	    
	                video = html;
	    
	            } else if (isVideo.vk) {
	    
	                a = '&autoplay=' + autoplay;
	                if (this.core.s.vkPlayerParams) {
	                    a = a + '&' + $.param(this.core.s.vkPlayerParams);
	                }
	    
	                video = '<iframe class="lg-video-object lg-vk ' + addClass + '" width="560" height="315" src="//vk.com/video_ext.php?' + isVideo.vk[1] + a + '" frameborder="0" allowfullscreen></iframe>';
	    
	            }
	    
	            return video;
	        };
	
	        Video.prototype.loadVideoOnclick = function($el){
	
	            var _this = this;
	            // check slide has poster
	            if ($el.find('.lg-object').hasClass('lg-has-poster') && $el.find('.lg-object').is(':visible')) {
	
	                // check already video element present
	                if (!$el.hasClass('lg-has-video')) {
	
	                    $el.addClass('lg-video-playing lg-has-video');
	
	                    var _src;
	                    var _html;
	                    var _loadVideo = function(_src, _html) {
	
	                        $el.find('.lg-video').append(_this.loadVideo(_src, '', false, _this.core.index, _html));
	
	                        if (_html) {
	                            if (_this.core.s.videojs) {
	                                try {
	                                    videojs(_this.core.$slide.eq(_this.core.index).find('.lg-html5').get(0), _this.core.s.videojsOptions, function() {
	                                        this.play();
	                                    });
	                                } catch (e) {
	                                    console.error('Make sure you have included videojs');
	                                }
	                            } else {
	                                _this.core.$slide.eq(_this.core.index).find('.lg-html5').get(0).play();
	                            }
	                        }
	
	                    };
	
	                    if (_this.core.s.dynamic) {
	
	                        _src = _this.core.s.dynamicEl[_this.core.index].src;
	                        _html = _this.core.s.dynamicEl[_this.core.index].html;
	
	                        _loadVideo(_src, _html);
	
	                    } else {
	
	                        _src = _this.core.$items.eq(_this.core.index).attr('href') || _this.core.$items.eq(_this.core.index).attr('data-src');
	                        _html = _this.core.$items.eq(_this.core.index).attr('data-html');
	
	                        _loadVideo(_src, _html);
	
	                    }
	
	                    var $tempImg = $el.find('.lg-object');
	                    $el.find('.lg-video').append($tempImg);
	
	                    // @todo loading icon for html5 videos also
	                    // for showing the loading indicator while loading video
	                    if (!$el.find('.lg-video-object').hasClass('lg-html5')) {
	                        $el.removeClass('lg-complete');
	                        $el.find('.lg-video-object').on('load.lg error.lg', function() {
	                            $el.addClass('lg-complete');
	                        });
	                    }
	
	                } else {
	
	                    var youtubePlayer = $el.find('.lg-youtube').get(0);
	                    var vimeoPlayer = $el.find('.lg-vimeo').get(0);
	                    var dailymotionPlayer = $el.find('.lg-dailymotion').get(0);
	                    var html5Player = $el.find('.lg-html5').get(0);
	                    if (youtubePlayer) {
	                        youtubePlayer.contentWindow.postMessage('{"event":"command","func":"playVideo","args":""}', '*');
	                    } else if (vimeoPlayer) {
	                        try {
	                            $f(vimeoPlayer).api('play');
	                        } catch (e) {
	                            console.error('Make sure you have included froogaloop2 js');
	                        }
	                    } else if (dailymotionPlayer) {
	                        dailymotionPlayer.contentWindow.postMessage('play', '*');
	
	                    } else if (html5Player) {
	                        if (_this.core.s.videojs) {
	                            try {
	                                videojs(html5Player).play();
	                            } catch (e) {
	                                console.error('Make sure you have included videojs');
	                            }
	                        } else {
	                            html5Player.play();
	                        }
	                    }
	
	                    $el.addClass('lg-video-playing');
	
	                }
	            }
	        };
	    
	        Video.prototype.destroy = function() {
	            this.videoLoaded = false;
	        };
	
	        function onHasVideo(event, index, src, html) {
	            /*jshint validthis:true */
	            var _this = this;
	            _this.core.$slide.eq(index).find('.lg-video').append(_this.loadVideo(src, 'lg-object', true, index, html));
	            if (html) {
	                if (_this.core.s.videojs) {
	                    try {
	                        videojs(_this.core.$slide.eq(index).find('.lg-html5').get(0), _this.core.s.videojsOptions, function() {
	                            if (!_this.videoLoaded && _this.core.s.autoplayFirstVideo) {
	                                this.play();
	                            }
	                        });
	                    } catch (e) {
	                        console.error('Make sure you have included videojs');
	                    }
	                } else {
	                    if(!_this.videoLoaded && _this.core.s.autoplayFirstVideo) {
	                        _this.core.$slide.eq(index).find('.lg-html5').get(0).play();
	                    }
	                }
	            }
	        }
	
	        function onAferAppendSlide(event, index) {
	            /*jshint validthis:true */
	            var $videoCont = this.core.$slide.eq(index).find('.lg-video-cont');
	            if (!$videoCont.hasClass('lg-has-iframe')) {
	                $videoCont.css('max-width', this.core.s.videoMaxWidth);
	                this.videoLoaded = true;
	            }
	        }
	
	        function onBeforeSlide(event, prevIndex, index) {
	            /*jshint validthis:true */
	            var _this = this;
	
	            var $videoSlide = _this.core.$slide.eq(prevIndex);
	            var youtubePlayer = $videoSlide.find('.lg-youtube').get(0);
	            var vimeoPlayer = $videoSlide.find('.lg-vimeo').get(0);
	            var dailymotionPlayer = $videoSlide.find('.lg-dailymotion').get(0);
	            var vkPlayer = $videoSlide.find('.lg-vk').get(0);
	            var html5Player = $videoSlide.find('.lg-html5').get(0);
	            if (youtubePlayer) {
	                youtubePlayer.contentWindow.postMessage('{"event":"command","func":"pauseVideo","args":""}', '*');
	            } else if (vimeoPlayer) {
	                try {
	                    $f(vimeoPlayer).api('pause');
	                } catch (e) {
	                    console.error('Make sure you have included froogaloop2 js');
	                }
	            } else if (dailymotionPlayer) {
	                dailymotionPlayer.contentWindow.postMessage('pause', '*');
	
	            } else if (html5Player) {
	                if (_this.core.s.videojs) {
	                    try {
	                        videojs(html5Player).pause();
	                    } catch (e) {
	                        console.error('Make sure you have included videojs');
	                    }
	                } else {
	                    html5Player.pause();
	                }
	            } if (vkPlayer) {
	                $(vkPlayer).attr('src', $(vkPlayer).attr('src').replace('&autoplay', '&noplay'));
	            }
	
	            var _src;
	            if (_this.core.s.dynamic) {
	                _src = _this.core.s.dynamicEl[index].src;
	            } else {
	                _src = _this.core.$items.eq(index).attr('href') || _this.core.$items.eq(index).attr('data-src');
	
	            }
	
	            var _isVideo = _this.core.isVideo(_src, index) || {};
	            if (_isVideo.youtube || _isVideo.vimeo || _isVideo.dailymotion || _isVideo.vk) {
	                _this.core.$outer.addClass('lg-hide-download');
	            }
	
	        }
	    
	        $.fn.lightGallery.modules.video = Video;
	    
	    })();
	
	}));


/***/ }),

/***/ 351:
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*! lightgallery - v1.6.9 - 2018-04-03
	* http://sachinchoolur.github.io/lightGallery/
	* Copyright (c) 2018 Sachin N; Licensed GPLv3 */
	(function (root, factory) {
	  if (true) {
	    // AMD. Register as an anonymous module unless amdModuleId is set
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(8)], __WEBPACK_AMD_DEFINE_RESULT__ = function (a0) {
	      return (factory(a0));
	    }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  } else if (typeof module === 'object' && module.exports) {
	    // Node. Does not work with strict CommonJS, but
	    // only CommonJS-like environments that support module.exports,
	    // like Node.
	    module.exports = factory(require('jquery'));
	  } else {
	    factory(root["jQuery"]);
	  }
	}(this, function ($) {
	
	(function() {
	    'use strict';
	
	    var defaults = {
	
	        mode: 'lg-slide',
	
	        // Ex : 'ease'
	        cssEasing: 'ease',
	
	        //'for jquery animation'
	        easing: 'linear',
	        speed: 600,
	        height: '100%',
	        width: '100%',
	        addClass: '',
	        startClass: 'lg-start-zoom',
	        backdropDuration: 150,
	        hideBarsDelay: 6000,
	
	        useLeft: false,
	
	        closable: true,
	        loop: true,
	        escKey: true,
	        keyPress: true,
	        controls: true,
	        slideEndAnimatoin: true,
	        hideControlOnEnd: false,
	        mousewheel: true,
	
	        getCaptionFromTitleOrAlt: true,
	
	        // .lg-item || '.lg-sub-html'
	        appendSubHtmlTo: '.lg-sub-html',
	
	        subHtmlSelectorRelative: false,
	
	        /**
	         * @desc number of preload slides
	         * will exicute only after the current slide is fully loaded.
	         *
	         * @ex you clicked on 4th image and if preload = 1 then 3rd slide and 5th
	         * slide will be loaded in the background after the 4th slide is fully loaded..
	         * if preload is 2 then 2nd 3rd 5th 6th slides will be preloaded.. ... ...
	         *
	         */
	        preload: 1,
	        showAfterLoad: true,
	        selector: '',
	        selectWithin: '',
	        nextHtml: '',
	        prevHtml: '',
	
	        // 0, 1
	        index: false,
	
	        iframeMaxWidth: '100%',
	
	        download: true,
	        counter: true,
	        appendCounterTo: '.lg-toolbar',
	
	        swipeThreshold: 50,
	        enableSwipe: true,
	        enableDrag: true,
	
	        dynamic: false,
	        dynamicEl: [],
	        galleryId: 1
	    };
	
	    function Plugin(element, options) {
	
	        // Current lightGallery element
	        this.el = element;
	
	        // Current jquery element
	        this.$el = $(element);
	
	        // lightGallery settings
	        this.s = $.extend({}, defaults, options);
	
	        // When using dynamic mode, ensure dynamicEl is an array
	        if (this.s.dynamic && this.s.dynamicEl !== 'undefined' && this.s.dynamicEl.constructor === Array && !this.s.dynamicEl.length) {
	            throw ('When using dynamic mode, you must also define dynamicEl as an Array.');
	        }
	
	        // lightGallery modules
	        this.modules = {};
	
	        // false when lightgallery complete first slide;
	        this.lGalleryOn = false;
	
	        this.lgBusy = false;
	
	        // Timeout function for hiding controls;
	        this.hideBartimeout = false;
	
	        // To determine browser supports for touch events;
	        this.isTouch = ('ontouchstart' in document.documentElement);
	
	        // Disable hideControlOnEnd if sildeEndAnimation is true
	        if (this.s.slideEndAnimatoin) {
	            this.s.hideControlOnEnd = false;
	        }
	
	        // Gallery items
	        if (this.s.dynamic) {
	            this.$items = this.s.dynamicEl;
	        } else {
	            if (this.s.selector === 'this') {
	                this.$items = this.$el;
	            } else if (this.s.selector !== '') {
	                if (this.s.selectWithin) {
	                    this.$items = $(this.s.selectWithin).find(this.s.selector);
	                } else {
	                    this.$items = this.$el.find($(this.s.selector));
	                }
	            } else {
	                this.$items = this.$el.children();
	            }
	        }
	
	        // .lg-item
	        this.$slide = '';
	
	        // .lg-outer
	        this.$outer = '';
	
	        this.init();
	
	        return this;
	    }
	
	    Plugin.prototype.init = function() {
	
	        var _this = this;
	
	        // s.preload should not be more than $item.length
	        if (_this.s.preload > _this.$items.length) {
	            _this.s.preload = _this.$items.length;
	        }
	
	        // if dynamic option is enabled execute immediately
	        var _hash = window.location.hash;
	        if (_hash.indexOf('lg=' + this.s.galleryId) > 0) {
	
	            _this.index = parseInt(_hash.split('&slide=')[1], 10);
	
	            $('body').addClass('lg-from-hash');
	            if (!$('body').hasClass('lg-on')) {
	                setTimeout(function() {
	                    _this.build(_this.index);
	                });
	
	                $('body').addClass('lg-on');
	            }
	        }
	
	        if (_this.s.dynamic) {
	
	            _this.$el.trigger('onBeforeOpen.lg');
	
	            _this.index = _this.s.index || 0;
	
	            // prevent accidental double execution
	            if (!$('body').hasClass('lg-on')) {
	                setTimeout(function() {
	                    _this.build(_this.index);
	                    $('body').addClass('lg-on');
	                });
	            }
	        } else {
	
	            // Using different namespace for click because click event should not unbind if selector is same object('this')
	            _this.$items.on('click.lgcustom', function(event) {
	
	                // For IE8
	                try {
	                    event.preventDefault();
	                    event.preventDefault();
	                } catch (er) {
	                    event.returnValue = false;
	                }
	
	                _this.$el.trigger('onBeforeOpen.lg');
	
	                _this.index = _this.s.index || _this.$items.index(this);
	
	                // prevent accidental double execution
	                if (!$('body').hasClass('lg-on')) {
	                    _this.build(_this.index);
	                    $('body').addClass('lg-on');
	                }
	            });
	        }
	
	    };
	
	    Plugin.prototype.build = function(index) {
	
	        var _this = this;
	
	        _this.structure();
	
	        // module constructor
	        $.each($.fn.lightGallery.modules, function(key) {
	            _this.modules[key] = new $.fn.lightGallery.modules[key](_this.el);
	        });
	
	        // initiate slide function
	        _this.slide(index, false, false, false);
	
	        if (_this.s.keyPress) {
	            _this.keyPress();
	        }
	
	        if (_this.$items.length > 1) {
	
	            _this.arrow();
	
	            setTimeout(function() {
	                _this.enableDrag();
	                _this.enableSwipe();
	            }, 50);
	
	            if (_this.s.mousewheel) {
	                _this.mousewheel();
	            }
	        } else {
	            _this.$slide.on('click.lg', function() {
	                _this.$el.trigger('onSlideClick.lg');
	            });
	        }
	
	        _this.counter();
	
	        _this.closeGallery();
	
	        _this.$el.trigger('onAfterOpen.lg');
	
	        // Hide controllers if mouse doesn't move for some period
	        _this.$outer.on('mousemove.lg click.lg touchstart.lg', function() {
	
	            _this.$outer.removeClass('lg-hide-items');
	
	            clearTimeout(_this.hideBartimeout);
	
	            // Timeout will be cleared on each slide movement also
	            _this.hideBartimeout = setTimeout(function() {
	                _this.$outer.addClass('lg-hide-items');
	            }, _this.s.hideBarsDelay);
	
	        });
	
	        _this.$outer.trigger('mousemove.lg');
	
	    };
	
	    Plugin.prototype.structure = function() {
	        var list = '';
	        var controls = '';
	        var i = 0;
	        var subHtmlCont = '';
	        var template;
	        var _this = this;
	
	        $('body').append('<div class="lg-backdrop"></div>');
	        $('.lg-backdrop').css('transition-duration', this.s.backdropDuration + 'ms');
	
	        // Create gallery items
	        for (i = 0; i < this.$items.length; i++) {
	            list += '<div class="lg-item"></div>';
	        }
	
	        // Create controlls
	        if (this.s.controls && this.$items.length > 1) {
	            controls = '<div class="lg-actions">' +
	                '<button class="lg-prev lg-icon">' + this.s.prevHtml + '</button>' +
	                '<button class="lg-next lg-icon">' + this.s.nextHtml + '</button>' +
	                '</div>';
	        }
	
	        if (this.s.appendSubHtmlTo === '.lg-sub-html') {
	            subHtmlCont = '<div class="lg-sub-html"></div>';
	        }
	
	        template = '<div class="lg-outer ' + this.s.addClass + ' ' + this.s.startClass + '">' +
	            '<div class="lg" style="width:' + this.s.width + '; height:' + this.s.height + '">' +
	            '<div class="lg-inner">' + list + '</div>' +
	            '<div class="lg-toolbar lg-group">' +
	            '<span class="lg-close lg-icon"></span>' +
	            '</div>' +
	            controls +
	            subHtmlCont +
	            '</div>' +
	            '</div>';
	
	        $('body').append(template);
	        this.$outer = $('.lg-outer');
	        this.$slide = this.$outer.find('.lg-item');
	
	        if (this.s.useLeft) {
	            this.$outer.addClass('lg-use-left');
	
	            // Set mode lg-slide if use left is true;
	            this.s.mode = 'lg-slide';
	        } else {
	            this.$outer.addClass('lg-use-css3');
	        }
	
	        // For fixed height gallery
	        _this.setTop();
	        $(window).on('resize.lg orientationchange.lg', function() {
	            setTimeout(function() {
	                _this.setTop();
	            }, 100);
	        });
	
	        // add class lg-current to remove initial transition
	        this.$slide.eq(this.index).addClass('lg-current');
	
	        // add Class for css support and transition mode
	        if (this.doCss()) {
	            this.$outer.addClass('lg-css3');
	        } else {
	            this.$outer.addClass('lg-css');
	
	            // Set speed 0 because no animation will happen if browser doesn't support css3
	            this.s.speed = 0;
	        }
	
	        this.$outer.addClass(this.s.mode);
	
	        if (this.s.enableDrag && this.$items.length > 1) {
	            this.$outer.addClass('lg-grab');
	        }
	
	        if (this.s.showAfterLoad) {
	            this.$outer.addClass('lg-show-after-load');
	        }
	
	        if (this.doCss()) {
	            var $inner = this.$outer.find('.lg-inner');
	            $inner.css('transition-timing-function', this.s.cssEasing);
	            $inner.css('transition-duration', this.s.speed + 'ms');
	        }
	
	        setTimeout(function() {
	            $('.lg-backdrop').addClass('in');
	        });
	
	        setTimeout(function() {
	            _this.$outer.addClass('lg-visible');
	        }, this.s.backdropDuration);
	
	        if (this.s.download) {
	            this.$outer.find('.lg-toolbar').append('<a id="lg-download" target="_blank" download class="lg-download lg-icon"></a>');
	        }
	
	        // Store the current scroll top value to scroll back after closing the gallery..
	        this.prevScrollTop = $(window).scrollTop();
	
	    };
	
	    // For fixed height gallery
	    Plugin.prototype.setTop = function() {
	        if (this.s.height !== '100%') {
	            var wH = $(window).height();
	            var top = (wH - parseInt(this.s.height, 10)) / 2;
	            var $lGallery = this.$outer.find('.lg');
	            if (wH >= parseInt(this.s.height, 10)) {
	                $lGallery.css('top', top + 'px');
	            } else {
	                $lGallery.css('top', '0px');
	            }
	        }
	    };
	
	    // Find css3 support
	    Plugin.prototype.doCss = function() {
	        // check for css animation support
	        var support = function() {
	            var transition = ['transition', 'MozTransition', 'WebkitTransition', 'OTransition', 'msTransition', 'KhtmlTransition'];
	            var root = document.documentElement;
	            var i = 0;
	            for (i = 0; i < transition.length; i++) {
	                if (transition[i] in root.style) {
	                    return true;
	                }
	            }
	        };
	
	        if (support()) {
	            return true;
	        }
	
	        return false;
	    };
	
	    /**
	     *  @desc Check the given src is video
	     *  @param {String} src
	     *  @return {Object} video type
	     *  Ex:{ youtube  :  ["//www.youtube.com/watch?v=c0asJgSyxcY", "c0asJgSyxcY"] }
	     */
	    Plugin.prototype.isVideo = function(src, index) {
	
	        var html;
	        if (this.s.dynamic) {
	            html = this.s.dynamicEl[index].html;
	        } else {
	            html = this.$items.eq(index).attr('data-html');
	        }
	
	        if (!src) {
	            if(html) {
	                return {
	                    html5: true
	                };
	            } else {
	                console.error('lightGallery :- data-src is not pvovided on slide item ' + (index + 1) + '. Please make sure the selector property is properly configured. More info - http://sachinchoolur.github.io/lightGallery/demos/html-markup.html');
	                return false;
	            }
	        }
	
	        var youtube = src.match(/\/\/(?:www\.)?youtu(?:\.be|be\.com)\/(?:watch\?v=|embed\/)?([a-z0-9\-\_\%]+)/i);
	        var vimeo = src.match(/\/\/(?:www\.)?vimeo.com\/([0-9a-z\-_]+)/i);
	        var dailymotion = src.match(/\/\/(?:www\.)?dai.ly\/([0-9a-z\-_]+)/i);
	        var vk = src.match(/\/\/(?:www\.)?(?:vk\.com|vkontakte\.ru)\/(?:video_ext\.php\?)(.*)/i);
	
	        if (youtube) {
	            return {
	                youtube: youtube
	            };
	        } else if (vimeo) {
	            return {
	                vimeo: vimeo
	            };
	        } else if (dailymotion) {
	            return {
	                dailymotion: dailymotion
	            };
	        } else if (vk) {
	            return {
	                vk: vk
	            };
	        }
	    };
	
	    /**
	     *  @desc Create image counter
	     *  Ex: 1/10
	     */
	    Plugin.prototype.counter = function() {
	        if (this.s.counter) {
	            $(this.s.appendCounterTo).append('<div id="lg-counter"><span id="lg-counter-current">' + (parseInt(this.index, 10) + 1) + '</span> / <span id="lg-counter-all">' + this.$items.length + '</span></div>');
	        }
	    };
	
	    /**
	     *  @desc add sub-html into the slide
	     *  @param {Number} index - index of the slide
	     */
	    Plugin.prototype.addHtml = function(index) {
	        var subHtml = null;
	        var subHtmlUrl;
	        var $currentEle;
	        if (this.s.dynamic) {
	            if (this.s.dynamicEl[index].subHtmlUrl) {
	                subHtmlUrl = this.s.dynamicEl[index].subHtmlUrl;
	            } else {
	                subHtml = this.s.dynamicEl[index].subHtml;
	            }
	        } else {
	            $currentEle = this.$items.eq(index);
	            if ($currentEle.attr('data-sub-html-url')) {
	                subHtmlUrl = $currentEle.attr('data-sub-html-url');
	            } else {
	                subHtml = $currentEle.attr('data-sub-html');
	                if (this.s.getCaptionFromTitleOrAlt && !subHtml) {
	                    subHtml = $currentEle.attr('title') || $currentEle.find('img').first().attr('alt');
	                }
	            }
	        }
	
	        if (!subHtmlUrl) {
	            if (typeof subHtml !== 'undefined' && subHtml !== null) {
	
	                // get first letter of subhtml
	                // if first letter starts with . or # get the html form the jQuery object
	                var fL = subHtml.substring(0, 1);
	                if (fL === '.' || fL === '#') {
	                    if (this.s.subHtmlSelectorRelative && !this.s.dynamic) {
	                        subHtml = $currentEle.find(subHtml).html();
	                    } else {
	                        subHtml = $(subHtml).html();
	                    }
	                }
	            } else {
	                subHtml = '';
	            }
	        }
	
	        if (this.s.appendSubHtmlTo === '.lg-sub-html') {
	
	            if (subHtmlUrl) {
	                this.$outer.find(this.s.appendSubHtmlTo).load(subHtmlUrl);
	            } else {
	                this.$outer.find(this.s.appendSubHtmlTo).html(subHtml);
	            }
	
	        } else {
	
	            if (subHtmlUrl) {
	                this.$slide.eq(index).load(subHtmlUrl);
	            } else {
	                this.$slide.eq(index).append(subHtml);
	            }
	        }
	
	        // Add lg-empty-html class if title doesn't exist
	        if (typeof subHtml !== 'undefined' && subHtml !== null) {
	            if (subHtml === '') {
	                this.$outer.find(this.s.appendSubHtmlTo).addClass('lg-empty-html');
	            } else {
	                this.$outer.find(this.s.appendSubHtmlTo).removeClass('lg-empty-html');
	            }
	        }
	
	        this.$el.trigger('onAfterAppendSubHtml.lg', [index]);
	    };
	
	    /**
	     *  @desc Preload slides
	     *  @param {Number} index - index of the slide
	     */
	    Plugin.prototype.preload = function(index) {
	        var i = 1;
	        var j = 1;
	        for (i = 1; i <= this.s.preload; i++) {
	            if (i >= this.$items.length - index) {
	                break;
	            }
	
	            this.loadContent(index + i, false, 0);
	        }
	
	        for (j = 1; j <= this.s.preload; j++) {
	            if (index - j < 0) {
	                break;
	            }
	
	            this.loadContent(index - j, false, 0);
	        }
	    };
	
	    /**
	     *  @desc Load slide content into slide.
	     *  @param {Number} index - index of the slide.
	     *  @param {Boolean} rec - if true call loadcontent() function again.
	     *  @param {Boolean} delay - delay for adding complete class. it is 0 except first time.
	     */
	    Plugin.prototype.loadContent = function(index, rec, delay) {
	
	        var _this = this;
	        var _hasPoster = false;
	        var _$img;
	        var _src;
	        var _poster;
	        var _srcset;
	        var _sizes;
	        var _html;
	        var getResponsiveSrc = function(srcItms) {
	            var rsWidth = [];
	            var rsSrc = [];
	            for (var i = 0; i < srcItms.length; i++) {
	                var __src = srcItms[i].split(' ');
	
	                // Manage empty space
	                if (__src[0] === '') {
	                    __src.splice(0, 1);
	                }
	
	                rsSrc.push(__src[0]);
	                rsWidth.push(__src[1]);
	            }
	
	            var wWidth = $(window).width();
	            for (var j = 0; j < rsWidth.length; j++) {
	                if (parseInt(rsWidth[j], 10) > wWidth) {
	                    _src = rsSrc[j];
	                    break;
	                }
	            }
	        };
	
	        if (_this.s.dynamic) {
	
	            if (_this.s.dynamicEl[index].poster) {
	                _hasPoster = true;
	                _poster = _this.s.dynamicEl[index].poster;
	            }
	
	            _html = _this.s.dynamicEl[index].html;
	            _src = _this.s.dynamicEl[index].src;
	
	            if (_this.s.dynamicEl[index].responsive) {
	                var srcDyItms = _this.s.dynamicEl[index].responsive.split(',');
	                getResponsiveSrc(srcDyItms);
	            }
	
	            _srcset = _this.s.dynamicEl[index].srcset;
	            _sizes = _this.s.dynamicEl[index].sizes;
	
	        } else {
	
	            if (_this.$items.eq(index).attr('data-poster')) {
	                _hasPoster = true;
	                _poster = _this.$items.eq(index).attr('data-poster');
	            }
	
	            _html = _this.$items.eq(index).attr('data-html');
	            _src = _this.$items.eq(index).attr('href') || _this.$items.eq(index).attr('data-src');
	
	            if (_this.$items.eq(index).attr('data-responsive')) {
	                var srcItms = _this.$items.eq(index).attr('data-responsive').split(',');
	                getResponsiveSrc(srcItms);
	            }
	
	            _srcset = _this.$items.eq(index).attr('data-srcset');
	            _sizes = _this.$items.eq(index).attr('data-sizes');
	
	        }
	
	        //if (_src || _srcset || _sizes || _poster) {
	
	        var iframe = false;
	        if (_this.s.dynamic) {
	            if (_this.s.dynamicEl[index].iframe) {
	                iframe = true;
	            }
	        } else {
	            if (_this.$items.eq(index).attr('data-iframe') === 'true') {
	                iframe = true;
	            }
	        }
	
	        var _isVideo = _this.isVideo(_src, index);
	        if (!_this.$slide.eq(index).hasClass('lg-loaded')) {
	            if (iframe) {
	                _this.$slide.eq(index).prepend('<div class="lg-video-cont lg-has-iframe" style="max-width:' + _this.s.iframeMaxWidth + '"><div class="lg-video"><iframe class="lg-object" frameborder="0" src="' + _src + '"  allowfullscreen="true"></iframe></div></div>');
	            } else if (_hasPoster) {
	                var videoClass = '';
	                if (_isVideo && _isVideo.youtube) {
	                    videoClass = 'lg-has-youtube';
	                } else if (_isVideo && _isVideo.vimeo) {
	                    videoClass = 'lg-has-vimeo';
	                } else {
	                    videoClass = 'lg-has-html5';
	                }
	
	                _this.$slide.eq(index).prepend('<div class="lg-video-cont ' + videoClass + ' "><div class="lg-video"><span class="lg-video-play"></span><img class="lg-object lg-has-poster" src="' + _poster + '" /></div></div>');
	
	            } else if (_isVideo) {
	                _this.$slide.eq(index).prepend('<div class="lg-video-cont "><div class="lg-video"></div></div>');
	                _this.$el.trigger('hasVideo.lg', [index, _src, _html]);
	            } else {
	                _this.$slide.eq(index).prepend('<div class="lg-img-wrap"><img class="lg-object lg-image" src="' + _src + '" /></div>');
	            }
	
	            _this.$el.trigger('onAferAppendSlide.lg', [index]);
	
	            _$img = _this.$slide.eq(index).find('.lg-object');
	            if (_sizes) {
	                _$img.attr('sizes', _sizes);
	            }
	
	            if (_srcset) {
	                _$img.attr('srcset', _srcset);
	                try {
	                    picturefill({
	                        elements: [_$img[0]]
	                    });
	                } catch (e) {
	                    console.warn('lightGallery :- If you want srcset to be supported for older browser please include picturefil version 2 javascript library in your document.');
	                }
	            }
	
	            if (this.s.appendSubHtmlTo !== '.lg-sub-html') {
	                _this.addHtml(index);
	            }
	
	            _this.$slide.eq(index).addClass('lg-loaded');
	        }
	
	        _this.$slide.eq(index).find('.lg-object').on('load.lg error.lg', function() {
	
	            // For first time add some delay for displaying the start animation.
	            var _speed = 0;
	
	            // Do not change the delay value because it is required for zoom plugin.
	            // If gallery opened from direct url (hash) speed value should be 0
	            if (delay && !$('body').hasClass('lg-from-hash')) {
	                _speed = delay;
	            }
	
	            setTimeout(function() {
	                _this.$slide.eq(index).addClass('lg-complete');
	                _this.$el.trigger('onSlideItemLoad.lg', [index, delay || 0]);
	            }, _speed);
	
	        });
	
	        // @todo check load state for html5 videos
	        if (_isVideo && _isVideo.html5 && !_hasPoster) {
	            _this.$slide.eq(index).addClass('lg-complete');
	        }
	
	        if (rec === true) {
	            if (!_this.$slide.eq(index).hasClass('lg-complete')) {
	                _this.$slide.eq(index).find('.lg-object').on('load.lg error.lg', function() {
	                    _this.preload(index);
	                });
	            } else {
	                _this.preload(index);
	            }
	        }
	
	        //}
	    };
	
	    /**
	    *   @desc slide function for lightgallery
	        ** Slide() gets call on start
	        ** ** Set lg.on true once slide() function gets called.
	        ** Call loadContent() on slide() function inside setTimeout
	        ** ** On first slide we do not want any animation like slide of fade
	        ** ** So on first slide( if lg.on if false that is first slide) loadContent() should start loading immediately
	        ** ** Else loadContent() should wait for the transition to complete.
	        ** ** So set timeout s.speed + 50
	    <=> ** loadContent() will load slide content in to the particular slide
	        ** ** It has recursion (rec) parameter. if rec === true loadContent() will call preload() function.
	        ** ** preload will execute only when the previous slide is fully loaded (images iframe)
	        ** ** avoid simultaneous image load
	    <=> ** Preload() will check for s.preload value and call loadContent() again accoring to preload value
	        ** loadContent()  <====> Preload();
	
	    *   @param {Number} index - index of the slide
	    *   @param {Boolean} fromTouch - true if slide function called via touch event or mouse drag
	    *   @param {Boolean} fromThumb - true if slide function called via thumbnail click
	    *   @param {String} direction - Direction of the slide(next/prev)
	    */
	    Plugin.prototype.slide = function(index, fromTouch, fromThumb, direction) {
	
	        var _prevIndex = this.$outer.find('.lg-current').index();
	        var _this = this;
	
	        // Prevent if multiple call
	        // Required for hsh plugin
	        if (_this.lGalleryOn && (_prevIndex === index)) {
	            return;
	        }
	
	        var _length = this.$slide.length;
	        var _time = _this.lGalleryOn ? this.s.speed : 0;
	
	        if (!_this.lgBusy) {
	
	            if (this.s.download) {
	                var _src;
	                if (_this.s.dynamic) {
	                    _src = _this.s.dynamicEl[index].downloadUrl !== false && (_this.s.dynamicEl[index].downloadUrl || _this.s.dynamicEl[index].src);
	                } else {
	                    _src = _this.$items.eq(index).attr('data-download-url') !== 'false' && (_this.$items.eq(index).attr('data-download-url') || _this.$items.eq(index).attr('href') || _this.$items.eq(index).attr('data-src'));
	
	                }
	
	                if (_src) {
	                    $('#lg-download').attr('href', _src);
	                    _this.$outer.removeClass('lg-hide-download');
	                } else {
	                    _this.$outer.addClass('lg-hide-download');
	                }
	            }
	
	            this.$el.trigger('onBeforeSlide.lg', [_prevIndex, index, fromTouch, fromThumb]);
	
	            _this.lgBusy = true;
	
	            clearTimeout(_this.hideBartimeout);
	
	            // Add title if this.s.appendSubHtmlTo === lg-sub-html
	            if (this.s.appendSubHtmlTo === '.lg-sub-html') {
	
	                // wait for slide animation to complete
	                setTimeout(function() {
	                    _this.addHtml(index);
	                }, _time);
	            }
	
	            this.arrowDisable(index);
	
	            if (!direction) {
	                if (index < _prevIndex) {
	                    direction = 'prev';
	                } else if (index > _prevIndex) {
	                    direction = 'next';
	                }
	            }
	
	            if (!fromTouch) {
	
	                // remove all transitions
	                _this.$outer.addClass('lg-no-trans');
	
	                this.$slide.removeClass('lg-prev-slide lg-next-slide');
	
	                if (direction === 'prev') {
	
	                    //prevslide
	                    this.$slide.eq(index).addClass('lg-prev-slide');
	                    this.$slide.eq(_prevIndex).addClass('lg-next-slide');
	                } else {
	
	                    // next slide
	                    this.$slide.eq(index).addClass('lg-next-slide');
	                    this.$slide.eq(_prevIndex).addClass('lg-prev-slide');
	                }
	
	                // give 50 ms for browser to add/remove class
	                setTimeout(function() {
	                    _this.$slide.removeClass('lg-current');
	
	                    //_this.$slide.eq(_prevIndex).removeClass('lg-current');
	                    _this.$slide.eq(index).addClass('lg-current');
	
	                    // reset all transitions
	                    _this.$outer.removeClass('lg-no-trans');
	                }, 50);
	            } else {
	
	                this.$slide.removeClass('lg-prev-slide lg-current lg-next-slide');
	                var touchPrev;
	                var touchNext;
	                if (_length > 2) {
	                    touchPrev = index - 1;
	                    touchNext = index + 1;
	
	                    if ((index === 0) && (_prevIndex === _length - 1)) {
	
	                        // next slide
	                        touchNext = 0;
	                        touchPrev = _length - 1;
	                    } else if ((index === _length - 1) && (_prevIndex === 0)) {
	
	                        // prev slide
	                        touchNext = 0;
	                        touchPrev = _length - 1;
	                    }
	
	                } else {
	                    touchPrev = 0;
	                    touchNext = 1;
	                }
	
	                if (direction === 'prev') {
	                    _this.$slide.eq(touchNext).addClass('lg-next-slide');
	                } else {
	                    _this.$slide.eq(touchPrev).addClass('lg-prev-slide');
	                }
	
	                _this.$slide.eq(index).addClass('lg-current');
	            }
	
	            if (_this.lGalleryOn) {
	                setTimeout(function() {
	                    _this.loadContent(index, true, 0);
	                }, this.s.speed + 50);
	
	                setTimeout(function() {
	                    _this.lgBusy = false;
	                    _this.$el.trigger('onAfterSlide.lg', [_prevIndex, index, fromTouch, fromThumb]);
	                }, this.s.speed);
	
	            } else {
	                _this.loadContent(index, true, _this.s.backdropDuration);
	
	                _this.lgBusy = false;
	                _this.$el.trigger('onAfterSlide.lg', [_prevIndex, index, fromTouch, fromThumb]);
	            }
	
	            _this.lGalleryOn = true;
	
	            if (this.s.counter) {
	                $('#lg-counter-current').text(index + 1);
	            }
	
	        }
	        _this.index = index;
	
	    };
	
	    /**
	     *  @desc Go to next slide
	     *  @param {Boolean} fromTouch - true if slide function called via touch event
	     */
	    Plugin.prototype.goToNextSlide = function(fromTouch) {
	        var _this = this;
	        var _loop = _this.s.loop;
	        if (fromTouch && _this.$slide.length < 3) {
	            _loop = false;
	        }
	
	        if (!_this.lgBusy) {
	            if ((_this.index + 1) < _this.$slide.length) {
	                _this.index++;
	                _this.$el.trigger('onBeforeNextSlide.lg', [_this.index]);
	                _this.slide(_this.index, fromTouch, false, 'next');
	            } else {
	                if (_loop) {
	                    _this.index = 0;
	                    _this.$el.trigger('onBeforeNextSlide.lg', [_this.index]);
	                    _this.slide(_this.index, fromTouch, false, 'next');
	                } else if (_this.s.slideEndAnimatoin && !fromTouch) {
	                    _this.$outer.addClass('lg-right-end');
	                    setTimeout(function() {
	                        _this.$outer.removeClass('lg-right-end');
	                    }, 400);
	                }
	            }
	        }
	    };
	
	    /**
	     *  @desc Go to previous slide
	     *  @param {Boolean} fromTouch - true if slide function called via touch event
	     */
	    Plugin.prototype.goToPrevSlide = function(fromTouch) {
	        var _this = this;
	        var _loop = _this.s.loop;
	        if (fromTouch && _this.$slide.length < 3) {
	            _loop = false;
	        }
	
	        if (!_this.lgBusy) {
	            if (_this.index > 0) {
	                _this.index--;
	                _this.$el.trigger('onBeforePrevSlide.lg', [_this.index, fromTouch]);
	                _this.slide(_this.index, fromTouch, false, 'prev');
	            } else {
	                if (_loop) {
	                    _this.index = _this.$items.length - 1;
	                    _this.$el.trigger('onBeforePrevSlide.lg', [_this.index, fromTouch]);
	                    _this.slide(_this.index, fromTouch, false, 'prev');
	                } else if (_this.s.slideEndAnimatoin && !fromTouch) {
	                    _this.$outer.addClass('lg-left-end');
	                    setTimeout(function() {
	                        _this.$outer.removeClass('lg-left-end');
	                    }, 400);
	                }
	            }
	        }
	    };
	
	    Plugin.prototype.keyPress = function() {
	        var _this = this;
	        if (this.$items.length > 1) {
	            $(window).on('keyup.lg', function(e) {
	                if (_this.$items.length > 1) {
	                    if (e.keyCode === 37) {
	                        e.preventDefault();
	                        _this.goToPrevSlide();
	                    }
	
	                    if (e.keyCode === 39) {
	                        e.preventDefault();
	                        _this.goToNextSlide();
	                    }
	                }
	            });
	        }
	
	        $(window).on('keydown.lg', function(e) {
	            if (_this.s.escKey === true && e.keyCode === 27) {
	                e.preventDefault();
	                if (!_this.$outer.hasClass('lg-thumb-open')) {
	                    _this.destroy();
	                } else {
	                    _this.$outer.removeClass('lg-thumb-open');
	                }
	            }
	        });
	    };
	
	    Plugin.prototype.arrow = function() {
	        var _this = this;
	        this.$outer.find('.lg-prev').on('click.lg', function() {
	            _this.goToPrevSlide();
	        });
	
	        this.$outer.find('.lg-next').on('click.lg', function() {
	            _this.goToNextSlide();
	        });
	    };
	
	    Plugin.prototype.arrowDisable = function(index) {
	
	        // Disable arrows if s.hideControlOnEnd is true
	        if (!this.s.loop && this.s.hideControlOnEnd) {
	            if ((index + 1) < this.$slide.length) {
	                this.$outer.find('.lg-next').removeAttr('disabled').removeClass('disabled');
	            } else {
	                this.$outer.find('.lg-next').attr('disabled', 'disabled').addClass('disabled');
	            }
	
	            if (index > 0) {
	                this.$outer.find('.lg-prev').removeAttr('disabled').removeClass('disabled');
	            } else {
	                this.$outer.find('.lg-prev').attr('disabled', 'disabled').addClass('disabled');
	            }
	        }
	    };
	
	    Plugin.prototype.setTranslate = function($el, xValue, yValue) {
	        // jQuery supports Automatic CSS prefixing since jQuery 1.8.0
	        if (this.s.useLeft) {
	            $el.css('left', xValue);
	        } else {
	            $el.css({
	                transform: 'translate3d(' + (xValue) + 'px, ' + yValue + 'px, 0px)'
	            });
	        }
	    };
	
	    Plugin.prototype.touchMove = function(startCoords, endCoords) {
	
	        var distance = endCoords - startCoords;
	
	        if (Math.abs(distance) > 15) {
	            // reset opacity and transition duration
	            this.$outer.addClass('lg-dragging');
	
	            // move current slide
	            this.setTranslate(this.$slide.eq(this.index), distance, 0);
	
	            // move next and prev slide with current slide
	            this.setTranslate($('.lg-prev-slide'), -this.$slide.eq(this.index).width() + distance, 0);
	            this.setTranslate($('.lg-next-slide'), this.$slide.eq(this.index).width() + distance, 0);
	        }
	    };
	
	    Plugin.prototype.touchEnd = function(distance) {
	        var _this = this;
	
	        // keep slide animation for any mode while dragg/swipe
	        if (_this.s.mode !== 'lg-slide') {
	            _this.$outer.addClass('lg-slide');
	        }
	
	        this.$slide.not('.lg-current, .lg-prev-slide, .lg-next-slide').css('opacity', '0');
	
	        // set transition duration
	        setTimeout(function() {
	            _this.$outer.removeClass('lg-dragging');
	            if ((distance < 0) && (Math.abs(distance) > _this.s.swipeThreshold)) {
	                _this.goToNextSlide(true);
	            } else if ((distance > 0) && (Math.abs(distance) > _this.s.swipeThreshold)) {
	                _this.goToPrevSlide(true);
	            } else if (Math.abs(distance) < 5) {
	
	                // Trigger click if distance is less than 5 pix
	                _this.$el.trigger('onSlideClick.lg');
	            }
	
	            _this.$slide.removeAttr('style');
	        });
	
	        // remove slide class once drag/swipe is completed if mode is not slide
	        setTimeout(function() {
	            if (!_this.$outer.hasClass('lg-dragging') && _this.s.mode !== 'lg-slide') {
	                _this.$outer.removeClass('lg-slide');
	            }
	        }, _this.s.speed + 100);
	
	    };
	
	    Plugin.prototype.enableSwipe = function() {
	        var _this = this;
	        var startCoords = 0;
	        var endCoords = 0;
	        var isMoved = false;
	
	        if (_this.s.enableSwipe && _this.doCss()) {
	
	            _this.$slide.on('touchstart.lg', function(e) {
	                if (!_this.$outer.hasClass('lg-zoomed') && !_this.lgBusy) {
	                    e.preventDefault();
	                    _this.manageSwipeClass();
	                    startCoords = e.originalEvent.targetTouches[0].pageX;
	                }
	            });
	
	            _this.$slide.on('touchmove.lg', function(e) {
	                if (!_this.$outer.hasClass('lg-zoomed')) {
	                    e.preventDefault();
	                    endCoords = e.originalEvent.targetTouches[0].pageX;
	                    _this.touchMove(startCoords, endCoords);
	                    isMoved = true;
	                }
	            });
	
	            _this.$slide.on('touchend.lg', function() {
	                if (!_this.$outer.hasClass('lg-zoomed')) {
	                    if (isMoved) {
	                        isMoved = false;
	                        _this.touchEnd(endCoords - startCoords);
	                    } else {
	                        _this.$el.trigger('onSlideClick.lg');
	                    }
	                }
	            });
	        }
	
	    };
	
	    Plugin.prototype.enableDrag = function() {
	        var _this = this;
	        var startCoords = 0;
	        var endCoords = 0;
	        var isDraging = false;
	        var isMoved = false;
	        if (_this.s.enableDrag && _this.doCss()) {
	            _this.$slide.on('mousedown.lg', function(e) {
	                if (!_this.$outer.hasClass('lg-zoomed') && !_this.lgBusy && !$(e.target).text().trim()) {
	                    e.preventDefault();
	                    _this.manageSwipeClass();
	                    startCoords = e.pageX;
	                    isDraging = true;
	
	                    // ** Fix for webkit cursor issue https://code.google.com/p/chromium/issues/detail?id=26723
	                    _this.$outer.scrollLeft += 1;
	                    _this.$outer.scrollLeft -= 1;
	
	                    // *
	
	                    _this.$outer.removeClass('lg-grab').addClass('lg-grabbing');
	
	                    _this.$el.trigger('onDragstart.lg');
	                }
	            });
	
	            $(window).on('mousemove.lg', function(e) {
	                if (isDraging) {
	                    isMoved = true;
	                    endCoords = e.pageX;
	                    _this.touchMove(startCoords, endCoords);
	                    _this.$el.trigger('onDragmove.lg');
	                }
	            });
	
	            $(window).on('mouseup.lg', function(e) {
	                if (isMoved) {
	                    isMoved = false;
	                    _this.touchEnd(endCoords - startCoords);
	                    _this.$el.trigger('onDragend.lg');
	                } else if ($(e.target).hasClass('lg-object') || $(e.target).hasClass('lg-video-play')) {
	                    _this.$el.trigger('onSlideClick.lg');
	                }
	
	                // Prevent execution on click
	                if (isDraging) {
	                    isDraging = false;
	                    _this.$outer.removeClass('lg-grabbing').addClass('lg-grab');
	                }
	            });
	
	        }
	    };
	
	    Plugin.prototype.manageSwipeClass = function() {
	        var _touchNext = this.index + 1;
	        var _touchPrev = this.index - 1;
	        if (this.s.loop && this.$slide.length > 2) {
	            if (this.index === 0) {
	                _touchPrev = this.$slide.length - 1;
	            } else if (this.index === this.$slide.length - 1) {
	                _touchNext = 0;
	            }
	        }
	
	        this.$slide.removeClass('lg-next-slide lg-prev-slide');
	        if (_touchPrev > -1) {
	            this.$slide.eq(_touchPrev).addClass('lg-prev-slide');
	        }
	
	        this.$slide.eq(_touchNext).addClass('lg-next-slide');
	    };
	
	    Plugin.prototype.mousewheel = function() {
	        var _this = this;
	        _this.$outer.on('mousewheel.lg', function(e) {
	
	            if (!e.deltaY) {
	                return;
	            }
	
	            if (e.deltaY > 0) {
	                _this.goToPrevSlide();
	            } else {
	                _this.goToNextSlide();
	            }
	
	            e.preventDefault();
	        });
	
	    };
	
	    Plugin.prototype.closeGallery = function() {
	
	        var _this = this;
	        var mousedown = false;
	        this.$outer.find('.lg-close').on('click.lg', function() {
	            _this.destroy();
	        });
	
	        if (_this.s.closable) {
	
	            // If you drag the slide and release outside gallery gets close on chrome
	            // for preventing this check mousedown and mouseup happened on .lg-item or lg-outer
	            _this.$outer.on('mousedown.lg', function(e) {
	
	                if ($(e.target).is('.lg-outer') || $(e.target).is('.lg-item ') || $(e.target).is('.lg-img-wrap')) {
	                    mousedown = true;
	                } else {
	                    mousedown = false;
	                }
	
	            });
	            
	            _this.$outer.on('mousemove.lg', function() {
	                mousedown = false;
	            });
	
	            _this.$outer.on('mouseup.lg', function(e) {
	
	                if ($(e.target).is('.lg-outer') || $(e.target).is('.lg-item ') || $(e.target).is('.lg-img-wrap') && mousedown) {
	                    if (!_this.$outer.hasClass('lg-dragging')) {
	                        _this.destroy();
	                    }
	                }
	
	            });
	
	        }
	
	    };
	
	    Plugin.prototype.destroy = function(d) {
	
	        var _this = this;
	
	        if (!d) {
	            _this.$el.trigger('onBeforeClose.lg');
	            $(window).scrollTop(_this.prevScrollTop);
	        }
	
	
	        /**
	         * if d is false or undefined destroy will only close the gallery
	         * plugins instance remains with the element
	         *
	         * if d is true destroy will completely remove the plugin
	         */
	
	        if (d) {
	            if (!_this.s.dynamic) {
	                // only when not using dynamic mode is $items a jquery collection
	                this.$items.off('click.lg click.lgcustom');
	            }
	
	            $.removeData(_this.el, 'lightGallery');
	        }
	
	        // Unbind all events added by lightGallery
	        this.$el.off('.lg.tm');
	
	        // Distroy all lightGallery modules
	        $.each($.fn.lightGallery.modules, function(key) {
	            if (_this.modules[key]) {
	                _this.modules[key].destroy();
	            }
	        });
	
	        this.lGalleryOn = false;
	
	        clearTimeout(_this.hideBartimeout);
	        this.hideBartimeout = false;
	        $(window).off('.lg');
	        $('body').removeClass('lg-on lg-from-hash');
	
	        if (_this.$outer) {
	            _this.$outer.removeClass('lg-visible');
	        }
	
	        $('.lg-backdrop').removeClass('in');
	
	        setTimeout(function() {
	            if (_this.$outer) {
	                _this.$outer.remove();
	            }
	
	            $('.lg-backdrop').remove();
	
	            if (!d) {
	                _this.$el.trigger('onCloseAfter.lg');
	            }
	
	        }, _this.s.backdropDuration + 50);
	    };
	
	    $.fn.lightGallery = function(options) {
	        return this.each(function() {
	            if (!$.data(this, 'lightGallery')) {
	                $.data(this, 'lightGallery', new Plugin(this, options));
	            } else {
	                try {
	                    $(this).data('lightGallery').init();
	                } catch (err) {
	                    console.error('lightGallery has not initiated properly');
	                }
	            }
	        });
	    };
	
	    $.fn.lightGallery.modules = {};
	
	})();
	
	
	}));


/***/ }),

/***/ 352:
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(__webpack_provided_window_dot_jQuery) {/*! Magnific Popup - v1.1.0 - 2016-02-20
	* http://dimsemenov.com/plugins/magnific-popup/
	* Copyright (c) 2016 Dmitry Semenov; */
	;(function (factory) { 
	if (true) { 
	 // AMD. Register as an anonymous module. 
	 !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(8)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)); 
	 } else if (typeof exports === 'object') { 
	 // Node/CommonJS 
	 factory(require('jquery')); 
	 } else { 
	 // Browser globals 
	 factory(window.jQuery || window.Zepto); 
	 } 
	 }(function($) { 
	
	/*>>core*/
	/**
	 * 
	 * Magnific Popup Core JS file
	 * 
	 */
	
	
	/**
	 * Private static constants
	 */
	var CLOSE_EVENT = 'Close',
		BEFORE_CLOSE_EVENT = 'BeforeClose',
		AFTER_CLOSE_EVENT = 'AfterClose',
		BEFORE_APPEND_EVENT = 'BeforeAppend',
		MARKUP_PARSE_EVENT = 'MarkupParse',
		OPEN_EVENT = 'Open',
		CHANGE_EVENT = 'Change',
		NS = 'mfp',
		EVENT_NS = '.' + NS,
		READY_CLASS = 'mfp-ready',
		REMOVING_CLASS = 'mfp-removing',
		PREVENT_CLOSE_CLASS = 'mfp-prevent-close';
	
	
	/**
	 * Private vars 
	 */
	/*jshint -W079 */
	var mfp, // As we have only one instance of MagnificPopup object, we define it locally to not to use 'this'
		MagnificPopup = function(){},
		_isJQ = !!(__webpack_provided_window_dot_jQuery),
		_prevStatus,
		_window = $(window),
		_document,
		_prevContentType,
		_wrapClasses,
		_currPopupType;
	
	
	/**
	 * Private functions
	 */
	var _mfpOn = function(name, f) {
			mfp.ev.on(NS + name + EVENT_NS, f);
		},
		_getEl = function(className, appendTo, html, raw) {
			var el = document.createElement('div');
			el.className = 'mfp-'+className;
			if(html) {
				el.innerHTML = html;
			}
			if(!raw) {
				el = $(el);
				if(appendTo) {
					el.appendTo(appendTo);
				}
			} else if(appendTo) {
				appendTo.appendChild(el);
			}
			return el;
		},
		_mfpTrigger = function(e, data) {
			mfp.ev.triggerHandler(NS + e, data);
	
			if(mfp.st.callbacks) {
				// converts "mfpEventName" to "eventName" callback and triggers it if it's present
				e = e.charAt(0).toLowerCase() + e.slice(1);
				if(mfp.st.callbacks[e]) {
					mfp.st.callbacks[e].apply(mfp, $.isArray(data) ? data : [data]);
				}
			}
		},
		_getCloseBtn = function(type) {
			if(type !== _currPopupType || !mfp.currTemplate.closeBtn) {
				mfp.currTemplate.closeBtn = $( mfp.st.closeMarkup.replace('%title%', mfp.st.tClose ) );
				_currPopupType = type;
			}
			return mfp.currTemplate.closeBtn;
		},
		// Initialize Magnific Popup only when called at least once
		_checkInstance = function() {
			if(!$.magnificPopup.instance) {
				/*jshint -W020 */
				mfp = new MagnificPopup();
				mfp.init();
				$.magnificPopup.instance = mfp;
			}
		},
		// CSS transition detection, http://stackoverflow.com/questions/7264899/detect-css-transitions-using-javascript-and-without-modernizr
		supportsTransitions = function() {
			var s = document.createElement('p').style, // 's' for style. better to create an element if body yet to exist
				v = ['ms','O','Moz','Webkit']; // 'v' for vendor
	
			if( s['transition'] !== undefined ) {
				return true; 
			}
				
			while( v.length ) {
				if( v.pop() + 'Transition' in s ) {
					return true;
				}
			}
					
			return false;
		};
	
	
	
	/**
	 * Public functions
	 */
	MagnificPopup.prototype = {
	
		constructor: MagnificPopup,
	
		/**
		 * Initializes Magnific Popup plugin. 
		 * This function is triggered only once when $.fn.magnificPopup or $.magnificPopup is executed
		 */
		init: function() {
			var appVersion = navigator.appVersion;
			mfp.isLowIE = mfp.isIE8 = document.all && !document.addEventListener;
			mfp.isAndroid = (/android/gi).test(appVersion);
			mfp.isIOS = (/iphone|ipad|ipod/gi).test(appVersion);
			mfp.supportsTransition = supportsTransitions();
	
			// We disable fixed positioned lightbox on devices that don't handle it nicely.
			// If you know a better way of detecting this - let me know.
			mfp.probablyMobile = (mfp.isAndroid || mfp.isIOS || /(Opera Mini)|Kindle|webOS|BlackBerry|(Opera Mobi)|(Windows Phone)|IEMobile/i.test(navigator.userAgent) );
			_document = $(document);
	
			mfp.popupsCache = {};
		},
	
		/**
		 * Opens popup
		 * @param  data [description]
		 */
		open: function(data) {
	
			var i;
	
			if(data.isObj === false) { 
				// convert jQuery collection to array to avoid conflicts later
				mfp.items = data.items.toArray();
	
				mfp.index = 0;
				var items = data.items,
					item;
				for(i = 0; i < items.length; i++) {
					item = items[i];
					if(item.parsed) {
						item = item.el[0];
					}
					if(item === data.el[0]) {
						mfp.index = i;
						break;
					}
				}
			} else {
				mfp.items = $.isArray(data.items) ? data.items : [data.items];
				mfp.index = data.index || 0;
			}
	
			// if popup is already opened - we just update the content
			if(mfp.isOpen) {
				mfp.updateItemHTML();
				return;
			}
			
			mfp.types = []; 
			_wrapClasses = '';
			if(data.mainEl && data.mainEl.length) {
				mfp.ev = data.mainEl.eq(0);
			} else {
				mfp.ev = _document;
			}
	
			if(data.key) {
				if(!mfp.popupsCache[data.key]) {
					mfp.popupsCache[data.key] = {};
				}
				mfp.currTemplate = mfp.popupsCache[data.key];
			} else {
				mfp.currTemplate = {};
			}
	
	
	
			mfp.st = $.extend(true, {}, $.magnificPopup.defaults, data ); 
			mfp.fixedContentPos = mfp.st.fixedContentPos === 'auto' ? !mfp.probablyMobile : mfp.st.fixedContentPos;
	
			if(mfp.st.modal) {
				mfp.st.closeOnContentClick = false;
				mfp.st.closeOnBgClick = false;
				mfp.st.showCloseBtn = false;
				mfp.st.enableEscapeKey = false;
			}
			
	
			// Building markup
			// main containers are created only once
			if(!mfp.bgOverlay) {
	
				// Dark overlay
				mfp.bgOverlay = _getEl('bg').on('click'+EVENT_NS, function() {
					mfp.close();
				});
	
				mfp.wrap = _getEl('wrap').attr('tabindex', -1).on('click'+EVENT_NS, function(e) {
					if(mfp._checkIfClose(e.target)) {
						mfp.close();
					}
				});
	
				mfp.container = _getEl('container', mfp.wrap);
			}
	
			mfp.contentContainer = _getEl('content');
			if(mfp.st.preloader) {
				mfp.preloader = _getEl('preloader', mfp.container, mfp.st.tLoading);
			}
	
	
			// Initializing modules
			var modules = $.magnificPopup.modules;
			for(i = 0; i < modules.length; i++) {
				var n = modules[i];
				n = n.charAt(0).toUpperCase() + n.slice(1);
				mfp['init'+n].call(mfp);
			}
			_mfpTrigger('BeforeOpen');
	
	
			if(mfp.st.showCloseBtn) {
				// Close button
				if(!mfp.st.closeBtnInside) {
					mfp.wrap.append( _getCloseBtn() );
				} else {
					_mfpOn(MARKUP_PARSE_EVENT, function(e, template, values, item) {
						values.close_replaceWith = _getCloseBtn(item.type);
					});
					_wrapClasses += ' mfp-close-btn-in';
				}
			}
	
			if(mfp.st.alignTop) {
				_wrapClasses += ' mfp-align-top';
			}
	
		
	
			if(mfp.fixedContentPos) {
				mfp.wrap.css({
					overflow: mfp.st.overflowY,
					overflowX: 'hidden',
					overflowY: mfp.st.overflowY
				});
			} else {
				mfp.wrap.css({ 
					top: _window.scrollTop(),
					position: 'absolute'
				});
			}
			if( mfp.st.fixedBgPos === false || (mfp.st.fixedBgPos === 'auto' && !mfp.fixedContentPos) ) {
				mfp.bgOverlay.css({
					height: _document.height(),
					position: 'absolute'
				});
			}
	
			
	
			if(mfp.st.enableEscapeKey) {
				// Close on ESC key
				_document.on('keyup' + EVENT_NS, function(e) {
					if(e.keyCode === 27) {
						mfp.close();
					}
				});
			}
	
			_window.on('resize' + EVENT_NS, function() {
				mfp.updateSize();
			});
	
	
			if(!mfp.st.closeOnContentClick) {
				_wrapClasses += ' mfp-auto-cursor';
			}
			
			if(_wrapClasses)
				mfp.wrap.addClass(_wrapClasses);
	
	
			// this triggers recalculation of layout, so we get it once to not to trigger twice
			var windowHeight = mfp.wH = _window.height();
	
			
			var windowStyles = {};
	
			if( mfp.fixedContentPos ) {
	            if(mfp._hasScrollBar(windowHeight)){
	                var s = mfp._getScrollbarSize();
	                if(s) {
	                    windowStyles.marginRight = s;
	                }
	            }
	        }
	
			if(mfp.fixedContentPos) {
				if(!mfp.isIE7) {
					windowStyles.overflow = 'hidden';
				} else {
					// ie7 double-scroll bug
					$('body, html').css('overflow', 'hidden');
				}
			}
	
			
			
			var classesToadd = mfp.st.mainClass;
			if(mfp.isIE7) {
				classesToadd += ' mfp-ie7';
			}
			if(classesToadd) {
				mfp._addClassToMFP( classesToadd );
			}
	
			// add content
			mfp.updateItemHTML();
	
			_mfpTrigger('BuildControls');
	
			// remove scrollbar, add margin e.t.c
			$('html').css(windowStyles);
			
			// add everything to DOM
			mfp.bgOverlay.add(mfp.wrap).prependTo( mfp.st.prependTo || $(document.body) );
	
			// Save last focused element
			mfp._lastFocusedEl = document.activeElement;
			
			// Wait for next cycle to allow CSS transition
			setTimeout(function() {
				
				if(mfp.content) {
					mfp._addClassToMFP(READY_CLASS);
					mfp._setFocus();
				} else {
					// if content is not defined (not loaded e.t.c) we add class only for BG
					mfp.bgOverlay.addClass(READY_CLASS);
				}
				
				// Trap the focus in popup
				_document.on('focusin' + EVENT_NS, mfp._onFocusIn);
	
			}, 16);
	
			mfp.isOpen = true;
			mfp.updateSize(windowHeight);
			_mfpTrigger(OPEN_EVENT);
	
			return data;
		},
	
		/**
		 * Closes the popup
		 */
		close: function() {
			if(!mfp.isOpen) return;
			_mfpTrigger(BEFORE_CLOSE_EVENT);
	
			mfp.isOpen = false;
			// for CSS3 animation
			if(mfp.st.removalDelay && !mfp.isLowIE && mfp.supportsTransition )  {
				mfp._addClassToMFP(REMOVING_CLASS);
				setTimeout(function() {
					mfp._close();
				}, mfp.st.removalDelay);
			} else {
				mfp._close();
			}
		},
	
		/**
		 * Helper for close() function
		 */
		_close: function() {
			_mfpTrigger(CLOSE_EVENT);
	
			var classesToRemove = REMOVING_CLASS + ' ' + READY_CLASS + ' ';
	
			mfp.bgOverlay.detach();
			mfp.wrap.detach();
			mfp.container.empty();
	
			if(mfp.st.mainClass) {
				classesToRemove += mfp.st.mainClass + ' ';
			}
	
			mfp._removeClassFromMFP(classesToRemove);
	
			if(mfp.fixedContentPos) {
				var windowStyles = {marginRight: ''};
				if(mfp.isIE7) {
					$('body, html').css('overflow', '');
				} else {
					windowStyles.overflow = '';
				}
				$('html').css(windowStyles);
			}
			
			_document.off('keyup' + EVENT_NS + ' focusin' + EVENT_NS);
			mfp.ev.off(EVENT_NS);
	
			// clean up DOM elements that aren't removed
			mfp.wrap.attr('class', 'mfp-wrap').removeAttr('style');
			mfp.bgOverlay.attr('class', 'mfp-bg');
			mfp.container.attr('class', 'mfp-container');
	
			// remove close button from target element
			if(mfp.st.showCloseBtn &&
			(!mfp.st.closeBtnInside || mfp.currTemplate[mfp.currItem.type] === true)) {
				if(mfp.currTemplate.closeBtn)
					mfp.currTemplate.closeBtn.detach();
			}
	
	
			if(mfp.st.autoFocusLast && mfp._lastFocusedEl) {
				$(mfp._lastFocusedEl).focus(); // put tab focus back
			}
			mfp.currItem = null;	
			mfp.content = null;
			mfp.currTemplate = null;
			mfp.prevHeight = 0;
	
			_mfpTrigger(AFTER_CLOSE_EVENT);
		},
		
		updateSize: function(winHeight) {
	
			if(mfp.isIOS) {
				// fixes iOS nav bars https://github.com/dimsemenov/Magnific-Popup/issues/2
				var zoomLevel = document.documentElement.clientWidth / window.innerWidth;
				var height = window.innerHeight * zoomLevel;
				mfp.wrap.css('height', height);
				mfp.wH = height;
			} else {
				mfp.wH = winHeight || _window.height();
			}
			// Fixes #84: popup incorrectly positioned with position:relative on body
			if(!mfp.fixedContentPos) {
				mfp.wrap.css('height', mfp.wH);
			}
	
			_mfpTrigger('Resize');
	
		},
	
		/**
		 * Set content of popup based on current index
		 */
		updateItemHTML: function() {
			var item = mfp.items[mfp.index];
	
			// Detach and perform modifications
			mfp.contentContainer.detach();
	
			if(mfp.content)
				mfp.content.detach();
	
			if(!item.parsed) {
				item = mfp.parseEl( mfp.index );
			}
	
			var type = item.type;
	
			_mfpTrigger('BeforeChange', [mfp.currItem ? mfp.currItem.type : '', type]);
			// BeforeChange event works like so:
			// _mfpOn('BeforeChange', function(e, prevType, newType) { });
	
			mfp.currItem = item;
	
			if(!mfp.currTemplate[type]) {
				var markup = mfp.st[type] ? mfp.st[type].markup : false;
	
				// allows to modify markup
				_mfpTrigger('FirstMarkupParse', markup);
	
				if(markup) {
					mfp.currTemplate[type] = $(markup);
				} else {
					// if there is no markup found we just define that template is parsed
					mfp.currTemplate[type] = true;
				}
			}
	
			if(_prevContentType && _prevContentType !== item.type) {
				mfp.container.removeClass('mfp-'+_prevContentType+'-holder');
			}
	
			var newContent = mfp['get' + type.charAt(0).toUpperCase() + type.slice(1)](item, mfp.currTemplate[type]);
			mfp.appendContent(newContent, type);
	
			item.preloaded = true;
	
			_mfpTrigger(CHANGE_EVENT, item);
			_prevContentType = item.type;
	
			// Append container back after its content changed
			mfp.container.prepend(mfp.contentContainer);
	
			_mfpTrigger('AfterChange');
		},
	
	
		/**
		 * Set HTML content of popup
		 */
		appendContent: function(newContent, type) {
			mfp.content = newContent;
	
			if(newContent) {
				if(mfp.st.showCloseBtn && mfp.st.closeBtnInside &&
					mfp.currTemplate[type] === true) {
					// if there is no markup, we just append close button element inside
					if(!mfp.content.find('.mfp-close').length) {
						mfp.content.append(_getCloseBtn());
					}
				} else {
					mfp.content = newContent;
				}
			} else {
				mfp.content = '';
			}
	
			_mfpTrigger(BEFORE_APPEND_EVENT);
			mfp.container.addClass('mfp-'+type+'-holder');
	
			mfp.contentContainer.append(mfp.content);
		},
	
	
		/**
		 * Creates Magnific Popup data object based on given data
		 * @param  {int} index Index of item to parse
		 */
		parseEl: function(index) {
			var item = mfp.items[index],
				type;
	
			if(item.tagName) {
				item = { el: $(item) };
			} else {
				type = item.type;
				item = { data: item, src: item.src };
			}
	
			if(item.el) {
				var types = mfp.types;
	
				// check for 'mfp-TYPE' class
				for(var i = 0; i < types.length; i++) {
					if( item.el.hasClass('mfp-'+types[i]) ) {
						type = types[i];
						break;
					}
				}
	
				item.src = item.el.attr('data-mfp-src');
				if(!item.src) {
					item.src = item.el.attr('href');
				}
			}
	
			item.type = type || mfp.st.type || 'inline';
			item.index = index;
			item.parsed = true;
			mfp.items[index] = item;
			_mfpTrigger('ElementParse', item);
	
			return mfp.items[index];
		},
	
	
		/**
		 * Initializes single popup or a group of popups
		 */
		addGroup: function(el, options) {
			var eHandler = function(e) {
				e.mfpEl = this;
				mfp._openClick(e, el, options);
			};
	
			if(!options) {
				options = {};
			}
	
			var eName = 'click.magnificPopup';
			options.mainEl = el;
	
			if(options.items) {
				options.isObj = true;
				el.off(eName).on(eName, eHandler);
			} else {
				options.isObj = false;
				if(options.delegate) {
					el.off(eName).on(eName, options.delegate , eHandler);
				} else {
					options.items = el;
					el.off(eName).on(eName, eHandler);
				}
			}
		},
		_openClick: function(e, el, options) {
			var midClick = options.midClick !== undefined ? options.midClick : $.magnificPopup.defaults.midClick;
	
	
			if(!midClick && ( e.which === 2 || e.ctrlKey || e.metaKey || e.altKey || e.shiftKey ) ) {
				return;
			}
	
			var disableOn = options.disableOn !== undefined ? options.disableOn : $.magnificPopup.defaults.disableOn;
	
			if(disableOn) {
				if($.isFunction(disableOn)) {
					if( !disableOn.call(mfp) ) {
						return true;
					}
				} else { // else it's number
					if( _window.width() < disableOn ) {
						return true;
					}
				}
			}
	
			if(e.type) {
				e.preventDefault();
	
				// This will prevent popup from closing if element is inside and popup is already opened
				if(mfp.isOpen) {
					e.stopPropagation();
				}
			}
	
			options.el = $(e.mfpEl);
			if(options.delegate) {
				options.items = el.find(options.delegate);
			}
			mfp.open(options);
		},
	
	
		/**
		 * Updates text on preloader
		 */
		updateStatus: function(status, text) {
	
			if(mfp.preloader) {
				if(_prevStatus !== status) {
					mfp.container.removeClass('mfp-s-'+_prevStatus);
				}
	
				if(!text && status === 'loading') {
					text = mfp.st.tLoading;
				}
	
				var data = {
					status: status,
					text: text
				};
				// allows to modify status
				_mfpTrigger('UpdateStatus', data);
	
				status = data.status;
				text = data.text;
	
				mfp.preloader.html(text);
	
				mfp.preloader.find('a').on('click', function(e) {
					e.stopImmediatePropagation();
				});
	
				mfp.container.addClass('mfp-s-'+status);
				_prevStatus = status;
			}
		},
	
	
		/*
			"Private" helpers that aren't private at all
		 */
		// Check to close popup or not
		// "target" is an element that was clicked
		_checkIfClose: function(target) {
	
			if($(target).hasClass(PREVENT_CLOSE_CLASS)) {
				return;
			}
	
			var closeOnContent = mfp.st.closeOnContentClick;
			var closeOnBg = mfp.st.closeOnBgClick;
	
			if(closeOnContent && closeOnBg) {
				return true;
			} else {
	
				// We close the popup if click is on close button or on preloader. Or if there is no content.
				if(!mfp.content || $(target).hasClass('mfp-close') || (mfp.preloader && target === mfp.preloader[0]) ) {
					return true;
				}
	
				// if click is outside the content
				if(  (target !== mfp.content[0] && !$.contains(mfp.content[0], target))  ) {
					if(closeOnBg) {
						// last check, if the clicked element is in DOM, (in case it's removed onclick)
						if( $.contains(document, target) ) {
							return true;
						}
					}
				} else if(closeOnContent) {
					return true;
				}
	
			}
			return false;
		},
		_addClassToMFP: function(cName) {
			mfp.bgOverlay.addClass(cName);
			mfp.wrap.addClass(cName);
		},
		_removeClassFromMFP: function(cName) {
			this.bgOverlay.removeClass(cName);
			mfp.wrap.removeClass(cName);
		},
		_hasScrollBar: function(winHeight) {
			return (  (mfp.isIE7 ? _document.height() : document.body.scrollHeight) > (winHeight || _window.height()) );
		},
		_setFocus: function() {
			(mfp.st.focus ? mfp.content.find(mfp.st.focus).eq(0) : mfp.wrap).focus();
		},
		_onFocusIn: function(e) {
			if( e.target !== mfp.wrap[0] && !$.contains(mfp.wrap[0], e.target) ) {
				mfp._setFocus();
				return false;
			}
		},
		_parseMarkup: function(template, values, item) {
			var arr;
			if(item.data) {
				values = $.extend(item.data, values);
			}
			_mfpTrigger(MARKUP_PARSE_EVENT, [template, values, item] );
	
			$.each(values, function(key, value) {
				if(value === undefined || value === false) {
					return true;
				}
				arr = key.split('_');
				if(arr.length > 1) {
					var el = template.find(EVENT_NS + '-'+arr[0]);
	
					if(el.length > 0) {
						var attr = arr[1];
						if(attr === 'replaceWith') {
							if(el[0] !== value[0]) {
								el.replaceWith(value);
							}
						} else if(attr === 'img') {
							if(el.is('img')) {
								el.attr('src', value);
							} else {
								el.replaceWith( $('<img>').attr('src', value).attr('class', el.attr('class')) );
							}
						} else {
							el.attr(arr[1], value);
						}
					}
	
				} else {
					template.find(EVENT_NS + '-'+key).html(value);
				}
			});
		},
	
		_getScrollbarSize: function() {
			// thx David
			if(mfp.scrollbarSize === undefined) {
				var scrollDiv = document.createElement("div");
				scrollDiv.style.cssText = 'width: 99px; height: 99px; overflow: scroll; position: absolute; top: -9999px;';
				document.body.appendChild(scrollDiv);
				mfp.scrollbarSize = scrollDiv.offsetWidth - scrollDiv.clientWidth;
				document.body.removeChild(scrollDiv);
			}
			return mfp.scrollbarSize;
		}
	
	}; /* MagnificPopup core prototype end */
	
	
	
	
	/**
	 * Public static functions
	 */
	$.magnificPopup = {
		instance: null,
		proto: MagnificPopup.prototype,
		modules: [],
	
		open: function(options, index) {
			_checkInstance();
	
			if(!options) {
				options = {};
			} else {
				options = $.extend(true, {}, options);
			}
	
			options.isObj = true;
			options.index = index || 0;
			return this.instance.open(options);
		},
	
		close: function() {
			return $.magnificPopup.instance && $.magnificPopup.instance.close();
		},
	
		registerModule: function(name, module) {
			if(module.options) {
				$.magnificPopup.defaults[name] = module.options;
			}
			$.extend(this.proto, module.proto);
			this.modules.push(name);
		},
	
		defaults: {
	
			// Info about options is in docs:
			// http://dimsemenov.com/plugins/magnific-popup/documentation.html#options
	
			disableOn: 0,
	
			key: null,
	
			midClick: false,
	
			mainClass: '',
	
			preloader: true,
	
			focus: '', // CSS selector of input to focus after popup is opened
	
			closeOnContentClick: false,
	
			closeOnBgClick: true,
	
			closeBtnInside: true,
	
			showCloseBtn: true,
	
			enableEscapeKey: true,
	
			modal: false,
	
			alignTop: false,
	
			removalDelay: 0,
	
			prependTo: null,
	
			fixedContentPos: 'auto',
	
			fixedBgPos: 'auto',
	
			overflowY: 'auto',
	
			closeMarkup: '<button title="%title%" type="button" class="mfp-close">&#215;</button>',
	
			tClose: 'Close (Esc)',
	
			tLoading: 'Loading...',
	
			autoFocusLast: true
	
		}
	};
	
	
	
	$.fn.magnificPopup = function(options) {
		_checkInstance();
	
		var jqEl = $(this);
	
		// We call some API method of first param is a string
		if (typeof options === "string" ) {
	
			if(options === 'open') {
				var items,
					itemOpts = _isJQ ? jqEl.data('magnificPopup') : jqEl[0].magnificPopup,
					index = parseInt(arguments[1], 10) || 0;
	
				if(itemOpts.items) {
					items = itemOpts.items[index];
				} else {
					items = jqEl;
					if(itemOpts.delegate) {
						items = items.find(itemOpts.delegate);
					}
					items = items.eq( index );
				}
				mfp._openClick({mfpEl:items}, jqEl, itemOpts);
			} else {
				if(mfp.isOpen)
					mfp[options].apply(mfp, Array.prototype.slice.call(arguments, 1));
			}
	
		} else {
			// clone options obj
			options = $.extend(true, {}, options);
	
			/*
			 * As Zepto doesn't support .data() method for objects
			 * and it works only in normal browsers
			 * we assign "options" object directly to the DOM element. FTW!
			 */
			if(_isJQ) {
				jqEl.data('magnificPopup', options);
			} else {
				jqEl[0].magnificPopup = options;
			}
	
			mfp.addGroup(jqEl, options);
	
		}
		return jqEl;
	};
	
	/*>>core*/
	
	/*>>inline*/
	
	var INLINE_NS = 'inline',
		_hiddenClass,
		_inlinePlaceholder,
		_lastInlineElement,
		_putInlineElementsBack = function() {
			if(_lastInlineElement) {
				_inlinePlaceholder.after( _lastInlineElement.addClass(_hiddenClass) ).detach();
				_lastInlineElement = null;
			}
		};
	
	$.magnificPopup.registerModule(INLINE_NS, {
		options: {
			hiddenClass: 'hide', // will be appended with `mfp-` prefix
			markup: '',
			tNotFound: 'Content not found'
		},
		proto: {
	
			initInline: function() {
				mfp.types.push(INLINE_NS);
	
				_mfpOn(CLOSE_EVENT+'.'+INLINE_NS, function() {
					_putInlineElementsBack();
				});
			},
	
			getInline: function(item, template) {
	
				_putInlineElementsBack();
	
				if(item.src) {
					var inlineSt = mfp.st.inline,
						el = $(item.src);
	
					if(el.length) {
	
						// If target element has parent - we replace it with placeholder and put it back after popup is closed
						var parent = el[0].parentNode;
						if(parent && parent.tagName) {
							if(!_inlinePlaceholder) {
								_hiddenClass = inlineSt.hiddenClass;
								_inlinePlaceholder = _getEl(_hiddenClass);
								_hiddenClass = 'mfp-'+_hiddenClass;
							}
							// replace target inline element with placeholder
							_lastInlineElement = el.after(_inlinePlaceholder).detach().removeClass(_hiddenClass);
						}
	
						mfp.updateStatus('ready');
					} else {
						mfp.updateStatus('error', inlineSt.tNotFound);
						el = $('<div>');
					}
	
					item.inlineElement = el;
					return el;
				}
	
				mfp.updateStatus('ready');
				mfp._parseMarkup(template, {}, item);
				return template;
			}
		}
	});
	
	/*>>inline*/
	
	/*>>ajax*/
	var AJAX_NS = 'ajax',
		_ajaxCur,
		_removeAjaxCursor = function() {
			if(_ajaxCur) {
				$(document.body).removeClass(_ajaxCur);
			}
		},
		_destroyAjaxRequest = function() {
			_removeAjaxCursor();
			if(mfp.req) {
				mfp.req.abort();
			}
		};
	
	$.magnificPopup.registerModule(AJAX_NS, {
	
		options: {
			settings: null,
			cursor: 'mfp-ajax-cur',
			tError: '<a href="%url%">The content</a> could not be loaded.'
		},
	
		proto: {
			initAjax: function() {
				mfp.types.push(AJAX_NS);
				_ajaxCur = mfp.st.ajax.cursor;
	
				_mfpOn(CLOSE_EVENT+'.'+AJAX_NS, _destroyAjaxRequest);
				_mfpOn('BeforeChange.' + AJAX_NS, _destroyAjaxRequest);
			},
			getAjax: function(item) {
	
				if(_ajaxCur) {
					$(document.body).addClass(_ajaxCur);
				}
	
				mfp.updateStatus('loading');
	
				var opts = $.extend({
					url: item.src,
					success: function(data, textStatus, jqXHR) {
						var temp = {
							data:data,
							xhr:jqXHR
						};
	
						_mfpTrigger('ParseAjax', temp);
	
						mfp.appendContent( $(temp.data), AJAX_NS );
	
						item.finished = true;
	
						_removeAjaxCursor();
	
						mfp._setFocus();
	
						setTimeout(function() {
							mfp.wrap.addClass(READY_CLASS);
						}, 16);
	
						mfp.updateStatus('ready');
	
						_mfpTrigger('AjaxContentAdded');
					},
					error: function() {
						_removeAjaxCursor();
						item.finished = item.loadError = true;
						mfp.updateStatus('error', mfp.st.ajax.tError.replace('%url%', item.src));
					}
				}, mfp.st.ajax.settings);
	
				mfp.req = $.ajax(opts);
	
				return '';
			}
		}
	});
	
	/*>>ajax*/
	
	/*>>image*/
	var _imgInterval,
		_getTitle = function(item) {
			if(item.data && item.data.title !== undefined)
				return item.data.title;
	
			var src = mfp.st.image.titleSrc;
	
			if(src) {
				if($.isFunction(src)) {
					return src.call(mfp, item);
				} else if(item.el) {
					return item.el.attr(src) || '';
				}
			}
			return '';
		};
	
	$.magnificPopup.registerModule('image', {
	
		options: {
			markup: '<div class="mfp-figure">'+
						'<div class="mfp-close"></div>'+
						'<figure>'+
							'<div class="mfp-img"></div>'+
							'<figcaption>'+
								'<div class="mfp-bottom-bar">'+
									'<div class="mfp-title"></div>'+
									'<div class="mfp-counter"></div>'+
								'</div>'+
							'</figcaption>'+
						'</figure>'+
					'</div>',
			cursor: 'mfp-zoom-out-cur',
			titleSrc: 'title',
			verticalFit: true,
			tError: '<a href="%url%">The image</a> could not be loaded.'
		},
	
		proto: {
			initImage: function() {
				var imgSt = mfp.st.image,
					ns = '.image';
	
				mfp.types.push('image');
	
				_mfpOn(OPEN_EVENT+ns, function() {
					if(mfp.currItem.type === 'image' && imgSt.cursor) {
						$(document.body).addClass(imgSt.cursor);
					}
				});
	
				_mfpOn(CLOSE_EVENT+ns, function() {
					if(imgSt.cursor) {
						$(document.body).removeClass(imgSt.cursor);
					}
					_window.off('resize' + EVENT_NS);
				});
	
				_mfpOn('Resize'+ns, mfp.resizeImage);
				if(mfp.isLowIE) {
					_mfpOn('AfterChange', mfp.resizeImage);
				}
			},
			resizeImage: function() {
				var item = mfp.currItem;
				if(!item || !item.img) return;
	
				if(mfp.st.image.verticalFit) {
					var decr = 0;
					// fix box-sizing in ie7/8
					if(mfp.isLowIE) {
						decr = parseInt(item.img.css('padding-top'), 10) + parseInt(item.img.css('padding-bottom'),10);
					}
					item.img.css('max-height', mfp.wH-decr);
				}
			},
			_onImageHasSize: function(item) {
				if(item.img) {
	
					item.hasSize = true;
	
					if(_imgInterval) {
						clearInterval(_imgInterval);
					}
	
					item.isCheckingImgSize = false;
	
					_mfpTrigger('ImageHasSize', item);
	
					if(item.imgHidden) {
						if(mfp.content)
							mfp.content.removeClass('mfp-loading');
	
						item.imgHidden = false;
					}
	
				}
			},
	
			/**
			 * Function that loops until the image has size to display elements that rely on it asap
			 */
			findImageSize: function(item) {
	
				var counter = 0,
					img = item.img[0],
					mfpSetInterval = function(delay) {
	
						if(_imgInterval) {
							clearInterval(_imgInterval);
						}
						// decelerating interval that checks for size of an image
						_imgInterval = setInterval(function() {
							if(img.naturalWidth > 0) {
								mfp._onImageHasSize(item);
								return;
							}
	
							if(counter > 200) {
								clearInterval(_imgInterval);
							}
	
							counter++;
							if(counter === 3) {
								mfpSetInterval(10);
							} else if(counter === 40) {
								mfpSetInterval(50);
							} else if(counter === 100) {
								mfpSetInterval(500);
							}
						}, delay);
					};
	
				mfpSetInterval(1);
			},
	
			getImage: function(item, template) {
	
				var guard = 0,
	
					// image load complete handler
					onLoadComplete = function() {
						if(item) {
							if (item.img[0].complete) {
								item.img.off('.mfploader');
	
								if(item === mfp.currItem){
									mfp._onImageHasSize(item);
	
									mfp.updateStatus('ready');
								}
	
								item.hasSize = true;
								item.loaded = true;
	
								_mfpTrigger('ImageLoadComplete');
	
							}
							else {
								// if image complete check fails 200 times (20 sec), we assume that there was an error.
								guard++;
								if(guard < 200) {
									setTimeout(onLoadComplete,100);
								} else {
									onLoadError();
								}
							}
						}
					},
	
					// image error handler
					onLoadError = function() {
						if(item) {
							item.img.off('.mfploader');
							if(item === mfp.currItem){
								mfp._onImageHasSize(item);
								mfp.updateStatus('error', imgSt.tError.replace('%url%', item.src) );
							}
	
							item.hasSize = true;
							item.loaded = true;
							item.loadError = true;
						}
					},
					imgSt = mfp.st.image;
	
	
				var el = template.find('.mfp-img');
				if(el.length) {
					var img = document.createElement('img');
					img.className = 'mfp-img';
					if(item.el && item.el.find('img').length) {
						img.alt = item.el.find('img').attr('alt');
					}
					item.img = $(img).on('load.mfploader', onLoadComplete).on('error.mfploader', onLoadError);
					img.src = item.src;
	
					// without clone() "error" event is not firing when IMG is replaced by new IMG
					// TODO: find a way to avoid such cloning
					if(el.is('img')) {
						item.img = item.img.clone();
					}
	
					img = item.img[0];
					if(img.naturalWidth > 0) {
						item.hasSize = true;
					} else if(!img.width) {
						item.hasSize = false;
					}
				}
	
				mfp._parseMarkup(template, {
					title: _getTitle(item),
					img_replaceWith: item.img
				}, item);
	
				mfp.resizeImage();
	
				if(item.hasSize) {
					if(_imgInterval) clearInterval(_imgInterval);
	
					if(item.loadError) {
						template.addClass('mfp-loading');
						mfp.updateStatus('error', imgSt.tError.replace('%url%', item.src) );
					} else {
						template.removeClass('mfp-loading');
						mfp.updateStatus('ready');
					}
					return template;
				}
	
				mfp.updateStatus('loading');
				item.loading = true;
	
				if(!item.hasSize) {
					item.imgHidden = true;
					template.addClass('mfp-loading');
					mfp.findImageSize(item);
				}
	
				return template;
			}
		}
	});
	
	/*>>image*/
	
	/*>>zoom*/
	var hasMozTransform,
		getHasMozTransform = function() {
			if(hasMozTransform === undefined) {
				hasMozTransform = document.createElement('p').style.MozTransform !== undefined;
			}
			return hasMozTransform;
		};
	
	$.magnificPopup.registerModule('zoom', {
	
		options: {
			enabled: false,
			easing: 'ease-in-out',
			duration: 300,
			opener: function(element) {
				return element.is('img') ? element : element.find('img');
			}
		},
	
		proto: {
	
			initZoom: function() {
				var zoomSt = mfp.st.zoom,
					ns = '.zoom',
					image;
	
				if(!zoomSt.enabled || !mfp.supportsTransition) {
					return;
				}
	
				var duration = zoomSt.duration,
					getElToAnimate = function(image) {
						var newImg = image.clone().removeAttr('style').removeAttr('class').addClass('mfp-animated-image'),
							transition = 'all '+(zoomSt.duration/1000)+'s ' + zoomSt.easing,
							cssObj = {
								position: 'fixed',
								zIndex: 9999,
								left: 0,
								top: 0,
								'-webkit-backface-visibility': 'hidden'
							},
							t = 'transition';
	
						cssObj['-webkit-'+t] = cssObj['-moz-'+t] = cssObj['-o-'+t] = cssObj[t] = transition;
	
						newImg.css(cssObj);
						return newImg;
					},
					showMainContent = function() {
						mfp.content.css('visibility', 'visible');
					},
					openTimeout,
					animatedImg;
	
				_mfpOn('BuildControls'+ns, function() {
					if(mfp._allowZoom()) {
	
						clearTimeout(openTimeout);
						mfp.content.css('visibility', 'hidden');
	
						// Basically, all code below does is clones existing image, puts in on top of the current one and animated it
	
						image = mfp._getItemToZoom();
	
						if(!image) {
							showMainContent();
							return;
						}
	
						animatedImg = getElToAnimate(image);
	
						animatedImg.css( mfp._getOffset() );
	
						mfp.wrap.append(animatedImg);
	
						openTimeout = setTimeout(function() {
							animatedImg.css( mfp._getOffset( true ) );
							openTimeout = setTimeout(function() {
	
								showMainContent();
	
								setTimeout(function() {
									animatedImg.remove();
									image = animatedImg = null;
									_mfpTrigger('ZoomAnimationEnded');
								}, 16); // avoid blink when switching images
	
							}, duration); // this timeout equals animation duration
	
						}, 16); // by adding this timeout we avoid short glitch at the beginning of animation
	
	
						// Lots of timeouts...
					}
				});
				_mfpOn(BEFORE_CLOSE_EVENT+ns, function() {
					if(mfp._allowZoom()) {
	
						clearTimeout(openTimeout);
	
						mfp.st.removalDelay = duration;
	
						if(!image) {
							image = mfp._getItemToZoom();
							if(!image) {
								return;
							}
							animatedImg = getElToAnimate(image);
						}
	
						animatedImg.css( mfp._getOffset(true) );
						mfp.wrap.append(animatedImg);
						mfp.content.css('visibility', 'hidden');
	
						setTimeout(function() {
							animatedImg.css( mfp._getOffset() );
						}, 16);
					}
	
				});
	
				_mfpOn(CLOSE_EVENT+ns, function() {
					if(mfp._allowZoom()) {
						showMainContent();
						if(animatedImg) {
							animatedImg.remove();
						}
						image = null;
					}
				});
			},
	
			_allowZoom: function() {
				return mfp.currItem.type === 'image';
			},
	
			_getItemToZoom: function() {
				if(mfp.currItem.hasSize) {
					return mfp.currItem.img;
				} else {
					return false;
				}
			},
	
			// Get element postion relative to viewport
			_getOffset: function(isLarge) {
				var el;
				if(isLarge) {
					el = mfp.currItem.img;
				} else {
					el = mfp.st.zoom.opener(mfp.currItem.el || mfp.currItem);
				}
	
				var offset = el.offset();
				var paddingTop = parseInt(el.css('padding-top'),10);
				var paddingBottom = parseInt(el.css('padding-bottom'),10);
				offset.top -= ( $(window).scrollTop() - paddingTop );
	
	
				/*
	
				Animating left + top + width/height looks glitchy in Firefox, but perfect in Chrome. And vice-versa.
	
				 */
				var obj = {
					width: el.width(),
					// fix Zepto height+padding issue
					height: (_isJQ ? el.innerHeight() : el[0].offsetHeight) - paddingBottom - paddingTop
				};
	
				// I hate to do this, but there is no another option
				if( getHasMozTransform() ) {
					obj['-moz-transform'] = obj['transform'] = 'translate(' + offset.left + 'px,' + offset.top + 'px)';
				} else {
					obj.left = offset.left;
					obj.top = offset.top;
				}
				return obj;
			}
	
		}
	});
	
	
	
	/*>>zoom*/
	
	/*>>iframe*/
	
	var IFRAME_NS = 'iframe',
		_emptyPage = '//about:blank',
	
		_fixIframeBugs = function(isShowing) {
			if(mfp.currTemplate[IFRAME_NS]) {
				var el = mfp.currTemplate[IFRAME_NS].find('iframe');
				if(el.length) {
					// reset src after the popup is closed to avoid "video keeps playing after popup is closed" bug
					if(!isShowing) {
						el[0].src = _emptyPage;
					}
	
					// IE8 black screen bug fix
					if(mfp.isIE8) {
						el.css('display', isShowing ? 'block' : 'none');
					}
				}
			}
		};
	
	$.magnificPopup.registerModule(IFRAME_NS, {
	
		options: {
			markup: '<div class="mfp-iframe-scaler">'+
						'<div class="mfp-close"></div>'+
						'<iframe class="mfp-iframe" src="//about:blank" frameborder="0" allowfullscreen></iframe>'+
					'</div>',
	
			srcAction: 'iframe_src',
	
			// we don't care and support only one default type of URL by default
			patterns: {
				youtube: {
					index: 'youtube.com',
					id: 'v=',
					src: '//www.youtube.com/embed/%id%?autoplay=1'
				},
				vimeo: {
					index: 'vimeo.com/',
					id: '/',
					src: '//player.vimeo.com/video/%id%?autoplay=1'
				},
				gmaps: {
					index: '//maps.google.',
					src: '%id%&output=embed'
				}
			}
		},
	
		proto: {
			initIframe: function() {
				mfp.types.push(IFRAME_NS);
	
				_mfpOn('BeforeChange', function(e, prevType, newType) {
					if(prevType !== newType) {
						if(prevType === IFRAME_NS) {
							_fixIframeBugs(); // iframe if removed
						} else if(newType === IFRAME_NS) {
							_fixIframeBugs(true); // iframe is showing
						}
					}// else {
						// iframe source is switched, don't do anything
					//}
				});
	
				_mfpOn(CLOSE_EVENT + '.' + IFRAME_NS, function() {
					_fixIframeBugs();
				});
			},
	
			getIframe: function(item, template) {
				var embedSrc = item.src;
				var iframeSt = mfp.st.iframe;
	
				$.each(iframeSt.patterns, function() {
					if(embedSrc.indexOf( this.index ) > -1) {
						if(this.id) {
							if(typeof this.id === 'string') {
								embedSrc = embedSrc.substr(embedSrc.lastIndexOf(this.id)+this.id.length, embedSrc.length);
							} else {
								embedSrc = this.id.call( this, embedSrc );
							}
						}
						embedSrc = this.src.replace('%id%', embedSrc );
						return false; // break;
					}
				});
	
				var dataObj = {};
				if(iframeSt.srcAction) {
					dataObj[iframeSt.srcAction] = embedSrc;
				}
				mfp._parseMarkup(template, dataObj, item);
	
				mfp.updateStatus('ready');
	
				return template;
			}
		}
	});
	
	
	
	/*>>iframe*/
	
	/*>>gallery*/
	/**
	 * Get looped index depending on number of slides
	 */
	var _getLoopedId = function(index) {
			var numSlides = mfp.items.length;
			if(index > numSlides - 1) {
				return index - numSlides;
			} else  if(index < 0) {
				return numSlides + index;
			}
			return index;
		},
		_replaceCurrTotal = function(text, curr, total) {
			return text.replace(/%curr%/gi, curr + 1).replace(/%total%/gi, total);
		};
	
	$.magnificPopup.registerModule('gallery', {
	
		options: {
			enabled: false,
			arrowMarkup: '<button title="%title%" type="button" class="mfp-arrow mfp-arrow-%dir%"></button>',
			preload: [0,2],
			navigateByImgClick: true,
			arrows: true,
	
			tPrev: 'Previous (Left arrow key)',
			tNext: 'Next (Right arrow key)',
			tCounter: '%curr% of %total%'
		},
	
		proto: {
			initGallery: function() {
	
				var gSt = mfp.st.gallery,
					ns = '.mfp-gallery';
	
				mfp.direction = true; // true - next, false - prev
	
				if(!gSt || !gSt.enabled ) return false;
	
				_wrapClasses += ' mfp-gallery';
	
				_mfpOn(OPEN_EVENT+ns, function() {
	
					if(gSt.navigateByImgClick) {
						mfp.wrap.on('click'+ns, '.mfp-img', function() {
							if(mfp.items.length > 1) {
								mfp.next();
								return false;
							}
						});
					}
	
					_document.on('keydown'+ns, function(e) {
						if (e.keyCode === 37) {
							mfp.prev();
						} else if (e.keyCode === 39) {
							mfp.next();
						}
					});
				});
	
				_mfpOn('UpdateStatus'+ns, function(e, data) {
					if(data.text) {
						data.text = _replaceCurrTotal(data.text, mfp.currItem.index, mfp.items.length);
					}
				});
	
				_mfpOn(MARKUP_PARSE_EVENT+ns, function(e, element, values, item) {
					var l = mfp.items.length;
					values.counter = l > 1 ? _replaceCurrTotal(gSt.tCounter, item.index, l) : '';
				});
	
				_mfpOn('BuildControls' + ns, function() {
					if(mfp.items.length > 1 && gSt.arrows && !mfp.arrowLeft) {
						var markup = gSt.arrowMarkup,
							arrowLeft = mfp.arrowLeft = $( markup.replace(/%title%/gi, gSt.tPrev).replace(/%dir%/gi, 'left') ).addClass(PREVENT_CLOSE_CLASS),
							arrowRight = mfp.arrowRight = $( markup.replace(/%title%/gi, gSt.tNext).replace(/%dir%/gi, 'right') ).addClass(PREVENT_CLOSE_CLASS);
	
						arrowLeft.click(function() {
							mfp.prev();
						});
						arrowRight.click(function() {
							mfp.next();
						});
	
						mfp.container.append(arrowLeft.add(arrowRight));
					}
				});
	
				_mfpOn(CHANGE_EVENT+ns, function() {
					if(mfp._preloadTimeout) clearTimeout(mfp._preloadTimeout);
	
					mfp._preloadTimeout = setTimeout(function() {
						mfp.preloadNearbyImages();
						mfp._preloadTimeout = null;
					}, 16);
				});
	
	
				_mfpOn(CLOSE_EVENT+ns, function() {
					_document.off(ns);
					mfp.wrap.off('click'+ns);
					mfp.arrowRight = mfp.arrowLeft = null;
				});
	
			},
			next: function() {
				mfp.direction = true;
				mfp.index = _getLoopedId(mfp.index + 1);
				mfp.updateItemHTML();
			},
			prev: function() {
				mfp.direction = false;
				mfp.index = _getLoopedId(mfp.index - 1);
				mfp.updateItemHTML();
			},
			goTo: function(newIndex) {
				mfp.direction = (newIndex >= mfp.index);
				mfp.index = newIndex;
				mfp.updateItemHTML();
			},
			preloadNearbyImages: function() {
				var p = mfp.st.gallery.preload,
					preloadBefore = Math.min(p[0], mfp.items.length),
					preloadAfter = Math.min(p[1], mfp.items.length),
					i;
	
				for(i = 1; i <= (mfp.direction ? preloadAfter : preloadBefore); i++) {
					mfp._preloadItem(mfp.index+i);
				}
				for(i = 1; i <= (mfp.direction ? preloadBefore : preloadAfter); i++) {
					mfp._preloadItem(mfp.index-i);
				}
			},
			_preloadItem: function(index) {
				index = _getLoopedId(index);
	
				if(mfp.items[index].preloaded) {
					return;
				}
	
				var item = mfp.items[index];
				if(!item.parsed) {
					item = mfp.parseEl( index );
				}
	
				_mfpTrigger('LazyLoad', item);
	
				if(item.type === 'image') {
					item.img = $('<img class="mfp-img" />').on('load.mfploader', function() {
						item.hasSize = true;
					}).on('error.mfploader', function() {
						item.hasSize = true;
						item.loadError = true;
						_mfpTrigger('LazyLoadError', item);
					}).attr('src', item.src);
				}
	
	
				item.preloaded = true;
			}
		}
	});
	
	/*>>gallery*/
	
	/*>>retina*/
	
	var RETINA_NS = 'retina';
	
	$.magnificPopup.registerModule(RETINA_NS, {
		options: {
			replaceSrc: function(item) {
				return item.src.replace(/\.\w+$/, function(m) { return '@2x' + m; });
			},
			ratio: 1 // Function or number.  Set to 1 to disable.
		},
		proto: {
			initRetina: function() {
				if(window.devicePixelRatio > 1) {
	
					var st = mfp.st.retina,
						ratio = st.ratio;
	
					ratio = !isNaN(ratio) ? ratio : ratio();
	
					if(ratio > 1) {
						_mfpOn('ImageHasSize' + '.' + RETINA_NS, function(e, item) {
							item.img.css({
								'max-width': item.img[0].naturalWidth / ratio,
								'width': '100%'
							});
						});
						_mfpOn('ElementParse' + '.' + RETINA_NS, function(e, item) {
							item.src = st.replaceSrc(item, ratio);
						});
					}
				}
	
			}
		}
	});
	
	/*>>retina*/
	 _checkInstance(); }));
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(8)))

/***/ }),

/***/ 953:
/***/ (function(module, exports, __webpack_require__) {

	/*!
	 * sweetalert2 v6.11.5
	 * Released under the MIT License.
	 */
	(function (global, factory) {
		 true ? module.exports = factory() :
		typeof define === 'function' && define.amd ? define(factory) :
		(global.Sweetalert2 = factory());
	}(this, (function () { 'use strict';
	
	var defaultParams = {
	  title: '',
	  titleText: '',
	  text: '',
	  html: '',
	  type: null,
	  customClass: '',
	  target: 'body',
	  animation: true,
	  allowOutsideClick: true,
	  allowEscapeKey: true,
	  allowEnterKey: true,
	  showConfirmButton: true,
	  showCancelButton: false,
	  preConfirm: null,
	  confirmButtonText: 'OK',
	  confirmButtonAriaLabel: '',
	  confirmButtonColor: '#3085d6',
	  confirmButtonClass: null,
	  cancelButtonText: 'Cancel',
	  cancelButtonAriaLabel: '',
	  cancelButtonColor: '#aaa',
	  cancelButtonClass: null,
	  buttonsStyling: true,
	  reverseButtons: false,
	  focusConfirm: true,
	  focusCancel: false,
	  showCloseButton: false,
	  closeButtonAriaLabel: 'Close this dialog',
	  showLoaderOnConfirm: false,
	  imageUrl: null,
	  imageWidth: null,
	  imageHeight: null,
	  imageAlt: '',
	  imageClass: null,
	  timer: null,
	  width: 500,
	  padding: 20,
	  background: '#fff',
	  input: null,
	  inputPlaceholder: '',
	  inputValue: '',
	  inputOptions: {},
	  inputAutoTrim: true,
	  inputClass: null,
	  inputAttributes: {},
	  inputValidator: null,
	  grow: false,
	  position: 'center',
	  progressSteps: [],
	  currentProgressStep: null,
	  progressStepsDistance: '40px',
	  onBeforeOpen: null,
	  onOpen: null,
	  onClose: null,
	  useRejections: true
	};
	
	var swalPrefix = 'swal2-';
	
	var prefix = function prefix(items) {
	  var result = {};
	  for (var i in items) {
	    result[items[i]] = swalPrefix + items[i];
	  }
	  return result;
	};
	
	var swalClasses = prefix(['container', 'shown', 'iosfix', 'modal', 'overlay', 'fade', 'show', 'hide', 'noanimation', 'close', 'title', 'content', 'buttonswrapper', 'confirm', 'cancel', 'icon', 'image', 'input', 'file', 'range', 'select', 'radio', 'checkbox', 'textarea', 'inputerror', 'validationerror', 'progresssteps', 'activeprogressstep', 'progresscircle', 'progressline', 'loading', 'styled', 'top', 'top-left', 'top-right', 'center', 'center-left', 'center-right', 'bottom', 'bottom-left', 'bottom-right', 'grow-row', 'grow-column', 'grow-fullscreen']);
	
	var iconTypes = prefix(['success', 'warning', 'info', 'question', 'error']);
	
	var consolePrefix = 'SweetAlert2:';
	
	/*
	 * Set hover, active and focus-states for buttons (source: http://www.sitepoint.com/javascript-generate-lighter-darker-color)
	 */
	var colorLuminance = function colorLuminance(hex, lum) {
	  // Validate hex string
	  hex = String(hex).replace(/[^0-9a-f]/gi, '');
	  if (hex.length < 6) {
	    hex = hex[0] + hex[0] + hex[1] + hex[1] + hex[2] + hex[2];
	  }
	  lum = lum || 0;
	
	  // Convert to decimal and change luminosity
	  var rgb = '#';
	  for (var i = 0; i < 3; i++) {
	    var c = parseInt(hex.substr(i * 2, 2), 16);
	    c = Math.round(Math.min(Math.max(0, c + c * lum), 255)).toString(16);
	    rgb += ('00' + c).substr(c.length);
	  }
	
	  return rgb;
	};
	
	var uniqueArray = function uniqueArray(arr) {
	  var result = [];
	  for (var i in arr) {
	    if (result.indexOf(arr[i]) === -1) {
	      result.push(arr[i]);
	    }
	  }
	  return result;
	};
	
	/**
	 * Standardise console warnings
	 * @param message
	 */
	var warn = function warn(message) {
	  console.warn(consolePrefix + ' ' + message);
	};
	
	/**
	 * Standardise console errors
	 * @param message
	 */
	var error = function error(message) {
	  console.error(consolePrefix + ' ' + message);
	};
	
	// Remember state in cases where opening and handling a modal will fiddle with it.
	var states = {
	  previousWindowKeyDown: null,
	  previousActiveElement: null,
	  previousBodyPadding: null
	
	  /*
	   * Add modal + overlay to DOM
	   */
	};var init = function init(params) {
	  // Clean up the old modal if it exists
	  var c = getContainer();
	  if (c) {
	    c.parentNode.removeChild(c);
	  }
	
	  if (typeof document === 'undefined') {
	    error('SweetAlert2 requires document to initialize');
	    return;
	  }
	
	  var container = document.createElement('div');
	  container.className = swalClasses.container;
	  container.innerHTML = sweetHTML;
	
	  var targetElement = typeof params.target === 'string' ? document.querySelector(params.target) : params.target;
	  targetElement.appendChild(container);
	
	  var modal = getModal();
	  var input = getChildByClass(modal, swalClasses.input);
	  var file = getChildByClass(modal, swalClasses.file);
	  var range = modal.querySelector('.' + swalClasses.range + ' input');
	  var rangeOutput = modal.querySelector('.' + swalClasses.range + ' output');
	  var select = getChildByClass(modal, swalClasses.select);
	  var checkbox = modal.querySelector('.' + swalClasses.checkbox + ' input');
	  var textarea = getChildByClass(modal, swalClasses.textarea);
	
	  input.oninput = function () {
	    sweetAlert.resetValidationError();
	  };
	
	  file.onchange = function () {
	    sweetAlert.resetValidationError();
	  };
	
	  range.oninput = function () {
	    sweetAlert.resetValidationError();
	    rangeOutput.value = range.value;
	  };
	
	  range.onchange = function () {
	    sweetAlert.resetValidationError();
	    range.previousSibling.value = range.value;
	  };
	
	  select.onchange = function () {
	    sweetAlert.resetValidationError();
	  };
	
	  checkbox.onchange = function () {
	    sweetAlert.resetValidationError();
	  };
	
	  textarea.oninput = function () {
	    sweetAlert.resetValidationError();
	  };
	
	  return modal;
	};
	
	/*
	 * Manipulate DOM
	 */
	
	var sweetHTML = ('\n <div role="dialog" aria-modal="true" aria-labelledby="' + swalClasses.title + '" aria-describedby="' + swalClasses.content + '" class="' + swalClasses.modal + '" tabindex="-1">\n   <ul class="' + swalClasses.progresssteps + '"></ul>\n   <div class="' + swalClasses.icon + ' ' + iconTypes.error + '">\n     <span class="swal2-x-mark"><span class="swal2-x-mark-line-left"></span><span class="swal2-x-mark-line-right"></span></span>\n   </div>\n   <div class="' + swalClasses.icon + ' ' + iconTypes.question + '">?</div>\n   <div class="' + swalClasses.icon + ' ' + iconTypes.warning + '">!</div>\n   <div class="' + swalClasses.icon + ' ' + iconTypes.info + '">i</div>\n   <div class="' + swalClasses.icon + ' ' + iconTypes.success + '">\n     <div class="swal2-success-circular-line-left"></div>\n     <span class="swal2-success-line-tip"></span> <span class="swal2-success-line-long"></span>\n     <div class="swal2-success-ring"></div> <div class="swal2-success-fix"></div>\n     <div class="swal2-success-circular-line-right"></div>\n   </div>\n   <img class="' + swalClasses.image + '" />\n   <h2 class="' + swalClasses.title + '" id="' + swalClasses.title + '"></h2>\n   <div id="' + swalClasses.content + '" class="' + swalClasses.content + '"></div>\n   <input class="' + swalClasses.input + '" />\n   <input type="file" class="' + swalClasses.file + '" />\n   <div class="' + swalClasses.range + '">\n     <output></output>\n     <input type="range" />\n   </div>\n   <select class="' + swalClasses.select + '"></select>\n   <div class="' + swalClasses.radio + '"></div>\n   <label for="' + swalClasses.checkbox + '" class="' + swalClasses.checkbox + '">\n     <input type="checkbox" />\n   </label>\n   <textarea class="' + swalClasses.textarea + '"></textarea>\n   <div class="' + swalClasses.validationerror + '" id="' + swalClasses.validationerror + '"></div>\n   <div class="' + swalClasses.buttonswrapper + '">\n     <button type="button" class="' + swalClasses.confirm + '">OK</button>\n     <button type="button" class="' + swalClasses.cancel + '">Cancel</button>\n   </div>\n   <button type="button" class="' + swalClasses.close + '">\xD7</button>\n </div>\n').replace(/(^|\n)\s*/g, '');
	
	var getContainer = function getContainer() {
	  return document.body.querySelector('.' + swalClasses.container);
	};
	
	var getModal = function getModal() {
	  return getContainer() ? getContainer().querySelector('.' + swalClasses.modal) : null;
	};
	
	var getIcons = function getIcons() {
	  var modal = getModal();
	  return modal.querySelectorAll('.' + swalClasses.icon);
	};
	
	var elementByClass = function elementByClass(className) {
	  return getContainer() ? getContainer().querySelector('.' + className) : null;
	};
	
	var getTitle = function getTitle() {
	  return elementByClass(swalClasses.title);
	};
	
	var getContent = function getContent() {
	  return elementByClass(swalClasses.content);
	};
	
	var getImage = function getImage() {
	  return elementByClass(swalClasses.image);
	};
	
	var getProgressSteps = function getProgressSteps() {
	  return elementByClass(swalClasses.progresssteps);
	};
	
	var getValidationError = function getValidationError() {
	  return elementByClass(swalClasses.validationerror);
	};
	
	var getConfirmButton = function getConfirmButton() {
	  return elementByClass(swalClasses.confirm);
	};
	
	var getCancelButton = function getCancelButton() {
	  return elementByClass(swalClasses.cancel);
	};
	
	var getButtonsWrapper = function getButtonsWrapper() {
	  return elementByClass(swalClasses.buttonswrapper);
	};
	
	var getCloseButton = function getCloseButton() {
	  return elementByClass(swalClasses.close);
	};
	
	var getFocusableElements = function getFocusableElements() {
	  var focusableElementsWithTabindex = Array.from(getModal().querySelectorAll('[tabindex]:not([tabindex="-1"]):not([tabindex="0"])'))
	  // sort according to tabindex
	  .sort(function (a, b) {
	    a = parseInt(a.getAttribute('tabindex'));
	    b = parseInt(b.getAttribute('tabindex'));
	    if (a > b) {
	      return 1;
	    } else if (a < b) {
	      return -1;
	    }
	    return 0;
	  });
	
	  var otherFocusableElements = Array.prototype.slice.call(getModal().querySelectorAll('button, input:not([type=hidden]), textarea, select, a, [tabindex="0"]'));
	
	  return uniqueArray(focusableElementsWithTabindex.concat(otherFocusableElements));
	};
	
	var hasClass = function hasClass(elem, className) {
	  if (elem.classList) {
	    return elem.classList.contains(className);
	  }
	  return false;
	};
	
	var focusInput = function focusInput(input) {
	  input.focus();
	
	  // place cursor at end of text in text input
	  if (input.type !== 'file') {
	    // http://stackoverflow.com/a/2345915/1331425
	    var val = input.value;
	    input.value = '';
	    input.value = val;
	  }
	};
	
	var addClass = function addClass(elem, className) {
	  if (!elem || !className) {
	    return;
	  }
	  var classes = className.split(/\s+/).filter(Boolean);
	  classes.forEach(function (className) {
	    elem.classList.add(className);
	  });
	};
	
	var removeClass = function removeClass(elem, className) {
	  if (!elem || !className) {
	    return;
	  }
	  var classes = className.split(/\s+/).filter(Boolean);
	  classes.forEach(function (className) {
	    elem.classList.remove(className);
	  });
	};
	
	var getChildByClass = function getChildByClass(elem, className) {
	  for (var i = 0; i < elem.childNodes.length; i++) {
	    if (hasClass(elem.childNodes[i], className)) {
	      return elem.childNodes[i];
	    }
	  }
	};
	
	var show = function show(elem, display) {
	  if (!display) {
	    display = 'block';
	  }
	  elem.style.opacity = '';
	  elem.style.display = display;
	};
	
	var hide = function hide(elem) {
	  elem.style.opacity = '';
	  elem.style.display = 'none';
	};
	
	var empty = function empty(elem) {
	  while (elem.firstChild) {
	    elem.removeChild(elem.firstChild);
	  }
	};
	
	// borrowed from jquery $(elem).is(':visible') implementation
	var isVisible = function isVisible(elem) {
	  return elem.offsetWidth || elem.offsetHeight || elem.getClientRects().length;
	};
	
	var removeStyleProperty = function removeStyleProperty(elem, property) {
	  if (elem.style.removeProperty) {
	    elem.style.removeProperty(property);
	  } else {
	    elem.style.removeAttribute(property);
	  }
	};
	
	var animationEndEvent = function () {
	  var testEl = document.createElement('div');
	  var transEndEventNames = {
	    'WebkitAnimation': 'webkitAnimationEnd',
	    'OAnimation': 'oAnimationEnd oanimationend',
	    'animation': 'animationend'
	  };
	  for (var i in transEndEventNames) {
	    if (transEndEventNames.hasOwnProperty(i) && testEl.style[i] !== undefined) {
	      return transEndEventNames[i];
	    }
	  }
	
	  return false;
	}();
	
	// Reset previous window keydown handler and focued element
	var resetPrevState = function resetPrevState() {
	  window.onkeydown = states.previousWindowKeyDown;
	  if (states.previousActiveElement && states.previousActiveElement.focus) {
	    var x = window.scrollX;
	    var y = window.scrollY;
	    states.previousActiveElement.focus();
	    if (x && y) {
	      // IE has no scrollX/scrollY support
	      window.scrollTo(x, y);
	    }
	  }
	};
	
	// Measure width of scrollbar
	// https://github.com/twbs/bootstrap/blob/master/js/modal.js#L279-L286
	var measureScrollbar = function measureScrollbar() {
	  var supportsTouch = 'ontouchstart' in window || navigator.msMaxTouchPoints;
	  if (supportsTouch) {
	    return 0;
	  }
	  var scrollDiv = document.createElement('div');
	  scrollDiv.style.width = '50px';
	  scrollDiv.style.height = '50px';
	  scrollDiv.style.overflow = 'scroll';
	  document.body.appendChild(scrollDiv);
	  var scrollbarWidth = scrollDiv.offsetWidth - scrollDiv.clientWidth;
	  document.body.removeChild(scrollDiv);
	  return scrollbarWidth;
	};
	
	/**
	 * Inject a string of CSS into the page header
	 *
	 * @param {String} css
	 */
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) {
	  return typeof obj;
	} : function (obj) {
	  return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
	};
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	var _extends = Object.assign || function (target) {
	  for (var i = 1; i < arguments.length; i++) {
	    var source = arguments[i];
	
	    for (var key in source) {
	      if (Object.prototype.hasOwnProperty.call(source, key)) {
	        target[key] = source[key];
	      }
	    }
	  }
	
	  return target;
	};
	
	var modalParams = _extends({}, defaultParams);
	var queue = [];
	
	/*
	 * Check for the existence of Promise
	 * Hopefully to avoid many github issues
	 */
	if (typeof Promise === 'undefined') {
	  error('This package requires a Promise library, please include a shim to enable it in this browser (See: https://github.com/limonte/sweetalert2/wiki/Migration-from-SweetAlert-to-SweetAlert2#1-ie-support)');
	}
	
	/**
	 * Set type, text and actions on modal
	 *
	 * @param params
	 * @returns {boolean}
	 */
	var setParameters = function setParameters(params) {
	  // If a custom element is set, determine if it is valid
	  if (typeof params.target === 'string' && !document.querySelector(params.target) || typeof params.target !== 'string' && !params.target.appendChild) {
	    warn('Target parameter is not valid, defaulting to "body"');
	    params.target = 'body';
	  }
	
	  var modal = void 0;
	  var oldModal = getModal();
	  var targetElement = typeof params.target === 'string' ? document.querySelector(params.target) : params.target;
	  // If the model target has changed, refresh the modal
	  if (oldModal && targetElement && oldModal.parentNode !== targetElement.parentNode) {
	    modal = init(params);
	  } else {
	    modal = oldModal || init(params);
	  }
	
	  for (var param in params) {
	    if (!sweetAlert.isValidParameter(param)) {
	      warn('Unknown parameter "' + param + '"');
	    }
	  }
	
	  // Set modal width
	  modal.style.width = typeof params.width === 'number' ? params.width + 'px' : params.width;
	
	  modal.style.padding = params.padding + 'px';
	  modal.style.background = params.background;
	  var successIconParts = modal.querySelectorAll('[class^=swal2-success-circular-line], .swal2-success-fix');
	  for (var i = 0; i < successIconParts.length; i++) {
	    successIconParts[i].style.background = params.background;
	  }
	
	  var container = getContainer();
	  var title = getTitle();
	  var content = getContent();
	  var buttonsWrapper = getButtonsWrapper();
	  var confirmButton = getConfirmButton();
	  var cancelButton = getCancelButton();
	  var closeButton = getCloseButton();
	
	  // Title
	  if (params.titleText) {
	    title.innerText = params.titleText;
	  } else {
	    title.innerHTML = params.title.split('\n').join('<br />');
	  }
	
	  // Content
	  if (params.text || params.html) {
	    if (_typeof(params.html) === 'object') {
	      content.innerHTML = '';
	      if (0 in params.html) {
	        for (var _i = 0; _i in params.html; _i++) {
	          content.appendChild(params.html[_i].cloneNode(true));
	        }
	      } else {
	        content.appendChild(params.html.cloneNode(true));
	      }
	    } else if (params.html) {
	      content.innerHTML = params.html;
	    } else if (params.text) {
	      content.textContent = params.text;
	    }
	    show(content);
	  } else {
	    hide(content);
	  }
	
	  // Position
	  if (params.position in swalClasses) {
	    addClass(container, swalClasses[params.position]);
	  }
	
	  // Grow
	  if (params.grow && typeof params.grow === 'string') {
	    var growClass = 'grow-' + params.grow;
	    if (growClass in swalClasses) {
	      addClass(container, swalClasses[growClass]);
	    }
	  }
	
	  // Close button
	  if (params.showCloseButton) {
	    closeButton.setAttribute('aria-label', params.closeButtonAriaLabel);
	    show(closeButton);
	  } else {
	    hide(closeButton);
	  }
	
	  // Custom Class
	  modal.className = swalClasses.modal;
	  if (params.customClass) {
	    addClass(modal, params.customClass);
	  }
	
	  // Progress steps
	  var progressStepsContainer = getProgressSteps();
	  var currentProgressStep = parseInt(params.currentProgressStep === null ? sweetAlert.getQueueStep() : params.currentProgressStep, 10);
	  if (params.progressSteps.length) {
	    show(progressStepsContainer);
	    empty(progressStepsContainer);
	    if (currentProgressStep >= params.progressSteps.length) {
	      warn('Invalid currentProgressStep parameter, it should be less than progressSteps.length ' + '(currentProgressStep like JS arrays starts from 0)');
	    }
	    params.progressSteps.forEach(function (step, index) {
	      var circle = document.createElement('li');
	      addClass(circle, swalClasses.progresscircle);
	      circle.innerHTML = step;
	      if (index === currentProgressStep) {
	        addClass(circle, swalClasses.activeprogressstep);
	      }
	      progressStepsContainer.appendChild(circle);
	      if (index !== params.progressSteps.length - 1) {
	        var line = document.createElement('li');
	        addClass(line, swalClasses.progressline);
	        line.style.width = params.progressStepsDistance;
	        progressStepsContainer.appendChild(line);
	      }
	    });
	  } else {
	    hide(progressStepsContainer);
	  }
	
	  // Icon
	  var icons = getIcons();
	  for (var _i2 = 0; _i2 < icons.length; _i2++) {
	    hide(icons[_i2]);
	  }
	  if (params.type) {
	    var validType = false;
	    for (var iconType in iconTypes) {
	      if (params.type === iconType) {
	        validType = true;
	        break;
	      }
	    }
	    if (!validType) {
	      error('Unknown alert type: ' + params.type);
	      return false;
	    }
	    var icon = modal.querySelector('.' + swalClasses.icon + '.' + iconTypes[params.type]);
	    show(icon);
	
	    // Animate icon
	    if (params.animation) {
	      switch (params.type) {
	        case 'success':
	          addClass(icon, 'swal2-animate-success-icon');
	          addClass(icon.querySelector('.swal2-success-line-tip'), 'swal2-animate-success-line-tip');
	          addClass(icon.querySelector('.swal2-success-line-long'), 'swal2-animate-success-line-long');
	          break;
	        case 'error':
	          addClass(icon, 'swal2-animate-error-icon');
	          addClass(icon.querySelector('.swal2-x-mark'), 'swal2-animate-x-mark');
	          break;
	        default:
	          break;
	      }
	    }
	  }
	
	  // Custom image
	  var image = getImage();
	  if (params.imageUrl) {
	    image.setAttribute('src', params.imageUrl);
	    image.setAttribute('alt', params.imageAlt);
	    show(image);
	
	    if (params.imageWidth) {
	      image.setAttribute('width', params.imageWidth);
	    } else {
	      image.removeAttribute('width');
	    }
	
	    if (params.imageHeight) {
	      image.setAttribute('height', params.imageHeight);
	    } else {
	      image.removeAttribute('height');
	    }
	
	    image.className = swalClasses.image;
	    if (params.imageClass) {
	      addClass(image, params.imageClass);
	    }
	  } else {
	    hide(image);
	  }
	
	  // Cancel button
	  if (params.showCancelButton) {
	    cancelButton.style.display = 'inline-block';
	  } else {
	    hide(cancelButton);
	  }
	
	  // Confirm button
	  if (params.showConfirmButton) {
	    removeStyleProperty(confirmButton, 'display');
	  } else {
	    hide(confirmButton);
	  }
	
	  // Buttons wrapper
	  if (!params.showConfirmButton && !params.showCancelButton) {
	    hide(buttonsWrapper);
	  } else {
	    show(buttonsWrapper);
	  }
	
	  // Edit text on confirm and cancel buttons
	  confirmButton.innerHTML = params.confirmButtonText;
	  cancelButton.innerHTML = params.cancelButtonText;
	
	  // ARIA labels for confirm and cancel buttons
	  confirmButton.setAttribute('aria-label', params.confirmButtonAriaLabel);
	  cancelButton.setAttribute('aria-label', params.cancelButtonAriaLabel);
	
	  // Set buttons to selected background colors
	  if (params.buttonsStyling) {
	    confirmButton.style.backgroundColor = params.confirmButtonColor;
	    cancelButton.style.backgroundColor = params.cancelButtonColor;
	  }
	
	  // Add buttons custom classes
	  confirmButton.className = swalClasses.confirm;
	  addClass(confirmButton, params.confirmButtonClass);
	  cancelButton.className = swalClasses.cancel;
	  addClass(cancelButton, params.cancelButtonClass);
	
	  // Buttons styling
	  if (params.buttonsStyling) {
	    addClass(confirmButton, swalClasses.styled);
	    addClass(cancelButton, swalClasses.styled);
	  } else {
	    removeClass(confirmButton, swalClasses.styled);
	    removeClass(cancelButton, swalClasses.styled);
	
	    confirmButton.style.backgroundColor = confirmButton.style.borderLeftColor = confirmButton.style.borderRightColor = '';
	    cancelButton.style.backgroundColor = cancelButton.style.borderLeftColor = cancelButton.style.borderRightColor = '';
	  }
	
	  // CSS animation
	  if (params.animation === true) {
	    removeClass(modal, swalClasses.noanimation);
	  } else {
	    addClass(modal, swalClasses.noanimation);
	  }
	
	  // showLoaderOnConfirm && preConfirm
	  if (params.showLoaderOnConfirm && !params.preConfirm) {
	    warn('showLoaderOnConfirm is set to true, but preConfirm is not defined.\n' + 'showLoaderOnConfirm should be used together with preConfirm, see usage example:\n' + 'https://limonte.github.io/sweetalert2/#ajax-request');
	  }
	};
	
	/**
	 * Animations
	 *
	 * @param animation
	 * @param onBeforeOpen
	 * @param onComplete
	 */
	var openModal = function openModal(animation, onBeforeOpen, onComplete) {
	  var container = getContainer();
	  var modal = getModal();
	
	  if (onBeforeOpen !== null && typeof onBeforeOpen === 'function') {
	    onBeforeOpen(modal);
	  }
	
	  if (animation) {
	    addClass(modal, swalClasses.show);
	    addClass(container, swalClasses.fade);
	    removeClass(modal, swalClasses.hide);
	  } else {
	    removeClass(modal, swalClasses.fade);
	  }
	  show(modal);
	
	  // scrolling is 'hidden' until animation is done, after that 'auto'
	  container.style.overflowY = 'hidden';
	  if (animationEndEvent && !hasClass(modal, swalClasses.noanimation)) {
	    modal.addEventListener(animationEndEvent, function swalCloseEventFinished() {
	      modal.removeEventListener(animationEndEvent, swalCloseEventFinished);
	      container.style.overflowY = 'auto';
	    });
	  } else {
	    container.style.overflowY = 'auto';
	  }
	
	  addClass(document.documentElement, swalClasses.shown);
	  addClass(document.body, swalClasses.shown);
	  addClass(container, swalClasses.shown);
	  fixScrollbar();
	  iOSfix();
	  states.previousActiveElement = document.activeElement;
	  if (onComplete !== null && typeof onComplete === 'function') {
	    setTimeout(function () {
	      onComplete(modal);
	    });
	  }
	};
	
	var fixScrollbar = function fixScrollbar() {
	  // for queues, do not do this more than once
	  if (states.previousBodyPadding !== null) {
	    return;
	  }
	  // if the body has overflow
	  if (document.body.scrollHeight > window.innerHeight) {
	    // add padding so the content doesn't shift after removal of scrollbar
	    states.previousBodyPadding = document.body.style.paddingRight;
	    document.body.style.paddingRight = measureScrollbar() + 'px';
	  }
	};
	
	var undoScrollbar = function undoScrollbar() {
	  if (states.previousBodyPadding !== null) {
	    document.body.style.paddingRight = states.previousBodyPadding;
	    states.previousBodyPadding = null;
	  }
	};
	
	// Fix iOS scrolling http://stackoverflow.com/q/39626302/1331425
	var iOSfix = function iOSfix() {
	  var iOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
	  if (iOS && !hasClass(document.body, swalClasses.iosfix)) {
	    var offset = document.body.scrollTop;
	    document.body.style.top = offset * -1 + 'px';
	    addClass(document.body, swalClasses.iosfix);
	  }
	};
	
	var undoIOSfix = function undoIOSfix() {
	  if (hasClass(document.body, swalClasses.iosfix)) {
	    var offset = parseInt(document.body.style.top, 10);
	    removeClass(document.body, swalClasses.iosfix);
	    document.body.style.top = '';
	    document.body.scrollTop = offset * -1;
	  }
	};
	
	// SweetAlert entry point
	var sweetAlert = function sweetAlert() {
	  for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	    args[_key] = arguments[_key];
	  }
	
	  if (args[0] === undefined) {
	    error('SweetAlert2 expects at least 1 attribute!');
	    return false;
	  }
	
	  var params = _extends({}, modalParams);
	
	  switch (_typeof(args[0])) {
	    case 'string':
	      params.title = args[0];
	      params.html = args[1];
	      params.type = args[2];
	
	      break;
	
	    case 'object':
	      _extends(params, args[0]);
	      params.extraParams = args[0].extraParams;
	
	      if (params.input === 'email' && params.inputValidator === null) {
	        params.inputValidator = function (email) {
	          return new Promise(function (resolve, reject) {
	            var emailRegex = /^[a-zA-Z0-9.+_-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,6}$/;
	            if (emailRegex.test(email)) {
	              resolve();
	            } else {
	              reject('Invalid email address');
	            }
	          });
	        };
	      }
	
	      if (params.input === 'url' && params.inputValidator === null) {
	        params.inputValidator = function (url) {
	          return new Promise(function (resolve, reject) {
	            // taken from https://stackoverflow.com/a/3809435/1331425
	            var urlRegex = /^https?:\/\/(www\.)?[-a-zA-Z0-9@:%._+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_+.~#?&//=]*)$/;
	            if (urlRegex.test(url)) {
	              resolve();
	            } else {
	              reject('Invalid URL');
	            }
	          });
	        };
	      }
	      break;
	
	    default:
	      error('Unexpected type of argument! Expected "string" or "object", got ' + _typeof(args[0]));
	      return false;
	  }
	
	  setParameters(params);
	
	  var container = getContainer();
	  var modal = getModal();
	
	  return new Promise(function (resolve, reject) {
	    // Close on timer
	    if (params.timer) {
	      modal.timeout = setTimeout(function () {
	        sweetAlert.closeModal(params.onClose);
	        if (params.useRejections) {
	          reject('timer');
	        } else {
	          resolve({ dismiss: 'timer' });
	        }
	      }, params.timer);
	    }
	
	    // Get input element by specified type or, if type isn't specified, by params.input
	    var getInput = function getInput(inputType) {
	      inputType = inputType || params.input;
	      if (!inputType) {
	        return null;
	      }
	      switch (inputType) {
	        case 'select':
	        case 'textarea':
	        case 'file':
	          return getChildByClass(modal, swalClasses[inputType]);
	        case 'checkbox':
	          return modal.querySelector('.' + swalClasses.checkbox + ' input');
	        case 'radio':
	          return modal.querySelector('.' + swalClasses.radio + ' input:checked') || modal.querySelector('.' + swalClasses.radio + ' input:first-child');
	        case 'range':
	          return modal.querySelector('.' + swalClasses.range + ' input');
	        default:
	          return getChildByClass(modal, swalClasses.input);
	      }
	    };
	
	    // Get the value of the modal input
	    var getInputValue = function getInputValue() {
	      var input = getInput();
	      if (!input) {
	        return null;
	      }
	      switch (params.input) {
	        case 'checkbox':
	          return input.checked ? 1 : 0;
	        case 'radio':
	          return input.checked ? input.value : null;
	        case 'file':
	          return input.files.length ? input.files[0] : null;
	        default:
	          return params.inputAutoTrim ? input.value.trim() : input.value;
	      }
	    };
	
	    // input autofocus
	    if (params.input) {
	      setTimeout(function () {
	        var input = getInput();
	        if (input) {
	          focusInput(input);
	        }
	      }, 0);
	    }
	
	    var confirm = function confirm(value) {
	      if (params.showLoaderOnConfirm) {
	        sweetAlert.showLoading();
	      }
	
	      if (params.preConfirm) {
	        params.preConfirm(value, params.extraParams).then(function (preConfirmValue) {
	          sweetAlert.closeModal(params.onClose);
	          resolve(preConfirmValue || value);
	        }, function (error$$1) {
	          sweetAlert.hideLoading();
	          if (error$$1) {
	            sweetAlert.showValidationError(error$$1);
	          }
	        });
	      } else {
	        sweetAlert.closeModal(params.onClose);
	        if (params.useRejections) {
	          resolve(value);
	        } else {
	          resolve({ value: value });
	        }
	      }
	    };
	
	    // Mouse interactions
	    var onButtonEvent = function onButtonEvent(event) {
	      var e = event || window.event;
	      var target = e.target || e.srcElement;
	      var confirmButton = getConfirmButton();
	      var cancelButton = getCancelButton();
	      var targetedConfirm = confirmButton && (confirmButton === target || confirmButton.contains(target));
	      var targetedCancel = cancelButton && (cancelButton === target || cancelButton.contains(target));
	
	      switch (e.type) {
	        case 'mouseover':
	        case 'mouseup':
	          if (params.buttonsStyling) {
	            if (targetedConfirm) {
	              confirmButton.style.backgroundColor = colorLuminance(params.confirmButtonColor, -0.1);
	            } else if (targetedCancel) {
	              cancelButton.style.backgroundColor = colorLuminance(params.cancelButtonColor, -0.1);
	            }
	          }
	          break;
	        case 'mouseout':
	          if (params.buttonsStyling) {
	            if (targetedConfirm) {
	              confirmButton.style.backgroundColor = params.confirmButtonColor;
	            } else if (targetedCancel) {
	              cancelButton.style.backgroundColor = params.cancelButtonColor;
	            }
	          }
	          break;
	        case 'mousedown':
	          if (params.buttonsStyling) {
	            if (targetedConfirm) {
	              confirmButton.style.backgroundColor = colorLuminance(params.confirmButtonColor, -0.2);
	            } else if (targetedCancel) {
	              cancelButton.style.backgroundColor = colorLuminance(params.cancelButtonColor, -0.2);
	            }
	          }
	          break;
	        case 'click':
	          // Clicked 'confirm'
	          if (targetedConfirm && sweetAlert.isVisible()) {
	            sweetAlert.disableButtons();
	            if (params.input) {
	              var inputValue = getInputValue();
	
	              if (params.inputValidator) {
	                sweetAlert.disableInput();
	                params.inputValidator(inputValue, params.extraParams).then(function () {
	                  sweetAlert.enableButtons();
	                  sweetAlert.enableInput();
	                  confirm(inputValue);
	                }, function (error$$1) {
	                  sweetAlert.enableButtons();
	                  sweetAlert.enableInput();
	                  if (error$$1) {
	                    sweetAlert.showValidationError(error$$1);
	                  }
	                });
	              } else {
	                confirm(inputValue);
	              }
	            } else {
	              confirm(true);
	            }
	
	            // Clicked 'cancel'
	          } else if (targetedCancel && sweetAlert.isVisible()) {
	            sweetAlert.disableButtons();
	            sweetAlert.closeModal(params.onClose);
	            if (params.useRejections) {
	              reject('cancel');
	            } else {
	              resolve({ dismiss: 'cancel' });
	            }
	          }
	          break;
	        default:
	      }
	    };
	
	    var buttons = modal.querySelectorAll('button');
	    for (var i = 0; i < buttons.length; i++) {
	      buttons[i].onclick = onButtonEvent;
	      buttons[i].onmouseover = onButtonEvent;
	      buttons[i].onmouseout = onButtonEvent;
	      buttons[i].onmousedown = onButtonEvent;
	    }
	
	    // Closing modal by close button
	    getCloseButton().onclick = function () {
	      sweetAlert.closeModal(params.onClose);
	      if (params.useRejections) {
	        reject('close');
	      } else {
	        resolve({ dismiss: 'close' });
	      }
	    };
	
	    // Closing modal by overlay click
	    container.onclick = function (e) {
	      if (e.target !== container) {
	        return;
	      }
	      if (params.allowOutsideClick) {
	        sweetAlert.closeModal(params.onClose);
	        if (params.useRejections) {
	          reject('overlay');
	        } else {
	          resolve({ dismiss: 'overlay' });
	        }
	      }
	    };
	
	    var buttonsWrapper = getButtonsWrapper();
	    var confirmButton = getConfirmButton();
	    var cancelButton = getCancelButton();
	
	    // Reverse buttons (Confirm on the right side)
	    if (params.reverseButtons) {
	      confirmButton.parentNode.insertBefore(cancelButton, confirmButton);
	    } else {
	      confirmButton.parentNode.insertBefore(confirmButton, cancelButton);
	    }
	
	    // Focus handling
	    var setFocus = function setFocus(index, increment) {
	      var focusableElements = getFocusableElements(params.focusCancel);
	      // search for visible elements and select the next possible match
	      for (var _i3 = 0; _i3 < focusableElements.length; _i3++) {
	        index = index + increment;
	
	        // rollover to first item
	        if (index === focusableElements.length) {
	          index = 0;
	
	          // go to last item
	        } else if (index === -1) {
	          index = focusableElements.length - 1;
	        }
	
	        // determine if element is visible
	        var el = focusableElements[index];
	        if (isVisible(el)) {
	          return el.focus();
	        }
	      }
	    };
	
	    var handleKeyDown = function handleKeyDown(event) {
	      var e = event || window.event;
	
	      if (e.key === 'Enter') {
	        if (e.target === getInput()) {
	          if (e.target.tagName.toLowerCase() === 'textarea') {
	            return; // do not submit
	          }
	          sweetAlert.clickConfirm();
	          e.preventDefault();
	        }
	
	        // TAB
	      } else if (e.key === 'Tab') {
	        var targetElement = e.target || e.srcElement;
	
	        var focusableElements = getFocusableElements(params.focusCancel);
	        var btnIndex = -1; // Find the button - note, this is a nodelist, not an array.
	        for (var _i4 = 0; _i4 < focusableElements.length; _i4++) {
	          if (targetElement === focusableElements[_i4]) {
	            btnIndex = _i4;
	            break;
	          }
	        }
	
	        if (!e.shiftKey) {
	          // Cycle to the next button
	          setFocus(btnIndex, 1);
	        } else {
	          // Cycle to the prev button
	          setFocus(btnIndex, -1);
	        }
	        e.stopPropagation();
	        e.preventDefault();
	
	        // ARROWS - switch focus between buttons
	      } else if (['ArrowLeft', 'ArrowRight', 'ArrowUp', 'Arrowdown'].indexOf(e.key) !== -1) {
	        // focus Cancel button if Confirm button is currently focused
	        if (document.activeElement === confirmButton && isVisible(cancelButton)) {
	          cancelButton.focus();
	          // and vice versa
	        } else if (document.activeElement === cancelButton && isVisible(confirmButton)) {
	          confirmButton.focus();
	        }
	
	        // ESC
	      } else if ((e.key === 'Escape' || e.key === 'Esc') && params.allowEscapeKey === true) {
	        sweetAlert.closeModal(params.onClose);
	        if (params.useRejections) {
	          reject('esc');
	        } else {
	          resolve({ dismiss: 'esc' });
	        }
	      }
	    };
	
	    if (!window.onkeydown || window.onkeydown.toString() !== handleKeyDown.toString()) {
	      states.previousWindowKeyDown = window.onkeydown;
	      window.onkeydown = handleKeyDown;
	    }
	
	    // Loading state
	    if (params.buttonsStyling) {
	      confirmButton.style.borderLeftColor = params.confirmButtonColor;
	      confirmButton.style.borderRightColor = params.confirmButtonColor;
	    }
	
	    /**
	     * Show spinner instead of Confirm button and disable Cancel button
	     */
	    sweetAlert.hideLoading = sweetAlert.disableLoading = function () {
	      if (!params.showConfirmButton) {
	        hide(confirmButton);
	        if (!params.showCancelButton) {
	          hide(getButtonsWrapper());
	        }
	      }
	      removeClass(buttonsWrapper, swalClasses.loading);
	      removeClass(modal, swalClasses.loading);
	      modal.removeAttribute('aria-busy');
	      confirmButton.disabled = false;
	      cancelButton.disabled = false;
	    };
	
	    sweetAlert.getTitle = function () {
	      return getTitle();
	    };
	    sweetAlert.getContent = function () {
	      return getContent();
	    };
	    sweetAlert.getInput = function () {
	      return getInput();
	    };
	    sweetAlert.getImage = function () {
	      return getImage();
	    };
	    sweetAlert.getButtonsWrapper = function () {
	      return getButtonsWrapper();
	    };
	    sweetAlert.getConfirmButton = function () {
	      return getConfirmButton();
	    };
	    sweetAlert.getCancelButton = function () {
	      return getCancelButton();
	    };
	
	    sweetAlert.enableButtons = function () {
	      confirmButton.disabled = false;
	      cancelButton.disabled = false;
	    };
	
	    sweetAlert.disableButtons = function () {
	      confirmButton.disabled = true;
	      cancelButton.disabled = true;
	    };
	
	    sweetAlert.enableConfirmButton = function () {
	      confirmButton.disabled = false;
	    };
	
	    sweetAlert.disableConfirmButton = function () {
	      confirmButton.disabled = true;
	    };
	
	    sweetAlert.enableInput = function () {
	      var input = getInput();
	      if (!input) {
	        return false;
	      }
	      if (input.type === 'radio') {
	        var radiosContainer = input.parentNode.parentNode;
	        var radios = radiosContainer.querySelectorAll('input');
	        for (var _i5 = 0; _i5 < radios.length; _i5++) {
	          radios[_i5].disabled = false;
	        }
	      } else {
	        input.disabled = false;
	      }
	    };
	
	    sweetAlert.disableInput = function () {
	      var input = getInput();
	      if (!input) {
	        return false;
	      }
	      if (input && input.type === 'radio') {
	        var radiosContainer = input.parentNode.parentNode;
	        var radios = radiosContainer.querySelectorAll('input');
	        for (var _i6 = 0; _i6 < radios.length; _i6++) {
	          radios[_i6].disabled = true;
	        }
	      } else {
	        input.disabled = true;
	      }
	    };
	
	    // Show block with validation error
	    sweetAlert.showValidationError = function (error$$1) {
	      var validationError = getValidationError();
	      validationError.innerHTML = error$$1;
	      show(validationError);
	
	      var input = getInput();
	      if (input) {
	        input.setAttribute('aria-invalid', true);
	        input.setAttribute('aria-describedBy', swalClasses.validationerror);
	        focusInput(input);
	        addClass(input, swalClasses.inputerror);
	      }
	    };
	
	    // Hide block with validation error
	    sweetAlert.resetValidationError = function () {
	      var validationError = getValidationError();
	      hide(validationError);
	
	      var input = getInput();
	      if (input) {
	        input.removeAttribute('aria-invalid');
	        input.removeAttribute('aria-describedBy');
	        removeClass(input, swalClasses.inputerror);
	      }
	    };
	
	    sweetAlert.getProgressSteps = function () {
	      return params.progressSteps;
	    };
	
	    sweetAlert.setProgressSteps = function (progressSteps) {
	      params.progressSteps = progressSteps;
	      setParameters(params);
	    };
	
	    sweetAlert.showProgressSteps = function () {
	      show(getProgressSteps());
	    };
	
	    sweetAlert.hideProgressSteps = function () {
	      hide(getProgressSteps());
	    };
	
	    sweetAlert.enableButtons();
	    sweetAlert.hideLoading();
	    sweetAlert.resetValidationError();
	
	    // inputs
	    var inputTypes = ['input', 'file', 'range', 'select', 'radio', 'checkbox', 'textarea'];
	    var input = void 0;
	    for (var _i7 = 0; _i7 < inputTypes.length; _i7++) {
	      var inputClass = swalClasses[inputTypes[_i7]];
	      var inputContainer = getChildByClass(modal, inputClass);
	      input = getInput(inputTypes[_i7]);
	
	      // set attributes
	      if (input) {
	        for (var j in input.attributes) {
	          if (input.attributes.hasOwnProperty(j)) {
	            var attrName = input.attributes[j].name;
	            if (attrName !== 'type' && attrName !== 'value') {
	              input.removeAttribute(attrName);
	            }
	          }
	        }
	        for (var attr in params.inputAttributes) {
	          input.setAttribute(attr, params.inputAttributes[attr]);
	        }
	      }
	
	      // set class
	      inputContainer.className = inputClass;
	      if (params.inputClass) {
	        addClass(inputContainer, params.inputClass);
	      }
	
	      hide(inputContainer);
	    }
	
	    var populateInputOptions = void 0;
	    switch (params.input) {
	      case 'text':
	      case 'email':
	      case 'password':
	      case 'number':
	      case 'tel':
	      case 'url':
	        input = getChildByClass(modal, swalClasses.input);
	        input.value = params.inputValue;
	        input.placeholder = params.inputPlaceholder;
	        input.type = params.input;
	        show(input);
	        break;
	      case 'file':
	        input = getChildByClass(modal, swalClasses.file);
	        input.placeholder = params.inputPlaceholder;
	        input.type = params.input;
	        show(input);
	        break;
	      case 'range':
	        var range = getChildByClass(modal, swalClasses.range);
	        var rangeInput = range.querySelector('input');
	        var rangeOutput = range.querySelector('output');
	        rangeInput.value = params.inputValue;
	        rangeInput.type = params.input;
	        rangeOutput.value = params.inputValue;
	        show(range);
	        break;
	      case 'select':
	        var select = getChildByClass(modal, swalClasses.select);
	        select.innerHTML = '';
	        if (params.inputPlaceholder) {
	          var placeholder = document.createElement('option');
	          placeholder.innerHTML = params.inputPlaceholder;
	          placeholder.value = '';
	          placeholder.disabled = true;
	          placeholder.selected = true;
	          select.appendChild(placeholder);
	        }
	        populateInputOptions = function populateInputOptions(inputOptions) {
	          for (var optionValue in inputOptions) {
	            var option = document.createElement('option');
	            option.value = optionValue;
	            option.innerHTML = inputOptions[optionValue];
	            if (params.inputValue.toString() === optionValue) {
	              option.selected = true;
	            }
	            select.appendChild(option);
	          }
	          show(select);
	          select.focus();
	        };
	        break;
	      case 'radio':
	        var radio = getChildByClass(modal, swalClasses.radio);
	        radio.innerHTML = '';
	        populateInputOptions = function populateInputOptions(inputOptions) {
	          for (var radioValue in inputOptions) {
	            var radioInput = document.createElement('input');
	            var radioLabel = document.createElement('label');
	            var radioLabelSpan = document.createElement('span');
	            radioInput.type = 'radio';
	            radioInput.name = swalClasses.radio;
	            radioInput.value = radioValue;
	            if (params.inputValue.toString() === radioValue) {
	              radioInput.checked = true;
	            }
	            radioLabelSpan.innerHTML = inputOptions[radioValue];
	            radioLabel.appendChild(radioInput);
	            radioLabel.appendChild(radioLabelSpan);
	            radioLabel.for = radioInput.id;
	            radio.appendChild(radioLabel);
	          }
	          show(radio);
	          var radios = radio.querySelectorAll('input');
	          if (radios.length) {
	            radios[0].focus();
	          }
	        };
	        break;
	      case 'checkbox':
	        var checkbox = getChildByClass(modal, swalClasses.checkbox);
	        var checkboxInput = getInput('checkbox');
	        checkboxInput.type = 'checkbox';
	        checkboxInput.value = 1;
	        checkboxInput.id = swalClasses.checkbox;
	        checkboxInput.checked = Boolean(params.inputValue);
	        var label = checkbox.getElementsByTagName('span');
	        if (label.length) {
	          checkbox.removeChild(label[0]);
	        }
	        label = document.createElement('span');
	        label.innerHTML = params.inputPlaceholder;
	        checkbox.appendChild(label);
	        show(checkbox);
	        break;
	      case 'textarea':
	        var textarea = getChildByClass(modal, swalClasses.textarea);
	        textarea.value = params.inputValue;
	        textarea.placeholder = params.inputPlaceholder;
	        show(textarea);
	        break;
	      case null:
	        break;
	      default:
	        error('Unexpected type of input! Expected "text", "email", "password", "number", "tel", "select", "radio", "checkbox", "textarea", "file" or "url", got "' + params.input + '"');
	        break;
	    }
	
	    if (params.input === 'select' || params.input === 'radio') {
	      if (params.inputOptions instanceof Promise) {
	        sweetAlert.showLoading();
	        params.inputOptions.then(function (inputOptions) {
	          sweetAlert.hideLoading();
	          populateInputOptions(inputOptions);
	        });
	      } else if (_typeof(params.inputOptions) === 'object') {
	        populateInputOptions(params.inputOptions);
	      } else {
	        error('Unexpected type of inputOptions! Expected object or Promise, got ' + _typeof(params.inputOptions));
	      }
	    }
	
	    openModal(params.animation, params.onBeforeOpen, params.onOpen);
	
	    if (!params.allowEnterKey) {
	      if (document.activeElement) {
	        document.activeElement.blur();
	      }
	    } else if (params.focusCancel && isVisible(cancelButton)) {
	      cancelButton.focus();
	    } else if (params.focusConfirm && isVisible(confirmButton)) {
	      confirmButton.focus();
	    } else {
	      setFocus(-1, 1);
	    }
	
	    // fix scroll
	    getContainer().scrollTop = 0;
	  });
	};
	
	/*
	 * Global function to determine if swal2 modal is shown
	 */
	sweetAlert.isVisible = function () {
	  return !!getModal();
	};
	
	/*
	 * Global function for chaining sweetAlert modals
	 */
	sweetAlert.queue = function (steps) {
	  queue = steps;
	  var resetQueue = function resetQueue() {
	    queue = [];
	    document.body.removeAttribute('data-swal2-queue-step');
	  };
	  var queueResult = [];
	  return new Promise(function (resolve, reject) {
	    (function step(i, callback) {
	      if (i < queue.length) {
	        document.body.setAttribute('data-swal2-queue-step', i);
	
	        sweetAlert(queue[i]).then(function (result) {
	          queueResult.push(result);
	          step(i + 1, callback);
	        }, function (dismiss) {
	          resetQueue();
	          reject(dismiss);
	        });
	      } else {
	        resetQueue();
	        resolve(queueResult);
	      }
	    })(0);
	  });
	};
	
	/*
	 * Global function for getting the index of current modal in queue
	 */
	sweetAlert.getQueueStep = function () {
	  return document.body.getAttribute('data-swal2-queue-step');
	};
	
	/*
	 * Global function for inserting a modal to the queue
	 */
	sweetAlert.insertQueueStep = function (step, index) {
	  if (index && index < queue.length) {
	    return queue.splice(index, 0, step);
	  }
	  return queue.push(step);
	};
	
	/*
	 * Global function for deleting a modal from the queue
	 */
	sweetAlert.deleteQueueStep = function (index) {
	  if (typeof queue[index] !== 'undefined') {
	    queue.splice(index, 1);
	  }
	};
	
	/*
	 * Global function to close sweetAlert
	 */
	sweetAlert.close = sweetAlert.closeModal = function (onComplete) {
	  var container = getContainer();
	  var modal = getModal();
	  if (!modal) {
	    return;
	  }
	  removeClass(modal, swalClasses.show);
	  addClass(modal, swalClasses.hide);
	  clearTimeout(modal.timeout);
	
	  resetPrevState();
	
	  var removeModalAndResetState = function removeModalAndResetState() {
	    if (container.parentNode) {
	      container.parentNode.removeChild(container);
	    }
	    removeClass(document.documentElement, swalClasses.shown);
	    removeClass(document.body, swalClasses.shown);
	    undoScrollbar();
	    undoIOSfix();
	  };
	
	  // If animation is supported, animate
	  if (animationEndEvent && !hasClass(modal, swalClasses.noanimation)) {
	    modal.addEventListener(animationEndEvent, function swalCloseEventFinished() {
	      modal.removeEventListener(animationEndEvent, swalCloseEventFinished);
	      if (hasClass(modal, swalClasses.hide)) {
	        removeModalAndResetState();
	      }
	    });
	  } else {
	    // Otherwise, remove immediately
	    removeModalAndResetState();
	  }
	  if (onComplete !== null && typeof onComplete === 'function') {
	    setTimeout(function () {
	      onComplete(modal);
	    });
	  }
	};
	
	/*
	 * Global function to click 'Confirm' button
	 */
	sweetAlert.clickConfirm = function () {
	  return getConfirmButton().click();
	};
	
	/*
	 * Global function to click 'Cancel' button
	 */
	sweetAlert.clickCancel = function () {
	  return getCancelButton().click();
	};
	
	/**
	 * Show spinner instead of Confirm button and disable Cancel button
	 */
	sweetAlert.showLoading = sweetAlert.enableLoading = function () {
	  var modal = getModal();
	  if (!modal) {
	    sweetAlert('');
	  }
	  modal = getModal();
	  var buttonsWrapper = getButtonsWrapper();
	  var confirmButton = getConfirmButton();
	  var cancelButton = getCancelButton();
	
	  show(buttonsWrapper);
	  show(confirmButton, 'inline-block');
	  addClass(buttonsWrapper, swalClasses.loading);
	  addClass(modal, swalClasses.loading);
	  confirmButton.disabled = true;
	  cancelButton.disabled = true;
	
	  modal.setAttribute('aria-busy', true);
	  modal.focus();
	};
	
	/**
	 * Is valid parameter
	 * @param {String} paramName
	 */
	sweetAlert.isValidParameter = function (paramName) {
	  return defaultParams.hasOwnProperty(paramName) || paramName === 'extraParams';
	};
	
	/**
	 * Set default params for each popup
	 * @param {Object} userParams
	 */
	sweetAlert.setDefaults = function (userParams) {
	  if (!userParams || (typeof userParams === 'undefined' ? 'undefined' : _typeof(userParams)) !== 'object') {
	    return error('the argument for setDefaults() is required and has to be a object');
	  }
	
	  for (var param in userParams) {
	    if (!sweetAlert.isValidParameter(param)) {
	      warn('Unknown parameter "' + param + '"');
	      delete userParams[param];
	    }
	  }
	
	  _extends(modalParams, userParams);
	};
	
	/**
	 * Reset default params for each popup
	 */
	sweetAlert.resetDefaults = function () {
	  modalParams = _extends({}, defaultParams);
	};
	
	sweetAlert.noop = function () {};
	
	sweetAlert.version = '6.11.5';
	
	sweetAlert.default = sweetAlert;
	
	return sweetAlert;
	
	})));
	if (window.Sweetalert2) window.sweetAlert = window.swal = window.Sweetalert2;


/***/ }),

/***/ 955:
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/**
	 * Time-To jQuery plug-in
	 * Show countdown timer or realtime clock
	 *
	 * @author Oleksii Teterin <altmoc@gmail.com>
	 * @version 1.3.0
	 * @license MIT http://opensource.org/licenses/MIT
	 * @date 2019-05-14
	 */
	(function(factory){if(true){!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(8)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__))}else if(typeof exports==="object"){module.exports=factory(require("jquery"))}else{factory(jQuery)}})(function($){var SECONDS_PER_DAY=86400;var SECONDS_PER_HOUR=3600;var defaults={callback:null,step:null,stepCount:1,captionSize:0,countdown:true,countdownAlertLimit:10,displayCaptions:false,displayDays:0,displayHours:true,fontFamily:"Verdana, sans-serif",fontSize:0,lang:"en",languages:{},seconds:0,start:true,theme:"white",width:25,height:30,gap:11,vals:[0,0,0,0,0,0,0,0,0],limits:[9,9,9,2,9,5,9,5,9],iSec:8,iHour:4,tickTimeout:1e3,intervalId:null,tickCount:0};var methods={start:function(sec){var intervalId;if(sec){init.call(this,sec);intervalId=setTimeout(tick.bind(this),1e3);this.data("ttStartTime",$.now());this.data("intervalId",intervalId)}},stop:function(){var data=this.data();if(data.intervalId){clearTimeout(data.intervalId);this.data("intervalId",null)}return data},reset:function(sec){var data=methods.stop.call(this);var secs=typeof sec==="undefined"?data.seconds:sec;this.find("div").css({backgroundPosition:"left center"});this.find("ul").parent().removeClass("timeTo-alert");init.call(this,secs,true)}};var dictionary={en:{days:"days",hours:"hours",min:"minutes",sec:"seconds"},ru:{days:"дней",hours:"часов",min:"минут",sec:"секунд"},ua:{days:"днiв",hours:"годин",min:"хвилин",sec:"секунд"},de:{days:"Tag",hours:"Uhr",min:"Minuten",sec:"Secunden"},fr:{days:"jours",hours:"heures",min:"minutes",sec:"secondes"},es:{days:"días",hours:"horas",min:"minutos",sec:"segundos"},sp:{days:"días",hours:"horas",min:"minutos",sec:"segundos"},it:{days:"giorni",hours:"ore",min:"minuti",sec:"secondi"},nl:{days:"dagen",hours:"uren",min:"minuten",sec:"seconden"},no:{days:"dager",hours:"timer",min:"minutter",sec:"sekunder"},pt:{days:"dias",hours:"horas",min:"minutos",sec:"segundos"},tr:{days:"gün",hours:"saat",min:"dakika",sec:"saniye"},pl:{days:"dni",hours:"godziny",min:"minuty",sec:"secundy"}};if(typeof $.support.transition==="undefined"){$.support.transition=function(){var thisBody=document.body||document.documentElement;var thisStyle=thisBody.style;var support=thisStyle.transition!==undefined||thisStyle.WebkitTransition!==undefined||thisStyle.MozTransition!==undefined||thisStyle.MsTransition!==undefined||thisStyle.OTransition!==undefined;return support}()}$.fn.timeTo=function(){var options={};var now=Date.now();var j,arg,num,method,time,days,tt,sec,m,t;for(j=0;j<arguments.length;j+=1){arg=arguments[j];if(j===0&&typeof arg==="string"){method=arg}else if(typeof arg==="object"){if(typeof arg.getTime==="function"){options.timeTo=arg}else{options=$.extend(options,arg)}}else if(typeof arg==="function"){options.callback=arg}else{num=parseInt(arg,10);if(!isNaN(num)){options.seconds=num}}}if(options.timeTo){if(options.timeTo.getTime){time=options.timeTo.getTime()}else if(typeof options.timeTo==="number"){time=options.timeTo}if(time>now){options.seconds=Math.floor((time-now)/1e3)}else{options.seconds=0}}else if(options.time||!options.seconds){time=options.time;if(!time){time=new Date(now)}if(typeof time==="object"&&time.getTime){options.seconds=time.getDate()*SECONDS_PER_DAY+time.getHours()*SECONDS_PER_HOUR+time.getMinutes()*60+time.getSeconds();options.countdown=false}else if(typeof time==="string"){tt=time.split(":");sec=0;m=1;while(tt.length){t=tt.pop();sec+=t*m;m*=60}options.seconds=sec;options.countdown=false}}if(options.countdown!==false&&options.seconds>SECONDS_PER_DAY&&typeof options.displayDays==="undefined"){days=Math.floor(options.seconds/SECONDS_PER_DAY);options.displayDays=days<10&&1||days<100&&2||3}else if(options.displayDays===true){options.displayDays=3}else if(options.displayDays){options.displayDays=options.displayDays>0?Math.floor(options.displayDays):3}return this.each(function(){var $this=$(this);var data=$this.data();var defs,opt,i,css,language,left,ulhtml,style,dhtml1,dhtml2,dot2,maxWidth,captionSize,fsStyleVal,fsStyle,thtml,marginRight,dhtml,$digits,dif,vals,limits;if(data.intervalId){clearInterval(data.intervalId);data.intervalId=null}if(!data.vals){if(data.opt){opt=data.options}else{opt=options}defs=Object.keys(defaults).reduce(function(obj,key){if(Array.isArray(defaults[key])){obj[key]=defaults[key].slice(0)}else{obj[key]=defaults[key]}return obj},{});data=$.extend(defs,opt);data.options=opt;data.height=Math.round(data.fontSize*100/93)||data.height;data.width=Math.round(data.fontSize*.8+data.height*.13)||data.width;data.displayHours=!!(data.displayDays||data.displayHours);css={fontFamily:data.fontFamily};if(data.fontSize>0){css.fontSize=data.fontSize+"px"}language=data.languages[data.lang]||dictionary[data.lang];$this.addClass("timeTo").addClass("timeTo-"+data.theme).css(css);left=Math.round(data.height/10);ulhtml='<ul style="left:'+left+"px; top:-"+data.height+'px"><li>0</li><li>0</li></ul></div>';style=data.fontSize?' style="width:'+data.width+"px; height:"+data.height+'px;"':' style=""';dhtml1='<div class="first"'+style+">"+ulhtml;dhtml2="<div"+style+">"+ulhtml;dot2="<span>:</span>";maxWidth=Math.round(data.width*2+3);captionSize=data.captionSize||data.fontSize&&Math.round(data.fontSize*.43);fsStyleVal=captionSize?"font-size:"+captionSize+"px;":"";fsStyle=captionSize?' style="'+fsStyleVal+'"':"";thtml=(data.displayCaptions?(data.displayHours?'<figure style="max-width:'+maxWidth+'px">$1<figcaption'+fsStyle+">"+language.hours+"</figcaption></figure>"+dot2:"")+'<figure style="max-width:'+maxWidth+'px">$1<figcaption'+fsStyle+">"+language.min+"</figcaption></figure>"+dot2+'<figure style="max-width:'+maxWidth+'px">$1<figcaption'+fsStyle+">"+language.sec+"</figcaption></figure>":(data.displayHours?"$1"+dot2:"")+"$1"+dot2+"$1").replace(/\$1/g,dhtml1+dhtml2);if(data.displayDays>0){marginRight=Math.round(data.fontSize*.4||defaults.gap);dhtml=dhtml1;for(i=data.displayDays-1;i>0;i-=1){dhtml+=i===1?dhtml2.replace('">',"margin-right:"+marginRight+'px">'):dhtml2}if(data.displayDays===1){dhtml=dhtml.replace('">',"margin-right:"+marginRight+'px">')}thtml=(data.displayCaptions?'<figure style="width:'+(data.width*data.displayDays+marginRight+4)+'px">$1'+'<figcaption style="'+fsStyleVal+"padding-right:"+marginRight+'px">'+language.days+"</figcaption></figure>":"$1").replace(/\$1/,dhtml)+thtml}$this.html(thtml)}else if(method!=="reset"){$.extend(data,options)}$digits=$this.find("div");if($digits.length<data.vals.length){dif=data.vals.length-$digits.length;vals=data.vals;limits=data.limits;data.vals=[];data.limits=[];for(i=0;i<$digits.length;i+=1){data.vals[i]=vals[dif+i];data.limits[i]=limits[dif+i]}data.iSec=data.vals.length-1;data.iHour=data.vals.length-5}data.sec=data.seconds;$this.data(data);if(method&&methods[method]){methods[method].call($this,data.seconds)}else if(data.start){methods.start.call($this,data.seconds)}else{init.call($this,data.seconds)}})};function init(sec,force){var data=this.data();var $digits=this.find("ul");var isInterval=false;var days,rest,hours,minutes,secs,str,i,j,val;if(!data.vals||$digits.length===0){return}if(!sec){sec=data.seconds}if(data.intervalId){isInterval=true;clearTimeout(data.intervalId)}days=Math.floor(sec/SECONDS_PER_DAY);rest=days*SECONDS_PER_DAY;hours=Math.floor((sec-rest)/SECONDS_PER_HOUR);rest+=hours*SECONDS_PER_HOUR;minutes=Math.floor((sec-rest)/60);rest+=minutes*60;secs=sec-rest;str=(days<100?"0"+(days<10?"0":""):"")+days+(hours<10?"0":"")+hours+(minutes<10?"0":"")+minutes+(secs<10?"0":"")+secs;for(i=data.vals.length-1,j=str.length-1;i>=0;i-=1,j-=1){val=parseInt(str.substr(j,1),10);data.vals[i]=val;$digits.eq(i).children().html(val)}if(isInterval||force){data.ttStartTime=Date.now();data.intervalId=setTimeout(tick.bind(this),1e3);this.data("intervalId",data.intervalId)}}function tick(digit){var me=this;var $digits=this.find("ul");var data=this.data();var n,$ul,$li,step,tickTimeout,timeDiff;if(!data.vals||$digits.length===0){if(data.intervalId){clearTimeout(data.intervalId);this.data("intervalId",null)}if(data.callback){data.callback()}return}if(typeof digit==="undefined"){digit=data.iSec}this.data("tickCount",data.tickCount+1);n=data.vals[digit];$ul=$digits.eq(digit);$li=$ul.children();step=data.countdown?-1:1;$li.eq(1).html(n);n+=step;if(typeof data.step==="function"&&data.tickCount%data.stepCount===0){this.data("tickCount",0);data.step()}if(digit===data.iSec){tickTimeout=data.tickTimeout;timeDiff=Date.now()-data.ttStartTime;data.sec+=step;tickTimeout+=Math.abs(data.seconds-data.sec)*tickTimeout-timeDiff;data.intervalId=setTimeout(tick.bind(this),tickTimeout)}if(n<0||n>data.limits[digit]){if(n<0){n=data.limits[digit];if(digit===data.iHour&&data.displayDays>0&&data.vals[digit-1]===0){n=3}}else{n=0}if(digit>0){tick.call(this,digit-1)}}else if(!data.countdown&&digit===data.iHour&&data.displayDays>0&&data.vals[digit-1]===2&&data.vals[digit]===3){n=0;tick.call(this,digit-1)}$li.eq(0).html(n);if($.support.transition){$ul.addClass("transition");$ul.css({top:0});setTimeout(function(){$ul.removeClass("transition");$li.eq(1).html(n);$ul.css({top:"-"+data.height+"px"});if(step>0||digit!==data.iSec){return}if(data.sec===data.countdownAlertLimit){$digits.parent().addClass("timeTo-alert")}if(data.sec===0){$digits.parent().removeClass("timeTo-alert");if(data.intervalId){clearTimeout(data.intervalId);me.data("intervalId",null)}if(typeof data.callback==="function"){data.callback()}}},410)}else{$ul.stop().animate({top:0},400,digit!==data.iSec?null:function(){$li.eq(1).html(n);$ul.css({top:"-"+data.height+"px"});if(step>0||digit!==data.iSec){return}if(data.sec===data.countdownAlertLimit){$digits.parent().addClass("timeTo-alert")}else if(data.sec===0){$digits.parent().removeClass("timeTo-alert");if(data.intervalId){clearTimeout(data.intervalId);me.data("intervalId",null)}if(typeof data.callback==="function"){data.callback()}}})}data.vals[digit]=n}return $});

/***/ }),

/***/ 960:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 961:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 962:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 963:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 964:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 965:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 966:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 967:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ })

});


// WEBPACK FOOTER //
// app.js